export const Symbols = [
  {
    Symbol: 'A',
    Issuer: 'AGILENT TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AA',
    Issuer: 'ALCOA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAA',
    Issuer: 'AAF FIRST PRIORITY CLO BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAAU',
    Issuer: 'GOLDMAN SACHS PHYSICAL GOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAC',
    Issuer: 'ARES ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAC=',
    Issuer: 'ARES ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AACG',
    Issuer: 'ATA CREATIVITY GLOBAL - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AACI',
    Issuer: 'ARMADA ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AACIU',
    Issuer: 'ARMADA ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AACIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AADI',
    Issuer: 'AADI BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AADR',
    Issuer: 'ADVISORSHARES DORSEY WRIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAIC',
    Issuer: 'ARLINGTON ASSET INVESTMENT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAIC-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAIC-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAIN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAL',
    Issuer: 'AMERICAN AIRLINES GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAM-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAM-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAMC',
    Issuer: 'ALTISOURCE ASSET MANAGEMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAME',
    Issuer: 'ATLANTIC AMERICAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAN',
    Issuer: "AARON'S CO INC/THE",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAOI',
    Issuer: 'APPLIED OPTOELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAON',
    Issuer: 'AAON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAP',
    Issuer: 'ADVANCE AUTO PARTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAPL',
    Issuer: 'APPLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAQC',
    Issuer: 'ACCELERATE ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAQC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAQC=',
    Issuer: 'ACCELERATE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAT',
    Issuer: 'AMERICAN ASSETS TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AATC',
    Issuer: 'AUTOSCOPE TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAU',
    Issuer: 'ALMADEN MINERALS LTD - B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAWW',
    Issuer: 'ATLAS AIR WORLDWIDE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AAXJ',
    Issuer: 'ISHARES MSCI ALL COUNTRY ASI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AB',
    Issuer: 'ALLIANCEBERNSTEIN HOLDING LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABB',
    Issuer: 'ABB LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABBV',
    Issuer: 'ABBVIE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABC',
    Issuer: 'AMERISOURCEBERGEN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABCB',
    Issuer: 'AMERIS BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABCL',
    Issuer: 'ABCELLERA BIOLOGICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABCM',
    Issuer: 'ABCAM PLC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABEO',
    Issuer: 'ABEONA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABEQ',
    Issuer: 'ABSOLUTE CORE STRATEGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABEV',
    Issuer: 'AMBEV SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABG',
    Issuer: 'ASBURY AUTOMOTIVE GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABGI',
    Issuer: 'ABG ACQUISITION CORP I - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABIO',
    Issuer: 'ARCA BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABM',
    Issuer: 'ABM INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABMD',
    Issuer: 'ABIOMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABNB',
    Issuer: 'AIRBNB INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABOS',
    Issuer: 'ACUMEN PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABR',
    Issuer: 'ARBOR REALTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABR-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABR-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABR-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABSI',
    Issuer: 'ABSCI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABST',
    Issuer: 'ABSOLUTE SOFTWARE CORPORATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABT',
    Issuer: 'ABBOTT LABORATORIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABTX',
    Issuer: 'ALLEGIANCE BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABUS',
    Issuer: 'ARBUTUS BIOPHARMA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ABVC',
    Issuer: 'ABVC BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AC',
    Issuer: 'ASSOCIATED CAPITAL GROUP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACA',
    Issuer: 'ARCOSA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAB',
    Issuer: 'ATLANTIC COAST ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACABU',
    Issuer: 'ATLANTIC COASTAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACABW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAD',
    Issuer: 'ACADIA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAH',
    Issuer: 'ATLANTIC COASTAL ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAHU',
    Issuer: 'ATLANTIC COASTAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAQ',
    Issuer: 'ATHENA CONSUMER ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAQ=',
    Issuer: 'ATHENA CONSUMER ACQU CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAX',
    Issuer: 'ALSET CAPITAL ACQUISITI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAXR',
    Issuer: 'ALSET CAPITAL ACQUISITIO-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAXU',
    Issuer: 'ALSET CAPITAL ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACB',
    Issuer: 'AURORA CANNABIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACBA',
    Issuer: 'ACE GLOBAL BUSINESS ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACBAU',
    Issuer: 'ACE GLOBAL BUSINESS ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACBAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACC',
    Issuer: 'AMERICAN CAMPUS COMMUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACCD',
    Issuer: 'ACCOLADE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACCO',
    Issuer: 'ACCO BRANDS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACDI',
    Issuer: 'ASCENDANT DIGITAL ACQU-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACDI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACDI=',
    Issuer: 'ASCENDANT DIGITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACEL',
    Issuer: 'ACCEL ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACER',
    Issuer: 'ACER THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACES',
    Issuer: 'ALPS CLEAN ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACET',
    Issuer: 'ADICET BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACEV',
    Issuer: 'ACE CONVERGENCE ACQU-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACEVU',
    Issuer: 'ACE CONVERGENCE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACEVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACGL',
    Issuer: 'ARCH CAPITAL GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACGLN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACGLO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACH',
    Issuer: 'ALUMINUM CORP OF CHINA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACHC',
    Issuer: 'ACADIA HEALTHCARE CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACHL',
    Issuer: 'ACHILLES THERAPEUTICS PL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACHR',
    Issuer: 'ARCHER AVIATION INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACHR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACHV',
    Issuer: 'ACHIEVE LIFE SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACI',
    Issuer: 'ALBERTSONS COS INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACII',
    Issuer: 'ATLAS CREST INVESTMENT COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACII+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACII=',
    Issuer: 'ATLAS CREST INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACIO',
    Issuer: 'APTUS COLLARED INC OPP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACIU',
    Issuer: 'AC IMMUNE SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACIW',
    Issuer: 'ACI WORLDWIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACKIT',
    Issuer: 'ACKRELL SPAC PARTNERS-SUBUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACKIU',
    Issuer: 'ACKRELL SPAC PARTNERS I CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACKIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACLS',
    Issuer: 'AXCELIS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACLX',
    Issuer: 'ARCELLX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACM',
    Issuer: 'AECOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACMR',
    Issuer: 'ACM RESEARCH INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACN',
    Issuer: 'ACCENTURE PLC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACNB',
    Issuer: 'ACNB CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACON',
    Issuer: 'ACLARION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACONW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACOR',
    Issuer: 'ACORDA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACP',
    Issuer: 'ABERDEEN INCOME CREDIT STRAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACQR',
    Issuer: 'INDEPENDENCE HDS CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACQRU',
    Issuer: 'INDEPENDENCE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACQRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACR',
    Issuer: 'ACRES COMMERCIAL REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACR-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRE',
    Issuer: 'ARES COMMERCIAL REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRO',
    Issuer: 'ACROPOLIS INFRASTRUCTURE - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRO=',
    Issuer: 'ACROPOLIS INFRASTRUCTURE ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRS',
    Issuer: 'ACLARIS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACRX',
    Issuer: 'ACELRX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACSI',
    Issuer: 'AMERICAN CUSTOMER SATISFACTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACST',
    Issuer: 'ACASTI PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACT',
    Issuer: 'ENACT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACTD',
    Issuer: 'ARCLIGHT CLEAN TRANSITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACTDU',
    Issuer: 'ARCLIGHT CLEAN TRANSITION II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACTDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACTG',
    Issuer: 'ACACIA RESEARCH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACTV',
    Issuer: 'LEADERSHARES ACTIVIST LEADER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACU',
    Issuer: 'ACME UNITED CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACV',
    Issuer: 'VIRTUS ALLIANZGI DIV & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACVA',
    Issuer: 'ACV AUCTIONS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACVF',
    Issuer: 'AMERICAN CONSERVATIVE VALUES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACWF',
    Issuer: 'ISHARES MSCI GLOBAL MULTIFAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACWI',
    Issuer: 'ISHARES MSCI ACWI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACWV',
    Issuer: 'ISHARES MSCI GLOBAL MIN VOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACWX',
    Issuer: 'ISHARES MSCI ACWI EX US ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ACXP',
    Issuer: 'ACURX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADAG',
    Issuer: 'ADAGENE INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADAL',
    Issuer: 'ANTHEMIS DIGITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADALU',
    Issuer: 'ANTHEMIS DIGITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADALW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADAP',
    Issuer: 'ADAPTIMMUNE THERAPEUTICS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADBE',
    Issuer: 'ADOBE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADC',
    Issuer: 'AGREE REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADCT',
    Issuer: 'ADC THERAPEUTICS SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADER',
    Issuer: '26 CAPITAL ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADERU',
    Issuer: '26 CAPITAL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADERW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADES',
    Issuer: 'ADVANCED EMISSIONS SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADEX',
    Issuer: 'ADIT EDTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADEX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADEX=',
    Issuer: 'ADIT EDTECH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADFI',
    Issuer: 'ANFIELD DYNAMIC FIXED INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADGI',
    Issuer: 'ADAGIO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADI',
    Issuer: 'ANALOG DEVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADIL',
    Issuer: 'ADIAL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADILW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADIV',
    Issuer: 'SMARTETFS APAC DVD BUILDER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADM',
    Issuer: 'ARCHER-DANIELS-MIDLAND CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADMA',
    Issuer: 'ADMA BIOLOGICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADME',
    Issuer: 'APTUS DRAWDOWN MANAGED EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADMP',
    Issuer: 'ADAMIS PHARMACEUTICALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADN',
    Issuer: 'ADVENT TECHNOLOGIES HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADNT',
    Issuer: 'ADIENT PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADNWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADOC',
    Issuer: 'EDOC ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADOCR',
    Issuer: 'DOC ACQUISITION CORP-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADOCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADP',
    Issuer: 'AUTOMATIC DATA PROCESSING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADPT',
    Issuer: 'ADAPTIVE BIOTECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRA',
    Issuer: 'ADARA ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRA=',
    Issuer: 'ADARA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRE',
    Issuer: 'INVESCO BLDRS EMERGING MARKE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRT',
    Issuer: 'AULT DISRUPTIVE TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADRT=',
    Issuer: 'AULT DISRUPTIVE TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADSE',
    Issuer: 'ADS-TEC ENERGY PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADSEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADSK',
    Issuer: 'AUTODESK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADT',
    Issuer: 'ADT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADTH',
    Issuer: 'ADTHEORENT HOLDINGS CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADTHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADTN',
    Issuer: 'ADTRAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADTX',
    Issuer: 'ADITXT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADUS',
    Issuer: 'ADDUS HOMECARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADV',
    Issuer: 'ADVANTAGE SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADVM',
    Issuer: 'ADVERUM BIOTECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADVWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADX',
    Issuer: 'ADAMS DIVERSIFIED EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ADXN',
    Issuer: 'ADDEX THERAPEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AE',
    Issuer: 'ADAMS RESOURCES & ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEAC',
    Issuer: 'AUTHENTIC EQUITY ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEACU',
    Issuer: 'AUTHENTIC EQUITY ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEAE',
    Issuer: 'ALTENERGY ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEAEU',
    Issuer: 'ALTENERGY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEAEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEE',
    Issuer: 'AMEREN CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEF',
    Issuer: 'ABERDEEN EM MRKT EQTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEFC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEG',
    Issuer: 'AEGON N.V.-NY REG SHR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEHA',
    Issuer: 'AESTHER HEALTHCARE ACQU-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEHAU',
    Issuer: 'AESTHER HEALTHCARE ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEHAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEHL',
    Issuer: 'ANTELOPE ENTERPRISE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEHR',
    Issuer: 'AEHR TEST SYSTEMS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEI',
    Issuer: 'ALSET EHOME INTERNATIONAL IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEIS',
    Issuer: 'ADVANCED ENERGY INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEL',
    Issuer: 'AMERICAN EQUITY INVT LIFE HL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEL-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEM',
    Issuer: 'AGNICO EAGLE MINES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEMB',
    Issuer: 'AMERICAN CENT EMERG MARK BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEMD',
    Issuer: 'AETHLON MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AENZ',
    Issuer: 'AENZA SAA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEO',
    Issuer: 'AMERICAN EAGLE OUTFITTERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEP',
    Issuer: 'AMERICAN ELECTRIC POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEPPZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AER',
    Issuer: 'AERCAP HOLDINGS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AERC',
    Issuer: 'AEROCLEAN TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AERI',
    Issuer: 'AERIE PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AES',
    Issuer: 'AES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AESC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AESE',
    Issuer: 'ALLIED ESPORTS ENTERTAINMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AESR',
    Issuer: 'ANFIELD US EQUITY SECTOR ROT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEVA',
    Issuer: 'AEVA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEVA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEY',
    Issuer: 'ADDVANTAGE TECHNOLOGIES GRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEYE',
    Issuer: 'AUDIOEYE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AEZS',
    Issuer: 'AETERNA ZENTARIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFAC',
    Issuer: 'ARENA FORTIFY ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFACU',
    Issuer: 'ARENA FORTIFY ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFAQ',
    Issuer: 'AF ACQUISITION CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFAQU',
    Issuer: 'AF ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFARU',
    Issuer: 'AURA FAT PROJECTS ACQUISITON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFB',
    Issuer: 'ALLIANCE NATIONAL MUNI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFBI',
    Issuer: 'AFFINITY BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFCG',
    Issuer: 'AFC GAMMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFG',
    Issuer: 'AMERICAN FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFGB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFGC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFGD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFGE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFIB',
    Issuer: 'ACUTUS MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFIF',
    Issuer: 'ANFIELD UNIVERSAL FIXED INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFK',
    Issuer: 'VANECK AFRICA INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFL',
    Issuer: 'AFLAC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFLG',
    Issuer: 'FIRST TRUST ACTIVE FACTOR LA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFMC',
    Issuer: 'FIRST TRUST ACTIVE FACTOR MI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFMD',
    Issuer: 'AFFIMED NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFRM',
    Issuer: 'AFFIRM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFSM',
    Issuer: 'FIRST TRUST ACTIVE FACTOR SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFT',
    Issuer: 'APOLLO SENIOR FLOATING RATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFTR',
    Issuer: 'AFTERNEXT HEALTHTECH ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFTR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFTR=',
    Issuer: 'AFTERNEXT HEALTHTECH ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFTY',
    Issuer: 'PACER CSOP FTSE CHINA A50 ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AFYA',
    Issuer: 'AFYA LTD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AG',
    Issuer: 'FIRST MAJESTIC SILVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGAC',
    Issuer: 'AFRICAN GOLD ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGAC=',
    Issuer: 'AFRICAN GOLD ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGBA',
    Issuer: 'AGBA ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGBAR',
    Issuer: 'AGBA ACQUISITION LTD-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGBAU',
    Issuer: 'AGBA ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGBAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGCB',
    Issuer: 'ALTIMETER GROWTH CORP 2-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGCO',
    Issuer: 'AGCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGD',
    Issuer: 'ABERDEEN GLBL DYN DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGE',
    Issuer: 'AGEX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGEN',
    Issuer: 'AGENUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGFS',
    Issuer: 'AGROFRESH SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGFY',
    Issuer: 'AGRIFY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGG',
    Issuer: 'ISHARES CORE U.S. AGGREGATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGGH',
    Issuer: 'SIMPLIFY AGGR BD PL CR HD ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGGR',
    Issuer: 'AGILE GROWTH CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGGRU',
    Issuer: 'AGILE GROWTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGGRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGGY',
    Issuer: 'WISDOMTREE YIELD ENHANCED US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGI',
    Issuer: 'ALAMOS GOLD INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGIL',
    Issuer: 'AGILETHOUGHT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGILW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGIO',
    Issuer: 'AGIOS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGL',
    Issuer: 'AGILON HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGLE',
    Issuer: 'AEGLEA BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM',
    Issuer: 'FEDERAL AGRIC MTG CORP-CL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGM.A',
    Issuer: 'FEDERAL AGRIC MTG CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGMH',
    Issuer: 'AGM GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNC',
    Issuer: 'AGNC INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNCM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNCN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGNG',
    Issuer: 'GLB X AGING POPULATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGO',
    Issuer: 'ASSURED GUARANTY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGOV',
    Issuer: 'ETC GAVEKAL ASIA PACIFIC GOV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGOX',
    Issuer: 'ADAPTIVE ALPHA OPPORTUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGQ',
    Issuer: 'PROSHARES ULTRA SILVER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGR',
    Issuer: 'AVANGRID INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGRI',
    Issuer: 'AGRIFORCE GROWING SYSTEMS LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGRIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGRO',
    Issuer: 'ADECOAGRO SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGRX',
    Issuer: 'AGILE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGS',
    Issuer: 'PLAYAGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGT',
    Issuer: 'ISHARES ARGENTINA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGTC',
    Issuer: 'APPLIED GENETIC TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGTI',
    Issuer: 'AGILITI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGX',
    Issuer: 'ARGAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGYS',
    Issuer: 'AGILYSYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGZ',
    Issuer: 'ISHARES AGENCY BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AGZD',
    Issuer: 'WISDOMTREE TRUST WISDOMTREE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHCO',
    Issuer: 'ADAPTHEALTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHG',
    Issuer: 'AKSO HEALTH GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHH',
    Issuer: 'ARMADA HOFFLER PROPERTIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHHX',
    Issuer: 'ADAPTIVE HIGH INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHI',
    Issuer: 'ADVANCED HUMAN IMAGING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHL-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHL-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHL-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHPA',
    Issuer: 'AVISTA PUBLIC ACQUIS-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHPAU',
    Issuer: 'AVISTA PUBLIC ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHPI',
    Issuer: 'ALLIED HEALTHCARE PRODUCTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHRN',
    Issuer: 'AHREN ACQUISITION CO-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHRNU',
    Issuer: 'AHREN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHRNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT',
    Issuer: 'ASHFORD HOSPITALITY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHT-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AHYB',
    Issuer: 'AMERICAN CENTURY SELECT HY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AI',
    Issuer: 'C3.AI INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIA',
    Issuer: 'ISHARES ASIA 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIB',
    Issuer: 'AIB ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIBBR',
    Issuer: 'AIB ACQUISITION CORP- RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIBBU',
    Issuer: 'AIB ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIEQ',
    Issuer: 'AI POWERED EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIF',
    Issuer: 'APOLLO TACTICAL INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIG',
    Issuer: 'AMERICAN INTERNATIONAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIH',
    Issuer: 'AESTHETIC MEDICAL INTERN-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIHS',
    Issuer: 'SENMIAO TECHNOLOGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIIQ',
    Issuer: 'AI POWERED INTERNATIONAL EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIKI',
    Issuer: 'AIKIDO PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AILG',
    Issuer: 'ALPHA INTELLIGENT-LRG CAP GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AILV',
    Issuer: 'ALPHA INTELLIGENT-LRG CAP VL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIM',
    Issuer: 'AIM IMMUNOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIMAU',
    Issuer: 'AIMFINITY INVESTMENT CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIMC',
    Issuer: 'ALTRA INDUSTRIAL MOTION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIN',
    Issuer: 'ALBANY INTL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AINC',
    Issuer: 'ASHFORD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AINV',
    Issuer: 'APOLLO INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIO',
    Issuer: 'VIRTUS ALLIANZGI ART INTEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIP',
    Issuer: 'ARTERIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIQ',
    Issuer: 'GLOBAL X ART INTEL & TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIR',
    Issuer: 'AAR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRC',
    Issuer: 'APARTMENT INCOME REIT CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRG',
    Issuer: 'AIRGAIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRI',
    Issuer: 'AIR INDUSTRIES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRR',
    Issuer: 'FIRST TRUST RBA AMERICAN IND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRS',
    Issuer: 'AIRSCULPT TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRT',
    Issuer: 'AIR T INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIRTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIT',
    Issuer: 'APPLIED INDUSTRIAL TECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIU',
    Issuer: 'META DATA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIV',
    Issuer: 'APARTMENT INVT & MGMT CO -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIVI',
    Issuer: 'WISDOMTREE INTERNATIONAL AI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIVL',
    Issuer: 'WISDOMTREE US AI ENHANCED VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIZ',
    Issuer: 'ASSURANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AIZN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AJG',
    Issuer: 'ARTHUR J GALLAGHER & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AJRD',
    Issuer: 'AEROJET ROCKETDYNE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AJX',
    Issuer: 'GREAT AJAX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AJXA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKA',
    Issuer: 'AKA BRANDS HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKAM',
    Issuer: 'AKAMAI TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKAN',
    Issuer: 'AKANDA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKBA',
    Issuer: 'AKEBIA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKIC',
    Issuer: 'SPORTS VENTURES ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKICU',
    Issuer: 'SPORTS VENTURES ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKO.A',
    Issuer: 'EMBOTELLADORA ANDINA-ADR A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKO.B',
    Issuer: 'EMBOTELLADORA ANDINA-ADR B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKR',
    Issuer: 'ACADIA REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKRO',
    Issuer: 'AKERO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKTS',
    Issuer: 'AKOUSTIS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKTX',
    Issuer: 'AKARI THERAPEUTICS PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKU',
    Issuer: 'AKUMIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKUS',
    Issuer: 'AKOUOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AKYA',
    Issuer: 'AKOYA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AL',
    Issuer: 'AIR LEASE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AL-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALB',
    Issuer: 'ALBEMARLE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALBO',
    Issuer: 'ALBIREO PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALC',
    Issuer: 'ALCON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALCC',
    Issuer: 'ALTC ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALCO',
    Issuer: 'ALICO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALDX',
    Issuer: 'ALDEYRA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALE',
    Issuer: 'ALLETE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALEC',
    Issuer: 'ALECTOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALEX',
    Issuer: 'ALEXANDER & BALDWIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALF',
    Issuer: 'ALFI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALFA',
    Issuer: 'ALPHACLONE ALTERNATIVE ALPHA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALFIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALG',
    Issuer: 'ALAMO GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALGM',
    Issuer: 'ALLEGRO MICROSYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALGN',
    Issuer: 'ALIGN TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALGS',
    Issuer: 'ALIGOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALGT',
    Issuer: 'ALLEGIANT TRAVEL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALHC',
    Issuer: 'ALIGNMENT HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALIM',
    Issuer: 'ALIMERA SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALIN-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALIN-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALIN-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALIT',
    Issuer: 'ALIGHT INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALJJ',
    Issuer: 'ALJ REGIONAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALK',
    Issuer: 'ALASKA AIR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALKS',
    Issuer: 'ALKERMES PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALKT',
    Issuer: 'ALKAMI TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALL',
    Issuer: 'ALLSTATE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALL-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALL-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALL-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLE',
    Issuer: 'ALLEGION PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLG',
    Issuer: 'ALLEGO NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLG+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLK',
    Issuer: 'ALLAKOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLO',
    Issuer: 'ALLOGENE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLR',
    Issuer: 'ALLARITY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLT',
    Issuer: 'ALLOT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALLY',
    Issuer: 'ALLY FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALNA',
    Issuer: 'ALLENA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALNY',
    Issuer: 'ALNYLAM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALOR',
    Issuer: 'ALSP ORCHID ACQUISITION-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALORU',
    Issuer: 'ALSP ORCHID ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALORW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALOT',
    Issuer: 'ASTRONOVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALP-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALPA',
    Issuer: 'ALPHA HEALTHCARE ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALPAU',
    Issuer: 'ALPHA HEALTHCARE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALPN',
    Issuer: 'ALPINE IMMUNE SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALPP',
    Issuer: 'ALPINE 4 HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALR',
    Issuer: 'ALERISLIFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALRM',
    Issuer: 'ALARM.COM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALRN',
    Issuer: 'AILERON THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALRS',
    Issuer: 'ALERUS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALSA',
    Issuer: 'ALPHA STAR ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALSAR',
    Issuer: 'ALPHA STAR ACQ CORP - RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALSAU',
    Issuer: 'ALPHA STAR ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALSN',
    Issuer: 'ALLISON TRANSMISSION HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALT',
    Issuer: 'ALTIMMUNE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTG',
    Issuer: 'ALTA EQUIPMENT GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTL',
    Issuer: 'PACER LUNT LARGE CAP ALTERNA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTO',
    Issuer: 'ALTO INGREDIENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTR',
    Issuer: 'ALTAIR ENGINEERING INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTU',
    Issuer: 'ALTITUDE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTUU',
    Issuer: 'ALTITUDE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTUW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALTY',
    Issuer: 'GLOBAL X ALTERNATIVE INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALV',
    Issuer: 'AUTOLIV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALVR',
    Issuer: 'ALLOVIR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALX',
    Issuer: "ALEXANDER'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALXO',
    Issuer: 'ALX ONCOLOGY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALYA',
    Issuer: 'ALITHYA GROUP INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ALZN',
    Issuer: 'ALZAMEND NEURO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AM',
    Issuer: 'ANTERO MIDSTREAM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAL',
    Issuer: 'AMALGAMATED FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAM',
    Issuer: 'AMBRX BIOPHARMA INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAO',
    Issuer: 'AMERICAN ACQUISITION OP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAOU',
    Issuer: 'AMERICAN ACQUISITION OPPORTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAT',
    Issuer: 'APPLIED MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMAX',
    Issuer: 'RH HEDGED MULTI-ASSET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBA',
    Issuer: 'AMBARELLA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBC',
    Issuer: 'AMBAC FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBO',
    Issuer: 'AMBOW EDUCATION HOLDING-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBP',
    Issuer: 'ARDAGH METAL PACKAGING SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMBP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMC',
    Issuer: 'AMC ENTERTAINMENT HLDS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMCI',
    Issuer: 'AMCI ACQUISITION CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMCIU',
    Issuer: 'AMCI ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMCIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMCR',
    Issuer: 'AMCOR PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMCX',
    Issuer: 'AMC NETWORKS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMD',
    Issuer: 'ADVANCED MICRO DEVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AME',
    Issuer: 'AMETEK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMED',
    Issuer: 'AMEDISYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMEH',
    Issuer: 'APOLLO MEDICAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMER',
    Issuer: 'EMLES MADE IN AMERICA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMG',
    Issuer: 'AFFILIATED MANAGERS GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMGN',
    Issuer: 'AMGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMH',
    Issuer: 'AMERICAN HOMES 4 RENT- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMH-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMH-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMJ',
    Issuer: 'JPMORGAN ALERIAN MLP INDEX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMK',
    Issuer: 'ASSETMARK FINANCIAL HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMKR',
    Issuer: 'AMKOR TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMLP',
    Issuer: 'ALERIAN MLP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMLX',
    Issuer: 'AMYLYX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMN',
    Issuer: 'AMN HEALTHCARE SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMNA',
    Issuer: 'ETRACS ALERIAN MIDSTREAM ENE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMNB',
    Issuer: 'AMER NATL BNKSHS/DANVILLE VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMND',
    Issuer: 'ETRACS ALERIAN MIDST H/DV EN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMOM',
    Issuer: 'QRAFT AI-ENH US LRG CAP MTM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMOT',
    Issuer: 'ALLIED MOTION TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMOV',
    Issuer: 'AMERICA MOVIL-ADR SERIES A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMP',
    Issuer: 'AMERIPRISE FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPE',
    Issuer: 'AMPIO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPG',
    Issuer: 'AMPLITECH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPH',
    Issuer: 'AMPHASTAR PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPI',
    Issuer: 'ADVANCED MERGER PARTNERS I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPI=',
    Issuer: 'ADVANCED MERGER PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPL',
    Issuer: 'AMPLITUDE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPS',
    Issuer: 'ALTUS POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMPY',
    Issuer: 'AMPLIFY ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMR',
    Issuer: 'ALPHA METALLURGICAL RESOURCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMRC',
    Issuer: 'AMERESCO INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMRK',
    Issuer: 'A-MARK PRECIOUS METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMRN',
    Issuer: 'AMARIN CORP PLC -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMRS',
    Issuer: 'AMYRIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMRX',
    Issuer: 'AMNEAL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMS',
    Issuer: 'AMERICAN SHARED HOSPITAL SER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMSC',
    Issuer: 'AMERICAN SUPERCONDUCTOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMSF',
    Issuer: 'AMERISAFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMST',
    Issuer: 'AMESITE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMSWA',
    Issuer: 'AMERICAN SOFTWARE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMT',
    Issuer: 'AMERICAN TOWER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMTB',
    Issuer: 'AMERANT BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMTD',
    Issuer: 'AMTD IDEA GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMTI',
    Issuer: 'APPLIED MOLECULAR TRANSPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMTR',
    Issuer: 'ETRACS ALERIAN MDSTR ENER TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMTX',
    Issuer: 'AEMETIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMUB',
    Issuer: 'ETRACS ALERIAN MLP IND SER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMWD',
    Issuer: 'AMERICAN WOODMARK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMWL',
    Issuer: 'AMERICAN WELL CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMX',
    Issuer: 'AMERICA MOVIL-SPN ADR CL L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMYT',
    Issuer: 'AMRYT PHARMA PLC - SPNR ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMZA',
    Issuer: 'INFRACAP MLP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AMZN',
    Issuer: 'AMAZON.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AN',
    Issuer: 'AUTONATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANAB',
    Issuer: 'ANAPTYSBIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANAC',
    Issuer: 'ARCTOS NORTHSTAR ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANAC=',
    Issuer: 'ARCTOS NORTHSTAR ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANDE',
    Issuer: 'ANDERSONS INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANEB',
    Issuer: 'ANEBULO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANET',
    Issuer: 'ARISTA NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANEW',
    Issuer: 'PROSHARES MSCI TRANSFORM CHG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANF',
    Issuer: 'ABERCROMBIE & FITCH CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGH',
    Issuer: 'ANGHAMI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGI',
    Issuer: 'ANGI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGL',
    Issuer: 'VANECK FALLEN ANGEL HIGH YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGN',
    Issuer: 'ANGION BIOMEDICA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANGO',
    Issuer: 'ANGIODYNAMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANIK',
    Issuer: 'ANIKA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANIP',
    Issuer: 'ANI PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANIX',
    Issuer: 'ANIXA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANNX',
    Issuer: 'ANNEXON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANPC',
    Issuer: 'ANPAC BIO-MEDICAL SCIENC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANSS',
    Issuer: 'ANSYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANTE',
    Issuer: 'AIRNET TECHNOLOGY INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANTM',
    Issuer: 'ANTHEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANTX',
    Issuer: 'AN2 THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANVS',
    Issuer: 'ANNOVIS BIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANY',
    Issuer: 'SPHERE 3D CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANZU',
    Issuer: 'ANZU SPECIAL ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANZUU',
    Issuer: 'ANZU SPECIAL ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ANZUW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOA',
    Issuer: 'ISHARES CORE AGGRESSIVE ALLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOD',
    Issuer: 'ABERDEEN TTL DYN DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOGO',
    Issuer: 'AROGO CAPITAL ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOGOU',
    Issuer: 'AROGO CAPITAL ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOGOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOK',
    Issuer: 'ISHARES CORE CONSERVATIVE AL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOM',
    Issuer: 'ISHARES CORE MODERATE ALLOCA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOMR',
    Issuer: 'ANGEL OAK MORTGAGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AON',
    Issuer: 'AON PLC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOR',
    Issuer: 'ISHARES CORE GROWTH ALLOCATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AORT',
    Issuer: 'ARTIVION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOS',
    Issuer: 'SMITH (A.O.) CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOSL',
    Issuer: 'ALPHA & OMEGA SEMICONDUCTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AOUT',
    Issuer: 'AMERICAN OUTDOOR BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AP',
    Issuer: 'AMPCO-PITTSBURGH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APA',
    Issuer: 'APA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APAC',
    Issuer: 'STONEBRIDGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APACU',
    Issuer: 'STONEBRIDGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APAM',
    Issuer: 'ARTISAN PARTNERS ASSET MA -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APCA',
    Issuer: 'AP ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APCA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APCA=',
    Issuer: 'AP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APCX',
    Issuer: 'APPTECH PAYMENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APCXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APD',
    Issuer: 'AIR PRODUCTS & CHEMICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APDN',
    Issuer: 'APPLIED DNA SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APEI',
    Issuer: 'AMERICAN PUBLIC EDUCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APEN',
    Issuer: 'APOLLO ENDOSURGERY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APG',
    Issuer: 'API GROUP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APGB',
    Issuer: 'APOLLO STRATEGIC GROWTH-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APGB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APGB=',
    Issuer: 'APOLLO STRATEGIC GROWTH CAPI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APH',
    Issuer: 'AMPHENOL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'API',
    Issuer: 'AGORA INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APLD',
    Issuer: 'APPLIED BLOCKCHAIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APLE',
    Issuer: 'APPLE HOSPITALITY REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APLS',
    Issuer: 'APELLIS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APLT',
    Issuer: 'APPLIED THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APM',
    Issuer: 'APTORUM GROUP LTD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APMI',
    Issuer: 'AXONPRIME INFRASTRUCTURE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APMIU',
    Issuer: 'AXON INFRASTRUCTURE ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APMIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APN',
    Issuer: 'APEIRON CAPITAL INVESTMENT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APN=',
    Issuer: 'APEIRON CAPITAL INVESTMENT C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APO',
    Issuer: 'APOLLO GLOBAL MANAGEMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APOG',
    Issuer: 'APOGEE ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APP',
    Issuer: 'APPLOVIN CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APPF',
    Issuer: 'APPFOLIO INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APPH',
    Issuer: 'APPHARVEST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APPHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APPN',
    Issuer: 'APPIAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APPS',
    Issuer: 'DIGITAL TURBINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APRE',
    Issuer: 'APREA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APRN',
    Issuer: 'BLUE APRON HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APRZ',
    Issuer: 'TRUESHARES STR OUTCOME APRIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APSG',
    Issuer: 'APOLLO STRATEGIC GROWTH-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APSG+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APSG=',
    Issuer: 'APOLLO STRATEGIC GROWTH CAPI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APT',
    Issuer: 'ALPHA PRO TECH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTM',
    Issuer: 'ALPHA PARTNERS TECHNOLOGY-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTMU',
    Issuer: 'ALPHA PARTNERS TECHNOLOGY ME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTO',
    Issuer: 'APTOSE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTS',
    Issuer: 'PREFERRED APARTMENT COMMUNIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTV',
    Issuer: 'APTIV PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTV-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APTX',
    Issuer: 'APTINYX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APVO',
    Issuer: 'APTEVO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APWC',
    Issuer: 'ASIA PACIFIC WIRE & CABLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APXH',
    Issuer: 'APEX HEALTHCARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APXI',
    Issuer: 'APX ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APXIU',
    Issuer: 'APX ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APXIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'APYX',
    Issuer: 'APYX MEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQB',
    Issuer: 'AQUABOUNTY TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQGX',
    Issuer: 'AI QUALITY GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQMS',
    Issuer: 'AQUA METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQN',
    Issuer: 'ALGONQUIN POWER & UTILITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQNA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQNB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQNU',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQST',
    Issuer: 'AQUESTIVE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQUA',
    Issuer: 'EVOQUA WATER TECHNOLOGIES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AQWA',
    Issuer: 'GLOBAL X CLEAN WATER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AR',
    Issuer: 'ANTERO RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARAV',
    Issuer: 'ARAVIVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARAY',
    Issuer: 'ACCURAY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARB',
    Issuer: 'ALTSHARES MERGER ARBITRAGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBE',
    Issuer: 'ARBE ROBOTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBG',
    Issuer: 'AEQUI ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBGU',
    Issuer: 'AEQUI ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBK',
    Issuer: 'ARGO BLOCKCHAIN PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARBKL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARC',
    Issuer: 'ARC DOCUMENT SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCB',
    Issuer: 'ARCBEST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCC',
    Issuer: 'ARES CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCE',
    Issuer: 'ARCO PLATFORM LTD - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCH',
    Issuer: 'ARCH RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCK',
    Issuer: 'ARBOR RAPHA CAPITAL BIOHOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCKU',
    Issuer: 'ARBOR RAPHA CAPITAL BIOHOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCM',
    Issuer: 'ARROW RESERVE CAP MANAG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCO',
    Issuer: 'ARCOS DORADOS HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARCT',
    Issuer: 'ARCTURUS THERAPEUTICS HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARDC',
    Issuer: 'ARES DYNAMIC CREDIT ALLOCATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARDS',
    Issuer: 'ARIDIS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARDX',
    Issuer: 'ARDELYX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARE',
    Issuer: 'ALEXANDRIA REAL ESTATE EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AREB',
    Issuer: 'AMERICAN REBEL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AREBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AREC',
    Issuer: 'AMERICAN RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AREN',
    Issuer: 'ARENA GROUP HOLDINGS INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARES',
    Issuer: 'ARES MANAGEMENT CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGO',
    Issuer: 'ARGO GROUP INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGT',
    Issuer: 'GLOBAL X MSCI ARGENTINA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGU',
    Issuer: 'ARGUS CAPITAL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGUU',
    Issuer: 'ARGUS CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGUW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARGX',
    Issuer: 'ARGENX SE - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARHS',
    Issuer: 'ARHAUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARI',
    Issuer: 'APOLLO COMMERCIAL REAL ESTAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARIS',
    Issuer: 'ARIS WATER SOLUTION INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARIZ',
    Issuer: 'ARISZ ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARIZR',
    Issuer: 'ARISZ ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARIZU',
    Issuer: 'ARISZ ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARIZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKF',
    Issuer: 'ARK FINTECH INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKG',
    Issuer: 'ARK GENOMIC REVOLUTION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKK',
    Issuer: 'ARK INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKO',
    Issuer: 'ARKO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKQ',
    Issuer: 'ARK AUTONOMOUS TECH & ROBOT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKR',
    Issuer: 'ARK RESTAURANTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKW',
    Issuer: 'ARK NEXT GENERATION INTERNET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARKX',
    Issuer: 'ARK SPACE EXPLORATION & INNO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARL',
    Issuer: 'AMERICAN REALTY INVESTORS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARLO',
    Issuer: 'ARLO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARLP',
    Issuer: 'ALLIANCE RESOURCE PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARMK',
    Issuer: 'ARAMARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARMP',
    Issuer: 'ARMATA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARMR',
    Issuer: 'ARMOR US EQUITY INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARNC',
    Issuer: 'ARCONIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AROC',
    Issuer: 'ARCHROCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AROW',
    Issuer: 'ARROW FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARQQ',
    Issuer: 'ARQIT QUANTUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARQQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARQT',
    Issuer: 'ARCUTIS BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARR',
    Issuer: 'ARMOUR RESIDENTIAL REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARRW',
    Issuer: 'ARROWROOT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARRWU',
    Issuer: 'ARROWROOT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARRWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARRY',
    Issuer: 'ARRAY TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTE',
    Issuer: 'ARTEMIS STRATEGIC INVES-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTEU',
    Issuer: 'ARTEMIS STRATEGIC INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTL',
    Issuer: 'ARTELO BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTNA',
    Issuer: 'ARTESIAN RESOURCES CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARTW',
    Issuer: "ART'S-WAY MANUFACTURING CO",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARVL',
    Issuer: 'ARRIVAL SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARVN',
    Issuer: 'ARVINAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARVR',
    Issuer: 'FIRST TRUST INDXX METAVERSE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARW',
    Issuer: 'ARROW ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARWR',
    Issuer: 'ARROWHEAD PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARYD',
    Issuer: 'ARYA SCIENCES ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ARYE',
    Issuer: 'ARYA SCIENCES ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASA',
    Issuer: 'ASA GOLD AND PRECIOUS METALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAI',
    Issuer: 'SENDAS DISTRIBUIDORA SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAN',
    Issuer: 'ASANA INC - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAQ',
    Issuer: 'ATLANTIC AVENUE ACQUISI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAQ=',
    Issuer: 'ATLANTIC AVENUE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAX',
    Issuer: 'ASTREA ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAXU',
    Issuer: 'ASTREA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASB',
    Issuer: 'ASSOCIATED BANC-CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASB-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASB-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASC',
    Issuer: 'ARDMORE SHIPPING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASCA',
    Issuer: 'A SPAC I ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASCAR',
    Issuer: 'A SPAC I ACQUISITION CO-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASCAU',
    Issuer: 'A SPAC I ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASCBU',
    Issuer: 'A SPAC II ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASEA',
    Issuer: 'GLOBAL X FTSE SOUTHEAST ASIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASET',
    Issuer: 'FLEXSHARES REAL ASSETS FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASG',
    Issuer: 'LIBERTY ALL-STAR GROWTH FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASGI',
    Issuer: 'ABERDEEN STNDRD GLBL INFRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASGN',
    Issuer: 'ASGN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASH',
    Issuer: 'ASHLAND GLOBAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASHR',
    Issuer: 'XTRACKERS HARVEST CSI 300 CH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASHS',
    Issuer: 'XTRACKERS HARVEST CSI 500 CH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASHX',
    Issuer: 'XTRACKERS MSCI CHINA A INCLU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASIX',
    Issuer: 'ADVANSIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASLE',
    Issuer: 'AERSALE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASLN',
    Issuer: 'ASLAN PHARMACEUTICALS LT-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASM',
    Issuer: 'AVINO SILVER & GOLD MINES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASMB',
    Issuer: 'ASSEMBLY BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASML',
    Issuer: 'ASML HOLDING NV-NY REG SHS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASND',
    Issuer: 'ASCENDIS PHARMA A/S - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASNS',
    Issuer: 'ACTELIS NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASO',
    Issuer: 'ACADEMY SPORTS & OUTDOORS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPA',
    Issuer: 'ABRI SPAC I INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPAU',
    Issuer: 'ABRI SPAC I INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPC',
    Issuer: 'ALPHA CAPITAL ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPCU',
    Issuer: 'ALPHA CAPITAL ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPN',
    Issuer: 'ASPEN AEROGELS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPPU',
    Issuer: 'ABRI SPAC 2 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPS',
    Issuer: 'ALTISOURCE PORTFOLIO SOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPU',
    Issuer: 'ASPEN GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASPY',
    Issuer: 'ASYMMETRIC S&P 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASR',
    Issuer: 'GRUPO AEROPORTUARIO SUR-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASRT',
    Issuer: 'ASSERTIO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASRV',
    Issuer: 'AMERISERV FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTC',
    Issuer: 'ASTROTECH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTE',
    Issuer: 'ASTEC INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTL',
    Issuer: 'ALGOMA STEEL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTR',
    Issuer: 'ASTRA SPACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTS',
    Issuer: 'AST SPACEMOBILE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASUR',
    Issuer: 'ASURE SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASX',
    Issuer: 'ASE TECHNOLOGY HOLDING -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASXC',
    Issuer: 'ASENSUS SURGICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASYS',
    Issuer: 'AMTECH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASZ',
    Issuer: 'AUSTERLITZ ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASZ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ASZ=',
    Issuer: 'AUSTERLITZ ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATA',
    Issuer: 'AMERICAS TECHNOLOGY ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATA=',
    Issuer: 'AMERICAS TECHNOLOGY ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAI',
    Issuer: 'ATAI LIFE SCIENCES NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAK',
    Issuer: 'AURORA TECHNOLOGY ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAKR',
    Issuer: 'AURORA TECHNOLOGY ACQUISI-R',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAKU',
    Issuer: 'AURORA TECHNOLOGY ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAQ',
    Issuer: 'ALTIMAR ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAQ=',
    Issuer: 'ALTIMAR ACQUISITION CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATAX',
    Issuer: 'AMERICA FIRST MULTIFAMILY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATC',
    Issuer: 'ATOTECH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCO',
    Issuer: 'ATLAS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCO-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCO-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCO-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCOL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATCX',
    Issuer: 'ATLAS TECHNICAL CONSULTANTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEC',
    Issuer: 'ALPHATEC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEK',
    Issuer: 'ATHENA TECHNOLOGY ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEK+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEK=',
    Issuer: 'ATHENA TECHNOLOGY ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEN',
    Issuer: 'A10 NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATER',
    Issuer: 'ATERIAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATEX',
    Issuer: 'ANTERIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATFV',
    Issuer: 'ALGER 35 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATGE',
    Issuer: 'ADTALEM GLOBAL EDUCATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATH-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATH-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATH-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATHA',
    Issuer: 'ATHIRA PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATHE',
    Issuer: 'ALTERITY THERAPEUTICS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATHM',
    Issuer: 'AUTOHOME INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATHX',
    Issuer: 'ATHERSYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATI',
    Issuer: 'ALLEGHENY TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATIF',
    Issuer: 'ATIF HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATIP',
    Issuer: 'ATI PHYSICAL THERAPY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATIP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATKR',
    Issuer: 'ATKORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATLC',
    Issuer: 'ATLANTICUS HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATLCL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATLCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATLO',
    Issuer: 'AMES NATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATMP',
    Issuer: 'IPATH SELECT MLP ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATNF',
    Issuer: '180 LIFE SCIENCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATNFW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATNI',
    Issuer: 'ATN INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATNM',
    Issuer: 'ACTINIUM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATNX',
    Issuer: 'ATHENEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATO',
    Issuer: 'ATMOS ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATOM',
    Issuer: 'ATOMERA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATOS',
    Issuer: 'ATOSSA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATR',
    Issuer: 'APTARGROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATRA',
    Issuer: 'ATARA BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATRC',
    Issuer: 'ATRICURE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATRI',
    Issuer: 'ATRION CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATRO',
    Issuer: 'ASTRONICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATSG',
    Issuer: 'AIR TRANSPORT SERVICES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATTO',
    Issuer: 'ATENTO SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATUS',
    Issuer: 'ALTICE USA INC- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATVC',
    Issuer: 'TRIBE CAPITAL GROWTH CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATVCU',
    Issuer: 'TRIBE CAPITAL GROWTH CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATVCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATVI',
    Issuer: 'ACTIVISION BLIZZARD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATXI',
    Issuer: 'AVENUE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATXS',
    Issuer: 'ASTRIA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ATY',
    Issuer: 'ACUITYADS HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AU',
    Issuer: 'ANGLOGOLD ASHANTI-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUB',
    Issuer: 'ATLANTIC UNION BANKSHARES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUBAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUBN',
    Issuer: 'AUBURN NATL BANCORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUD',
    Issuer: 'AUDACY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUDC',
    Issuer: 'AUDIOCODES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUGX',
    Issuer: 'AUGMEDIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUGZ',
    Issuer: 'TRUESHARES STRUC OUT AUG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUID',
    Issuer: 'IPSIDY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUMN',
    Issuer: 'GOLDEN MINERALS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUPH',
    Issuer: 'AURINIA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUR',
    Issuer: 'AURORA INNOVATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AURA',
    Issuer: 'AURA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AURC',
    Issuer: 'AURORA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AURCU',
    Issuer: 'AURORA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AURCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUROW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUS',
    Issuer: 'AUSTERLITZ ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUS=',
    Issuer: 'AUSTERLITZ ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUSF',
    Issuer: 'GLOBAL X ADAPTIVE US FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUST',
    Issuer: 'AUSTIN GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUTL',
    Issuer: 'AUTOLUS THERAPEUTICS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUTO',
    Issuer: 'AUTOWEB INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUUD',
    Issuer: 'AUDDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUUDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUVI',
    Issuer: 'APPLIED UV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUVIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AUY',
    Issuer: 'YAMANA GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVA',
    Issuer: 'AVISTA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAC',
    Issuer: 'AVALON ACQUISITION INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVACU',
    Issuer: 'AVALON ACQUISITION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAH',
    Issuer: 'AVEANNA HEALTHCARE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAL',
    Issuer: 'GRUPO AVAL ACCIONES Y VALORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAN',
    Issuer: 'AVANTI ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAN=',
    Issuer: 'AVANTI ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVAV',
    Issuer: 'AEROVIRONMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVB',
    Issuer: 'AVALONBAY COMMUNITIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVCO',
    Issuer: 'AVALON GLOBOCARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVCT',
    Issuer: 'AMERICAN VIRTUAL CLOUD TECHN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVCTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVD',
    Issuer: 'AMERICAN VANGUARD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDE',
    Issuer: 'AVANTIS INTERNATIONAL EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDG',
    Issuer: 'AVDR US LARGECAP ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDL',
    Issuer: 'AVADEL PHARMACEUTICALS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDR',
    Issuer: 'AVDR US LARGECAP LEADING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDV',
    Issuer: 'AVANTIS INTL S/C VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVDX',
    Issuer: 'AVIDXCHANGE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVEM',
    Issuer: 'AVANTIS EMERGING MARKETS EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVEO',
    Issuer: 'AVEO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVES',
    Issuer: 'AVANTIS EMERGING MARKETS VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVGO',
    Issuer: 'BROADCOM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVGOP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVGR',
    Issuer: 'AVINGER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVHI',
    Issuer: 'ACHARI VENTURES HOLDINGS COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVHIU',
    Issuer: 'ACHARI VENTURES HOLDINGS COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVHIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVID',
    Issuer: 'AVID TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVIG',
    Issuer: 'AVANTIS CORE FIXED INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVIR',
    Issuer: 'ATEA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVIV',
    Issuer: 'AVANTIS INT LRG CAP VAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVK',
    Issuer: 'ADVENT CONVERT & INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVLR',
    Issuer: 'AVALARA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVLV',
    Issuer: 'AVANTIS US LARGE CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVMU',
    Issuer: 'AVANTIS CORE MUNICIPAL FIXED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVNS',
    Issuer: 'AVANOS MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVNT',
    Issuer: 'AVIENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVNW',
    Issuer: 'AVIAT NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVO',
    Issuer: 'MISSION PRODUCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVPT',
    Issuer: 'AVEPOINT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVPTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVRE',
    Issuer: 'AVANTIS REAL ESTATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVRO',
    Issuer: 'AVROBIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVSC',
    Issuer: 'AVANTIS US SMALL CAP EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVSD',
    Issuer: 'AVANTIS REPS INTERN EQUI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVSE',
    Issuer: 'AVANTIS RESP EMERG MKTS EQ-E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVSF',
    Issuer: 'AVANTIS SHORT-TERM FIXED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVSU',
    Issuer: 'AVANTIS RESP US EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVT',
    Issuer: 'AVNET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVTE',
    Issuer: 'AEROVATE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVTR',
    Issuer: 'AVANTOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVTX',
    Issuer: 'AVALO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVUS',
    Issuer: 'AVANTIS U.S. EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVUV',
    Issuer: 'AVANTIS US SMALL CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVXL',
    Issuer: 'ANAVEX LIFE SCIENCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVY',
    Issuer: 'AVERY DENNISON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AVYA',
    Issuer: 'AVAYA HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWAY',
    Issuer: 'ETFMG TRAVEL TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWF',
    Issuer: 'ALLIANCEBERNSTEIN GL HI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWH',
    Issuer: "ASPIRA WOMEN'S HEALTH INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWI',
    Issuer: 'ARMSTRONG WORLD INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWK',
    Issuer: 'AMERICAN WATER WORKS CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWP',
    Issuer: 'ABERDEEN GLBL PREM PROP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWR',
    Issuer: 'AMERICAN STATES WATER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWRE',
    Issuer: 'AWARE INC/MASS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWTM',
    Issuer: 'NATIONAL INVESTMENT SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWX',
    Issuer: 'AVALON HOLDINGS CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AWYX',
    Issuer: 'ETFMG 2X DAILY TRAVEL TECH E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AX',
    Issuer: 'AXOS FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXAC',
    Issuer: 'AXIOS SUSTAINABLE GROWTH A-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXAC^',
    Issuer: 'AXIOS SUSTAINABLE GROWTH-RGT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXDX',
    Issuer: 'ACCELERATE DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXGN',
    Issuer: 'AXOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXH',
    Issuer: 'INDUSTRIAL HUMAN CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXH=',
    Issuer: 'INDUSTRIAL HUMAN CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXL',
    Issuer: 'AMERICAN AXLE & MFG HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXLA',
    Issuer: 'AXCELLA HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXNX',
    Issuer: 'AXONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXON',
    Issuer: 'AXON ENTERPRISE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXP',
    Issuer: 'AMERICAN EXPRESS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXR',
    Issuer: 'AMREP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXS',
    Issuer: 'AXIS CAPITAL HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXS-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXSM',
    Issuer: 'AXSOME THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXTA',
    Issuer: 'AXALTA COATING SYSTEMS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXTI',
    Issuer: 'AXT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AXU',
    Issuer: 'ALEXCO RESOURCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AY',
    Issuer: 'ATLANTICA SUSTAINABLE INFRAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AYI',
    Issuer: 'ACUITY BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AYLA',
    Issuer: 'AYALA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AYRO',
    Issuer: 'AYRO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AYTU',
    Issuer: 'AYTU BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AYX',
    Issuer: 'ALTERYX INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZ',
    Issuer: 'A2Z SMART TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZAA',
    Issuer: 'ALLIANZIM US LG CAP BUFFER10',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZAJ',
    Issuer: 'ALLIANZ US LRG CAP BUFF10 JA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZAL',
    Issuer: 'ALLIANZIM US LRG CAP BU10 JU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZAO',
    Issuer: 'ALLIANZIM US LARGE CAP BUFFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZBA',
    Issuer: 'ALLIANZIM US LG CAP BUFFER20',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZBJ',
    Issuer: 'ALLIANZIM US LRG CAP BUFF20',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZBL',
    Issuer: 'ALLIANZIM US LRG CAP BU 20 J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZBO',
    Issuer: 'ALLIANZIM US LARGE CAP BUFFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZEK',
    Issuer: 'AZEK CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZN',
    Issuer: 'ASTRAZENECA PLC-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZO',
    Issuer: 'AUTOZONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZPN',
    Issuer: 'ASPEN TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZRE',
    Issuer: 'AZURE POWER GLOBAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZTA',
    Issuer: 'AZENTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZUL',
    Issuer: 'AZUL SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZYO',
    Issuer: 'AZIYO BIOLOGICS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'AZZ',
    Issuer: 'AZZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'B',
    Issuer: 'BARNES GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BA',
    Issuer: 'BOEING CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAB',
    Issuer: 'INVESCO TAXABLE MUNICIPAL BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BABA',
    Issuer: 'ALIBABA GROUP HOLDING-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC',
    Issuer: 'BANK OF AMERICA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-P',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAC-S',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BACA',
    Issuer: 'BERENSON ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BACA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BACA=',
    Issuer: 'BERENSON ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAD',
    Issuer: 'BAD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAFN',
    Issuer: 'BAYFIRST FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAH',
    Issuer: 'BOOZ ALLEN HAMILTON HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAK',
    Issuer: 'BRASKEM SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAL',
    Issuer: 'IPATHR SERIES B BLOOMBERG CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BALL',
    Issuer: 'BALL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BALT',
    Issuer: 'INN DEFINED WEALTH SHIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BALY',
    Issuer: "BALLY'S CORP",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAM',
    Issuer: 'BROOKFIELD ASSET MANAGE-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAMH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAMI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAMR',
    Issuer: 'BROOKFIELD ASSET MANAGEMEN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BANC',
    Issuer: 'BANC OF CALIFORNIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAND',
    Issuer: 'BANDWIDTH INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BANF',
    Issuer: 'BANCFIRST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BANFP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BANR',
    Issuer: 'BANNER CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BANX',
    Issuer: 'ARROWMARK FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAOS',
    Issuer: 'BAOSHENG MEDIA GROUP HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAP',
    Issuer: 'CREDICORP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAPR',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAR',
    Issuer: 'GRANITESHARES GOLD TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BARK',
    Issuer: 'BARK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BARK+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BASE',
    Issuer: 'COUCHBASE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BATL',
    Issuer: 'BATTALION OIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BATRA',
    Issuer: 'LIBERTY MEDIA CORP-BRAVES A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BATRK',
    Issuer: 'LIBERTY MEDIA CORP-BRAVES C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BATT',
    Issuer: 'AMPLIFY LITHIUM BATTERY TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAUG',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BAX',
    Issuer: 'BAXTER INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BB',
    Issuer: 'BLACKBERRY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBAI',
    Issuer: 'BIGBEAR.AI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBAI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBAR',
    Issuer: 'BBVA ARGENTINA SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBAX',
    Issuer: 'JPMORGAN BETABUILDERS DEVELO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBBY',
    Issuer: 'BED BATH & BEYOND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBC',
    Issuer: 'VIRTUS LIFESCI BIOTECH CLINI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBCA',
    Issuer: 'JPMORGAN BETABUILDERS CANADA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBCP',
    Issuer: 'CONCRETE PUMPING HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBD',
    Issuer: 'BANCO BRADESCO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBDC',
    Issuer: 'BARINGS BDC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBDO',
    Issuer: 'BANCO BRADESCO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBEU',
    Issuer: 'JPMORGAN BETABUILDERS EUROPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBGI',
    Issuer: 'BEASLEY BROADCAST GRP INC -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBH',
    Issuer: 'VANECK BIOTECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBI',
    Issuer: 'BRICKELL BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBIG',
    Issuer: 'VINCO VENTURES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBIGV',
    Issuer: 'VINCO VENTURES INC - W/I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBIN',
    Issuer: 'JPM BETABUILDERS INTL EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBIO',
    Issuer: 'BRIDGEBIO PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBJP',
    Issuer: 'JPMORGAN BETABUILDERS JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBLG',
    Issuer: 'BONE BIOLOGICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBLGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBLN',
    Issuer: 'BABYLON HOLDINGS LTD- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBLN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBMC',
    Issuer: 'JPM BETABUILDERS US MID CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBN',
    Issuer: 'BLACKROCK TAXABLE MUNICIPAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBP',
    Issuer: 'VIRTUS LIFESCI BIOTECH PRODU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBQ',
    Issuer: 'BBQ HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBRE',
    Issuer: 'JPM BETABLDRS MSCI US REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBSA',
    Issuer: 'JPMORGAN BETABUILDERS 1-5 YR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBSC',
    Issuer: 'JPMORGAN BETABUILDERS US SC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBSI',
    Issuer: 'BARRETT BUSINESS SVCS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBU',
    Issuer: 'BROOKFIELD BUSINESS PT-UNIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBUC',
    Issuer: 'BROOKFIELD BUSINESS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBUS',
    Issuer: 'JPMORGAN BETABUILDERS US EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBVA',
    Issuer: 'BANCO BILBAO VIZCAYA-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBW',
    Issuer: 'BUILD-A-BEAR WORKSHOP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBWI',
    Issuer: 'BATH & BODY WORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BBY',
    Issuer: 'BEST BUY CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BC',
    Issuer: 'BRUNSWICK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BC-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BC-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCAB',
    Issuer: 'BIOATLA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCAC',
    Issuer: 'BROOKLINE CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCACU',
    Issuer: 'BROOKLINE CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCAT',
    Issuer: 'BLACKROCK CAPITAL ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCBP',
    Issuer: 'BCB BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCC',
    Issuer: 'BOISE CASCADE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCD',
    Issuer: 'ABRDN BLOOMBERG ALL COMMODIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCDA',
    Issuer: 'BIOCARDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCDAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCE',
    Issuer: 'BCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCEL',
    Issuer: 'ATRECA INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCH',
    Issuer: 'BANCO DE CHILE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCI',
    Issuer: 'ABRDN BLOOMBERG ALL COMMODIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCIM',
    Issuer: 'ABRDN BLOOMBERG INDUSTRIAL M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCLI',
    Issuer: 'BRAINSTORM CELL THERAPEUTICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCM',
    Issuer: 'IPATH PURE BETA BROAD CMDTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCML',
    Issuer: 'BAYCOM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCO',
    Issuer: "BRINK'S CO/THE",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCOR',
    Issuer: 'BLUCORA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCOV',
    Issuer: 'BRIGHTCOVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCOW',
    Issuer: '1895 BANCORP OF WISCONSIN IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCPC',
    Issuer: 'BALCHEM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCRX',
    Issuer: 'BIOCRYST PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCS',
    Issuer: 'BARCLAYS PLC-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCSA',
    Issuer: 'BLOCKCHAIN COINVESTORS -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCSAU',
    Issuer: 'BLOCKCHAIN COINVESTORS ACQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCSF',
    Issuer: 'BAIN CAPITAL SPECIALTY FINAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCTX',
    Issuer: 'BRIACELL THERAPEUTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCTXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCV',
    Issuer: 'BANCROFT FUND LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCV-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCX',
    Issuer: 'BLACKROCK RESOURCES & COMMOD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BCYC',
    Issuer: 'BICYCLE THERAPEUTICS PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDC',
    Issuer: 'BELDEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDCX',
    Issuer: 'ETRACS QRT 1.5 LEV BDC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDCZ',
    Issuer: 'ETRACS MVIS BUSINESS DEVELOP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDEC',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDJ',
    Issuer: 'BLACKROCK ENHANCED EQTY DVD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDL',
    Issuer: "FLANIGAN'S ENTERPRISES INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDN',
    Issuer: 'BRANDYWINE REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDR',
    Issuer: 'BLONDER TONGUE LABORATORIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDRY',
    Issuer: 'BREAKWAVE DRY BULK SHIPPING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDSX',
    Issuer: 'BIODESIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDTX',
    Issuer: 'BLACK DIAMOND THERAPEUTICS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDX',
    Issuer: 'BECTON DICKINSON AND CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BDXB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BE',
    Issuer: 'BLOOM ENERGY CORP- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEAM',
    Issuer: 'BEAM THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEAT',
    Issuer: 'HEARTBEAM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEATW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BECN',
    Issuer: 'BEACON ROOFING SUPPLY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BECO',
    Issuer: 'BLACKROCK FUTURE CLIMATE AND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEDU',
    Issuer: 'BRIGHT SCHOLAR EDUCATION-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEDZ',
    Issuer: 'ADVISORSHARES HOTEL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEEM',
    Issuer: 'BEAM GLOBAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEEMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEKE',
    Issuer: 'KE HOLDINGS INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BELFA',
    Issuer: 'BEL FUSE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BELFB',
    Issuer: 'BEL FUSE INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEN',
    Issuer: 'FRANKLIN RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BENE',
    Issuer: 'BENESSERE CAPITAL ACQUI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BENER',
    Issuer: 'BENESSERE CAPITAL ACQUI-RGT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BENEU',
    Issuer: 'BENESSERE CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BENEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEP',
    Issuer: 'BROOKFIELD RENEWABLE PARTNER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEPC',
    Issuer: 'BROOKFIELD RENEWABLE COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEPH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEPI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BERY',
    Issuer: 'BERRY GLOBAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BERZ',
    Issuer: 'MICROSECTORS FANG & INN -3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BEST',
    Issuer: 'BEST INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BETZ',
    Issuer: 'ROUNDHILL SPORTS BET & IGAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BF.A',
    Issuer: 'BROWN-FORMAN CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BF.B',
    Issuer: 'BROWN-FORMAN CORP-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFAC',
    Issuer: 'BATTERY FUTURE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFAC=',
    Issuer: 'BATTERY FUTURE ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFAM',
    Issuer: 'BRIGHT HORIZONS FAMILY SOLUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFC',
    Issuer: 'BANK FIRST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFEB',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFH',
    Issuer: 'BREAD FINANCIAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFI',
    Issuer: 'BURGERFI INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFIN',
    Issuer: 'BANKFINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFIT',
    Issuer: 'GLB X HEALTH & WELLNESS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFIX',
    Issuer: 'BUILD BOND INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFK',
    Issuer: 'BLACKROCK MUNICIPAL INC TRST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFLY',
    Issuer: 'BUTTERFLY NETWORK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFLY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFOR',
    Issuer: "BARRON'S 400 ETF",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFRI',
    Issuer: 'BIOFRONTERA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFRIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFS',
    Issuer: 'SAUL CENTERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFS-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFS-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFST',
    Issuer: 'BUSINESS FIRST BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFTR',
    Issuer: 'BLACKROCK FUTURE INNOVATORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BFZ',
    Issuer: 'BLACKROCK CALIFOR MUNI IN TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BG',
    Issuer: 'BUNGE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGB',
    Issuer: 'BLACKSTONE STRATEGIC CREDIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGCP',
    Issuer: 'BGC PARTNERS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGFV',
    Issuer: 'BIG 5 SPORTING GOODS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGH',
    Issuer: 'BARINGS GL SH DUR HI YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGI',
    Issuer: 'BIRKS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGLD',
    Issuer: 'FT CBOE VEST GOLD STR QRT B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGNE',
    Issuer: 'BEIGENE LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGR',
    Issuer: 'BLACKROCK ENRGY & RES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGRN',
    Issuer: 'ISHARES USD GREEN BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGRY',
    Issuer: 'BERKSHIRE GREY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGRYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGS',
    Issuer: 'B&G FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGSF',
    Issuer: 'BGSF INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGSX',
    Issuer: 'BUILD ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGSX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGSX=',
    Issuer: 'BUILD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGT',
    Issuer: 'BLACKROCK FLT RT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGX',
    Issuer: 'BLACKSTONE LONG-SHORT CREDIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGXX',
    Issuer: 'BRIGHT GREEN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BGY',
    Issuer: 'BLACKROCK ENHANCED INTERNATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BH',
    Issuer: 'BIGLARI HOLDINGS INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BH.A',
    Issuer: 'BIGLARI HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHAC',
    Issuer: 'CRIXUS BH3 ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHACU',
    Issuer: 'CRIXUS BH3 ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHAT',
    Issuer: 'BLUE HAT INTERACTIVE ENTERTA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHB',
    Issuer: 'BAR HARBOR BANKSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHC',
    Issuer: 'BAUSCH HEALTH COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHE',
    Issuer: 'BENCHMARK ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHF',
    Issuer: 'BRIGHTHOUSE FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHFAL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHFAM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHFAN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHFAO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHFAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHG',
    Issuer: 'BRIGHT HEALTH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHIL',
    Issuer: 'BENSON HILL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHIL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHK',
    Issuer: 'BLACKROCK CORE BOND TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHLB',
    Issuer: 'BERKSHIRE HILLS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHP',
    Issuer: 'BHP GROUP LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHR',
    Issuer: 'BRAEMAR HOTELS & RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHR-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHSE',
    Issuer: 'BULL HORN HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHSEU',
    Issuer: 'BULL HORN HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHSEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHV',
    Issuer: 'BLACKROCK VIRGINIA MUNI BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BHVN',
    Issuer: 'BIOHAVEN PHARMACEUTICAL HOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIB',
    Issuer: 'PROSHARES ULTRA NASD BIOTECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIBL',
    Issuer: 'INSPIRE 100 ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BICK',
    Issuer: 'FIRST TRUST BICK INDEX FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIDS',
    Issuer: 'AMPLIFY DIGITAL & ONLINE TRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIDU',
    Issuer: 'BAIDU INC - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIG',
    Issuer: 'BIG LOTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIGC',
    Issuer: 'BIGCOMMERCE HOLDINGS-SER 1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIGZ',
    Issuer: 'BLACKROCK INNOV & GROW TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIIB',
    Issuer: 'BIOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIL',
    Issuer: 'SPDR BLOOMBERG 1-3 MONTH T-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BILI',
    Issuer: 'BILIBILI INC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BILL',
    Issuer: 'BILL.COM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BILS',
    Issuer: 'SPDR BLOOMBERG 3-12 MONTH T-',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIMI',
    Issuer: 'BIMI INTERNATIONAL MEDICAL I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIO',
    Issuer: 'BIO-RAD LABORATORIES-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIO.B',
    Issuer: 'BIO-RAD LABORATORIES -CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOC',
    Issuer: 'BIOCEPT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOL',
    Issuer: 'BIOLASE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOR',
    Issuer: 'BIORA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOS',
    Issuer: 'BIOPLUS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOSU',
    Issuer: 'BIOPLUS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOT',
    Issuer: 'BIOTECH ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOTU',
    Issuer: 'BIOTECH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIOX',
    Issuer: 'BIOCERES CROP SOLUTIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIP',
    Issuer: 'BROOKFIELD INFRASTRUCTURE PA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIP-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIPC',
    Issuer: 'BROOKFIELD INFRASTRUCTURE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIPH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIPI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIRD',
    Issuer: 'ALLBIRDS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIS',
    Issuer: 'PROSHARES ULTRASHORT NAS BIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIT',
    Issuer: 'BLACKROCK MULTI-SECTOR INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITE',
    Issuer: 'BITE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITE=',
    Issuer: 'BITE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITF',
    Issuer: 'BITFARMS LTD/CANADA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITO',
    Issuer: 'PROSHARES BITCOIN STRATEGY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITQ',
    Issuer: 'BITWISE CRYPTO IND INNOV ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BITS',
    Issuer: 'GLOBAL X BLOCK & BIT STRAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIV',
    Issuer: 'VANGUARD INTERMEDIATE-TERM B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIVI',
    Issuer: 'BIOVIE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BIZD',
    Issuer: 'VANECK BDC INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJ',
    Issuer: "BJ'S WHOLESALE CLUB HOLDINGS",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJAN',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJDX',
    Issuer: 'BLUEJAY DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJK',
    Issuer: 'VANECK GAMING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJRI',
    Issuer: "BJ'S RESTAURANTS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJUL',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BJUN',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BK',
    Issuer: 'BANK OF NEW YORK MELLON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKAG',
    Issuer: 'BNY MELLON CORE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKCC',
    Issuer: 'BLACKROCK CAPITAL INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKCH',
    Issuer: 'GLOBAL X BLOCKCHAIN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKCI',
    Issuer: 'BNY MELLON CONCENTRATED INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKD',
    Issuer: 'BROOKDALE SENIOR LIVING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKE',
    Issuer: 'BUCKLE INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKEM',
    Issuer: 'BNY MELLON EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKEP',
    Issuer: 'BLUEKNIGHT ENERGY PARTNERS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKEPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKES',
    Issuer: 'BNY MELLON GLOBAL EMERG MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKF',
    Issuer: 'ISHARES MSCI BIC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKH',
    Issuer: 'BLACK HILLS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKHY',
    Issuer: 'BNY MELLON HIGH YIELD BETA E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKI',
    Issuer: 'BLACK KNIGHT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKIE',
    Issuer: 'BNY MELLON INTERNATIONAL EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKIS',
    Issuer: 'BNY MELLON SUST INT EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKKT',
    Issuer: 'BAKKT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKKT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKLC',
    Issuer: 'BNY MELLON US LARGE CAP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKLN',
    Issuer: 'INVESCO SENIOR LOAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKMC',
    Issuer: 'BNY MELLON US MID CAP CORE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKN',
    Issuer: 'BLACKROCK INVT QUALITY MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKNG',
    Issuer: 'BOOKING HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKR',
    Issuer: 'BAKER HUGHES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKSB',
    Issuer: 'BNY MELLON SHORT DURATION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKSC',
    Issuer: 'BANK OF SOUTH CAROLINA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKSE',
    Issuer: 'BNY MELLON US SMALL CAP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKSY',
    Issuer: 'BLACKSKY TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKSY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKT',
    Issuer: 'BLACKROCK INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKTI',
    Issuer: 'BK TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKU',
    Issuer: 'BANKUNITED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKUI',
    Issuer: 'BNY MELLON ULTRA SHORT INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKUS',
    Issuer: 'BNY MELLON SUSTAIN US EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BKYI',
    Issuer: 'BIO-KEY INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BL',
    Issuer: 'BLACKLINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLACU',
    Issuer: 'BELLEVUE LIFE SCIENCES ACQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLBD',
    Issuer: 'BLUE BIRD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLBX',
    Issuer: 'BLACKBOXSTOCKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLCM',
    Issuer: 'BELLICUM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLCN',
    Issuer: 'SIREN NEXGEN ECONOMY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLCO',
    Issuer: 'BAUSCH + LOMB CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLCT',
    Issuer: 'BLUECITY HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLD',
    Issuer: 'TOPBUILD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLDE',
    Issuer: 'BLADE AIR MOBILITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLDEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLDG',
    Issuer: 'CAMBRIA GLOBAL REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLDP',
    Issuer: 'BALLARD POWER SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLDR',
    Issuer: 'BUILDERS FIRSTSOURCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLE',
    Issuer: 'BLACKROCK MUN INC TRUST II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLES',
    Issuer: 'INSPIRE GLOBAL HOPE ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLEU',
    Issuer: 'BLUEACACIA LTD - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLEUR',
    Issuer: 'BLUEACACIA LTD - RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLEUU',
    Issuer: 'BLEUACACIA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLEUW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLFS',
    Issuer: 'BIOLIFE SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLFY',
    Issuer: 'BLUE FOUNDRY BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLHY',
    Issuer: 'VIRTUS NEWFLEET HIGH YIELD B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLI',
    Issuer: 'BERKELEY LIGHTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLIN',
    Issuer: 'BRIDGELINE DIGITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLK',
    Issuer: 'BLACKROCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLKB',
    Issuer: 'BLACKBAUD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLKC',
    Issuer: 'INVESCO ALERIAN GALAXY BLOCK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLMN',
    Issuer: "BLOOMIN' BRANDS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLND',
    Issuer: 'BLEND LABS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLNG',
    Issuer: 'BELONG ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLNGU',
    Issuer: 'BELONG ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLNGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLNK',
    Issuer: 'BLINK CHARGING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLNKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLOK',
    Issuer: 'AMPLIFY TRANSFOR DATA SHARIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLPH',
    Issuer: 'BELLEROPHON THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLRX',
    Issuer: 'BIOLINERX LTD-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLSA',
    Issuer: 'BCLS ACQUISITION CORP- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLTE',
    Issuer: 'BELITE BIO INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLTS',
    Issuer: 'BRIGHT LIGHTS ACQUISITI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLTSU',
    Issuer: 'BRIGHT LIGHTS ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLU',
    Issuer: 'BELLUS HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLUA',
    Issuer: 'BLUERIVER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLUA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLUA=',
    Issuer: 'BLUERIVER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLUE',
    Issuer: 'BLUEBIRD BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLV',
    Issuer: 'VANGUARD LONG-TERM BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLW',
    Issuer: 'BLACKROCK LTD DURATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLX',
    Issuer: 'BANCO LATINOAMERICANO COME-E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BLZE',
    Issuer: 'BACKBLAZE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMA',
    Issuer: 'BANCO MACRO SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAC',
    Issuer: 'BLACK MOUNTAIN ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAC=',
    Issuer: 'BLACK MOUNTAIN ACQ CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAQ',
    Issuer: 'BLOCKCHAIN MOON ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAQR',
    Issuer: 'BLOCKCHAIN MOON ACQ-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAQU',
    Issuer: 'BLOCKCHAIN MOON ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAR',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMAY',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMBL',
    Issuer: 'BUMBLE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BME',
    Issuer: 'BLACKROCK HEALTH SCIENCES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMEA',
    Issuer: 'BIOMEA FUSION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMED',
    Issuer: 'BLACKROCK FUTURE HEALTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMEZ',
    Issuer: 'BLACKROCK HEALTH SCI TR II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMI',
    Issuer: 'BADGER METER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BML-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BML-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BML-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BML-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMO',
    Issuer: 'BANK OF MONTREAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMRA',
    Issuer: 'BIOMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMRC',
    Issuer: 'BANK OF MARIN BANCORP/CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMRN',
    Issuer: 'BIOMARIN PHARMACEUTICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMTX',
    Issuer: 'BM TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMTX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BMY',
    Issuer: 'BRISTOL-MYERS SQUIBB CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BND',
    Issuer: 'VANGUARD TOTAL BOND MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNDC',
    Issuer: 'FLEXSHARES CORE SELECT BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNDD',
    Issuer: 'QUADRATIC DEFLATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNDW',
    Issuer: 'VANGUARD TOTAL WORLD BOND ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNDX',
    Issuer: 'VANGUARD TOTAL INTL BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNE',
    Issuer: 'BLUE HORIZON BNE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNED',
    Issuer: 'BARNES & NOBLE EDUCATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNFT',
    Issuer: 'BENEFITFOCUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNGE',
    Issuer: 'FIRST TRUST S-NETWORK STREAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNGO',
    Issuer: 'BIONANO GENOMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNGOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNIX',
    Issuer: 'BANNIX ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNIXR',
    Issuer: 'BANNIX ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNIXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNKD',
    Issuer: 'MICROSECTORS US BIG BANK -3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNKU',
    Issuer: 'MICROSECTORS US BIG BANKS 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNL',
    Issuer: 'BROADSTONE NET LEASE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNNR',
    Issuer: 'BANNER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNNRU',
    Issuer: 'BANNER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNNRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNO',
    Issuer: 'UNITED STATES BRENT OIL FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNOV',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNOX',
    Issuer: 'BIONOMICS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNR',
    Issuer: 'BURNING ROCK BIOTECH LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNRG',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNS',
    Issuer: 'BANK OF NOVA SCOTIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNSO',
    Issuer: 'BONSO ELECTRONICS INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNTC',
    Issuer: 'BENITEC BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNTX',
    Issuer: 'BIONTECH SE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BNY',
    Issuer: 'BLACKROCK NEW YORK MUNI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAC',
    Issuer: 'BLUESCAPE OPPORTUNITIES AC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAC=',
    Issuer: 'BLUESCAPE OPPORTUNITIES ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAS',
    Issuer: 'BOA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAS=',
    Issuer: 'BOA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOAT',
    Issuer: 'SONICSHARES GLOBAL SHIPPING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOB',
    Issuer: 'MERLYN AI BEST OF BREED CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOC',
    Issuer: 'BOSTON OMAHA CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOCN',
    Issuer: 'BLUE OCEAN ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOCNU',
    Issuer: 'BLUE OCEAN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOCNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOCT',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BODY',
    Issuer: 'BEACHBODY CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BODY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOE',
    Issuer: 'BLACKROCK ENHANCED GLOBAL DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOH',
    Issuer: 'BANK OF HAWAII CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOIL',
    Issuer: 'PROSHARES ULTRA BLOOMBERG NA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOKF',
    Issuer: 'BOK FINANCIAL CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOLT',
    Issuer: 'BOLT BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BON',
    Issuer: 'BON NATURAL LIFE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOND',
    Issuer: 'PIMCO ACTIVE BOND EXCHANGE-T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOOM',
    Issuer: 'DMC GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOOT',
    Issuer: 'BOOT BARN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BORR',
    Issuer: 'BORR DRILLING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOSC',
    Issuer: 'BOS BETTER ON-LINE SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOSS',
    Issuer: 'GLOBAL X FOUNDER-RUN COMPANI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOTJ',
    Issuer: 'BANK OF THE JAMES FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOTZ',
    Issuer: 'GLOBAL X ROBOTICS & ARTIFICI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOUT',
    Issuer: 'INNOVATOR IBD BREAKOUT OPPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOWL',
    Issuer: 'BOWLERO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOX',
    Issuer: 'BOX INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOXD',
    Issuer: 'BOXED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOXD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BOXL',
    Issuer: 'BOXLIGHT CORP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BP',
    Issuer: 'BP PLC-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPAC',
    Issuer: 'BULLPEN PARLAY ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPACU',
    Issuer: 'BULLPEN PARLAY ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPMC',
    Issuer: 'BLUEPRINT MEDICINES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPOP',
    Issuer: 'POPULAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPOPM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPRN',
    Issuer: 'THE BANK OF PRINCETON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPT',
    Issuer: 'BP PRUDHOE BAY ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPTH',
    Issuer: 'BIO-PATH HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPTS',
    Issuer: 'BIOPHYTIS SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPYPM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPYPN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPYPO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BPYPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BQ',
    Issuer: 'BOQII HOLDING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BR',
    Issuer: 'BROADRIDGE FINANCIAL SOLUTIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRAC',
    Issuer: 'BROAD CAPITAL ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRACR',
    Issuer: 'BROAD CAPITAL ACQUIS-RIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRACU',
    Issuer: 'BROAD CAPITAL ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRAG',
    Issuer: 'BRAGG GAMING GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRBR',
    Issuer: 'BELLRING BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRBS',
    Issuer: 'BLUE RIDGE BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRC',
    Issuer: 'BRADY CORPORATION - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRCC',
    Issuer: 'BRC INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRCN',
    Issuer: 'BURCON NUTRASCIENCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRD',
    Issuer: 'BEARD ENERGY TRANSITION AC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRD=',
    Issuer: 'BEARD ENERGY TRANSITION ACQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRDG',
    Issuer: 'BRIDGE INVESTMENT GRP HDS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRDS',
    Issuer: 'BIRD GLOBAL INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRDS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BREZ',
    Issuer: 'BREEZE HOLDINGS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BREZR',
    Issuer: 'BREEZE HOLDINGS ACQ- RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BREZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRF',
    Issuer: 'VANECK BRAZIL SMALL-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRFH',
    Issuer: 'BARFRESH FOOD GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRFS',
    Issuer: 'BRF SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRG',
    Issuer: 'BLUEROCK RESIDENTIAL GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRG-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRG-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRID',
    Issuer: 'BRIDGFORD FOODS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRIV',
    Issuer: 'B RILEY PRINCIPAL 250 MERG-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRIVU',
    Issuer: 'B RILEY PRINCIPAL 250 MERGER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRIVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRK.B',
    Issuer: 'BERKSHIRE HATHAWAY INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRKH',
    Issuer: 'BURTECH ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRKHU',
    Issuer: 'BURTECH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRKHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRKL',
    Issuer: 'BROOKLINE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRKR',
    Issuer: 'BRUKER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRLI',
    Issuer: 'BRILLIANT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRLIR',
    Issuer: 'BRILLIANT ACQUISITION - RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRLIU',
    Issuer: 'BRILLIANT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRLIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRLT',
    Issuer: 'BRILLIANT EARTH GROUP INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRMK',
    Issuer: 'BROADMARK REALTY CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRMK+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRN',
    Issuer: 'BARNWELL INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRO',
    Issuer: 'BROWN & BROWN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BROG',
    Issuer: 'BROOGE ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BROGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BROS',
    Issuer: 'DUTCH BROS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRP',
    Issuer: 'BRP GROUP INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRPM',
    Issuer: 'B RILEY PRINCIPAL 150 MERG-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRPMU',
    Issuer: 'B RILEY PRINCIPAL 150 MERGER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRPMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRQS',
    Issuer: 'BORQS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRSP',
    Issuer: 'BRIGHTSPIRE CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRT',
    Issuer: 'BRT APARTMENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRTX',
    Issuer: 'BIORESTORATIVE THERAPIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRW',
    Issuer: 'SABA CAPITAL INCOME & OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRX',
    Issuer: 'BRIXMOR PROPERTY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRY',
    Issuer: 'BERRY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRZE',
    Issuer: 'BRAZE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BRZU',
    Issuer: 'DIREXION DAILY MSCI BRAZIL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSAC',
    Issuer: 'BANCO SANTANDER-CHILE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSAQ',
    Issuer: 'BLACK SPADE ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSAQ=',
    Issuer: 'BLACK SPADE ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSBE',
    Issuer: 'INVESCO 2022 USD EM MKT DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSBK',
    Issuer: 'BOGOTA FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSBR',
    Issuer: 'BANCO SANTANDER BRASIL-ADS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCE',
    Issuer: 'INVESCO 2023 USD EM MKT DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCM',
    Issuer: 'INVESCO BULLETSHARES 2022 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCN',
    Issuer: 'INVESCO BULLETSHARES 2023 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCO',
    Issuer: 'INVESCO BULLETSHARES 2024 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCP',
    Issuer: 'INVESCO BULLETSHARES 2025 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCQ',
    Issuer: 'INVESCO BULLETSHARES 2026 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCR',
    Issuer: 'INVESCO BULLETSHARES 2027 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCS',
    Issuer: 'INVESCO BULLETSHARES 2028',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCT',
    Issuer: 'INVESCO BULLETSHARES 2029 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCU',
    Issuer: 'INVESCO BULLETSHARES 2030 CB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSCV',
    Issuer: 'INVESCO BULLETSHARES 2031 CR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSDE',
    Issuer: 'INVESCO 2024 USD EM MKT DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSEA',
    Issuer: 'ETFMG BREAKWAVE SEA DECARB T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSEP',
    Issuer: 'INNOVATOR U.S. EQUITY BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSET',
    Issuer: 'BASSETT FURNITURE INDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSFC',
    Issuer: 'BLUE STAR FOODS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSGA',
    Issuer: 'BLUE SAFARI GROUP ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSGAR',
    Issuer: 'BLUE SAFARI GROUP ACQUIS-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSGAU',
    Issuer: 'BLUE SAFARI GROUP ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSGM',
    Issuer: 'BIOSIG TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSIG',
    Issuer: 'BRIGHTSPHERE INVESTMENT GROU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJM',
    Issuer: 'INVESCO BULLETSHARES 2022 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJN',
    Issuer: 'INVESCO BULLETSHARES 2023 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJO',
    Issuer: 'INVESCO BULLETSHARES 2024 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJP',
    Issuer: 'INVESCO BULLETSHARES 2025 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJQ',
    Issuer: 'INVESCO BULLETSHARES 2026 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJR',
    Issuer: 'INVESCO BULLETSHARES 2027 HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJS',
    Issuer: 'INVESCO BULLETSHARE 2028 HYC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSJT',
    Issuer: 'INVESCO 2029 HIGH YIELD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSKY',
    Issuer: 'BIG SKY GROWTH PARTNERS IN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSKYU',
    Issuer: 'BIG SKY GROWTH PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSKYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSL',
    Issuer: 'BLACKSTONE SENIOR FLOATING R',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSM',
    Issuer: 'BLACK STONE MINERALS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMM',
    Issuer: 'INVESCO BULLETSHARES 2022 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMN',
    Issuer: 'INVESCO BULLETSHARES 2023 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMO',
    Issuer: 'INVESCO BULLETSHARES 2024 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMP',
    Issuer: 'INVESCO BULLETSHARES 2025 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMQ',
    Issuer: 'INVESCO BULLETSHARES 2026 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMR',
    Issuer: 'INVESCO BULLETSHARES 2027 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMS',
    Issuer: 'INVESCO BULLETSHARES 2028 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMT',
    Issuer: 'INVESCO BULLETSHARES 2029 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMU',
    Issuer: 'INVESCO BULLETSHARES 2030 MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMV',
    Issuer: 'INVESCO BLTSHRS 2031 MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSMX',
    Issuer: 'BANCO SANTANDER MEXICO -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSQR',
    Issuer: 'BSQUARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSRR',
    Issuer: 'SIERRA BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BST',
    Issuer: 'BLACKROCK SCIENCE & TECH TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSTP',
    Issuer: 'INNOVATOR BUFF SU STRAT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSTZ',
    Issuer: 'BLACKROCK SCIENCE & TECH II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSV',
    Issuer: 'VANGUARD SHORT-TERM BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSVN',
    Issuer: 'BANK7 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSX',
    Issuer: 'BOSTON SCIENTIFIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSX-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BSY',
    Issuer: 'BENTLEY SYSTEMS INC-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTA',
    Issuer: 'BLACKROCK LNG-TM MUN ADV TST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTAI',
    Issuer: 'BIOXCEL THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTAL',
    Issuer: 'AGFIQ US MARKET NEUTRAL ANTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTB',
    Issuer: 'BIT BROTHER LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTBD',
    Issuer: 'BT BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTBDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTBT',
    Issuer: 'BIT DIGITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTCM',
    Issuer: 'BIT MINING LTD - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTCR',
    Issuer: 'VOLT CRYPTO INDUS REV TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTCS',
    Issuer: 'BTCS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTCY',
    Issuer: 'BIOTRICITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTEC',
    Issuer: 'PRINCIPAL HEALTHCARE INNOVAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTEK',
    Issuer: 'BLACKROCK FUTURE TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTF',
    Issuer: 'VALKYRIE BITCOIN STRATEGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTG',
    Issuer: 'B2GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTHM',
    Issuer: 'BLACKROCK FUTURE US THEMES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTI',
    Issuer: 'BRITISH AMERICAN TOB-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTN',
    Issuer: 'BALLANTYNE STRONG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTO',
    Issuer: 'JOHN HANCOCK FINANCIAL OPPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTOG',
    Issuer: 'CHINA XIANGTAI FOOD CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTRS',
    Issuer: 'BTRS HOLDINGS INC-CL 1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTT',
    Issuer: 'BLACKROCK MUNICIPAL 2030 TAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTTR',
    Issuer: 'BETTER CHOICE CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTTX',
    Issuer: 'BETTER THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTU',
    Issuer: 'PEABODY ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTWN',
    Issuer: 'BRIDGETOWN HOLDINGS LTD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTWNU',
    Issuer: 'BRIDGETOWN HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTWNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTX',
    Issuer: 'BROOKLYN IMMUNOTHERAPEUTICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BTZ',
    Issuer: 'BLACKROCK CREDIT ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUD',
    Issuer: 'ANHEUSER-BUSCH INBEV-SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFB',
    Issuer: 'INNOVATOR LADD ALLO BUFF ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFD',
    Issuer: 'FT CBOE VEST FUND DEEP BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFF',
    Issuer: 'INNOVATOR LADDERED ALLOCATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFG',
    Issuer: 'FT CBOE VEST BUFF ALLOC GROW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFR',
    Issuer: 'FT CBOE VEST FUND OF BUFFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUFT',
    Issuer: 'FT CBOE VEST BUFF ALLOC DEF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUG',
    Issuer: 'GLOBAL X CYBERSECURITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUI',
    Issuer: 'BLCKRCK UTIL INFRA & PWR OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUL',
    Issuer: 'PACER US CASH COWS GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BULD',
    Issuer: 'PACER BLUESTAR ENG FUTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BULZ',
    Issuer: 'MICROSECTORS FANG&INN 3X LEV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUR',
    Issuer: 'BURFORD CAPITAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BURL',
    Issuer: 'BURLINGTON STORES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUSE',
    Issuer: 'FIRST BUSEY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUYZ',
    Issuer: 'FRANKLIN DISRUPTIVE COMMERCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BUZZ',
    Issuer: 'VANECK SOCIAL SENTIMENT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BV',
    Issuer: 'BRIGHTVIEW HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BVH',
    Issuer: 'BLUEGREEN VACATIONS HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BVN',
    Issuer: 'CIA DE MINAS BUENAVENTUR-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BVS',
    Issuer: 'BIOVENTUS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BVXV',
    Issuer: 'BIONDVAX PHARMACEUTICALS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BW',
    Issuer: 'BABCOCK & WILCOX ENTERPR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BW-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWA',
    Issuer: 'BORGWARNER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAC',
    Issuer: 'BETTER WORLD ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWACU',
    Issuer: 'BETTER WORLD ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAQ',
    Issuer: 'BLUE WORLD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAQR',
    Issuer: 'BLUE WORLD ACQUISITION - RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAQU',
    Issuer: 'BLUE WORLD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWAY',
    Issuer: 'BRAINSWAY LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWB',
    Issuer: 'BRIDGEWATER BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWBBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWC',
    Issuer: 'BLUE WHALE ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWCAU',
    Issuer: 'BLUE WHALE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWEN',
    Issuer: 'BROADWIND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWFG',
    Issuer: 'BANKWELL FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWG',
    Issuer: 'BRANDYWINEGLOBAL GLOBAL INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWMN',
    Issuer: 'BOWMAN CONSULTING GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWMX',
    Issuer: 'BETTERWARE DE MEXICO SAB DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWNB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWSN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWV',
    Issuer: 'BLUE WATER VACCINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWX',
    Issuer: 'SPDR BLOOMBERG INT TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWXT',
    Issuer: 'BWX TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BWZ',
    Issuer: 'SPDR BLOOMBERG SHORT TERM IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BX',
    Issuer: 'BLACKSTONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXC',
    Issuer: 'BLUELINX HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXMT',
    Issuer: 'BLACKSTONE MORTGAGE TRU-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXMX',
    Issuer: 'NUVEEN S&P500 BUY-WRT INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXP',
    Issuer: 'BOSTON PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXRX',
    Issuer: 'BAUDAX BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BXSL',
    Issuer: 'BLACKSTONE SECURED LENDING F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BY',
    Issuer: 'BYLINE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYD',
    Issuer: 'BOYD GAMING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYFC',
    Issuer: 'BROADWAY FINANCIAL CORP/DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYLD',
    Issuer: 'ISHARES YIELD OPTIMIZED BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYM',
    Issuer: 'BLACKROCK MUNICIPAL INCOME Q',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYN',
    Issuer: 'BANYAN ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYN=',
    Issuer: 'BANYAN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYND',
    Issuer: 'BEYOND MEAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYNO',
    Issuer: 'BYNORDIC ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYNOU',
    Issuer: 'BYNORDIC ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYNOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYRE',
    Issuer: 'PRINCIPAL RE ACTIVE OPP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYRN',
    Issuer: 'BYRNA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYSI',
    Issuer: 'BEYONDSPRING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYTE',
    Issuer: 'ROUNDHILL IO DIGITAL INFRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYTS',
    Issuer: 'BYTE ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYTSU',
    Issuer: 'BYTE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BYTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZ',
    Issuer: 'KANZHUN LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZFD',
    Issuer: 'BUZZFEED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZFDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZH',
    Issuer: 'BEAZER HOMES USA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZQ',
    Issuer: 'PROSHARES ULTRASHORT MSCI BR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'BZUN',
    Issuer: 'BAOZUN INC-SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'C',
    Issuer: 'CITIGROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'C-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'C-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'C-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAAP',
    Issuer: 'CORP AMERICA AIRPORTS SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAAS',
    Issuer: 'CHINA AUTOMOTIVE SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CABA',
    Issuer: 'CABALETTA BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CABO',
    Issuer: 'CABLE ONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAC',
    Issuer: 'CAMDEN NATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CACC',
    Issuer: 'CREDIT ACCEPTANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CACG',
    Issuer: 'CLEARBRIDGE ALL CAP GROWTH E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CACI',
    Issuer: 'CACI INTERNATIONAL INC -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CADE',
    Issuer: 'CADENCE BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CADE-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CADL',
    Issuer: 'CANDEL THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAE',
    Issuer: 'CAE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAF',
    Issuer: 'MORGAN STANLEY CHINA A SHARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAG',
    Issuer: 'CONAGRA BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAH',
    Issuer: 'CARDINAL HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAJ',
    Issuer: 'CANON INC-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAKE',
    Issuer: 'CHEESECAKE FACTORY INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAL',
    Issuer: 'CALERES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALA',
    Issuer: 'CALITHERA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALB',
    Issuer: 'CALIFORNIA BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALF',
    Issuer: 'PACER US SMALL CAP CASH COWS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALM',
    Issuer: 'CAL-MAINE FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALT',
    Issuer: 'CALLIDITAS THERAPEUTICS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CALX',
    Issuer: 'CALIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAMP',
    Issuer: 'CALAMP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAMT',
    Issuer: 'CAMTEK LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAN',
    Issuer: 'CANAAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CANE',
    Issuer: 'TEUCRIUM SUGAR FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CANF',
    Issuer: 'CAN FITE BIOPHARMA LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CANG',
    Issuer: 'CANGO INC/KY - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CANO',
    Issuer: 'CANO HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CANO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAPD',
    Issuer: 'IPATH SHILLER CAPE ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAPE',
    Issuer: 'DOUBLELINE SHILLER CAPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAPL',
    Issuer: 'CROSSAMERICA PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAPR',
    Issuer: 'CAPRICOR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAR',
    Issuer: 'AVIS BUDGET GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARA',
    Issuer: 'CARA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARE',
    Issuer: 'CARTER BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARG',
    Issuer: 'CARGURUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARR',
    Issuer: 'CARRIER GLOBAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARS',
    Issuer: 'CARS.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARV',
    Issuer: 'CARVER BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CARZ',
    Issuer: 'FIRST TRUST S-NETWORK FUTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAS',
    Issuer: 'CASCADE ACQUISITION COR-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAS=',
    Issuer: 'CASCADE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CASA',
    Issuer: 'CASA SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CASH',
    Issuer: 'META FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CASI',
    Issuer: 'CASI PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CASS',
    Issuer: 'CASS INFORMATION SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CASY',
    Issuer: "CASEY'S GENERAL STORES INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CAT',
    Issuer: 'CATERPILLAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CATC',
    Issuer: 'CAMBRIDGE BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CATH',
    Issuer: 'GLOBAL X S&P 500 CA VAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CATO',
    Issuer: 'CATO CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CATY',
    Issuer: 'CATHAY GENERAL BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CB',
    Issuer: 'CHUBB LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBAN',
    Issuer: 'COLONY BANKCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBAT',
    Issuer: 'CBAK ENERGY TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBAY',
    Issuer: 'CYMABAY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBD',
    Issuer: 'CIA BRASILEIRA DE DIS- ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBFV',
    Issuer: 'CB FINANCIAL SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBH',
    Issuer: 'VIRTUS ALLIANZGI CVRT 2024',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBIO',
    Issuer: 'CATALYST BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBL',
    Issuer: 'CBL & ASSOCIATES PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBLS',
    Issuer: 'CHANGEBRIDGE CAPITAL LONG/SH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBNK',
    Issuer: 'CAPITAL BANCORP INC/MD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBOE',
    Issuer: 'CBOE GLOBAL MARKETS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBON',
    Issuer: 'VANECK CHINA BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBRE',
    Issuer: 'CBRE GROUP INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBRG',
    Issuer: 'CHAIN BRIDGE I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBRGU',
    Issuer: 'CHAIN BRIDGE I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBRGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBRL',
    Issuer: 'CRACKER BARREL OLD COUNTRY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBSE',
    Issuer: 'CHANGEBRIDGE CAPITAL SUST EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBSH',
    Issuer: 'COMMERCE BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBT',
    Issuer: 'CABOT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBTX',
    Issuer: 'CBTX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBU',
    Issuer: 'COMMUNITY BANK SYSTEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBX',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CBZ',
    Issuer: 'CBIZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CC',
    Issuer: 'CHEMOURS CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCAI',
    Issuer: 'CASCADIA ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCAIU',
    Issuer: 'CASCADIA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCAIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCAP',
    Issuer: 'CRESCENT CAPITAL BDC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCB',
    Issuer: 'COASTAL FINANCIAL CORP/WA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCBG',
    Issuer: 'CAPITAL CITY BANK GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCCC',
    Issuer: 'C4 THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCCS',
    Issuer: 'CCC INTELLIGENT SOLUTIONS HO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCD',
    Issuer: 'CALAMOS DYNAMIC CONVERTIBLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCEL',
    Issuer: 'CRYO-CELL INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCEP',
    Issuer: 'COCA-COLA EUROPACIFIC PARTNE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCF',
    Issuer: 'CHASE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCI',
    Issuer: 'CROWN CASTLE INTL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCJ',
    Issuer: 'CAMECO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCK',
    Issuer: 'CROWN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCL',
    Issuer: 'CARNIVAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCLP',
    Issuer: 'CSI COMPRESSCO LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCM',
    Issuer: 'CONCORD MEDICAL - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCMP',
    Issuer: 'CMC MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCNC',
    Issuer: 'CODE CHAIN NEW CONTINENT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCNE',
    Issuer: 'CNB FINANCIAL CORP/PA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCNEP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCO',
    Issuer: 'CLEAR CHANNEL OUTDOOR HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCOI',
    Issuer: 'COGENT COMMUNICATIONS HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCOR',
    Issuer: 'CORE ALTERNATIVE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCRD',
    Issuer: 'CORECARD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCRN',
    Issuer: 'CROSS COUNTRY HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCRV',
    Issuer: 'ISHARES COMM CURVE CARRY STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCS',
    Issuer: 'CENTURY COMMUNITIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCSI',
    Issuer: 'CONSENSUS CLOUD SOLUTION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCTS',
    Issuer: 'CACTUS ACQUISITION CORP 1 LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCTSU',
    Issuer: 'CACTUS ACQUISITION CORP 1 LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCU',
    Issuer: 'CIA CERVECERIAS UNI-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCV',
    Issuer: 'CHURCHILL CAPITAL CORP V-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCV=',
    Issuer: 'CHURCHILL CAPITAL CORP V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCVI',
    Issuer: 'CHURCHILL CAPITAL CORP VI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCVI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCVI=',
    Issuer: 'CHURCHILL CAPITAL CORP VI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCXI',
    Issuer: 'CHEMOCENTRYX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CCZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CD',
    Issuer: 'CHINDATA GROUP HOLDINGS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDAK',
    Issuer: 'CODIAK BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDAQ',
    Issuer: 'COMPASS DIGITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDAQU',
    Issuer: 'COMPASS DIGITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDAY',
    Issuer: 'CERIDIAN HCM HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDC',
    Issuer: 'VICTORYSHARES US EQ INCOME E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDE',
    Issuer: 'COEUR MINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDEV',
    Issuer: 'CENTENNIAL RESOURCE DEVELO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDK',
    Issuer: 'CDK GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDL',
    Issuer: 'VICTORYSHARES US LARGE CAP H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDLX',
    Issuer: 'CARDLYTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDMO',
    Issuer: 'AVID BIOSERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDNA',
    Issuer: 'CAREDX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDNS',
    Issuer: 'CADENCE DESIGN SYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDR',
    Issuer: 'CEDAR REALTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDRE',
    Issuer: 'CADRE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDRO',
    Issuer: 'CODERE ONLINE LUXEMBOURG SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDROW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDTX',
    Issuer: 'CIDARA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDW',
    Issuer: 'CDW CORP/DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDX',
    Issuer: 'SIMPLIFY HIGH YIELD PL CR HD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDXC',
    Issuer: 'CHROMADEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDXS',
    Issuer: 'CODEXIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDZI',
    Issuer: 'CADIZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CDZIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CE',
    Issuer: 'CELANESE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEA',
    Issuer: 'CHINA EASTERN AIRLINES-ADS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEAD',
    Issuer: 'CEA INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEADW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CECE',
    Issuer: 'CECO ENVIRONMENTAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEE',
    Issuer: 'CENTRAL AND EASTERN EUROPE F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEF',
    Issuer: 'SPROTT PHYSICAL GOLD AND SIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEFA',
    Issuer: 'GLOBAL X S&P CATH VAL DEVEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEFD',
    Issuer: 'ETRACS 150% CL END FUND ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEFS',
    Issuer: 'SABA CLOSED END FUNDS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEG',
    Issuer: 'CONSTELLATION ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEI',
    Issuer: 'CAMBER ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEIX',
    Issuer: 'CONSOL ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELC',
    Issuer: 'CELCUITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELG^',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELH',
    Issuer: 'CELSIUS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELU',
    Issuer: 'CELULARITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELUW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CELZ',
    Issuer: 'CREATIVE MEDICAL TECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEM',
    Issuer: 'CLEARBRIDGE MLP & MIDSTREAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEMB',
    Issuer: 'ISHARES JP MORGAN EM CORPORA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEMI',
    Issuer: 'CHEMBIO DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEN',
    Issuer: 'CENTER COAST BROOKFIELD MLP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENN',
    Issuer: 'CENNTRO ELECTRIC GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENQ',
    Issuer: 'CENAQ ENERGY CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENQU',
    Issuer: 'CENAQ ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENT',
    Issuer: 'CENTRAL GARDEN & PET CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENTA',
    Issuer: 'CENTRAL GARDEN AND PET CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CENX',
    Issuer: 'CENTURY ALUMINUM COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEPU',
    Issuer: 'CENTRAL PUERTO-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEQP',
    Issuer: 'CRESTWOOD EQUITY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEQP-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CERE',
    Issuer: 'CEREVEL THERAPEUTICS HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CERN',
    Issuer: 'CERNER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CERS',
    Issuer: 'CERUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CERT',
    Issuer: 'CERTARA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CET',
    Issuer: 'CENTRAL SECURITIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CETX',
    Issuer: 'CEMTREX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CETXP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEV',
    Issuer: 'EATON VANCE CA MUNI INC TRST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEVA',
    Issuer: 'CEVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEW',
    Issuer: 'WISDOMTREE EMERGING CURRENCY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CEY',
    Issuer: 'VICTORYSHARES EMERGING MARKE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CF',
    Issuer: 'CF INDUSTRIES HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFA',
    Issuer: 'VICTORYSHARES US 500 VOLATIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFB',
    Issuer: 'CROSSFIRST BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFBK',
    Issuer: 'CF BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFCV',
    Issuer: 'CLEARBRIDGE FOCUS VALUE ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFE',
    Issuer: 'CF ACQUISITION CORP VIII-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFEU',
    Issuer: 'CF ACQUISITION CORP VIII',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFI',
    Issuer: 'C & F FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFN',
    Issuer: 'CAPITOL FEDERAL FINANCIAL IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFS',
    Issuer: 'CF ACQUISITION CORP VII-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFSU',
    Issuer: 'CF ACQUISITION CORP VII',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFFSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFG',
    Issuer: 'CITIZENS FINANCIAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFG-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFG-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFIV',
    Issuer: 'CF ACQUISITION CORP IV-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFIVU',
    Issuer: 'CF ACQUISITION CORP IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFIVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFLT',
    Issuer: 'CONFLUENT INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFMS',
    Issuer: 'CONFORMIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFO',
    Issuer: 'VICTORYSHARES US 500 ENHANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFR',
    Issuer: 'CULLEN/FROST BANKERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFRX',
    Issuer: 'CONTRAFECT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFSB',
    Issuer: 'CFSB BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFVI',
    Issuer: 'CF ACQUISITION CORP VI-CLS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFVIU',
    Issuer: 'CF ACQUISITION CORP VI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CFVIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CG',
    Issuer: 'CARLYLE GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGA',
    Issuer: 'CHINA GREEN AGRICULTURE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGABL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGAU',
    Issuer: 'CENTERRA GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGBD',
    Issuer: 'CARLYLE SECURED LENDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGC',
    Issuer: 'CANOPY GROWTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGCP',
    Issuer: 'CAPITAL GROUP CORE PLUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGDV',
    Issuer: 'CAPITAL GROUP DIVIDEND VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGEM',
    Issuer: 'CULLINAN ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGEN',
    Issuer: 'COMPUGEN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGGO',
    Issuer: 'Capital Group Global Growth',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGGR',
    Issuer: 'CAPITAL GROUP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGNT',
    Issuer: 'COGNYTE SOFTWARE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGNX',
    Issuer: 'COGNEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGO',
    Issuer: 'CALAMOS GLOBAL TOTAL RETURN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGRN',
    Issuer: 'CAPSTONE GREEN ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGTX',
    Issuer: 'COGNITION THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGUS',
    Issuer: 'CAPITAL GROUP CORE EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGW',
    Issuer: 'INVESCO S&P GLOBAL WATER IND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CGXU',
    Issuer: 'CAPITAL GROUP INTL FOCUS ETY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHAA',
    Issuer: 'CATCHA INVESTMENT CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHAA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHAA=',
    Issuer: 'CATCHA INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHAD',
    Issuer: 'DRX DLY CHINA A-SHR BEAR 1X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHAU',
    Issuer: 'DRX DLY CHINA A-SHR BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHB',
    Issuer: 'GLOBAL X CHINA BIOTECH INNOV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHCI',
    Issuer: 'COMSTOCK HOLDING COMPANIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHCO',
    Issuer: 'CITY HOLDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHCT',
    Issuer: 'COMMUNITY HEALTHCARE TRUST I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHD',
    Issuer: 'CHURCH & DWIGHT CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHDN',
    Issuer: 'CHURCHILL DOWNS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHE',
    Issuer: 'CHEMED CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHEAU',
    Issuer: 'CHENGHE ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHEF',
    Issuer: "CHEFS' WAREHOUSE INC/THE",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHEK',
    Issuer: 'CHECK CAP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHEKZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHGG',
    Issuer: 'CHEGG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHGX',
    Issuer: 'AXS CHANGE FINANCE ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHH',
    Issuer: 'CHOICE HOTELS INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHI',
    Issuer: 'CALAMOS CONVERTIBLE OPP&INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIC',
    Issuer: 'GLOBAL X MSCI CHINA COMMUNIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIE',
    Issuer: 'GLOBAL X MSCI CHINA ENERGY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIH',
    Issuer: 'GLOBAL X MSCI CHINA HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHII',
    Issuer: 'GLOBAL X MSCI CHINA INDUSTRI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIK',
    Issuer: 'GLOBAL X MSCI CHINA INFO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIM',
    Issuer: 'GLOBAL X MSCI CHINA MATERIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIQ',
    Issuer: 'GLOBAL X MSCI CHINA CONSUMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIR',
    Issuer: 'GBL X MSCI CHINA REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIS',
    Issuer: 'GBL X MSCI CHINA CONSUMER ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIU',
    Issuer: 'GLOBAL X MSCI CHINA UTIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHIX',
    Issuer: 'GLOBAL X MSCI CHINA FINANCIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHK',
    Issuer: 'CHESAPEAKE ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHKEL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHKEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHKEZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHKP',
    Issuer: 'CHECK POINT SOFTWARE TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHMG',
    Issuer: 'CHEMUNG FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHMI',
    Issuer: 'CHERRY HILL MORTGAGE INVESTM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHMI-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHMI-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHN',
    Issuer: 'CHINA FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHNA',
    Issuer: 'LONCAR CHINA BIOPHARMA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHNG',
    Issuer: 'CHANGE HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHNGU',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHNR',
    Issuer: 'CHINA NATURAL RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHPT',
    Issuer: 'CHARGEPOINT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHRA',
    Issuer: 'CHARAH SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHRB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHRS',
    Issuer: 'COHERUS BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHRW',
    Issuer: 'C.H. ROBINSON WORLDWIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHS',
    Issuer: "CHICO'S FAS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHSCL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHSCM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHSCN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHSCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHSCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHT',
    Issuer: 'CHUNGHWA TELECOM LT-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHTR',
    Issuer: 'CHARTER COMMUNICATIONS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHUY',
    Issuer: "CHUY'S HOLDINGS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHW',
    Issuer: 'CALAMOS GLOBAL DYNAMIC INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHWA',
    Issuer: 'CHW ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHWAU',
    Issuer: 'CHW ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHWAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHWY',
    Issuer: 'CHEWY INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHX',
    Issuer: 'CHAMPIONX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CHY',
    Issuer: 'CALAMOS CVT AND HIGH INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CI',
    Issuer: 'CIGNA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIA',
    Issuer: 'CITIZENS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIAN',
    Issuer: 'CIAN PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIB',
    Issuer: 'BANCOLOMBIA S.A.-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIBR',
    Issuer: 'FIRST TRUST NASDAQ CYBERSECU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CID',
    Issuer: 'VICTORYSHARES INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIDM',
    Issuer: 'CINEDIGM CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIEN',
    Issuer: 'CIENA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIF',
    Issuer: 'MFS INTERMEDIATE HIGH INC FN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIFR',
    Issuer: 'CIPHER MINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIFRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIG',
    Issuer: 'CIA ENERGETICA DE-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIG.C',
    Issuer: 'CIA ENERGETICA DE-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIGI',
    Issuer: 'COLLIERS INTERNATIONAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIH',
    Issuer: 'CHINA INDEX HDS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CII',
    Issuer: 'BLACKROCK ENH CAP AND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIIG',
    Issuer: 'CIIG CAPITAL PARTNERS II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIIGU',
    Issuer: 'CIIG CAPITAL PARTNERS II INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIIGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIK',
    Issuer: 'CREDIT SUISSE ASSET MGMT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIL',
    Issuer: 'VICTORYSHARES INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIM',
    Issuer: 'CHIMERA INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIM-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIM-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIM-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIM-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CINC',
    Issuer: 'CINCOR PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CINF',
    Issuer: 'CINCINNATI FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CING',
    Issuer: 'CINGULATE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CINGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CINT',
    Issuer: 'CI&T INC/UNITED STATES-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIO',
    Issuer: 'CITY OFFICE REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CION',
    Issuer: 'CION INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIR',
    Issuer: 'CIRCOR INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CISO',
    Issuer: 'CERBERUS CYBER SENTINEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CITE',
    Issuer: 'CARTICA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CITEU',
    Issuer: 'CARTICA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CITEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIVB',
    Issuer: 'CIVISTA BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIVI',
    Issuer: 'CIVITAS RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIX',
    Issuer: 'COMPX INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIXX',
    Issuer: 'CI FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIZ',
    Issuer: 'VICTORYSHARES DEVELOPED ENHA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CIZN',
    Issuer: 'CITIZENS HOLDING COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CJJD',
    Issuer: 'CHINA JO-JO DRUGSTORES HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CKPT',
    Issuer: 'CHECKPOINT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CKX',
    Issuer: 'CKX LANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CL',
    Issuer: 'COLGATE-PALMOLIVE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAA',
    Issuer: 'COLONNADE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAA=',
    Issuer: 'COLONNADE ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAQ',
    Issuer: 'CLEANTECH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAQR',
    Issuer: 'CLEANTECH ACQUISITION CO-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAQU',
    Issuer: 'CLEANTECH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAR',
    Issuer: 'CLARUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAS',
    Issuer: 'CLASS ACCELERATION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAS=',
    Issuer: 'CLASS ACCELERATION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAY',
    Issuer: 'CHAVANT CAPITAL ACQ CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAYU',
    Issuer: 'CHAVANT CAPITAL ACQ CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLAYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLB',
    Issuer: 'CORE LABORATORIES N.V.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBK',
    Issuer: 'COLUMBIA FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBR',
    Issuer: 'COLOMBIER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBR=',
    Issuer: 'COLOMBIER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBS',
    Issuer: 'CALADRIUS BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBT',
    Issuer: 'CELLEBRITE DI LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLBTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLDL',
    Issuer: 'DIREXION DAILY CLOUD BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLDS',
    Issuer: 'DIREXION DAILY CLOUD BEAR 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLDT',
    Issuer: 'CHATHAM LODGING TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLDT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLDX',
    Issuer: 'CELLDEX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLEU',
    Issuer: 'CHINA LIBERAL EDUCATION HOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLF',
    Issuer: 'CLEVELAND-CLIFFS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLFD',
    Issuer: 'CLEARFIELD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLGN',
    Issuer: 'COLLPLANT BIOTECHNOLOGIES LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLH',
    Issuer: 'CLEAN HARBORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIM',
    Issuer: 'CLIMATE REAL IMPACT SOLUTI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIM=',
    Issuer: 'CLIMATE REAL IMPACT SOLUTION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIN',
    Issuer: 'CLEAN EARTH ACQUISITIONS -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLINR',
    Issuer: 'CLEAN EARTH ACQUISITION-RGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLINU',
    Issuer: 'CLEAN EARTH ACQUISITIONS COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLINW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIR',
    Issuer: 'CLEARSIGN TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLIX',
    Issuer: 'PROSHARES LONG ONLINE/SHORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLLS',
    Issuer: 'CELLECTIS - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLM',
    Issuer: 'CORNERSTONE STRATEGIC VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLMA',
    Issuer: 'ICLIMA CLIMATE CHANGE SOLUTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLMT',
    Issuer: 'CALUMET SPECIALTY PRODUCTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLNE',
    Issuer: 'CLEAN ENERGY FUELS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLNN',
    Issuer: 'CLENE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLNNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLNR',
    Issuer: 'IQ CLEANER TRANSPORT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLOE',
    Issuer: 'CLOVER LEAF CAPITAL CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLOER',
    Issuer: 'CLOVER LEAF CAPITAL CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLOEU',
    Issuer: 'CLOVER LEAF CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLOU',
    Issuer: 'GLOBAL X CLOUD COMPUTING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLOV',
    Issuer: 'CLOVER HEALTH INVESTMENTS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLPR',
    Issuer: 'CLIPPER REALTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLPS',
    Issuer: 'CLPS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLPT',
    Issuer: 'CLEARPOINT NEURO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLR',
    Issuer: 'CONTINENTAL RESOURCES INC/OK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRB',
    Issuer: 'CELLECTAR BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRCU',
    Issuer: 'CLIMATEROCK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRG',
    Issuer: 'IQ CHAIKIN US LARGE CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRM',
    Issuer: 'CLARIM ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRMU',
    Issuer: 'CLARIM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLRO',
    Issuer: 'CLEARONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLS',
    Issuer: 'CELESTICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSA',
    Issuer: 'CABANA TARGET LEADING SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSC',
    Issuer: 'CABANA TARGET LEADING SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSD',
    Issuer: 'CLEARSIDE BIOMEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSE',
    Issuer: 'CONVERGENCE LONG/SHORT EQY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSK',
    Issuer: 'CLEANSPARK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSM',
    Issuer: 'CABANA TARGET LEADING SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLSN',
    Issuer: 'CELSION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLST',
    Issuer: 'CATALYST BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLTL',
    Issuer: 'INVESCO TREASURY COLLATERAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLVR',
    Issuer: 'CLEVER LEAVES HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLVRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLVS',
    Issuer: 'CLOVIS ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLVT',
    Issuer: 'CLARIVATE PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLVT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLW',
    Issuer: 'CLEARWATER PAPER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLWT',
    Issuer: 'EURO TECH HOLDINGS CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLX',
    Issuer: 'CLOROX COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CLXT',
    Issuer: 'CALYXT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CM',
    Issuer: 'CAN IMPERIAL BK OF COMMERCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMA',
    Issuer: 'COMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMAX',
    Issuer: 'CAREMAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMBM',
    Issuer: 'CAMBIUM NETWORKS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMBS',
    Issuer: 'ISHARES CMBS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMC',
    Issuer: 'COMMERCIAL METALS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCA',
    Issuer: 'CAPITALWORKS EMERGING M-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCAU',
    Issuer: 'CAPITALWORKS EMERGING MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCL',
    Issuer: 'CALEDONIA MINING CORP PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCM',
    Issuer: 'CHEETAH MOBILE INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCO',
    Issuer: 'COLUMBUS MCKINNON CORP/NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCSA',
    Issuer: 'COMCAST CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCT',
    Issuer: 'CREATIVE MEDIA & COMMUNITY T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMCTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMDY',
    Issuer: 'ISHARES BLOOMBERG ROLL SELEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CME',
    Issuer: 'CME GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMF',
    Issuer: 'ISHARES CALIFORNIA MUNI BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMG',
    Issuer: 'CHIPOTLE MEXICAN GRILL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMI',
    Issuer: 'CUMMINS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMLS',
    Issuer: 'CUMULUS MEDIA INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMMB',
    Issuer: 'CHEMOMAB THERAPEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMP',
    Issuer: 'COMPASS MINERALS INTERNATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPI',
    Issuer: 'CHECKMATE PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPO',
    Issuer: 'COMPOSECURE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPR',
    Issuer: 'CIMPRESS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPS',
    Issuer: 'COMPASS PATHWAYS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMPX',
    Issuer: 'COMPASS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRA',
    Issuer: 'COMERA LIFE SCIENCES HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRE',
    Issuer: 'COSTAMARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRE-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRE-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRE-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRE-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMRX',
    Issuer: 'CHIMERIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMS',
    Issuer: 'CMS ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMS-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMS-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMSA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMSC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMSD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMT',
    Issuer: 'CORE MOLDING TECHNOLOGIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMTG',
    Issuer: 'CLAROS MORTGAGE TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMTL',
    Issuer: 'COMTECH TELECOMMUNICATIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CMU',
    Issuer: 'MFS HIGH YIELD MUNICIPAL TRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CN',
    Issuer: 'XTRACKERS MSCI ALL CHINA EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNA',
    Issuer: 'CNA FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNBS',
    Issuer: 'AMPLIFY SEYMOUR CANNABIS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNC',
    Issuer: 'CENTENE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNCE',
    Issuer: 'CONCERT PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNCR',
    Issuer: 'LONCAR CANCER IMMUNOTHERAPY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CND',
    Issuer: 'CONCORD ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CND+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CND=',
    Issuer: 'CONCORD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDA',
    Issuer: 'CONCORD ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDA=',
    Issuer: 'CONCORD ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDB',
    Issuer: 'CONCORD ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDB=',
    Issuer: 'CONCORD ACQUISITION CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNDT',
    Issuer: 'CONDUENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNET',
    Issuer: 'ZW DATA ACTION TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNEY',
    Issuer: 'CN ENERGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNF',
    Issuer: 'CNFINANCE HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNFR',
    Issuer: 'CONIFER HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNFRL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNGL',
    Issuer: 'CANNA-GLOBAL ACQUISITIO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNGLU',
    Issuer: 'CANNA-GLOBAL ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNGLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNHI',
    Issuer: 'CNH INDUSTRIAL NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNI',
    Issuer: 'CANADIAN NATL RAILWAY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNK',
    Issuer: 'CINEMARK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNM',
    Issuer: 'CORE & MAIN INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNMD',
    Issuer: 'CONMED CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNNB',
    Issuer: 'CINCINNATI BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNNE',
    Issuer: 'CANNAE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNO',
    Issuer: 'CNO FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNOB',
    Issuer: 'CONNECTONE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNOBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNP',
    Issuer: 'CENTERPOINT ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNQ',
    Issuer: 'CANADIAN NATURAL RESOURCES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNR',
    Issuer: 'CORNERSTONE BUILDING BRANDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNRG',
    Issuer: 'SPDR S&P KENSHO CLEAN POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNS',
    Issuer: 'COHEN & STEERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNSL',
    Issuer: 'CONSOLIDATED COMMUNICATIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNSP',
    Issuer: 'CNS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTA',
    Issuer: 'CENTESSA PHARMACEUTICALS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTB',
    Issuer: 'CONNECT BIOPHARMA HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTG',
    Issuer: 'CENTOGENE NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTQ',
    Issuer: 'CHARDAN NEXTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTQU',
    Issuer: 'CHARDAN NEXTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTX',
    Issuer: 'CONTEXT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNTY',
    Issuer: 'CENTURY CASINOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNVY',
    Issuer: 'CONVEY HEALTH SOLUTIONS HOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNX',
    Issuer: 'CNX RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNXC',
    Issuer: 'CONCENTRIX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNXN',
    Issuer: 'PC CONNECTION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNXT',
    Issuer: 'VANECK CHINEXT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CNYA',
    Issuer: 'ISHARES MSCI CHINA A ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CO',
    Issuer: 'GLOBAL CORD BLOOD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COCO',
    Issuer: 'VITA COCO CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COCP',
    Issuer: 'COCRYSTAL PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODA',
    Issuer: 'CODA OCTOPUS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODI',
    Issuer: 'COMPASS DIVERSIFIED HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODI-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODI-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODI-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CODX',
    Issuer: 'CO-DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COE',
    Issuer: 'CHINA ONLINE EDUCATION-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF',
    Issuer: 'CAPITAL ONE FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COF-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COFS',
    Issuer: 'CHOICEONE FINANCIAL SVCS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COGT',
    Issuer: 'COGENT BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COHN',
    Issuer: 'COHEN & CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COHR',
    Issuer: 'COHERENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COHU',
    Issuer: 'COHU INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COIN',
    Issuer: 'COINBASE GLOBAL INC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COKE',
    Issuer: 'COCA-COLA CONSOLIDATED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLB',
    Issuer: 'COLUMBIA BANKING SYSTEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLD',
    Issuer: 'AMERICOLD REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLI',
    Issuer: 'COLICITY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLIU',
    Issuer: 'COLICITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLL',
    Issuer: 'COLLEGIUM PHARMACEUTICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COLM',
    Issuer: 'COLUMBIA SPORTSWEAR CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COM',
    Issuer: 'DIREXION AUSPICE BRD CMDTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMB',
    Issuer: 'GRANITESHARES BCOM BROAD STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMM',
    Issuer: 'COMMSCOPE HOLDING CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMP',
    Issuer: 'COMPASS INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMS',
    Issuer: 'COMSOVEREIGN HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMSP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COMT',
    Issuer: 'ISHARES GSCI COMMODITY DYNAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CONN',
    Issuer: "CONN'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CONX',
    Issuer: 'CONX CORP-CLASS A SHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CONXU',
    Issuer: 'CONX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CONXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COO',
    Issuer: 'COOPER COS INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COOK',
    Issuer: 'TRAEGER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COOL',
    Issuer: 'CORNER GROWTH ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COOLU',
    Issuer: 'CORNER GROWTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COOLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COOP',
    Issuer: 'MR COOPER GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COP',
    Issuer: 'CONOCOPHILLIPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COPX',
    Issuer: 'GLOBAL X COPPER MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORN',
    Issuer: 'TEUCRIUM CORN FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORP',
    Issuer: 'PIMCO INV GRADE CORP BD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORR',
    Issuer: 'CORENERGY INFRASTRUCTURE TRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORR-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORS',
    Issuer: 'CORSAIR PARTNERING CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORS=',
    Issuer: 'CORSAIR PARTNERING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORT',
    Issuer: 'CORCEPT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORZ',
    Issuer: 'CORE SCIENTIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CORZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COSM',
    Issuer: 'COSMOS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COST',
    Issuer: 'COSTCO WHOLESALE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COTY',
    Issuer: 'COTY INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COUP',
    Issuer: 'COUPA SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COUR',
    Issuer: 'COURSERA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COVA',
    Issuer: 'CRESCENT COVE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COVAU',
    Issuer: 'COVA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COVAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COW',
    Issuer: 'IPATH SERIES B BLOOMBERG LIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COWN',
    Issuer: 'COWEN INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COWNL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'COWZ',
    Issuer: 'PACER US CASH COWS 100 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CP',
    Issuer: 'CANADIAN PACIFIC RAILWAY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPA',
    Issuer: 'COPA HOLDINGS SA-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAA',
    Issuer: 'CONYERS PARK III ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAAU',
    Issuer: 'CONYERS PARK III ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAC',
    Issuer: 'CEMENTOS PACASMAYO SAA - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAQ',
    Issuer: 'COUNTER PRESS ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAQU',
    Issuer: 'COUNTER PRESS ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPAR',
    Issuer: 'CATALYST PARTNERS ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPARU',
    Issuer: 'CATALYST PARTNERS ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPARW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPB',
    Issuer: 'CAMPBELL SOUP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPE',
    Issuer: 'CALLON PETROLEUM CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPER',
    Issuer: 'UNITED STATES COPPER INDEX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPF',
    Issuer: 'CENTRAL PACIFIC FINANCIAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPG',
    Issuer: 'CRESCENT POINT ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPHC',
    Issuer: 'CANTERBURY PARK HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPHI',
    Issuer: 'CHINA PHARMA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPI',
    Issuer: 'IQ REAL RETURN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPIX',
    Issuer: 'CUMBERLAND PHARMACEUTICALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPK',
    Issuer: 'CHESAPEAKE UTILITIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPLP',
    Issuer: 'CAPITAL PRODUCT PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPNG',
    Issuer: 'COUPANG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPOP',
    Issuer: 'POP CULTURE GROUP CO LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPRI',
    Issuer: 'CAPRI HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPRT',
    Issuer: 'COPART INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPRX',
    Issuer: 'CATALYST PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPS',
    Issuer: 'COOPER-STANDARD HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPSH',
    Issuer: 'CPS TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPSI',
    Issuer: 'COMPUTER PROGRAMS & SYSTEMS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPSS',
    Issuer: 'CONSUMER PORTFOLIO SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPT',
    Issuer: 'CAMDEN PROPERTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTAG',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTAL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTK',
    Issuer: 'CROWN PROPTECH ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTK+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTK=',
    Issuer: 'CROWN PROPTECH ACQUISITIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTN',
    Issuer: 'CEPTON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPTNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPUH',
    Issuer: 'COMPUTE HEALTH ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPUH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPUH=',
    Issuer: 'COMPUTE HEALTH ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CPZ',
    Issuer: 'CALAMOS LNG/SHRT EQ & DYN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CQP',
    Issuer: 'CHENIERE ENERGY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CQQQ',
    Issuer: 'INVESCO CHINA TECHNOLOGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CR',
    Issuer: 'CRANE HOLDINGS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRAI',
    Issuer: 'CRA INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRAK',
    Issuer: 'VANECK OIL REFINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRBN',
    Issuer: 'ISHARES MSCI ACWI LOW CARBON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRBP',
    Issuer: 'CORBUS PHARMACEUTICALS HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRBU',
    Issuer: 'CARIBOU BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRC',
    Issuer: 'CALIFORNIA RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRCT',
    Issuer: 'CRICUT INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRD.A',
    Issuer: 'CRAWFORD & COMPANY -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRD.B',
    Issuer: 'CRAWFORD & CO  -CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRDF',
    Issuer: 'CARDIFF ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRDL',
    Issuer: 'CARDIOL THERAPEUTICS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRDO',
    Issuer: 'CREDO TECHNOLOGY GROUP HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CREC',
    Issuer: 'CRESCERA CAPITAL ACQUIS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRECU',
    Issuer: 'CRESCERA CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRECW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CREG',
    Issuer: 'SMART POWERR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRESW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRESY',
    Issuer: 'CRESUD S.A.-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CREX',
    Issuer: 'CREATIVE REALITIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CREXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRF',
    Issuer: 'CORNERSTONE TOTAL RETURN FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRGE',
    Issuer: 'CHARGE ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRGY',
    Issuer: 'CRESCENT ENERGY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRH',
    Issuer: 'CRH PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRHC',
    Issuer: 'COHN ROBBINS HOLDINGS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRHC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRHC=',
    Issuer: 'COHN ROBBINS HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRI',
    Issuer: "CARTER'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRIS',
    Issuer: 'CURIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRIT',
    Issuer: 'OPTICA RARE EARTH & CMS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRK',
    Issuer: 'COMSTOCK RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRKN',
    Issuer: 'CROWN ELECTROKINETICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRL',
    Issuer: 'CHARLES RIVER LABORATORIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRM',
    Issuer: 'SALESFORCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRMD',
    Issuer: 'CORMEDIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRMT',
    Issuer: "AMERICA'S CAR-MART INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRNC',
    Issuer: 'CERENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRNT',
    Issuer: 'CERAGON NETWORKS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRNX',
    Issuer: 'CRINETICS PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRON',
    Issuer: 'CRONOS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CROX',
    Issuer: 'CROCS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRPT',
    Issuer: 'FT SKYBR CRYPT & DIG ECON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRS',
    Issuer: 'CARPENTER TECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRSP',
    Issuer: 'CRISPR THERAPEUTICS AG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRSR',
    Issuer: 'CORSAIR GAMING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRT',
    Issuer: 'CROSS TIMBERS ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRTD',
    Issuer: 'CREATD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRTDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRTO',
    Issuer: 'CRITEO SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRTX',
    Issuer: 'CORTEXYME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRU',
    Issuer: 'CRUCIBLE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRU+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRU=',
    Issuer: 'CRUCIBLE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRUS',
    Issuer: 'CIRRUS LOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRUZ',
    Issuer: 'DEFIANCE HOTEL  AIRLINE  CRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRVL',
    Issuer: 'CORVEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRVS',
    Issuer: 'CORVUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRWD',
    Issuer: 'CROWDSTRIKE HOLDINGS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRWS',
    Issuer: 'CROWN CRAFTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRXT',
    Issuer: 'CLARUS THERAPEUTICS HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRXTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRYP',
    Issuer: 'ADVISORSHARES MANAGE BITCOIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRZN',
    Issuer: 'CORAZON CAPITAL V838 MONOC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRZNU',
    Issuer: 'CORAZON CAPITAL V838 MONOCER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CRZNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CS',
    Issuer: 'CREDIT SUISSE GROUP-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSA',
    Issuer: 'VICTORYSHARES US SMALL CAP V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSAN',
    Issuer: 'COSAN SA -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSB',
    Issuer: 'VICTORYSHARES US SMALL CAP H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSBR',
    Issuer: 'CHAMPIONS ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSCO',
    Issuer: 'CISCO SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSCW',
    Issuer: 'COLOR STAR TECHNOLOGY CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSD',
    Issuer: 'INVESCO S&P SPIN-OFF ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSF',
    Issuer: 'VICTORYSHARES US DISCOVERY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSGP',
    Issuer: 'COSTAR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSGS',
    Issuer: 'CSG SYSTEMS INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSH',
    Issuer: 'EXOS ACTIVE SPAC ARBITRAGE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSII',
    Issuer: 'CARDIOVASCULAR SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSIQ',
    Issuer: 'CANADIAN SOLAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSL',
    Issuer: 'CARLISLE COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSLM',
    Issuer: 'CONSILIUM ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSLMR',
    Issuer: 'CONSILIUM ACQUISITION -RIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSLMU',
    Issuer: 'CONSILIUM ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSLMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSM',
    Issuer: 'PROSHARES LARGE CAP CORE PLU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSML',
    Issuer: 'IQ CHAIKIN SMALL CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSPI',
    Issuer: 'CSP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSQ',
    Issuer: 'CALAMOS STRAT TOT RETURN FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSR',
    Issuer: 'CENTERSPACE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSSE',
    Issuer: 'CHICKEN SOUP FOR THE SOUL EN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSSEN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSSEP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTA',
    Issuer: 'CONSTELLATION ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTA=',
    Issuer: 'CONSTELLATION ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTE',
    Issuer: 'CAESARSTONE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTL',
    Issuer: 'CASTLE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTM',
    Issuer: 'CONSTELLIUM SE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSTR',
    Issuer: 'CAPSTAR FINANCIAL HOLDINGS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSV',
    Issuer: 'CARRIAGE SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSWC',
    Issuer: 'CAPITAL SOUTHWEST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSWI',
    Issuer: 'CSW INDUSTRIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CSX',
    Issuer: 'CSX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTA',
    Issuer: 'SIMPLIFY MANAGED FUTURES ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTA-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTA-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTAQ',
    Issuer: 'CARNEY TECHNOLOGY ACQU- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTAQU',
    Issuer: 'CARNEY TECHNOLOGY ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTAS',
    Issuer: 'CINTAS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTBB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTBI',
    Issuer: 'COMMUNITY TRUST BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTDD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTEC',
    Issuer: 'GLOBAL X CLEANTECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTEK',
    Issuer: 'CYNERGISTEK INC/DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTEX',
    Issuer: 'PROSHARES S&P KENSHO CLEANTC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTG',
    Issuer: 'COMPUTER TASK GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTGO',
    Issuer: 'CONTANGO ORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTHR',
    Issuer: 'CHARLES & COLVARD LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTIB',
    Issuer: 'YUNHONG CTI LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTIC',
    Issuer: 'CTI BIOPHARMA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTKB',
    Issuer: 'CYTEK BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTLP',
    Issuer: 'CANTALOUPE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTLT',
    Issuer: 'CATALENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTMX',
    Issuer: 'CYTOMX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTO',
    Issuer: 'CTO REALTY GROWTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTOS',
    Issuer: 'CUSTOM TRUCK ONE SOURCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTOS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTR',
    Issuer: 'CLEARBRIDGE MLP & MIDSTREAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTRA',
    Issuer: 'COTERRA ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTRE',
    Issuer: 'CARETRUST REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTRM',
    Issuer: 'CASTOR MARITIME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTRN',
    Issuer: 'CITI TRENDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTRU',
    Issuer: 'ARK TRANSPARENCY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTS',
    Issuer: 'CTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTSH',
    Issuer: 'COGNIZANT TECH SOLUTIONS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTSO',
    Issuer: 'CYTOSORBENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTT',
    Issuer: 'CATCHMARK TIMBER TRUST INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTV',
    Issuer: 'INNOVID CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTVA',
    Issuer: 'CORTEVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTXR',
    Issuer: 'CITIUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTXRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CTXS',
    Issuer: 'CITRIX SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBA',
    Issuer: 'HERZFELD CARIBBEAN BASIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBE',
    Issuer: 'CUBESMART',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBI',
    Issuer: 'CUSTOMERS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBI-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBI-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUBS',
    Issuer: 'ASIAN GROWTH CUBS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUE',
    Issuer: 'CUE BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUEN',
    Issuer: 'CUENTAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUENW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUK',
    Issuer: 'CARNIVAL PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CULL',
    Issuer: 'CULLMAN BANCORP INC/MD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CULP',
    Issuer: 'CULP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CURE',
    Issuer: 'DRX DLY HEALTHCARE BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CURI',
    Issuer: 'CURIOSITYSTREAM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CURIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CURO',
    Issuer: 'CURO GROUP HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CURV',
    Issuer: 'TORRID HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUT',
    Issuer: 'INVESCO MSCI GLOBAL TIMBER E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUTR',
    Issuer: 'CUTERA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CUZ',
    Issuer: 'COUSINS PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVAC',
    Issuer: 'CUREVAC NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVAR',
    Issuer: 'CULTIVAR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVBF',
    Issuer: 'CVB FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVCO',
    Issuer: 'CAVCO INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVCY',
    Issuer: 'CENTRAL VALLEY COMM BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVE',
    Issuer: 'CENOVUS ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVEO',
    Issuer: 'CIVEO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVET',
    Issuer: 'COVETRUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVGI',
    Issuer: 'COMMERCIAL VEHICLE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVGW',
    Issuer: 'CALAVO GROWERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVI',
    Issuer: 'CVR ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVII',
    Issuer: 'CHURCHILL CAPITAL CORP VII-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVII+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVII=',
    Issuer: 'CHURCHILL CAPITAL CORP VII',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVLG',
    Issuer: 'COVENANT LOGISTICS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVLT',
    Issuer: 'COMMVAULT SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVLY',
    Issuer: 'CODORUS VALLEY BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVM',
    Issuer: 'CEL-SCI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVNA',
    Issuer: 'CARVANA CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVR',
    Issuer: 'CHICAGO RIVET & MACHINE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVRX',
    Issuer: 'CVRX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVS',
    Issuer: 'CVS HEALTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVT',
    Issuer: 'CVENT HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVV',
    Issuer: 'CVD EQUIPMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVX',
    Issuer: 'CHEVRON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CVY',
    Issuer: 'INVESCO ZACKS MULTI-ASSET IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CW',
    Issuer: 'CURTISS-WRIGHT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWAN',
    Issuer: 'CLEARWATER ANALYTICS HDS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWB',
    Issuer: 'SPDR BLOOMBERG CONVERTIBLE S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWBC',
    Issuer: 'COMMUNITY WEST BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWBR',
    Issuer: 'COHBAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWCO',
    Issuer: 'CONSOLIDATED WATER CO-ORD SH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWEB',
    Issuer: 'DRX DLY CHINA INT BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWEN',
    Issuer: 'CLEARWAY ENERGY INC-C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWEN.A',
    Issuer: 'CLEARWAY ENERGY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWH',
    Issuer: 'CAMPING WORLD HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWI',
    Issuer: 'SPDR MSCI ACWI EX-US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWK',
    Issuer: 'CUSHMAN & WAKEFIELD PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWS',
    Issuer: 'ADVISORSHARES EQUITY FOCUSED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWST',
    Issuer: 'CASELLA WASTE SYSTEMS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CWT',
    Issuer: 'CALIFORNIA WATER SERVICE GRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CX',
    Issuer: 'CEMEX SAB-SPONS ADR PART CER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXAC',
    Issuer: 'C5 ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXAC=',
    Issuer: 'C5 ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXDO',
    Issuer: 'CREXENDO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXE',
    Issuer: 'MFS HIGH INCOME MUNICIPAL TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXH',
    Issuer: 'MFS INVESTMENT GRADE MUNICIP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXM',
    Issuer: 'SPRINKLR INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXSE',
    Issuer: 'WISDOMTREE CHINA EX-ST OW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CXW',
    Issuer: 'CORECIVIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYA',
    Issuer: 'SIMPLIFY TAIL RISK STRATEGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYAD',
    Issuer: 'CELYAD ONCOLOGY-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYAN',
    Issuer: 'CYANOTECH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYB',
    Issuer: 'WISDOMTREE CHINESE YUAN STRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYBE',
    Issuer: 'CYBEROPTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYBN',
    Issuer: 'CYBIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYBR',
    Issuer: 'CYBERARK SOFTWARE LTD/ISRAEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYCC',
    Issuer: 'CYCLACEL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYCCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYCN',
    Issuer: 'CYCLERION THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYD',
    Issuer: 'CHINA YUCHAI INTL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYH',
    Issuer: 'COMMUNITY HEALTH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYN',
    Issuer: 'CYNGN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYRN',
    Issuer: 'CYREN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYRX',
    Issuer: 'CRYOPORT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYT',
    Issuer: 'CYTEIR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYTH',
    Issuer: 'CYCLO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYTHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYTK',
    Issuer: 'CYTOKINETICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYTO',
    Issuer: 'ALTAMIRA THERAPEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CYXT',
    Issuer: 'CYXTERA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZA',
    Issuer: 'INVESCO ZACKS MID-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZNC',
    Issuer: 'CITIZENS & NORTHERN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZOO',
    Issuer: 'CAZOO GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZOO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZR',
    Issuer: 'CAESARS ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'CZWI',
    Issuer: 'CITIZENS COMMUNITY BANCORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'D',
    Issuer: 'DOMINION ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAC',
    Issuer: 'DANAOS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DADA',
    Issuer: 'DADA NEXUS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAIO',
    Issuer: 'DATA I/O CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAKT',
    Issuer: 'DAKTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAL',
    Issuer: 'DELTA AIR LINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DALI',
    Issuer: 'FIRST TRUST DORSEYWRIGHT DAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DALN',
    Issuer: 'DALLASNEWS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DALS',
    Issuer: 'DA32 LIFE SCIENCE TECH ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DALT',
    Issuer: 'ANFIELD CAP DIVERSIFIED ALT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAM',
    Issuer: 'VANECK DIGITAL ASSETS MINING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAN',
    Issuer: 'DANA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAO',
    Issuer: 'YOUDAO INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAOO',
    Issuer: 'CRYPTO 1 ACQUISITION COR-CLA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAOOU',
    Issuer: 'CRYPTO 1 ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAOOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAPP',
    Issuer: 'VANECK DIGITAL TRANSFORMATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAPR',
    Issuer: 'FT CB US EQ DEEP BUFF APR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAR',
    Issuer: 'DARLING INGREDIENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DARE',
    Issuer: 'DARE BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DASH',
    Issuer: 'DOORDASH INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAT',
    Issuer: 'PROSHARES BIG DATA REFINERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DATS',
    Issuer: 'DATCHAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DATSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAUG',
    Issuer: 'FT CBOE US EQUITY DEEP BUFFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAVA',
    Issuer: 'ENDAVA PLC- SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAVE',
    Issuer: 'DAVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAVEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAWN',
    Issuer: 'DAY ONE BIOPHARMACEUTICALS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DAX',
    Issuer: 'GLOBAL X DAX GERMANY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DB',
    Issuer: 'DEUTSCHE BANK AG-REGISTERED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBA',
    Issuer: 'INVESCO DB AGRICULTURE FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBAW',
    Issuer: 'XTRACKERS MSCI ALL WORLD EX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBB',
    Issuer: 'INVESCO DB BASE METALS FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBC',
    Issuer: 'INVESCO DB COMMODITY INDEX T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBD',
    Issuer: 'DIEBOLD NIXDORF INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBE',
    Issuer: 'INVESCO DB ENERGY FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBEF',
    Issuer: 'XTRACKERS MSCI EAFE HEDGED E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBEH',
    Issuer: 'IMGP DBI HEDGE STRATEGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBEM',
    Issuer: 'XTRACKERS MSCI EMERGING MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBEU',
    Issuer: 'XTRACKERS MSCI EUROPE HEDGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBEZ',
    Issuer: 'XTRACKERS MSCI EUROZONE HEDG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBGI',
    Issuer: 'DIGITAL BRANDS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBGIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBGR',
    Issuer: 'XTRACKERS MSCI GERMANY HEDGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBI',
    Issuer: 'DESIGNER BRANDS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBJA',
    Issuer: 'INNOVATOR DBL STACK 9 BUFF-J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBJP',
    Issuer: 'XTRACKERS MSCI JAPAN HEDGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBL',
    Issuer: 'DOUBLELINE OPPORT CREDIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBLV',
    Issuer: 'ADVISORSHARES DOUBLELINE VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBMF',
    Issuer: 'IMGP DBI MANAGED FUTURES STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBND',
    Issuer: 'DOUBLELINE OPPORTUNISTIC BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBO',
    Issuer: 'INVESCO DB OIL FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBOC',
    Issuer: 'INNOV DBL STACKER 9 BUFF OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBP',
    Issuer: 'INVESCO DB PRECIOUS METALS F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBRG',
    Issuer: 'DIGITALBRIDGE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBRG-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBRG-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBRG-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBS',
    Issuer: 'INVESCO DB SILVER FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBTX',
    Issuer: 'DECIBEL THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBV',
    Issuer: 'INVESCO DB G10 CURRENCY HARV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBVT',
    Issuer: 'DBV TECHNOLOGIES SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DBX',
    Issuer: 'DROPBOX INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DC',
    Issuer: 'DAKOTA GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCBO',
    Issuer: 'DOCEBO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCF',
    Issuer: 'BNY MELLON ALCENTRA GLOBAL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCFC',
    Issuer: 'TRITIUM DCFC LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCFCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCGO',
    Issuer: 'DOCGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCGOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCI',
    Issuer: 'DONALDSON CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCO',
    Issuer: 'DUCOMMUN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCOM',
    Issuer: 'DIME COMMUNITY BANCSHARES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCOMP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCP',
    Issuer: 'DCP MIDSTREAM LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCP-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCP-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCPH',
    Issuer: 'DECIPHERA PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCRD',
    Issuer: 'DECARBONIZATION PLUS ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCRDU',
    Issuer: 'DECARBONIZATION PLUS ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCRDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCT',
    Issuer: 'DUCK CREEK TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCTH',
    Issuer: 'DELCATH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DCUE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DD',
    Issuer: 'DUPONT DE NEMOURS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDD',
    Issuer: '3D SYSTEMS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDEC',
    Issuer: 'FT CBOE VEST US DEEP BUF DEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDF',
    Issuer: 'DELAWARE INV DIVIDEND & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDI',
    Issuer: 'DOUBLEDOWN INTERACTIVE -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDIV',
    Issuer: 'FIRST TRUST DORSEY WRIGHT MO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDL',
    Issuer: 'DINGDONG CAYMAN LTD -SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDLS',
    Issuer: 'WISDOMTREE DY CUR HDG SCP EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDM',
    Issuer: 'PROSHARES ULTRA DOW30',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDOG',
    Issuer: 'DATADOG INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDS',
    Issuer: 'DILLARDS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DDWM',
    Issuer: 'WISDOMTREE DY CUR HDG INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DE',
    Issuer: 'DEERE & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEA',
    Issuer: 'EASTERLY GOVERNMENT PROPERTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DECAU',
    Issuer: 'DENALI CAPITAL ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DECK',
    Issuer: 'DECKERS OUTDOOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DECZ',
    Issuer: 'TRUESHARES STRUC OUT DEC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEED',
    Issuer: 'FIRST TRUST TCW SEC PLUS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEEF',
    Issuer: 'XTRACK FTSE DEV EX US MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEEP',
    Issuer: 'ROUNDHILL ACQUIRERS DEEP VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEF',
    Issuer: 'INVESCO DEFENSIVE EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEHP',
    Issuer: 'DIMENSIONAL EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEI',
    Issuer: 'DOUGLAS EMMETT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEIF',
    Issuer: 'STERLING CAP DIV MULT MAN AT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DELL',
    Issuer: 'DELL TECHNOLOGIES -C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEM',
    Issuer: 'WISDOMTREE EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEMZ',
    Issuer: 'DEMOCRATIC LARGE CAP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEN',
    Issuer: 'DENBURY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DENN',
    Issuer: "DENNY'S CORP",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEO',
    Issuer: 'DIAGEO PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DERM',
    Issuer: 'JOURNEY MEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DES',
    Issuer: 'WISDOMTREE US SMALLCAP DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DESP',
    Issuer: 'DESPEGAR.COM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEUS',
    Issuer: 'XTRACKERS RUSSELL US MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEW',
    Issuer: 'WISDOMTREE GLOBAL HIGH DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DEX',
    Issuer: 'DELAWARE ENHANCED GLOBAL DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAC',
    Issuer: 'DIMENSIONAL US CORE EQUITY 2',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAE',
    Issuer: 'DIMENSIONAL EMERGING CORE EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAI',
    Issuer: 'DIMENSIONAL INTERNATIONAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAR',
    Issuer: 'DIMENSIONAL US REAL EST ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAS',
    Issuer: 'DIMENSIONAL US SMALL CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAT',
    Issuer: 'DIMENSIONAL US TARGET VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAU',
    Issuer: 'DIMENSIONAL US CORE EQUITY M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFAX',
    Issuer: 'DIMENSIONAL WORLD EX US CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFCF',
    Issuer: 'DIMENSIONAL CORE FIXED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFE',
    Issuer: 'WISDOMTREE EUR S/C DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFEB',
    Issuer: 'FT CBOE VEST US EQY DEEP BUF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFEM',
    Issuer: 'DIMENSIONAL EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFEN',
    Issuer: 'DRX DLY AERO & DEF BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFEV',
    Issuer: 'DIMENSIONAL EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFFN',
    Issuer: 'DIFFUSION PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFH',
    Issuer: 'DREAM FINDERS HOMES INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFHY',
    Issuer: 'DONOGHUE FORLINES TACTICAL H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFIC',
    Issuer: 'DIMENSIONAL INTERNATIONAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFIN',
    Issuer: 'DONNELLEY FINANCIAL SOLUTION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFIP',
    Issuer: 'Dimensional Inflation-Protec',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFIS',
    Issuer: 'DIMENSIONAL INTERNATIONAL SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFIV',
    Issuer: 'DIMENSIONAL INTERNATIONAL VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFJ',
    Issuer: 'WISDOMTREE JPN S/C DVD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFND',
    Issuer: 'SIREN DIVCON DIVIDEND DEFEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFNL',
    Issuer: 'DAVIS SELECT FINANCIAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFNM',
    Issuer: 'DIMENSIONAL NATIONAL MUNI BD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFNV',
    Issuer: 'DONOGHUE FORLINES RISK MANAG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFP',
    Issuer: 'FLAHERTY & CRUMRINE DYNAMIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFRA',
    Issuer: 'DONOGHUE FORLINES YLD R/A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFS',
    Issuer: 'DISCOVER FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFSD',
    Issuer: 'DIMENSIONAL SHORT DURATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFSV',
    Issuer: 'DIMENSIONAL US SMALL CAP VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFUS',
    Issuer: 'DIMENSIONAL US EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DFUV',
    Issuer: 'DIMENSIONAL US MARKETWIDE VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DG',
    Issuer: 'DOLLAR GENERAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGHI',
    Issuer: 'DIGIHOST TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGICA',
    Issuer: 'DONEGAL GROUP INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGICB',
    Issuer: 'DONEGAL GROUP INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGII',
    Issuer: 'DIGI INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGIN',
    Issuer: 'VANECK DIGITAL INDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGL',
    Issuer: 'INVESCO DB GOLD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGLY',
    Issuer: 'DIGITAL ALLY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGNU',
    Issuer: 'DRAGONEER GROWTH OPP III-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGP',
    Issuer: 'DB GOLD DOUBLE LONG ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGRE',
    Issuer: 'WISDOMTREE EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGRO',
    Issuer: 'ISHARES CORE DIVIDEND GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGRS',
    Issuer: 'WISDOMTREE U.S. SMALLCAP QUA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGRW',
    Issuer: 'WISDOMTREE U.S. QUALITY DIVI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGS',
    Issuer: 'WISDOMTREE EM SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGT',
    Issuer: 'SPDR GLOBAL DOW ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGX',
    Issuer: 'QUEST DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DGZ',
    Issuer: 'DB GOLD SHORT ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DH',
    Issuer: 'DEFINITIVE HEALTHCARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHAC',
    Issuer: 'DIGITAL HEALTH ACQUISTION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHACU',
    Issuer: 'DIGITAL HEALTH ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHBC',
    Issuer: 'DHB CAPITAL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHBCU',
    Issuer: 'DHB CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHBCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHC',
    Issuer: 'DIVERSIFIED HEALTHCARE TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHCA',
    Issuer: 'DHC ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHCAU',
    Issuer: 'DHC ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHCNI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHCNL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHF',
    Issuer: 'BNYM HIGH YIELD STRAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHHC',
    Issuer: 'DIAMONDHEAD HOLDINGS CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHHCU',
    Issuer: 'DIAMONDHEAD HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHHCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHI',
    Issuer: 'DR HORTON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHIL',
    Issuer: 'DIAMOND HILL INVESTMENT GRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHR',
    Issuer: 'DANAHER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHS',
    Issuer: 'WISDOMTREE US HIGH DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHT',
    Issuer: 'DHT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHX',
    Issuer: 'DHI GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DHY',
    Issuer: 'CREDIT SUISSE HIGH YIELD BD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIA',
    Issuer: 'SPDR DJIA TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIAL',
    Issuer: 'COLUMBIA DIVERSIFIED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIAX',
    Issuer: 'NUVEEN DOW30 DYN OVERWRT FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIBS',
    Issuer: '1STDIBS.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DICE',
    Issuer: 'DICE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIDI',
    Issuer: 'DIDI GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIG',
    Issuer: 'PROSHARES ULTRA OIL & GAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIHP',
    Issuer: 'DIMENSIONAL INTERNATIONAL HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DILA',
    Issuer: 'DILA CAPITAL ACQUISITION - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DILAU',
    Issuer: 'DILA CAPITAL ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DILAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIM',
    Issuer: 'WISDOMTREE INTL M/C DVD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIN',
    Issuer: 'DINE BRANDS GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DINO',
    Issuer: 'HF SINCLAIR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DINT',
    Issuer: 'DAVIS SELECT INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIOD',
    Issuer: 'DIODES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIS',
    Issuer: 'WALT DISNEY CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DISA',
    Issuer: 'DISRUPTIVE ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DISAU',
    Issuer: 'DISRUPTIVE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DISAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DISH',
    Issuer: 'DISH NETWORK CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DISV',
    Issuer: 'DIMENSIONAL INTERNATIONAL SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIT',
    Issuer: 'AMCON DISTRIBUTING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIV',
    Issuer: 'GLOBAL X SUPERDIVIDEND USE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIVA',
    Issuer: 'AGFIQ HEDGED DIVIDEND INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIVB',
    Issuer: 'ISHARES US DVD AND BUYBACK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIVO',
    Issuer: 'AMPLIFY CWP ENHANCED DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIVS',
    Issuer: 'SMARTETFS DIVIDEND BUILDER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DIVZ',
    Issuer: 'TRUESHARES LOW VOLATILITY EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJAN',
    Issuer: 'FT CBOE VEST US EQ DEEP JAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJCB',
    Issuer: 'ETRACS BLOOMBERG CMD INX-S/B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJCO',
    Issuer: 'DAILY JOURNAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJD',
    Issuer: 'INVESCO DOW JONES INDUSTRIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJIA',
    Issuer: 'GLOBAL X DOW 30 COV CALL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJP',
    Issuer: 'IPATH BLOOMBERG COMMODITY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJUL',
    Issuer: 'FT CBOE VEST US EQ DEEP BUF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DJUN',
    Issuer: 'FT CBOE VEST U.S. EQUITY DEE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DK',
    Issuer: 'DELEK US HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKDCA',
    Issuer: 'DATA KNIGHTS ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKDCU',
    Issuer: 'DATA KNIGHTS ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKDCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKL',
    Issuer: 'DELEK LOGISTICS PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKNG',
    Issuer: 'DRAFTKINGS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DKS',
    Issuer: "DICK'S SPORTING GOODS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLA',
    Issuer: 'DELTA APPAREL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLB',
    Issuer: 'DOLBY LABORATORIES INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLCA',
    Issuer: 'DEEP LAKE CAPITAL ACQUIS-CLA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLCAU',
    Issuer: 'DEEP LAKE CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLHC',
    Issuer: 'DLH HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLN',
    Issuer: 'WISDOMTREE US LARGECAP DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLNG',
    Issuer: 'DYNAGAS LNG PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLNG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLNG-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLO',
    Issuer: 'DLOCAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLPN',
    Issuer: 'DOLPHIN ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLR',
    Issuer: 'DIGITAL REALTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLR-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLR-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLR-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLS',
    Issuer: 'WISDOMTREE INTL S/C DVD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLTH',
    Issuer: 'DULUTH HOLDINGS INC - CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLTR',
    Issuer: 'DOLLAR TREE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLX',
    Issuer: 'DELUXE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DLY',
    Issuer: 'DOUBLELINE YIELD OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DM',
    Issuer: 'DESKTOP METAL INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMA',
    Issuer: 'DESTRA MULTI-ALTERNATIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAC',
    Issuer: 'DIAMEDICA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAQ',
    Issuer: 'DEEP MEDICINE ACQUISITI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAQR',
    Issuer: 'DEEP MEDICINE ACQUITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAR',
    Issuer: 'FT CBOE VST US EQY DP BUF-MR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAT',
    Issuer: 'GLOBAL X DISRUPTIVE MATER ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMAY',
    Issuer: 'FT CBOE VEST US EQY D BU-MAY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMB',
    Issuer: 'BNYM MUNI BND INFRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMCY',
    Issuer: 'DEMOCRACY INTERNATIONAL FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMDV',
    Issuer: 'AAM S&P DEVELOPED MARKETS HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMF',
    Issuer: 'BNYM MUNICIPAL INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMLP',
    Issuer: 'DORCHESTER MINERALS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMO',
    Issuer: 'WESTERN ASSET MORTGAGE OPPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMRC',
    Issuer: 'DIGIMARC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMS',
    Issuer: 'DIGITAL MEDIA SOLUTIONS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMTK',
    Issuer: 'DERMTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMXF',
    Issuer: 'ISHARES ESG ADVANC MSCI EAFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMYS',
    Issuer: 'DMY TECHNOLOGY GROUP INC VI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMYS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DMYS=',
    Issuer: 'DMY TECHNOLOGY GROUP INC VI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNA',
    Issuer: 'GINKGO BIOWORKS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNAA',
    Issuer: 'SOCIAL CAPITAL SUVRETTA HO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNAB',
    Issuer: 'SOCIAL CAPITAL SUVRETTA HO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNAC',
    Issuer: 'SOCIAL CAPITAL SUVRETTA HO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNAD',
    Issuer: 'SOCIAL CAPITAL SUVRETTA HO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNAY',
    Issuer: 'CODEX DNA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNB',
    Issuer: 'DUN & BRADSTREET HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNL',
    Issuer: 'WISDOMTREE GLOBAL EX-US QUAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNLI',
    Issuer: 'DENALI THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNMR',
    Issuer: 'DANIMER SCIENTIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNN',
    Issuer: 'DENISON MINES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNOV',
    Issuer: 'FT CBOE VEST US EQUITY DEEP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNOW',
    Issuer: 'NOW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNP',
    Issuer: 'DNP SELECT INCOME FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNUT',
    Issuer: 'KRISPY KREME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNZ',
    Issuer: 'D AND Z MEDIA ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNZ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DNZ=',
    Issuer: 'D AND Z MEDIA ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DO',
    Issuer: 'DIAMOND OFFSHORE DRILLING IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOC',
    Issuer: 'PHYSICIANS REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOCN',
    Issuer: 'DIGITALOCEAN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOCS',
    Issuer: 'DOXIMITY INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOCT',
    Issuer: 'FT CBOE VEST US DEEP BUF OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOCU',
    Issuer: 'DOCUSIGN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOG',
    Issuer: 'PROSHARES SHORT DOW30',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOGZ',
    Issuer: 'DOGNESS INTERNATIONAL CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOL',
    Issuer: 'WISDOMTREE INTL L/C DVD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOLE',
    Issuer: 'DOLE PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOMA',
    Issuer: 'DOMA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOMA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOMO',
    Issuer: 'DOMO INC - CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DON',
    Issuer: 'WISDOMTREE US MIDCAP DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOOO',
    Issuer: 'BRP INC/CA- SUB VOTING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOOR',
    Issuer: 'MASONITE INTERNATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DORM',
    Issuer: 'DORMAN PRODUCTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOUG',
    Issuer: 'DOUGLAS ELLIMAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOV',
    Issuer: 'DOVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOW',
    Issuer: 'DOW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOX',
    Issuer: 'AMDOCS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOYU',
    Issuer: 'DOUYU INTERNATIONAL HOLD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DOZR',
    Issuer: 'DIREX DAILY US INFRA BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPCS',
    Issuer: 'DP CAP ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPCSU',
    Issuer: 'DP CAP ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPCSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPG',
    Issuer: 'DUFF & PHELPS UTILITY & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPRO',
    Issuer: 'DRAGANFLY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPSI',
    Issuer: 'DECISIONPOINT SYSTEMS INC/CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPST',
    Issuer: 'DRX DLY REG BANK BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DPZ',
    Issuer: "DOMINO'S PIZZA INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DQ',
    Issuer: 'DAQO NEW ENERGY CORP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRAY',
    Issuer: 'MACONDRAY CAPITAL AC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRAYU',
    Issuer: 'MACONDRAY CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRAYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRCT',
    Issuer: 'DIRECT DIGITAL HOLDINGS IN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRCTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRD',
    Issuer: 'DRDGOLD LTD-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRE',
    Issuer: 'DUKE REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRH',
    Issuer: 'DIAMONDROCK HOSPITALITY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRI',
    Issuer: 'DARDEN RESTAURANTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRIO',
    Issuer: 'DARIOHEALTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRIP',
    Issuer: 'DIREXION DAILY S&P OIL & GAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRIV',
    Issuer: 'GLOBAL X AUTONOMOUS&ELEC-ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRMA',
    Issuer: 'DERMATA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRMAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRN',
    Issuer: 'DIREXION DAILY REAL ESTATE B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRQ',
    Issuer: 'DRIL-QUIP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRRX',
    Issuer: 'DURECT CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRSK',
    Issuer: 'APTUS DEFINED RISK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRTS',
    Issuer: 'ALPHA TAU MEDICAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRTT',
    Issuer: 'DIRTT ENVIRONMENTAL SOLUTION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRUG',
    Issuer: 'BRIGHT MINDS BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRV',
    Issuer: 'DIREXION DAILY REAL ESTATE B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DRVN',
    Issuer: 'DRIVEN BRANDS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DS',
    Issuer: 'DRIVE SHACK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DS-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DS-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DS-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSAC',
    Issuer: 'DUDDELL STREET ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSACU',
    Issuer: 'DUDDELL STREET ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSAQ',
    Issuer: 'DIRECT SELLING ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSAQ=',
    Issuer: 'DIRECT SELLING ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSCF',
    Issuer: 'DISCIPLINE FUND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSEP',
    Issuer: 'FT CBOE VEST US DEEP BUF SEP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSEY',
    Issuer: 'DIVERSEY HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSGN',
    Issuer: 'DESIGN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSGR',
    Issuer: 'DISTRIBUTION SOLUTIONS GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSGX',
    Issuer: 'DESCARTES SYSTEMS GRP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSI',
    Issuer: 'ISHARES MSCI KLD 400 SOCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSJA',
    Issuer: 'INNOVATOR DOUBLE STACKER-JAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSKE',
    Issuer: 'DASEKE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSL',
    Issuer: 'DOUBLELINE INCOME SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSM',
    Issuer: 'BNYM STRAT MUNI BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSOC',
    Issuer: 'INNOVATOR DOUBLE STACKER OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSP',
    Issuer: 'VIANT TECHNOLOGY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSPC',
    Issuer: 'THE DE-SPAC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSS',
    Issuer: 'DSS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSTL',
    Issuer: 'DISTILLATE US FUNDAMENTAL ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSTX',
    Issuer: 'DISTILLATE INTERNATIONAL FUN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSU',
    Issuer: 'BLACKROCK DEBT STRATEGIES FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSWL',
    Issuer: 'DESWELL INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSX',
    Issuer: 'DIANA SHIPPING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DSX-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DT',
    Issuer: 'DYNATRACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTC',
    Issuer: 'SOLO BRANDS INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTD',
    Issuer: 'WISDOMTREE US TOTAL DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTE',
    Issuer: 'DTE ENERGY COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTEA',
    Issuer: 'DAVIDSTEA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTEC',
    Issuer: 'ALPS DISRUPTIVE TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTF',
    Issuer: 'DTF TAX-FREE INCOME 2028 TER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTG',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTH',
    Issuer: 'WISDOMTREE INTERNATIONAL HIG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTIL',
    Issuer: 'PRECISION BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTLA-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTM',
    Issuer: 'DT MIDSTREAM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTOC',
    Issuer: 'DIGITAL TRANSFORMATION OPP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTOCU',
    Issuer: 'DIGITAL TRANSFORMATION OPPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTOCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTOX',
    Issuer: 'AMPLIFY CLEANER LIVING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTRT',
    Issuer: 'DTRT HEALTH ACQ CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTRTU',
    Issuer: 'DTRT HEALTH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTRTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTSS',
    Issuer: 'DATASEA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTST',
    Issuer: 'DATA STORAGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTSTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUDE',
    Issuer: 'MERLYN AI SECTORSURFER MOMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUET',
    Issuer: 'DUET ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUETU',
    Issuer: 'DUET ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUETW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUG',
    Issuer: 'PROSHARES ULTRASHORT OIL&GAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUHP',
    Issuer: 'DIMENSIONAL US HIGH PROFI ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUK',
    Issuer: 'DUKE ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUK-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUKB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUNE',
    Issuer: 'DUNE ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUNEU',
    Issuer: 'DUNE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUNEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUO',
    Issuer: 'FANGDD NETWORK GROUP LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUOL',
    Issuer: 'DUOLINGO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUOT',
    Issuer: 'DUOS TECHNOLOGIES GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DURA',
    Issuer: 'VANECK MSTAR DURABLE DVD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUSA',
    Issuer: 'DAVIS SELECT US EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUSL',
    Issuer: 'DRX DLY INDUSTRIALS BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DUST',
    Issuer: 'DIREXION DAILY GOLD MINERS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DV',
    Issuer: 'DOUBLEVERIFY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVA',
    Issuer: 'DAVITA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVAX',
    Issuer: 'DYNAVAX TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVLU',
    Issuer: 'FIRST TRUST DRSY WRIGHT MOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVN',
    Issuer: 'DEVON ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVOL',
    Issuer: 'FIRST TRUST DW MOMTM & LOW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVY',
    Issuer: 'ISHARES SELECT DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVYA',
    Issuer: 'ISHARES ASIA/PACIFIC DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DVYE',
    Issuer: 'ISHARES EMERGING MARKETS DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWAC',
    Issuer: 'DIGITAL WORLD ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWACU',
    Issuer: 'DIGITAL WORLD ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWAS',
    Issuer: 'INVESCO DWA SMALLCAP MOMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWAT',
    Issuer: 'ARROW DWA TACTICAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWAW',
    Issuer: 'ADVISORSHARES D/W FSM CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWCR',
    Issuer: 'ARROW DWA COUNTRY ROTATION E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWEQ',
    Issuer: 'ADVISORSHARES D/W ALPH EQ WT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWIN',
    Issuer: 'DELWINDS INSURANCE - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWIN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWIN=',
    Issuer: 'DELWINDS INSURANCE ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWLD',
    Issuer: 'DAVIS SELECT WORLDWIDE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWM',
    Issuer: 'WISDOMTREE INTERNATIONAL EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWMC',
    Issuer: 'ADVISORSHARES DORSEY MC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWMF',
    Issuer: 'WISDOMTREE INTERNATIONAL MUL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWPP',
    Issuer: 'FIRST TRUST DORSEY WRIGHT PE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWSH',
    Issuer: 'ADVISORSHARES DORSEY WS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWSN',
    Issuer: 'DAWSON GEOPHYSICAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWUS',
    Issuer: 'ADVISORSHARES D/W FSM CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DWX',
    Issuer: 'SPDR S&P INTER DVD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DX',
    Issuer: 'DYNEX CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DX-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXC',
    Issuer: 'DXC TECHNOLOGY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXCM',
    Issuer: 'DEXCOM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXD',
    Issuer: 'PROSHARES ULTRASHORT DOW30',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXF',
    Issuer: 'DUNXIN FINANCIAL HOLDING-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXGE',
    Issuer: 'WISDOMTREE GERMANY HEDGED EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXJ',
    Issuer: 'WISDOMTREE JAPAN HEDGED EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXJS',
    Issuer: 'WISDOMTREE JAPAN HEDGED SMAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXLG',
    Issuer: 'DESTINATION XL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXPE',
    Issuer: 'DXP ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXR',
    Issuer: 'DAXOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DXYN',
    Issuer: 'DIXIE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DY',
    Issuer: 'DYCOM INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYAI',
    Issuer: 'DYADIC INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYFN',
    Issuer: 'ANGEL OAK DYN FIN STRAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYLD',
    Issuer: 'LEADERSHARES DYNAMIC YIELD E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYN',
    Issuer: 'DYNE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYNF',
    Issuer: 'BLACKROCK US EQY FCTR ROTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYNS',
    Issuer: 'DYNAMICS SPECIAL PURPOSE C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DYNT',
    Issuer: 'DYNATRONICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DZSI',
    Issuer: 'DZS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'DZZ',
    Issuer: 'DB GOLD DOUBLE SHORT ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'E',
    Issuer: 'ENI SPA-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EA',
    Issuer: 'ELECTRONIC ARTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAC',
    Issuer: 'EDIFY ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EACPU',
    Issuer: 'EDIFY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EACPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAD',
    Issuer: 'ALLSPRING INCOME OPPORTUNITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAF',
    Issuer: 'GRAFTECH INTERNATIONAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAFD',
    Issuer: 'SIMPLIFY DEV EX-US PL DN CTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAGG',
    Issuer: 'ISHARES ESG AWARE US AGGREGA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAOA',
    Issuer: 'ISHARES ESG AWARE AGGR ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAOK',
    Issuer: 'ISHARES ESG AWARE CONS ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAOM',
    Issuer: 'ISHARES ESG AWARE MOD ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAOR',
    Issuer: 'ISHARES ESG AWARE GROW ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAPR',
    Issuer: 'INNOVATOR EMERGING MARKETS P',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAR',
    Issuer: 'EARGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EARN',
    Issuer: 'ELLINGTON RESIDENTIAL MORTGA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EASG',
    Issuer: 'XTRACKERS MSCI EAFE ESG LDRS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAST',
    Issuer: 'EASTSIDE DISTILLING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EAT',
    Issuer: 'BRINKER INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EATV',
    Issuer: 'VEGTECH PLANT BASED INNOVATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EATZ',
    Issuer: 'ADVISORSHARES RESTAURANT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EB',
    Issuer: 'EVENTBRITE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBAC',
    Issuer: 'EUROPEAN BIOTECH ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBACU',
    Issuer: 'EUROPEAN BIOTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBAY',
    Issuer: 'EBAY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBC',
    Issuer: 'EASTERN BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBET',
    Issuer: 'EBET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBF',
    Issuer: 'ENNIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBIX',
    Issuer: 'EBIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBIZ',
    Issuer: 'GLOBAL X E-COMMERCE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBLU',
    Issuer: 'ECOFIN GLOBAL WATER ESG FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBMT',
    Issuer: 'EAGLE BANCORP MONTANA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBND',
    Issuer: 'SPDR BLOOMBERG EM BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBON',
    Issuer: 'EBANG INTERNATIONAL HLDGS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBR',
    Issuer: 'CENTRAIS ELETRICAS BR-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBR.B',
    Issuer: 'CENTRAIS ELEC BRAS-ADR PREF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBS',
    Issuer: 'EMERGENT BIOSOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EBTC',
    Issuer: 'ENTERPRISE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EC',
    Issuer: 'ECOPETROL SA-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECAT',
    Issuer: 'BLACKROCK ESG CAPITAL ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECC',
    Issuer: 'EAGLE POINT CREDIT CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECC-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECCC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECCV',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECCX',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECF',
    Issuer: 'ELLSWORTH GROWTH AND INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECF-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECH',
    Issuer: 'ISHARES MSCI CHILE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECL',
    Issuer: 'ECOLAB INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECLN',
    Issuer: 'FIRST TRUST EIP CARBON IMPAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECNS',
    Issuer: 'ISHARES MSCI CHINA SMALL-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECOM',
    Issuer: 'CHANNELADVISOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECON',
    Issuer: 'COLUMBIA EMERGING MARKETS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECOR',
    Issuer: 'ELECTROCORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECOW',
    Issuer: 'PACER EMERGING MARKETS CASH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECOZ',
    Issuer: 'TRUESHARES ESG ACTIVE OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECPG',
    Issuer: 'ENCORE CAPITAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ECVT',
    Issuer: 'ECOVYST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ED',
    Issuer: 'CONSOLIDATED EDISON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDAP',
    Issuer: 'EDAP TMS SA -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDBL',
    Issuer: 'EDIBLE GARDEN AG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDBLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDC',
    Issuer: 'DIREXION DLY EMG MKT BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDD',
    Issuer: 'MORGAN STANLEY EMERGING MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDEN',
    Issuer: 'ISHARES MSCI DENMARK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDF',
    Issuer: 'VIRTUS STONE HARBOR EMERGING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDI',
    Issuer: 'VIRTUS STONE HARBOR EMERGING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDIT',
    Issuer: 'EDITAS MEDICINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDIV',
    Issuer: 'SPDR S&P EMERGING MARKETS DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDN',
    Issuer: 'EMP DISTRIB Y COMERC NOR-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDNC',
    Issuer: 'ENDURANCE ACQUISITIO-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDNCU',
    Issuer: 'ENDURANCE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDNCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDOC',
    Issuer: 'GL X TELEMEDICINE DIG HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDOG',
    Issuer: 'ALPS EMERGING SECTOR DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDOW',
    Issuer: 'FIRST TRUST DOW 30 EQL WGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDR',
    Issuer: 'ENDEAVOR GROUP HOLD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDRY',
    Issuer: 'EURODRY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDSA',
    Issuer: 'EDESA BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDTK',
    Issuer: 'SKILLFUL CRAFTSMAN EDUCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDTX',
    Issuer: 'EDTECHX HOLDINGS II-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDTXU',
    Issuer: 'EDTECHX HOLDINGS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDTXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDU',
    Issuer: 'NEW ORIENTAL EDUCATIO-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDUC',
    Issuer: 'EDUCATIONAL DEVELOPMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDUT',
    Issuer: 'GLOBAL X EDUCATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDV',
    Issuer: 'VANGUARD EXTENDED DUR TREAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EDZ',
    Issuer: 'DIREXION DLY EMG MKT BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EE',
    Issuer: 'EXCELERATE ENERGY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEA',
    Issuer: 'EUROPEAN EQUITY FUND INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEFT',
    Issuer: 'EURONET WORLDWIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEH',
    Issuer: 'ELEMENTS SPECTRUM ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEIQ',
    Issuer: 'ELITE EDUCATION GROUP INTERN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EELV',
    Issuer: 'INVESCO S&P EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEM',
    Issuer: 'ISHARES MSCI EMERGING MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMA',
    Issuer: 'ISHARES MSCI EMERG MRKT ASIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMD',
    Issuer: 'AAM S&P EM HIGH DIV VAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMO',
    Issuer: 'INVESCO S&P EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMS',
    Issuer: 'ISHARES MSCI EMERGING MKT SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMV',
    Issuer: 'ISHARES MSCI EMG MKT MIN VOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEMX',
    Issuer: 'SPDR MSCI EM FSL FL RSV FREE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EERN',
    Issuer: 'DriveWealth Power Saver ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EES',
    Issuer: 'WISDOMTREE US SMALLCAP FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EET',
    Issuer: 'PROSHARES ULT MSCI EMER MKTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEV',
    Issuer: 'PROSHARES ULTSHRT MSCI EM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EEX',
    Issuer: 'EMERALD HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFA',
    Issuer: 'ISHARES MSCI EAFE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFAD',
    Issuer: 'PROSHARES EAFE DVD GROWERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFAS',
    Issuer: 'GLOBAL X MSCI SUPERDIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFAV',
    Issuer: 'ISHARES MSCI EAFE MIN VOL FA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFAX',
    Issuer: 'SPDR MSCI EAFA FOSSIL FUEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFC',
    Issuer: 'ELLINGTON FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFC-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFG',
    Issuer: 'ISHARES MSCI EAFE GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFIV',
    Issuer: 'SPDR S&P 500 ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFIX',
    Issuer: 'FT TCW EMERGING MARKETS DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFL',
    Issuer: 'EATON VANCE FLOATING-RATE 20',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFNL',
    Issuer: 'ISHARES MSCI FINLAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFO',
    Issuer: 'PROSHARES ULTRA MSCI EAFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFOI',
    Issuer: 'ENERGY FOCUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFR',
    Issuer: 'EATON VANCE SR FLTG RATE TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFSC',
    Issuer: 'ENTERPRISE FINANCIAL SERVICE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFSCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFT',
    Issuer: 'EATON VANCE FLOAT RT INC TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFTR',
    Issuer: 'EFFECTOR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFTRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFU',
    Issuer: 'PROSHARES ULTSHRT MSCI EAFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFV',
    Issuer: 'ISHARES MSCI EAFE VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFX',
    Issuer: 'EQUIFAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EFZ',
    Issuer: 'PROSHARES SHORT MSCI EAFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGAN',
    Issuer: 'EGAIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGBN',
    Issuer: 'EAGLE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGF',
    Issuer: 'BLACKROCK ENHANCED GOVT FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGGF',
    Issuer: 'EG ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGGF+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGGF=',
    Issuer: 'EG ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGHT',
    Issuer: '8X8 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGIS',
    Issuer: '2NDVOTE SOCIETY DEFENDED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGLE',
    Issuer: 'EAGLE BULK SHIPPING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGLX',
    Issuer: 'ENTHUSIAST GAMING HOLDINGS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGO',
    Issuer: 'ELDORADO GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGP',
    Issuer: 'EASTGROUP PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGPT',
    Issuer: 'VANECK EGYPT INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGRX',
    Issuer: 'EAGLE PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EGY',
    Issuer: 'VAALCO ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EH',
    Issuer: 'EHANG HOLDINGS LTD-SPS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EHC',
    Issuer: 'ENCOMPASS HEALTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EHI',
    Issuer: 'WESTERN ASSET GLOBAL HIGH IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EHTH',
    Issuer: 'EHEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIC',
    Issuer: 'EAGLE POINT INCOME CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EICA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIDO',
    Issuer: 'ISHARES MSCI INDONESIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIG',
    Issuer: 'EMPLOYERS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIGR',
    Issuer: 'EIGER BIOPHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIM',
    Issuer: 'EATON VANCE MUNICIPAL BOND F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EINC',
    Issuer: 'VANECK ENERGY INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIRL',
    Issuer: 'ISHARES MSCI IRELAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIS',
    Issuer: 'ISHARES MSCI ISRAEL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EIX',
    Issuer: 'EDISON INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJAN',
    Issuer: 'INNOVATOR EMERGING MARKETS P',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJFA',
    Issuer: 'EJF ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJFAU',
    Issuer: 'EJF ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJFAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJH',
    Issuer: 'E-HOME HOUSEHOLD SERVICE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EJUL',
    Issuer: 'INNOVATOR EMERGING MARKETS P',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EKAR',
    Issuer: 'CAPITAL LINK GLOBAL GREEN EN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EKG',
    Issuer: 'FIRST TRUST NASDAQ LUX DIGIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EKSO',
    Issuer: 'EKSO BIONICS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EL',
    Issuer: 'ESTEE LAUDER COMPANIES-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELA',
    Issuer: 'ENVELA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELAN',
    Issuer: 'ELANCO ANIMAL HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELAT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELBM',
    Issuer: 'ELECTRA BATTERY MATERIALS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELD',
    Issuer: 'WISDOMTREE EMRG MKTS DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELDN',
    Issuer: 'ELEDON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELEV',
    Issuer: 'ELEVATION ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELF',
    Issuer: 'ELF BEAUTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELLO',
    Issuer: 'ELLOMAY CAPITAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELMD',
    Issuer: 'ELECTROMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELMS',
    Issuer: 'ELECTRIC LAST MILE SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELMSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELOX',
    Issuer: 'ELOXX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELP',
    Issuer: 'CIA PARANAENSE ENER-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELQD',
    Issuer: 'ISHARES ESG ADV INV GR CB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELS',
    Issuer: 'EQUITY LIFESTYLE PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELSE',
    Issuer: 'ELECTRO-SENSORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELTK',
    Issuer: 'ELTEK LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELVT',
    Issuer: 'ELEVATE CREDIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELY',
    Issuer: 'CALLAWAY GOLF COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELYM',
    Issuer: 'ELIEM THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ELYS',
    Issuer: 'ELYS GAME TECHNOLOGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EM',
    Issuer: 'SMART SHARE GLOBAL LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMAN',
    Issuer: 'EMAGIN CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMB',
    Issuer: 'ISHARES JP MORGAN USD EMERGI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMBC',
    Issuer: 'EMBECTA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMBD',
    Issuer: 'GLOBAL X EMERGING MARKETS BD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMBH',
    Issuer: 'ISHARES INT RATE HDG EM BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMBK',
    Issuer: 'EMBARK TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMBKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMCB',
    Issuer: 'WISDOMTREE EM CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMCF',
    Issuer: 'EMCLAIRE FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMCGU',
    Issuer: 'EMBRACE CHANGE ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMCR',
    Issuer: 'XTRACKERS EMERG MARK CARB RE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMD',
    Issuer: 'WESTERN ASSET EMRG MRKT DBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMDV',
    Issuer: 'PROSHARES MSCI EMERGING MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EME',
    Issuer: 'EMCOR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMF',
    Issuer: 'TEMPLETON EMERGING MKTS FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMFM',
    Issuer: 'GLOBAL X MSCI NEXT EMERGING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMFQ',
    Issuer: 'AMPLIFY EMERGING MARKETS FIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMGD',
    Issuer: 'SIMPLIFY EM EQ PLUS DOWN CON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMGF',
    Issuer: 'ISHARES MSCI EMERGING MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMHC',
    Issuer: 'SPDR BLOOMBERG EM USD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMHY',
    Issuer: 'ISHARES J.P. MORGAN EM HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMIF',
    Issuer: 'ISHARES EMERGING MARKETS INF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMKR',
    Issuer: 'EMCORE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EML',
    Issuer: 'EASTERN CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMLC',
    Issuer: 'VANECK JPM EM LOCAL CURR BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMLD',
    Issuer: 'FTAC EMERALD ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMLDU',
    Issuer: 'FTAC EMERALD ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMLDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMLP',
    Issuer: 'FIRST TRUST NORTH AMERICAN E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMMF',
    Issuer: 'WISDOMTREE EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMN',
    Issuer: 'EASTMAN CHEMICAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMNT',
    Issuer: 'PIMCO ENHCD ST M-ACTIVE ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMO',
    Issuer: 'CLEARBRIDGE ENERGY MIDSTREAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMQQ',
    Issuer: 'EMERGING MRKTS INTERNET & EC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMR',
    Issuer: 'EMERSON ELECTRIC CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMSG',
    Issuer: 'XTRACKERS MSCI EMERGING MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMTL',
    Issuer: 'SPDR DL EM FX IN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMTY',
    Issuer: 'PROSHARES DECLINE OF THE RET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMX',
    Issuer: 'EMX ROYALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMXC',
    Issuer: 'ISHARES MSCI EMR MRK EX CHNA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EMXF',
    Issuer: 'ISHARES ESG ADV MSCI EM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENB',
    Issuer: 'ENBRIDGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENBA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENCP',
    Issuer: 'ENERGEM CORP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENCPU',
    Issuer: 'ENERGEM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENCPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENDP',
    Issuer: 'ENDO INTERNATIONAL PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENER',
    Issuer: 'ACCRETION ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENERR',
    Issuer: 'ACCRETION ACQUISITION COR-RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENERU',
    Issuer: 'ACCRETION ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENERW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENFN',
    Issuer: 'ENFUSION INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENFR',
    Issuer: 'ALERIAN ENERGY INFRASTRUCTUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENG',
    Issuer: 'ENGLOBAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENIA',
    Issuer: 'ENEL AMERICAS SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENIC',
    Issuer: 'ENEL CHILE SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENJ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENJY',
    Issuer: 'ENJOY TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENJYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENLC',
    Issuer: 'ENLINK MIDSTREAM LLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENLV',
    Issuer: 'ENLIVEX THERAPEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENOB',
    Issuer: 'ENOCHIAN BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENOR',
    Issuer: 'ISHARES MSCI NORWAY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENOV',
    Issuer: 'ENOVIS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENPC',
    Issuer: 'EXECUTIVE NETWORK PARTNER-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENPC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENPC=',
    Issuer: 'EXECUTIVE NETWORK PARTNERING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENPH',
    Issuer: 'ENPHASE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENR',
    Issuer: 'ENERGIZER HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENS',
    Issuer: 'ENERSYS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENSC',
    Issuer: 'ENSYSCE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENSG',
    Issuer: 'ENSIGN GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENSV',
    Issuer: 'ENSERVCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTA',
    Issuer: 'ENANTA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTF',
    Issuer: 'ENTERPRISE 4.0 TECHNOLOGY AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTFU',
    Issuer: 'ENTERPRISE 4.0 TECHNOLOGY AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTFW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTG',
    Issuer: 'ENTEGRIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTR',
    Issuer: 'ERSHARES ENTREPRENEURS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTX',
    Issuer: 'ENTERA BIO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENTXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENV',
    Issuer: 'ENVESTNET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENVA',
    Issuer: 'ENOVA INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENVB',
    Issuer: 'ENVERIC BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENVX',
    Issuer: 'ENOVIX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENX',
    Issuer: 'EATON VANCE NEW YORK MUNICIP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENZ',
    Issuer: 'ENZO BIOCHEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ENZL',
    Issuer: 'ISHARES MSCI NEW ZEALAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOCT',
    Issuer: 'INNOVATOR EMER MKT PWR BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOCW',
    Issuer: 'ELLIOTT OPPORTUNITY II COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOCW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOCW=',
    Issuer: 'ELLIOTT OPPORTUNITY II CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOD',
    Issuer: 'ALLSPRING GLOBAL DIVIDEND OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOG',
    Issuer: 'EOG RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOI',
    Issuer: 'EATON VANCE ENHANCED EQ INCM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOLS',
    Issuer: 'EVOLUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOPS',
    Issuer: 'EMLES ALPHA OPPORTUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOS',
    Issuer: 'EATON VANCE ENH EQT INC II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOSE',
    Issuer: 'EOS ENERGY ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOSEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EOT',
    Issuer: 'EATON VANCE NATIONAL MUNICIP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EP',
    Issuer: 'EMPIRE PETROLEUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EP-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPAC',
    Issuer: 'ENERPAC TOOL GROUP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPAM',
    Issuer: 'EPAM SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPC',
    Issuer: 'EDGEWELL PERSONAL CARE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPD',
    Issuer: 'ENTERPRISE PRODUCTS PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPHE',
    Issuer: 'ISHARES MSCI PHILIPPINES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPHY',
    Issuer: 'EPIPHANY TECHNOLOGY ACQ-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPHYU',
    Issuer: 'EPIPHANY TECHNOLOGY ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPHYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPI',
    Issuer: 'WISDOMTREE INDIA EARNINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPIX',
    Issuer: 'ESSA PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPM',
    Issuer: 'EVOLUTION PETROLEUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPOL',
    Issuer: 'ISHARES MSCI POLAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPP',
    Issuer: 'ISHARES MSCI PACIFIC EX JAPA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPR',
    Issuer: 'EPR PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPR-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPR-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPRE',
    Issuer: 'FIRST TRUST TCW ESG PREMIER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPRF',
    Issuer: 'INNOVAT S&P INVEST GRD PREF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPRT',
    Issuer: 'ESSENTIAL PROPERTIES REALTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPS',
    Issuer: 'WISDOMTREE US LARGE CAP FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPSN',
    Issuer: 'EPSILON ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPU',
    Issuer: 'ISHARES MSCI PERU ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPV',
    Issuer: 'PROSHARES ULTRASHORT FTSE EU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPWR',
    Issuer: 'EMPOWERMENT & INCLUSION-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPWR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPWR=',
    Issuer: 'EMPOWERMENT & INCLUSION CAPI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EPZM',
    Issuer: 'EPIZYME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQ',
    Issuer: 'EQUILLIUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQAL',
    Issuer: 'INVESCO RUSSELL 1000 EQUAL W',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQBK',
    Issuer: 'EQUITY BANCSHARES INC - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQC',
    Issuer: 'EQUITY COMMONWEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQC-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQD',
    Issuer: 'EQUITY DISTRIBUTION ACQUIS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQD=',
    Issuer: 'EQUITY DISTRIBUTION ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQH',
    Issuer: 'EQUITABLE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQH-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQHA',
    Issuer: 'EQ HEALTH ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQHA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQHA=',
    Issuer: 'EQ HEALTH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQIX',
    Issuer: 'EQUINIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQL',
    Issuer: 'ALPS EQUAL SECTOR WEIGHT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQNR',
    Issuer: 'EQUINOR ASA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQOP',
    Issuer: 'NATIXIS US EQUITY OPPORT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQOS',
    Issuer: 'EQONEX LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQR',
    Issuer: 'EQUITY RESIDENTIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQRR',
    Issuer: 'PROSHRS EQTY RISING RATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQRX',
    Issuer: 'EQRX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQRXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQS',
    Issuer: 'EQUUS TOTAL RETURN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQT',
    Issuer: 'EQT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQUL',
    Issuer: 'IQ ENGENDER EQUALITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQWL',
    Issuer: 'INVESCO S&P 100 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EQX',
    Issuer: 'EQUINOX GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERAS',
    Issuer: 'ERASCA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERC',
    Issuer: 'ALLSPRING MULTI-SECTOR INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERES',
    Issuer: 'EAST RESOURCES ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERESU',
    Issuer: 'EAST RESOURCES ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERESW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERF',
    Issuer: 'ENERPLUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERH',
    Issuer: 'ALLSPRING UTILITIES AND HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERIC',
    Issuer: 'ERICSSON (LM) TEL-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERIE',
    Issuer: 'ERIE INDEMNITY COMPANY-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERII',
    Issuer: 'ENERGY RECOVERY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERJ',
    Issuer: 'EMBRAER SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERM',
    Issuer: 'EQUITYCOMPASS RISK MNGR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERO',
    Issuer: 'ERO COPPER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERSX',
    Issuer: 'ERSHARES NEXTGEN ENTREPRENEU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERTH',
    Issuer: 'INVESCO MSCI SUSTAINABLE FUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERUS',
    Issuer: 'ISHARES MSCI RUSSIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERX',
    Issuer: 'DIREXION DAILY ENERGY BULL 2',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERY',
    Issuer: 'DIREXION DAILY ENERGY BEAR 2',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ERYP',
    Issuer: 'ERYTECH PHARMA - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ES',
    Issuer: 'EVERSOURCE ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESAB',
    Issuer: 'ESAB CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESAC',
    Issuer: 'ESGEN ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESACU',
    Issuer: 'ESGEN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESBA',
    Issuer: 'EMPIRE STATE REALTY OP LP-ES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESCA',
    Issuer: 'ESCALADE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESCR',
    Issuer: 'XTRACKERS BBG US IG CORP ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESE',
    Issuer: 'ESCO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESEA',
    Issuer: 'EUROSEAS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESEB',
    Issuer: 'X-TRACKERS J.P. MORGAN ESG E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESG',
    Issuer: 'FLEXSHARES STOXX US ESG SELE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGA',
    Issuer: 'AMERICAN CENTURY SUSTAINABLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGB',
    Issuer: 'IQ MACKAY ESG CORE PLUS BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGC',
    Issuer: 'EROS STX GLOBAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGD',
    Issuer: 'ISHARES TRUST ISHARES ESG AW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGE',
    Issuer: 'ISHARES INC ISHARES ESG AWAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGG',
    Issuer: 'FLEXSHARES STOXX GLOBAL ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGN',
    Issuer: 'COLUMBIA SUSTAIN INTL EQ ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGR',
    Issuer: 'ENSTAR GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGRO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGRP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGS',
    Issuer: 'COLUMBIA SUSTAIN US EQ I ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGU',
    Issuer: 'ISHARES ESG AWARE MSCI USA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGV',
    Issuer: 'VANGUARD ESG US STOCK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESGY',
    Issuer: 'AMERICAN CENT SUST GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESHY',
    Issuer: 'X-TRACKERS J.P. MORGAN ESG U',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESI',
    Issuer: 'ELEMENT SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESIX',
    Issuer: 'SPDR S&P SMALLCAP 600 ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESLT',
    Issuer: 'ELBIT SYSTEMS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESM',
    Issuer: 'ESM ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESM=',
    Issuer: 'ESM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESML',
    Issuer: 'ISHARES ESG AWARE MSCI USA S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESMT',
    Issuer: 'ENGAGESMART INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESMV',
    Issuer: 'ISHARES ESG MSCI USA MIN VOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESNT',
    Issuer: 'ESSENT GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESOA',
    Issuer: 'ENERGY SERVICES OF AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESP',
    Issuer: 'ESPEY MFG & ELECTRONICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESPO',
    Issuer: 'VANECK VIDEOGAMING ESPORTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESPR',
    Issuer: 'ESPERION THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESQ',
    Issuer: 'ESQUIRE FINANCIAL HOLDINGS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESRT',
    Issuer: 'EMPIRE STATE REALTY TRUST-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESS',
    Issuer: 'ESSEX PROPERTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESSA',
    Issuer: 'ESSA BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESSC',
    Issuer: 'EAST STONE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESSCR',
    Issuer: 'EAST STONE ACQUISITION-RIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESSCU',
    Issuer: 'EAST STONE ACQUISITION -UNIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESSCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESTA',
    Issuer: 'ESTABLISHMENT LABS HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESTC',
    Issuer: 'ELASTIC NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESTE',
    Issuer: 'EARTHSTONE ENERGY INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ESUS',
    Issuer: 'ESTRACS 2X LEV MSCI US ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ET',
    Issuer: 'ENERGY TRANSFER LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ET-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ET-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ET-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETAC',
    Issuer: 'E.MERGE TECHNOLOGY ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETACU',
    Issuer: 'E.MERGE TECHNOLOGY ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETB',
    Issuer: 'EATON VANCE T/M BUY-WR IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETD',
    Issuer: 'ETHAN ALLEN INTERIORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETG',
    Issuer: 'EATON VANCE T/A GL DVD INCM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETHO',
    Issuer: 'ETHO CLIMATE LEADERSHIP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETI-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETJ',
    Issuer: 'EATON VANCE RISK-MANAGED DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETN',
    Issuer: 'EATON CORP PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETNB',
    Issuer: '89BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETO',
    Issuer: 'EATON VANCE TAX ADV GL DVD O',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETON',
    Issuer: 'ETON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETR',
    Issuer: 'ENTERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETRN',
    Issuer: 'EQUITRANS MIDSTREAM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETSY',
    Issuer: 'ETSY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETTX',
    Issuer: 'ENTASIS THERAPEUTICS HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETV',
    Issuer: 'EATON VANCE T/M BUY-WRITE OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETW',
    Issuer: 'EATON VANCE TAX MAN GLBL BR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETWO',
    Issuer: 'E2OPEN PARENT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETWO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETX',
    Issuer: 'EATON VANCE MUNI INC 2028 TM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ETY',
    Issuer: 'EATON VANCE TAX-MANAGED DIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUCG',
    Issuer: 'EUCLID CAPITAL GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUCR',
    Issuer: 'EUCRATES BIOMEDICAL ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUCRU',
    Issuer: 'EUCRATES BIOMEDICAL ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUCRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUDG',
    Issuer: 'WISDOMTREE EUROPE QUALITY DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUDV',
    Issuer: 'PROSHARES MSCI EUROPE DIVIDE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUFN',
    Issuer: 'ISHARES MSCI EUROPE FINANCIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUM',
    Issuer: 'PROSHARES SHORT MSCI EMR MKT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUO',
    Issuer: 'PROSHARES ULTRASHORT EURO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EURL',
    Issuer: 'DRX DLY FTSE EUROPE BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EURN',
    Issuer: 'EURONAV NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUSA',
    Issuer: 'ISHARES MSCI USA EQUAL WEIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUSB',
    Issuer: 'ISHARES ESG ADV TOT USD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EUSC',
    Issuer: 'WISDOMTREE EUROPE HEDG SM EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVA',
    Issuer: 'ENVIVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVAX',
    Issuer: 'EVAXION BIOTECH A/S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVBG',
    Issuer: 'EVERBRIDGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVBN',
    Issuer: 'EVANS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVC',
    Issuer: 'ENTRAVISION COMMUNICATIONS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVCM',
    Issuer: 'EVERCOMMERCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVE',
    Issuer: 'EVE MOBILITY ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVE=',
    Issuer: 'EVE MOBILITY ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVEN',
    Issuer: 'DIREXION DAILY S&P EQ W B2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVER',
    Issuer: 'EVERQUOTE INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVEX',
    Issuer: 'EVE HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVEX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVF',
    Issuer: 'EATON VANCE SENIOR INCOME TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVFM',
    Issuer: 'EVOFEM BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVG',
    Issuer: 'EATON VANCE SHORT DUR DIV IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGBC',
    Issuer: 'EATON VANCE GBL INC BLDR NS',
    date: '2022-05-26',
    isEnabled: '0',
    lit: '1',
  },
  {
    Symbol: 'EVGN',
    Issuer: 'EVOGENE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGO',
    Issuer: 'EVGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGR',
    Issuer: 'EVERGREEN CORPORATION - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGRU',
    Issuer: 'EVERGREEN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVGRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVH',
    Issuer: 'EVOLENT HEALTH INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVI',
    Issuer: 'EVI INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVK',
    Issuer: 'EVER-GLORY INTERNATIONAL GRO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVLMC',
    Issuer: 'EATON VANCE TABS 5-15 LDR MU',
    date: '2022-05-26',
    isEnabled: '0',
    lit: '1',
  },
  {
    Symbol: 'EVLO',
    Issuer: 'EVELO BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVLV',
    Issuer: 'EVOLV TECHNOLOGIES HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVLVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVM',
    Issuer: 'EATON VANCE CAL MUNI BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVMT',
    Issuer: 'INVESCO ELECT VEH MET COM ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVN',
    Issuer: 'EATON VANCE MUNICIPAL INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVNT',
    Issuer: 'ALTSHARES EVENT-DRIVEN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVO',
    Issuer: 'EVOTEC SE - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVOJ',
    Issuer: 'EVO ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVOJU',
    Issuer: 'EVO ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVOJW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVOK',
    Issuer: 'EVOKE PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVOP',
    Issuer: 'EVO PAYMENTS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVR',
    Issuer: 'EVERCORE INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVRG',
    Issuer: 'EVERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVRI',
    Issuer: 'EVERI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVSTC',
    Issuer: 'EATON VANCE STOCK NEXTSHARES',
    date: '2022-05-26',
    isEnabled: '0',
    lit: '1',
  },
  {
    Symbol: 'EVT',
    Issuer: 'EATON VANCE TAX-ADV DVD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVTC',
    Issuer: 'EVERTEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVTL',
    Issuer: 'VERTICAL AEROSPACE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVTL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVV',
    Issuer: 'EATON VANCE LTD DURATION FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EVX',
    Issuer: 'VANECK ENVIRONMENTAL SERVICE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EW',
    Issuer: 'EDWARDS LIFESCIENCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWA',
    Issuer: 'ISHARES MSCI AUSTRALIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWBC',
    Issuer: 'EAST WEST BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWC',
    Issuer: 'ISHARES MSCI CANADA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWCO',
    Issuer: 'INVESCO S&P 500 EQUAL WEIG C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWCZ',
    Issuer: 'EUROPEAN WAX CENTER INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWD',
    Issuer: 'ISHARES MSCI SWEDEN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWEB',
    Issuer: 'GLOBAL X EM INTERNET & ECOMM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWG',
    Issuer: 'ISHARES MSCI GERMANY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWGS',
    Issuer: 'ISHARES MSCI GERMANY SMALL-C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWH',
    Issuer: 'ISHARES MSCI HONG KONG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWI',
    Issuer: 'ISHARES MSCI ITALY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWJ',
    Issuer: 'ISHARES MSCI JAPAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWJE',
    Issuer: 'ISHARES MSCI JAPAN EQL WGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWJV',
    Issuer: 'ISHARES MSCI JAPAN VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWK',
    Issuer: 'ISHARES MSCI BELGIUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWL',
    Issuer: 'ISHARES MSCI SWITZERLAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWM',
    Issuer: 'ISHARES MSCI MALAYSIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWMC',
    Issuer: 'INVESCO S&P MIDCAP 400 EQUAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWN',
    Issuer: 'ISHARES MSCI NETHERLANDS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWO',
    Issuer: 'ISHARES MSCI AUSTRIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWP',
    Issuer: 'ISHARES MSCI SPAIN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWQ',
    Issuer: 'ISHARES MSCI FRANCE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWRE',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWS',
    Issuer: 'ISHARES MSCI SINGAPORE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWSC',
    Issuer: 'INVESCO S&P SMALLCAP 600 EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWT',
    Issuer: 'ISHARES MSCI TAIWAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWTX',
    Issuer: 'EDGEWISE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWU',
    Issuer: 'ISHARES MSCI UNITED KINGDOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWUS',
    Issuer: 'ISHARES MSCI UNITED KINGDOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWV',
    Issuer: 'PROSHARES ULTSHRT MSCI JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWW',
    Issuer: 'ISHARES MSCI MEXICO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWX',
    Issuer: 'SPDR S&P EMERGING MKTS SMALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWY',
    Issuer: 'ISHARES MSCI SOUTH KOREA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWZ',
    Issuer: 'ISHARES MSCI BRAZIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EWZS',
    Issuer: 'ISHARES MSCI BRAZIL SMALL-CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXAI',
    Issuer: 'EXSCIENTIA PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXAS',
    Issuer: 'EXACT SCIENCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXC',
    Issuer: 'EXELON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXD',
    Issuer: 'EATON VANCE TAX-MGD B/W STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXEL',
    Issuer: 'EXELIXIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXFY',
    Issuer: 'EXPENSIFY INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXG',
    Issuer: 'EATON VANCE TAX-MANAGED GLOB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXI',
    Issuer: 'ISHARES GLOBAL INDUSTRIALS E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXK',
    Issuer: 'ENDEAVOUR SILVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXLS',
    Issuer: 'EXLSERVICE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXN',
    Issuer: 'EXCELLON RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXP',
    Issuer: 'EAGLE MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXPD',
    Issuer: 'EXPEDITORS INTL WASH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXPE',
    Issuer: 'EXPEDIA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXPI',
    Issuer: 'EXP WORLD HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXPO',
    Issuer: 'EXPONENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXPR',
    Issuer: 'EXPRESS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXR',
    Issuer: 'EXTRA SPACE STORAGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXTN',
    Issuer: 'EXTERRAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EXTR',
    Issuer: 'EXTREME NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYE',
    Issuer: 'NATIONAL VISION HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYEN',
    Issuer: 'EYENOVIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYES',
    Issuer: 'SECOND SIGHT MEDICAL PRODUCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYESW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYLD',
    Issuer: 'CAMBRIA EMERG SHRHLDR YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EYPT',
    Issuer: 'EYEPOINT PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZA',
    Issuer: 'ISHARES MSCI SOUTH AFRICA ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZFL',
    Issuer: 'EZFILL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZGO',
    Issuer: 'EZGO TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZJ',
    Issuer: 'PROSHARES ULTRA MSCI JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZM',
    Issuer: 'WISDOMTREE US MIDCAP FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZPW',
    Issuer: 'EZCORP INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'EZU',
    Issuer: 'ISHARES MSCI EUROZONE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'F',
    Issuer: 'FORD MOTOR CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'F-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'F-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FA',
    Issuer: 'FIRST ADVANTAGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAAR',
    Issuer: 'FIRST TRUST ALT ABS RET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAB',
    Issuer: 'FIRST TRUST MULTI CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACA',
    Issuer: 'FIGURE ACQUISITION CORP I -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACA=',
    Issuer: 'FIGURE ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACT',
    Issuer: 'FREEDOM ACQUISITION I CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FACT=',
    Issuer: 'FREEDOM ACQUISITION I CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAD',
    Issuer: 'FIRST TRUST MULTI CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAF',
    Issuer: 'FIRST AMERICAN FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAIL',
    Issuer: 'CAMBRIA GLOBAL TAIL RISK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FALN',
    Issuer: 'ISHARES FALLEN ANGELS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAM',
    Issuer: 'FIRST TRUST ABERDEEN GLOBAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAMI',
    Issuer: 'FARMMI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAN',
    Issuer: 'FIRST TRUST GLOBAL WIND ENER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FANG',
    Issuer: 'DIAMONDBACK ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FANH',
    Issuer: 'FANHUA INC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAPR',
    Issuer: 'FT CBOE VEST US EQ BUFF APR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FARM',
    Issuer: 'FARMER BROS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FARO',
    Issuer: 'FARO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAS',
    Issuer: 'DIREXION DAILY FIN BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAST',
    Issuer: 'FASTENAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAT',
    Issuer: 'FAT BRANDS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATBB',
    Issuer: 'FAT BRANDS INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATE',
    Issuer: 'FATE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATH',
    Issuer: 'FATHOM DIGITAL MANUFACTURING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATP',
    Issuer: 'FAT PROJECTS ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATPU',
    Issuer: 'FAT PROJECTS ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FATPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAUG',
    Issuer: 'FT CBOE VEST US EQUITY BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAX',
    Issuer: 'ABERDEEN ASIA-PACIFIC INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FAZ',
    Issuer: 'DIREXION DAILY FIN BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FB',
    Issuer: 'META PLATFORMS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBC',
    Issuer: 'FLAGSTAR BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBCG',
    Issuer: 'FIDELITY BLUE CHIP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBCV',
    Issuer: 'FIDELITY BLUE CHIP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBGX',
    Issuer: 'FI ENHANCED LARGE CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBHS',
    Issuer: 'FORTUNE BRANDS HOME & SECURI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBIO',
    Issuer: 'FORTRESS BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBIOP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBIZ',
    Issuer: 'FIRST BUSINESS FINANCIAL SER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBK',
    Issuer: 'FB FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBMS',
    Issuer: 'FIRST BANCSHARES INC/MS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBNC',
    Issuer: 'FIRST BANCORP/NC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBND',
    Issuer: 'FIDELITY TOTAL BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBP',
    Issuer: 'FIRST BANCORP PUERTO RICO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBRT',
    Issuer: 'FRANKLIN BSP REALTY TRUST IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBRT-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBRX',
    Issuer: 'FORTE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBT',
    Issuer: 'FIRST TRUST NYSE ARCA BIOTEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FBZ',
    Issuer: 'FIRST TRUST BRAZIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FC',
    Issuer: 'FRANKLIN COVEY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCA',
    Issuer: 'FIRST TRUST CHINA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCAL',
    Issuer: 'FIRST TRUST CALIFORNIA MUNIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCAP',
    Issuer: 'FIRST CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCAX',
    Issuer: 'FORTRESS CAPITAL ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCAX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCAX=',
    Issuer: 'FORTRESS CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCBC',
    Issuer: 'FIRST COMMUNITY BANKSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCCO',
    Issuer: 'FIRST COMMUNITY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCEF',
    Issuer: 'FIRST TRUST EXCHANGE-TRADED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCEL',
    Issuer: 'FUELCELL ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCF',
    Issuer: 'FIRST COMMONWEALTH FINL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCFS',
    Issuer: 'FIRSTCASH HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCG',
    Issuer: 'FIRST TRUST NATURAL GAS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCLD',
    Issuer: 'FIDELITY CLOUD COMPUTING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCN',
    Issuer: 'FTI CONSULTING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCNCA',
    Issuer: 'FIRST CITIZENS BCSHS  -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCNCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCNCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCO',
    Issuer: 'ABERDEEN GLOBAL INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCOM',
    Issuer: 'FIDELITY MSCI COMMUNICATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCOR',
    Issuer: 'FIDELITY CORPORATE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCPI',
    Issuer: 'FIDELITY STOCKS FOR INFL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCPT',
    Issuer: 'FOUR CORNERS PROPERTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCRD',
    Issuer: 'FIRST EAGLE ALTERNATIVE CAPI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCRX',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCSH',
    Issuer: 'FEDERATED HERMES SHORT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCT',
    Issuer: 'FIRST TRUST SENIOR FLOATING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCTR',
    Issuer: 'FIRST TRUST LUNT US FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCUV',
    Issuer: 'FOCUS UNIVERSAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCVT',
    Issuer: 'FIRST TRUST SSI STRATEGI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FCX',
    Issuer: 'FREEPORT-MCMORAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDBC',
    Issuer: 'FIDELITY D&D BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDD',
    Issuer: 'FIRST TRUST STOXX EUROPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDEC',
    Issuer: 'FT CBOE VEST US EQ BUFF DEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDEM',
    Issuer: 'FIDELITY EMERG MARKETS MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDEU',
    Issuer: 'FIRST TR DYN EUR EQTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDEV',
    Issuer: 'FIDELITY INTERNATIONAL MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDG',
    Issuer: 'AMERICAN CENTURY FOCUSED DYN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDHT',
    Issuer: 'FIDELITY DIGITAL HEALTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDHY',
    Issuer: 'FIDELITY HI YIELD FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDIG',
    Issuer: 'FIDELITY CRYPTO INDUSTRY & D',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDIS',
    Issuer: 'FIDELITY CON DISCRET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDL',
    Issuer: 'FIRST TRUST MORN DVD LEAD IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDLO',
    Issuer: 'FIDELITY LOW VOLATILITY FACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDM',
    Issuer: 'FIRST TRUST DOW J SELECT MIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDMO',
    Issuer: 'FIDELITY MOMENTUM FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDMT',
    Issuer: '4D MOLECULAR THERAPEUTICS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDN',
    Issuer: 'FIRST TRUST DJ INTERNET IND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDNI',
    Issuer: 'FIRST TRUST DOW JONES INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDP',
    Issuer: 'FRESH DEL MONTE PRODUCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDRR',
    Issuer: 'FIDELITY DIV ETF RISE RATES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDRV',
    Issuer: 'FIDELITY ELETRIC VEHICLES AN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDS',
    Issuer: 'FACTSET RESEARCH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDT',
    Issuer: 'FIRST TRUST DEVELP MKT EX-US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDTS',
    Issuer: 'FIRST TRUST DEVELOPED MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDUS',
    Issuer: 'FIDUS INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDVV',
    Issuer: 'FIDELITY HIGH DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDWM',
    Issuer: 'FIDELITY WOMENS LEADERSHIP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FDX',
    Issuer: 'FEDEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FE',
    Issuer: 'FIRSTENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEAM',
    Issuer: '5E ADVANCED MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEBZ',
    Issuer: 'TrueShares Structured Outcom',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEDL',
    Issuer: 'ETRACS 2X LEVERAGED IFED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEDM',
    Issuer: 'FLEXSHARES ESG & CLIMATE US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEDU',
    Issuer: 'FOUR SEASONS EDUCATION CAYMA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEDX',
    Issuer: 'EMLES FEDERAL CONTRACTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEEM',
    Issuer: 'FLEXSHARES ESG & CLIMATE EM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEHY',
    Issuer: 'FLEXSHARES ESG H/Y CORP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEI',
    Issuer: 'FIRST TRUST MLP AND ENERGY I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEIG',
    Issuer: 'FLEXSHARES ESG IG CORP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEIM',
    Issuer: 'FREQUENCY ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FELE',
    Issuer: 'FRANKLIN ELECTRIC CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEM',
    Issuer: 'FIRST TRUST EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEMB',
    Issuer: 'FIRST TRUST EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEMS',
    Issuer: 'FIRST TRUST EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEMY',
    Issuer: 'FEMASYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEN',
    Issuer: 'FIRST TR ENRGY INC & GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FENC',
    Issuer: 'FENNEC PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FENG',
    Issuer: 'PHOENIX NEW MEDIA LTD -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FENY',
    Issuer: 'FIDELITY MSCI ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEO',
    Issuer: 'FIRST TRUST ABERDEEN EMG OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEP',
    Issuer: 'FIRST TRUST EUROPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FERG',
    Issuer: 'FERGUSON PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FET',
    Issuer: 'FORUM ENERGY TECHNOLOGIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEUS',
    Issuer: 'FLEXSHARES ESG & CLIMATE US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEUZ',
    Issuer: 'FIRST TRUST EUROZONE ALPHADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEVR',
    Issuer: 'INSPIRE FAITHWARD LARCAP MOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEX',
    Issuer: 'FIRST TRUST LARGE CAP CORE A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEXD',
    Issuer: 'FINTECH ECOSYSTEM DEVELOPM-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEXDR',
    Issuer: 'FINTECH ECOSYSTEM DEVELO-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEXDU',
    Issuer: 'FINTECH ECOSYSTEM DEVELOPMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEXDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FEZ',
    Issuer: 'SPDR EURO STOXX 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FF',
    Issuer: 'FUTUREFUEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFA',
    Issuer: 'FIRST TRUST ENH EQUITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFBC',
    Issuer: 'FIRST FINANCIAL BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFBW',
    Issuer: 'FFBW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFC',
    Issuer: 'FLAHERTY & CRUMRINE PREFERRE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFEB',
    Issuer: 'FT CBOE VEST US EQY BUFF-FEB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFHG',
    Issuer: 'FORMULA FOLIOS HEDGED GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFHL',
    Issuer: 'FUWEI FILMS HOLDINGS CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIC',
    Issuer: 'FLUSHING FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIE',
    Issuer: 'FARADAY FUTURE INTELLIGENT E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIN',
    Issuer: 'FIRST FINL BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIU',
    Issuer: 'UVA UNCONSTRAINED MEDIUM-TER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFIV',
    Issuer: 'F5 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFND',
    Issuer: 'The Future Fund Active ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFNW',
    Issuer: 'FIRST FINANCIAL NORTHWEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFR',
    Issuer: 'FT FTSE EPRA/NAREIT REAL EST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFSG',
    Issuer: 'FORMULAFOLIOS SMART GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFTG',
    Issuer: 'FORMULAFOLIOS TACTICAL GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFTI',
    Issuer: 'FORMULAFOLIOS TACTICAL INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFTY',
    Issuer: 'INNOVATOR IBD 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FFWM',
    Issuer: 'FIRST FOUNDATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGB',
    Issuer: 'FIRST TRUST SPECIALTY FINANC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGBI',
    Issuer: 'FIRST GUARANTY BANCSHARES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGBIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGD',
    Issuer: 'FIRST TRUST DJ GL SEL DVD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGEN',
    Issuer: 'FIBROGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGF',
    Issuer: 'FG FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGFPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGI',
    Issuer: 'FGI INDUSTRIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGIWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGM',
    Issuer: 'FIRST TRUST GERMANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGMC',
    Issuer: 'FG MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGMCU',
    Issuer: 'FG MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGMCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FGRO',
    Issuer: 'FIDELITY GROWTH OPPORTUNITIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHB',
    Issuer: 'FIRST HAWAIIAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHI',
    Issuer: 'FEDERATED HERMES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHLC',
    Issuer: 'FIDELITY HEALTH CARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHLT',
    Issuer: 'FUTURE HEALTH ESG CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHLTU',
    Issuer: 'FUTURE HEALTH ESG CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHLTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN',
    Issuer: 'FIRST HORIZON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHN-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHS',
    Issuer: 'FIRST HIGH-SCHOOL EDUCAT-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHTX',
    Issuer: 'FOGHORN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FHYS',
    Issuer: 'FED HERMES SHRT DUR HI YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIAC',
    Issuer: 'FOCUS IMPACT ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIACU',
    Issuer: 'FOCUS IMPACT ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIBK',
    Issuer: 'FIRST INTERSTATE BANCSYS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIBR',
    Issuer: 'ISHARES U.S. FIXED INCOME BA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FICO',
    Issuer: 'FAIR ISAAC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FICS',
    Issuer: 'FT INTERNATIONAL DEV CAP STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FICV',
    Issuer: 'FRONTIER INVESTMENT CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FICVU',
    Issuer: 'FRONTIER INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FICVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FID',
    Issuer: 'FIRST TRUST S&P INTERNATIONA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIDI',
    Issuer: 'FIDELITY INTL HIGH DIV ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIDU',
    Issuer: 'FIDELITY INDUSTRIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIEE',
    Issuer: 'UBS FI ENHANCED EUR 50 ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIF',
    Issuer: 'FIRST TRUST ENERGY INFRASTRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIG',
    Issuer: 'SIMPLIFY MACRO STRATEGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIGB',
    Issuer: 'FIDELITY INV GRADE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIGS',
    Issuer: 'FIGS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIHD',
    Issuer: 'UBS FI ENH GL HI YLD ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FILL',
    Issuer: 'ISHARES MSCI GLOBAL ENERGY P',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINM',
    Issuer: 'MARLIN TECHNOLOGY CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINMU',
    Issuer: 'MARLIN TECHNOLOGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINS',
    Issuer: 'ANGEL OAK FINANC STRAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINV',
    Issuer: 'FINVOLUTION GROUP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINW',
    Issuer: 'FINWISE BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FINX',
    Issuer: 'GLOBAL X FINTECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIS',
    Issuer: 'FIDELITY NATIONAL INFO SERV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FISI',
    Issuer: 'FINANCIAL INSTITUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FISK',
    Issuer: 'EMPIRE STATE REALTY OP -S250',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FISR',
    Issuer: 'SPDR SSGA F/I SECTOR ROTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FISV',
    Issuer: 'FISERV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FITB',
    Issuer: 'FIFTH THIRD BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FITBI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FITBO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FITBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FITE',
    Issuer: 'SPDR S&P KENSHO FUTURE SECUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIVA',
    Issuer: 'FIDELITY INTL VAL FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIVE',
    Issuer: 'FIVE BELOW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIVG',
    Issuer: 'DEFIANCE NEXT GEN CONN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIVN',
    Issuer: 'FIVE9 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIVR',
    Issuer: 'STRATEGY SH NASDAQ 5HANDL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIW',
    Issuer: 'FIRST TRUST WATER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIX',
    Issuer: 'COMFORT SYSTEMS USA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIXD',
    Issuer: 'FIRST TRUST TCW OPP FIXED IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIXX',
    Issuer: 'HOMOLOGY MEDICINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FIZZ',
    Issuer: 'NATIONAL BEVERAGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FJAN',
    Issuer: 'FT CBOE VEST US EQ BUFF JAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FJP',
    Issuer: 'FIRST TRUST JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FJUL',
    Issuer: 'FT CBOE VEST US EQ BUFF JUL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FJUN',
    Issuer: 'FT CBOE VEST U.S. EQUITY BUF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FKU',
    Issuer: 'FIRST TRUST UNITED KINGDOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FKWL',
    Issuer: 'FRANKLIN WIRELESS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FL',
    Issuer: 'FOOT LOCKER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAC',
    Issuer: 'FRAZIER LIFESCIENCES ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLACU',
    Issuer: 'FRAZIER LIFESCIENCES ACQUIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAG',
    Issuer: 'FIRST LIGHT ACQUISITION GR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAG+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAG=',
    Issuer: 'FIRST LIGHT ACQUISITION GROU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAU',
    Issuer: 'FRANKLIN FTSE AUSTRALIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLAX',
    Issuer: 'FRANKLIN FTSE ASIA EX JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLBL',
    Issuer: 'FRANKLIN LIBERTY SENIOR LOAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLBR',
    Issuer: 'FRANKLIN FTSE BRAZIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLC',
    Issuer: 'FLAH & CRUM TTL RTRN FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLCA',
    Issuer: 'FRANKLIN FTSE CANADA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLCB',
    Issuer: 'FRANKLIN LIBERTY US CORE BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLCH',
    Issuer: 'FRANKLIN FTSE CHINA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLCO',
    Issuer: 'FRANKLIN LIBERTY IG CORP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLDR',
    Issuer: 'FIDELITY LOW DURATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLDZ',
    Issuer: 'RIVERNORTH PATRIOT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLEE',
    Issuer: 'FRANKLIN FTSE EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLEH',
    Issuer: 'FRANKLIN FTSE EUROPE HEDGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLEX',
    Issuer: 'FLEX LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLFR',
    Issuer: 'FRANKLIN FTSE FRANCE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLGB',
    Issuer: 'FRANKLIN FTSE UNITED KINGDOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLGC',
    Issuer: 'FLORA GROWTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLGR',
    Issuer: 'FRANKLIN FTSE GERMANY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLGT',
    Issuer: 'FULGENT GENETICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLGV',
    Issuer: 'FRANKLIN LIBERTY US TR B ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLHK',
    Issuer: 'FRANKLIN FTSE HONG KONG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLHY',
    Issuer: 'FRANKLIN LIBERTY HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLIA',
    Issuer: 'FRANKLIN LIBERTY INTL AGG BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLIC',
    Issuer: 'FIRST OF LONG ISLAND CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLIN',
    Issuer: 'FRANKLIN FTSE INDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLIY',
    Issuer: 'FRANKLIN FTSE ITALY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLJH',
    Issuer: 'FRANKLIN FTSE JPN HEDGED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLJP',
    Issuer: 'FRANKLIN FTSE JAPAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLKR',
    Issuer: 'FRANKLIN FTSE SOUTH KOREA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLL',
    Issuer: 'FULL HOUSE RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLLA',
    Issuer: 'FRANKLIN FTSE LATIN AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLLV',
    Issuer: 'FRANKLIN LIBERTY US LOW VOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLM',
    Issuer: 'FIRST TRUST GLOBAL ENGINEERI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLMB',
    Issuer: 'FRANKLIN MUNICIPAL GREEN BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLME',
    Issuer: 'FLAME ACQUISITION CORP -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLME+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLME=',
    Issuer: 'FLAME ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLMI',
    Issuer: 'FRANKLIN DYNAMIC MUNICIPAL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLMN',
    Issuer: 'FALCON MINERALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLMNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLMX',
    Issuer: 'FRANKLIN FTSE MEXICO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLN',
    Issuer: 'FIRST TRUST LATIN AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLNC',
    Issuer: 'FLUENCE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLNG',
    Issuer: 'FLEX LNG LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLNT',
    Issuer: 'FLUENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLO',
    Issuer: 'FLOWERS FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLOT',
    Issuer: 'ISHARES FLOATING RATE BOND E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQD',
    Issuer: 'FRANKLIN LIBERTYQ GLOBAL DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQE',
    Issuer: 'FRANKLIN LIBERTYQ EMERGING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQG',
    Issuer: 'FRANKLIN LIBERTYQ GLOBAL EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQH',
    Issuer: 'FRANKLIN LIBERTYQ INT EQ HED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQL',
    Issuer: 'FRANKLIN LIBERTYQ US EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQM',
    Issuer: 'FRANKLIN LIBERTYQ MID CAP EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLQS',
    Issuer: 'FRANKLIN LIBERTYQ SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLR',
    Issuer: 'FLUOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLRG',
    Issuer: 'FIDELITY US MULTIFACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLRN',
    Issuer: 'SPDR BLOOMBERG INVESTMENT GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLRT',
    Issuer: 'PACER PACIFIC ASSET FLOATING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLRU',
    Issuer: 'FRANKLIN FTSE RUSSIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLS',
    Issuer: 'FLOWSERVE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLSA',
    Issuer: 'FRANKLIN FTSE SAUDI ARABIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLSP',
    Issuer: 'FRANKLIN LIBERTY SYSTEMATIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLSW',
    Issuer: 'FRANKLIN FTSE SWITZERLAND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLT',
    Issuer: 'FLEETCOR TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLTB',
    Issuer: 'FIDELITY LTD TERM BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLTN',
    Issuer: 'RAREVIEW INFLAT/DEFLAT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLTR',
    Issuer: 'V/E INV GR FLOATING RATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLTW',
    Issuer: 'FRANKLIN FTSE TAIWAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLUD',
    Issuer: 'FRANKLIN LIBERTY UL SHT BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLUX',
    Issuer: 'FLUX POWER HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLV',
    Issuer: 'AMERICAN CENTURY FOCUSED LAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLWS',
    Issuer: '1-800-FLOWERS.COM INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLXS',
    Issuer: 'FLEXSTEEL INDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLYA',
    Issuer: 'SOAR TECHNOLOGY ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLYA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLYA=',
    Issuer: 'SOAR TECHNOLOGY ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLYW',
    Issuer: 'FLYWIRE CORP-VOTING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FLZA',
    Issuer: 'FRANKLIN FTSE SOUTH AFRICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FM',
    Issuer: 'ISHR MSCI FRONT & SEL EM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMAG',
    Issuer: 'FIDELITY MAGELLAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMAO',
    Issuer: 'FARMERS & MERCHANTS BANCO/OH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMAR',
    Issuer: 'FT CBOE VEST US EQTY BUF-MAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMAT',
    Issuer: 'FIDELITY MATERIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMAY',
    Issuer: 'FT CBOE VEST US EQY BUFF-MAY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMB',
    Issuer: 'FIRST TRUST MANAGED MUNICIPA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMBH',
    Issuer: 'FIRST MID BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMC',
    Issuer: 'FMC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMCX',
    Issuer: 'FMC EXCELSIOR FOCUS EQT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMET',
    Issuer: 'FIDELITY METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMF',
    Issuer: 'FIRST TRUST MANAGED FUTURES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMHI',
    Issuer: 'FIRST TRUST MUNICIPAL HIGH I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMIL',
    Issuer: 'FIDELITY NEW MILLENNIUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMIV',
    Issuer: 'FORUM MERGER IV CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMIVU',
    Issuer: 'FORUM MERGER IV CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMIVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMN',
    Issuer: 'FEDERATED HERMES PREMIER MUN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMNB',
    Issuer: 'FARMERS NATL BANC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMNY',
    Issuer: 'FIRST TRUST NY MUNI HIGH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMQQ',
    Issuer: 'FMQQ NXT FRNT & ECOMM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMS',
    Issuer: 'FRESENIUS MEDICAL CARE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMTX',
    Issuer: 'FORMA THERAPEUTICS HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMX',
    Issuer: 'FOMENTO ECONOMICO MEX-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FMY',
    Issuer: 'FIRST TRUST MORTGAGE INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FN',
    Issuer: 'FABRINET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNA',
    Issuer: 'PARAGON 28 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNB',
    Issuer: 'FNB CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNB-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNCB',
    Issuer: 'FNCB BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNCH',
    Issuer: 'FINCH THERAPEUTICS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNCL',
    Issuer: 'FIDELITY FINANCIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FND',
    Issuer: 'FLOOR & DECOR HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDA',
    Issuer: 'SCHWAB FUNDAMENTAL SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDB',
    Issuer: 'SCHWAB FUNDAMENTAL BROAD MKT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDC',
    Issuer: 'SCHWAB FUNDAMENTAL INTL S/C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDE',
    Issuer: 'SCHWAB FUNDAMENTAL EM L/C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDF',
    Issuer: 'SCHWAB FUNDAMENTAL INTL L/C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNDX',
    Issuer: 'SCHWAB FUNDAMENTAL LARGE CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNF',
    Issuer: 'FIDELITY NATIONAL FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGD',
    Issuer: 'MICROSECTORS FANG+ INDEX -3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGG',
    Issuer: 'DIR DAY SL LRG FANGS BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGO',
    Issuer: 'MICROSECTORS FANG INDEX 2X L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGR',
    Issuer: 'FINGERMOTION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGS',
    Issuer: 'MICROSECTORS FANG+ ETNS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNGU',
    Issuer: 'MICROSECTORS FANG+ INDEX 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNHC',
    Issuer: 'FEDNAT HOLDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNI',
    Issuer: 'FIRST TRUST CHINDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNK',
    Issuer: 'FIRST TRUST MID CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNKO',
    Issuer: 'FUNKO INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNLC',
    Issuer: 'FIRST BANCORP INC/ME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNOV',
    Issuer: 'FT CBOE VEST US EQUITY BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNTC',
    Issuer: 'DIREXION DAILY FINT BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNV',
    Issuer: 'FRANCO-NEVADA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNVT',
    Issuer: 'FINNOVATE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNVTU',
    Issuer: 'FINNOVATE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNVTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNWB',
    Issuer: 'FIRST NORTHWEST BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNWD',
    Issuer: 'FINWARD BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNX',
    Issuer: 'FIRST TRUST MID CAP CORE ALP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FNY',
    Issuer: 'FIRST TRUST MID CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOA',
    Issuer: 'FINANCE OF AMERICA COS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOCS',
    Issuer: 'FOCUS FINANCIAL PARTNERS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOCT',
    Issuer: 'FT CBOE VEST US EQ BUFF OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOF',
    Issuer: 'COHEN & STEERS CLOSED-END OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOLD',
    Issuer: 'AMICUS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOMO',
    Issuer: 'FOMO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FONR',
    Issuer: 'FONAR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOR',
    Issuer: 'FORESTAR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORA',
    Issuer: 'FORIAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORD',
    Issuer: 'FORWARD INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORG',
    Issuer: 'FORGEROCK INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORH',
    Issuer: 'FORMIDABLE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORM',
    Issuer: 'FORMFACTOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORR',
    Issuer: 'FORRESTER RESEARCH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FORTY',
    Issuer: 'FORMULA SYSTEMS 1985-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOSL',
    Issuer: 'FOSSIL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOSLL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOUN',
    Issuer: 'FOUNDER SPAC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOUNU',
    Issuer: 'FOUNDER SPAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOUNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOUR',
    Issuer: 'SHIFT4 PAYMENTS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOVL',
    Issuer: 'ISHARES FOCUSED VALUE FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOX',
    Issuer: 'FOX CORP - CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOXA',
    Issuer: 'FOX CORP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOXF',
    Issuer: 'FOX FACTORY HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOXW',
    Issuer: 'FOXWAYNE ENTERPRISES ACQ- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOXWU',
    Issuer: 'FOXWAYNE ENTERPRISES ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FOXWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPA',
    Issuer: 'FIRST TRUST ASIA PAC EX-JAPN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPAC',
    Issuer: 'FAR PEAK ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPAC=',
    Issuer: 'FAR PEAK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPAG',
    Issuer: 'FPA GLOBAL EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPAY',
    Issuer: 'FLEXSHOPPER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPE',
    Issuer: 'FT-PREFERRED SECUR & INC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPEI',
    Issuer: 'FIRST TRUST INSTITUTIONAL PR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPF',
    Issuer: 'FIRST TRUST INTERMEDIATE DUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPFD',
    Issuer: 'FIDELITY PREFERRED SEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPH',
    Issuer: 'FIVE POINT HOLDINGS LLC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPI',
    Issuer: 'FARMLAND PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPL',
    Issuer: 'FIRST TRUST NEW OPPORTUNITIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPRO',
    Issuer: 'FIDELITY REAL ESTATE INVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPX',
    Issuer: 'FIRST TRUST US EQUITY OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPXE',
    Issuer: 'FIRST TRUST IPOX EUROPE EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FPXI',
    Issuer: 'FIRST TRUST INTERNATIONAL EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FQAL',
    Issuer: 'FIDELITY QUALITY FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FR',
    Issuer: 'FIRST INDUSTRIAL REALTY TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRA',
    Issuer: 'BLACKROCK FLOAT RT INCOME ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRAF',
    Issuer: 'FRANKLIN FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRBA',
    Issuer: 'FIRST BANK/HAMILTON NJ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRBK',
    Issuer: 'REPUBLIC FIRST BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRBN',
    Issuer: 'FORBION EUROPEAN ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRBNU',
    Issuer: 'FORBION EUROPEAN ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRBNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC',
    Issuer: 'FIRST REPUBLIC BANK/CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRC-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRD',
    Issuer: 'FRIEDMAN INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRDM',
    Issuer: 'FREEDOM 100 EMEGING MRKT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREE',
    Issuer: 'WHOLE EARTH BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREL',
    Issuer: 'FIDELITY REAL ESTATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREQ',
    Issuer: 'FREQUENCY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREY',
    Issuer: 'FREYR BATTERY SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FREY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRG',
    Issuer: 'FRANCHISE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRGAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRGE',
    Issuer: 'FORGE GLOBAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRGE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRGI',
    Issuer: 'FIESTA RESTAURANT GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRHC',
    Issuer: 'FREEDOM HOLDING CORP/NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRI',
    Issuer: 'FIRST TRUST S&P REIT INDEX F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRLA',
    Issuer: 'FORTUNE RISE ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRLAU',
    Issuer: 'FORTUNE RISE ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRLAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRLN',
    Issuer: 'FREELINE THERAPEUTICS HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRME',
    Issuer: 'FIRST MERCHANTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRMEP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRNW',
    Issuer: 'FIDELITY CLEAN ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRO',
    Issuer: 'FRONTLINE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FROG',
    Issuer: 'JFROG LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRON',
    Issuer: 'FRONTIER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRONU',
    Issuer: 'FRONTIER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRONW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRPH',
    Issuer: 'FRP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRPT',
    Issuer: 'FRESHPET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRSG',
    Issuer: 'FIRST RESERVE SUSTAINABLE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRSGU',
    Issuer: 'FIRST RESERVE SUSTAINABLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRSGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRSH',
    Issuer: 'FRESHWORKS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRST',
    Issuer: 'PRIMIS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRSX',
    Issuer: 'FORESIGHT AUTONOMOUS-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRT',
    Issuer: 'FEDERAL REALTY INVS TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRT-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRTY',
    Issuer: 'ALGER MID CAP 40 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRW',
    Issuer: 'PWP FORWARD ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRWAU',
    Issuer: 'PWP FORWARD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRWAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRXB',
    Issuer: 'FOREST ROAD ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRXB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FRXB=',
    Issuer: 'FOREST ROAD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSBC',
    Issuer: 'FIVE STAR BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSBD',
    Issuer: 'FIDELITY SUSTAINABLE CORE PL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSBW',
    Issuer: 'FS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSD',
    Issuer: 'FIRST TRUST HIGH INCOME LONG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSEA',
    Issuer: 'FIRST SEACOAST BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSEC',
    Issuer: 'FIDELITY INV GRADE SECURIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSEP',
    Issuer: 'FT CBOE VEST US EQ BUFF SEP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSFG',
    Issuer: 'FIRST SAVINGS FINANCIAL GRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSI',
    Issuer: 'FLEXIBLE SOLUTIONS INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSIG',
    Issuer: 'FT LTD DURATION INV GRADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSK',
    Issuer: 'FS KKR CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSLD',
    Issuer: 'FIDELITY SUSTAINABLE LOW DUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSLR',
    Issuer: 'FIRST SOLAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSLY',
    Issuer: 'FASTLY INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSM',
    Issuer: 'FORTUNA SILVER MINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSMB',
    Issuer: 'FIRST TRUST SHORT DUR MANAG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSMD',
    Issuer: 'FIDELITY SMALL-MID MULTIFACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSMO',
    Issuer: 'FIDELITY SMALL-MID CAP OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSNB',
    Issuer: 'FUSION ACQUISITION CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSNB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSNB=',
    Issuer: 'FUSION ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSP',
    Issuer: 'FRANKLIN STREET PROPERTIES C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSR',
    Issuer: 'FISKER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSRD',
    Issuer: 'FAST RADIUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSRDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSRX',
    Issuer: 'FINSERV ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSRXU',
    Issuer: 'FINSERV ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSRXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSS',
    Issuer: 'FEDERAL SIGNAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSSI',
    Issuer: 'FORTISTAR SUSTAINABLE SOLU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSSIU',
    Issuer: 'FORTISTAR SUSTAINABLE SOLUTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSSIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSST',
    Issuer: 'FIDELITY SUSTAINABLE U.S. EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FST',
    Issuer: 'FAST ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FST+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FST=',
    Issuer: 'FAST ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSTA',
    Issuer: 'FIDELITY CON STAPLES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSTR',
    Issuer: 'FOSTER (LB) CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSTX',
    Issuer: 'F-STAR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSV',
    Issuer: 'FIRSTSERVICE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSYD',
    Issuer: 'FIDELITY SUSTAINABLE HY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FSZ',
    Issuer: 'FIRST TRUST SWITZERLAND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FT',
    Issuer: 'FRANKLIN UNIVERSAL TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTA',
    Issuer: 'FIRST TRUST L C VAL ALP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAA',
    Issuer: 'FTAC ATHENA ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAAU',
    Issuer: 'FTAC ATHENA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAG',
    Issuer: 'FIRST TRUST INDXX GLOBAL AGR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAI',
    Issuer: 'FORTRESS TRANSPORTATION & IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAIN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAIO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTAIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTC',
    Issuer: 'FIRST TRUST LARGE CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCH',
    Issuer: 'FARFETCH LTD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCI',
    Issuer: 'FTC SOLAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCS',
    Issuer: 'FIRST TRUST CAPITAL STRENGTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCV',
    Issuer: 'FINTECH ACQUISITION CORP V-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCVU',
    Issuer: 'FINTECH ACQUISITION CORP V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTCVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTDR',
    Issuer: 'FRONTDOOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTDS',
    Issuer: 'FIRST TRUST DIVIDEND STRENGT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTEC',
    Issuer: 'FIDELITY MSCI INFO TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTEK',
    Issuer: 'FUEL TECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTEV',
    Issuer: 'FINTECH EVOLUTION ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTEV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTEV=',
    Issuer: 'FINTECH EVOLUTION ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTF',
    Issuer: 'FRANKLIN LTD DUR INC TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTFT',
    Issuer: 'FUTURE FINTECH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTGC',
    Issuer: 'FIRST TRUST GLOBAL TACTICAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTHI',
    Issuer: 'FTHI/FIRST TRUST EXCHANGE-TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTHM',
    Issuer: 'FATHOM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTHY',
    Issuer: 'FIRST TRUST HIGH YLD OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTI',
    Issuer: 'TECHNIPFMC PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTII',
    Issuer: 'FUTURETECH II ACQUISITI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTIIU',
    Issuer: 'FUTURETECH II ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTK',
    Issuer: 'FLOTEK INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTLS',
    Issuer: 'FIRST TRUST LONG/SHORT EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTNT',
    Issuer: 'FORTINET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTPA',
    Issuer: 'FTAC PARNASSUS ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTPAU',
    Issuer: 'FTAC PARNASSUS ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTQI',
    Issuer: 'FIRST TRUST NASDAQ BUYWRITE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTRI',
    Issuer: 'FIRST TRUST INDXX GLOBAL NAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTRP',
    Issuer: 'FIELD TRIP HEALTH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTS',
    Issuer: 'FORTIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTSD',
    Issuer: 'FRANKLIN LIBERTY SHORT DURAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTSL',
    Issuer: 'FIRST TRUST SENIOR LOAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTSM',
    Issuer: 'FIRST TRUST ENH SHORT MAT FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTV',
    Issuer: 'FORTIVE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTVI',
    Issuer: 'FINTECH ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTVIU',
    Issuer: 'FINTECH ACQUISITION CORP VI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTVIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXG',
    Issuer: 'FIRST TRUST NASDAQ FOOD & BE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXH',
    Issuer: 'FIRST TRUST NASDAQ PHARMACEU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXL',
    Issuer: 'FIRST TRUST NASDAQ SEMICONDU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXN',
    Issuer: 'FIRST TRUST NASDAQ OIL & GAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXO',
    Issuer: 'FIRST TRUST NASDAQ BANK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FTXR',
    Issuer: 'FIRST TRUST NASDAQ TRANSPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUBO',
    Issuer: 'FUBOTV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUE',
    Issuer: 'ELEMENTS ICE EXTRA BIOFUELS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUL',
    Issuer: 'H.B. FULLER CO.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FULC',
    Issuer: 'FULCRUM THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FULT',
    Issuer: 'FULTON FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FULTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUMB',
    Issuer: 'FIRST TRUST ULTRA SHORT DUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUN',
    Issuer: 'CEDAR FAIR LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUNC',
    Issuer: 'FIRST UNITED CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUND',
    Issuer: 'SPROTT FOCUS TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUNL',
    Issuer: 'CORNERCAP FUNDAMETRICS L-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FURY',
    Issuer: 'FURY GOLD MINES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUSB',
    Issuer: 'FIRST US BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUSN',
    Issuer: 'FUSION PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUTU',
    Issuer: 'FUTU HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUTY',
    Issuer: 'FIDELITY US UTILITIES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FUV',
    Issuer: 'ARCIMOTO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FV',
    Issuer: 'FIRST TRUST DW FOCUS 5 FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVAL',
    Issuer: 'FIDELITY VALUE FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVAM',
    Issuer: '5:01 ACQUISITION CORP- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVC',
    Issuer: 'FIRST TRUST DORSEY WRIGHT DY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVCB',
    Issuer: 'FVCBANKCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVD',
    Issuer: 'FIRST TRUST VALUE LINE DVD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVIV',
    Issuer: 'FORTRESS VALUE ACQUIS IV-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVIV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVIV=',
    Issuer: 'FORTRESS VALUE ACQUISITIN IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVRR',
    Issuer: 'FIVERR INTERNATIONAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVT',
    Issuer: 'FORTRESS VALUE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FVT=',
    Issuer: 'FORTRESS VALUE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWAC',
    Issuer: 'FIFTH WALL ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWBI',
    Issuer: 'FIRST WAVE BIOPHARMA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWONA',
    Issuer: 'LIBERTY MEDIA CORP-LIBERTY-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWONK',
    Issuer: 'LIBERTY MEDIA CORP-LIBERTY-C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWP',
    Issuer: 'FORWARD PHARMA A/S-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWRD',
    Issuer: 'FORWARD AIR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FWRG',
    Issuer: 'FIRST WATCH RESTAURANT GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXA',
    Issuer: 'INVESCO CURRENCYSHARES AUSTR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXB',
    Issuer: 'INVESCO CURRENCYSHARES BRITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXC',
    Issuer: 'INVESCO CURRENCYSHARES CANAD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXCO',
    Issuer: 'FINANCIAL STRATEGIES ACQ-CLA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXCOR',
    Issuer: 'FINANCIAL STRATEGIES ACQ -RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXCOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXD',
    Issuer: 'FIRST TRUST CONSUMER DISCRET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXE',
    Issuer: 'INVESCO CURRENCYSHARES EURO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXF',
    Issuer: 'INVESCO CURRENCYSHARES SWISS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXG',
    Issuer: 'FIRST TRUST CONSUMER STAPLES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXH',
    Issuer: 'FIRST TRUST HEALTH CARE ALPH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXI',
    Issuer: 'ISHARES CHINA LARGE-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXL',
    Issuer: 'FIRST TRUST TECHNOLOGY ALPHA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXLV',
    Issuer: 'F45 TRAINING HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXN',
    Issuer: 'FIRST TRUST ENERGY ALPHADEX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXNC',
    Issuer: 'FIRST NATIONAL CORP/VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXO',
    Issuer: 'FIRST TRUST FINANCIAL ALPHAD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXP',
    Issuer: 'PROSHARES ULTRASHORT FTSE CH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXR',
    Issuer: 'FIRST TRUST INDST/PRODUCERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXU',
    Issuer: 'FIRST TRUST UTILITIES ALPHAD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXY',
    Issuer: 'INVESCO CURRENCYSHARES JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FXZ',
    Issuer: 'FIRST TRUST MATERIALS ALPHAD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FYBR',
    Issuer: 'FRONTIER COMMUNICATIONS PARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FYC',
    Issuer: 'FIRST TRUST SMALL CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FYLD',
    Issuer: 'CAMBRIA FOREIGN SHAREHOLDER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FYT',
    Issuer: 'FIRST TRUST SMALL CAP VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FYX',
    Issuer: 'FIRST TRUST SMALL CAP CORE A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FZT',
    Issuer: 'FAST ACQUISITION CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FZT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'FZT=',
    Issuer: 'FAST ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'G',
    Issuer: 'GENPACT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAA',
    Issuer: 'CAMBRIA GLOBAL ASSET ALLOCAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAB',
    Issuer: 'GABELLI EQUITY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAB-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAB-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAB-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GABC',
    Issuer: 'GERMAN AMERICAN BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GABF',
    Issuer: 'GABELLI FIN SRVCS OPP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GACQ',
    Issuer: 'GLOBAL CONSUMER ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GACQU',
    Issuer: 'GLOBAL CONSUMER ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GACQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAIA',
    Issuer: 'GAIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAIN',
    Issuer: 'GLADSTONE INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAINN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAINZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAL',
    Issuer: 'SPDR SSGA GLOBAL ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GALT',
    Issuer: 'GALECTIN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAM',
    Issuer: 'GENERAL AMERICAN INVESTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAM-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAMB',
    Issuer: 'GAMBLING.COM GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAMC',
    Issuer: 'GOLDEN ARROW MERGER CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAMCU',
    Issuer: 'GOLDEN ARROW MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAMCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAME',
    Issuer: 'ENGINE GAMING AND MEDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAMR',
    Issuer: 'WEDBUSH ETFMG VIDEO GAME TEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAN',
    Issuer: 'GAN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GANX',
    Issuer: 'GAIN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAPA',
    Issuer: 'G&P ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAPA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAPA=',
    Issuer: 'G&P ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAQ',
    Issuer: 'GENERATION ASIA I ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAQ=',
    Issuer: 'GENERATION ASIA I ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GASS',
    Issuer: 'STEALTHGAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAST',
    Issuer: 'GABELLI ASSET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GATE',
    Issuer: 'MARBLEGATE ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GATEU',
    Issuer: 'MARBLEGATE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GATEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GATO',
    Issuer: 'GATOS SILVER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GATX',
    Issuer: 'GATX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAU',
    Issuer: 'GALIANO GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GAZ',
    Issuer: 'IPATH SER B BBG NAT GAS TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GB',
    Issuer: 'GLOBAL BLUE GROUP HOLDING AG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBAB',
    Issuer: 'GUGGENHEIM TAXABLE MUNICIPAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBBKU',
    Issuer: 'GLOBAL BLOCKCHAIN ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBCI',
    Issuer: 'GLACIER BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBDC',
    Issuer: 'GOLUB CAPITAL BDC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBDV',
    Issuer: 'GLOBAL BETA SMART INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBF',
    Issuer: 'ISHARES GOVERNMENT/CREDIT BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBGR',
    Issuer: 'GLOBAL BETA RISING STARS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBIL',
    Issuer: 'GOLDMAN SACHS ACCESS TREASUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBIO',
    Issuer: 'GENERATION BIO CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBL',
    Issuer: 'GAMCO INVESTORS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBLD',
    Issuer: 'INVESCO MSCI BUILDING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBLI',
    Issuer: 'GLOBAL INDEMNITY GROUP LLC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBLO',
    Issuer: 'GLOBAL BETA LOW BETA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBNH',
    Issuer: 'GREENBROOK TMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBNY',
    Issuer: 'GENERATIONS BANCORP NY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBOX',
    Issuer: 'GREENBOX POS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBR',
    Issuer: 'NEW CONCEPT ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBRG',
    Issuer: 'GOLDENBRIDGE ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBRGR',
    Issuer: 'GOLDENBRIDGE ACQUISITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBRGU',
    Issuer: 'GOLDENBRIDGE ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBRGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBS',
    Issuer: 'GBS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBT',
    Issuer: 'GLOBAL BLOOD THERAPEUTICS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBUG',
    Issuer: 'PACER IPATH GOLD ETNS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBUY',
    Issuer: 'GOLDMAN SACHS FUT CONSUMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GBX',
    Issuer: 'GREENBRIER COMPANIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCBC',
    Issuer: 'GREENE COUNTY BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCC',
    Issuer: 'WISDOMTREE ENHANCED COMMODIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCI',
    Issuer: 'GANNETT CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCIG',
    Issuer: 'GENUINE INVESTORS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCLN',
    Issuer: 'GS BLOOMBERG CLEAN ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCMG',
    Issuer: 'GCM GROSVENOR INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCMGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCO',
    Issuer: 'GENESCO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCOR',
    Issuer: 'GOLDMAN SACHS ACCESS US AGG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCOW',
    Issuer: 'PACER GLOBAL CASH COWS DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCP',
    Issuer: 'GCP APPLIED TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCTK',
    Issuer: 'GLUCOTRACK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GCV',
    Issuer: 'GABELLI CONV AND INCOME SEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GD',
    Issuer: 'GENERAL DYNAMICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDDY',
    Issuer: 'GODADDY INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDE',
    Issuer: 'WISDOMTREE EFFICIENT GOLD PL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDEN',
    Issuer: 'GOLDEN ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDEV',
    Issuer: 'NEXTERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDEVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDIV',
    Issuer: 'HARBOR DIVIDEND GROWTH LEADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDL',
    Issuer: 'GDL FUND/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDL-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDMA',
    Issuer: 'GADSDEN DYNAMIC MULTI-ASSET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDMN',
    Issuer: 'WISDOMTREE EFF GOLD PL MINER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDNR',
    Issuer: 'GARDINER HEALTHCARE ACQUIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDNRU',
    Issuer: 'GARDINER HEALTHCARE ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDNRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDO',
    Issuer: 'WESTERN ASSET GL CORP DEF OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDOC',
    Issuer: 'GOLDMAN SACHS FUTURE HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDOT',
    Issuer: 'GREEN DOT CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDRX',
    Issuer: 'GOODRX HOLDINGS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDS',
    Issuer: 'GDS HOLDINGS LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDST',
    Issuer: 'GOLDENSTONE ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDSTR',
    Issuer: 'GOLDENSTONE ACQUISITIO-RIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDSTU',
    Issuer: 'GOLDENSTONE ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDSTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDV',
    Issuer: 'GABELLI DIVIDEND & INCOME TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDV-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDV-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDVD',
    Issuer: 'R3 GLOBAL DIVIDEND GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDX',
    Issuer: 'VANECK GOLD MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDXD',
    Issuer: 'MICROSECTORS GOLD MINERS -3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDXJ',
    Issuer: 'VANECK JUNIOR GOLD MINERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDXU',
    Issuer: 'MICROSECTORS GOLD MINERS 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GDYN',
    Issuer: 'GRID DYNAMICS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GE',
    Issuer: 'GENERAL ELECTRIC CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GECC',
    Issuer: 'GREAT ELM CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GECCM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GECCN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GECCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEEX',
    Issuer: 'GAMES & ESPORTS EXPERIENCE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEEXU',
    Issuer: 'GAMES & ESPORTS EXPERIENCE A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEEXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEF',
    Issuer: 'GREIF INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEF.B',
    Issuer: 'GREIF INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEG',
    Issuer: 'GREAT ELM GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEHI',
    Issuer: 'RYB EDUCATION INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEL',
    Issuer: 'GENESIS ENERGY L.P.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEM',
    Issuer: 'GOLDMAN SACHS ACTIVEBETA EM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEMD',
    Issuer: 'GOLDMAN ACCESS EM USD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENC',
    Issuer: 'GENCOR INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENE',
    Issuer: 'GENETIC TECH LTD-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENI',
    Issuer: 'GENIUS SPORTS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENQ',
    Issuer: 'GENESIS UNICORN CAPITAL CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENQU',
    Issuer: 'GENESIS UNICORN CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GENY',
    Issuer: 'PRINCIPAL MILLENNIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEO',
    Issuer: 'GEO GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEOS',
    Issuer: 'GEOSPACE TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GER',
    Issuer: 'GOLDMAN SACHS MLP & ENERGY R',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GERM',
    Issuer: 'ETFMG TRTMNT TESTING ADV ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GERN',
    Issuer: 'GERON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GES',
    Issuer: 'GUESS? INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GET',
    Issuer: 'GETNET ADQUIRENCIA E SERVISO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GEVO',
    Issuer: 'GEVO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GF',
    Issuer: 'NEW GERMANY FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFAI',
    Issuer: 'GUARDFORCE AI CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFAIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFF',
    Issuer: 'GRIFFON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFGD',
    Issuer: 'GROWTH FOR GOOD ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFGDR',
    Issuer: 'GROWTH FOR GOOD ACQUISIT-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFGDU',
    Issuer: 'GROWTH FOR GOOD ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFGDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFGF',
    Issuer: 'GURU FAVORITE STOCKS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFI',
    Issuer: 'GOLD FIELDS LTD-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFL',
    Issuer: 'GFL ENVIRONMENTAL INC-SUB VT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFLU',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFOF',
    Issuer: 'GRAYSCALE FUTURE OF FINANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFOR',
    Issuer: 'GRAF ACQUISITION CORP IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFOR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFOR=',
    Issuer: 'GRAF ACQUISITION CORP IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFS',
    Issuer: 'GLOBALFOUNDRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFX',
    Issuer: 'GOLDEN FALCON ACQUISITI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GFX=',
    Issuer: 'GOLDEN FALCON ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGAA',
    Issuer: 'GENESIS GROWTH TECH ACQUIS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGAAU',
    Issuer: 'GENESIS GROWTH TECH ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGAL',
    Issuer: 'GRUPO FINANCIERO GALICIA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGB',
    Issuer: 'GERDAU SA -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGE',
    Issuer: 'GREEN GIANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGG',
    Issuer: 'GRACO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGGV',
    Issuer: 'G3 VRM ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGGVR',
    Issuer: 'G3 VRM ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGGVU',
    Issuer: 'G3 VRM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGMC',
    Issuer: 'GLENFARNE MERGER CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGMCU',
    Issuer: 'GLENFARNE MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGMCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGN',
    Issuer: 'GAMCO GLOBAL GOLD NATURAL RE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGN-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGPI',
    Issuer: 'GORES GUGGENHEIM INC -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGPIU',
    Issuer: 'GORES GUGGENHEIM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGPIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGR',
    Issuer: 'GOGORO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGROW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGRW',
    Issuer: 'GABELLI GLOBAL GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGT',
    Issuer: 'GABELLI MULTIMEDIA TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGT-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGT-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GGZ',
    Issuer: 'GABELLI GLOBAL SMALL & M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GH',
    Issuer: 'GUARDANT HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHAC',
    Issuer: 'GAMING & HOSPITALITY ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHACU',
    Issuer: 'GAMING & HOSPITALITY ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHC',
    Issuer: 'GRAHAM HOLDINGS CO-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHG',
    Issuer: 'GREENTREE HOSPITALITY GR-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHIX',
    Issuer: 'GORES HOLDING IX INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHIXU',
    Issuer: 'GORES HOLDING IX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHIXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHL',
    Issuer: 'GREENHILL & CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHLD',
    Issuer: 'GUILD HOLDINGS CO - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHM',
    Issuer: 'GRAHAM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHRS',
    Issuer: 'GH RESEARCH PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHSI',
    Issuer: 'GUARDION HEALTH SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHTA',
    Issuer: 'GOOSE HOLLOW TACTICAL ALLOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHY',
    Issuer: 'PGIM GLOBAL HIGH YIELD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHYB',
    Issuer: 'GOLDMAN SACHS ACCESS HY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GHYG',
    Issuer: 'ISHARES US&INTL HIGH YIELD C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIA',
    Issuer: 'GIGCAPITAL5 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIA=',
    Issuer: 'GIGCAPITAL5 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIAC',
    Issuer: 'GESHER I ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIACU',
    Issuer: 'GESHER I ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIB',
    Issuer: 'CGI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIC',
    Issuer: 'GLOBAL INDUSTRIAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIFI',
    Issuer: 'GULF ISLAND FABRICATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIGB',
    Issuer: 'GOLDMAN SACHS INV GRD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIGE',
    Issuer: 'SOFI GIG ECONOMY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIGM',
    Issuer: 'GIGAMEDIA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GII',
    Issuer: 'SPDR S&P GLOBAL INFRASTRUCTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIII',
    Issuer: 'G-III APPAREL GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIIX',
    Issuer: 'GORES HOLDINGS VIII INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIIXU',
    Issuer: 'GORES HOLDINGS VIII INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIIXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIL',
    Issuer: 'GILDAN ACTIVEWEAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GILD',
    Issuer: 'GILEAD SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GILT',
    Issuer: 'GILAT SATELLITE NETWORKS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIM',
    Issuer: 'TEMPLETON GLOBAL INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GINN',
    Issuer: 'GOLDMAN SACHS INNOVATE EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIPR',
    Issuer: 'GENERATION INCOME PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIPRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIS',
    Issuer: 'GENERAL MILLS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIW',
    Issuer: 'GIGINTERNATIONAL1 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIWWU',
    Issuer: 'GIGINTERNATIONAL1 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GIWWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJR',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJS',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GJT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GK',
    Issuer: 'ADVISORSHARES GERBER KAWASAK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GKOS',
    Issuer: 'GLAUKOS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GL',
    Issuer: 'GLOBE LIFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GL-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLAD',
    Issuer: 'GLADSTONE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLAQ',
    Issuer: 'GLOBIS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLAQU',
    Issuer: 'GLOBIS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBE',
    Issuer: 'GLOBAL-E ONLINE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBL',
    Issuer: 'CARTESIAN GROWTH CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBLU',
    Issuer: 'CARTESIAN GROWTH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBS',
    Issuer: 'GLOBUS MARITIME LIMITED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLBZ',
    Issuer: 'GLEN BURNIE BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLCN',
    Issuer: 'VANECK CHINA GROWTH LEADERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLD',
    Issuer: 'SPDR GOLD SHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDB',
    Issuer: 'STRATEGY SHARES GLD HDG BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDD',
    Issuer: 'GREAT LAKES DREDGE & DOCK CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDG',
    Issuer: 'GOLDMINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDI',
    Issuer: 'X-LINKS GOLD SHRS COVRD CALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDM',
    Issuer: 'SPDR GOLD MINISHARES TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLDX',
    Issuer: 'USCF GOLD STRATEGY PLUS INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLEE',
    Issuer: 'GLADSTONE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLEEU',
    Issuer: 'GLADSTONE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLEEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLG',
    Issuer: 'TD HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLHA',
    Issuer: 'GLASS HOUSES ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLHAU',
    Issuer: 'GLASS HOUSES ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLHAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLIF',
    Issuer: 'AGFIQ GLOBAL INFRASTRUCTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLIN',
    Issuer: 'VANECK INDIA GROWTH LEADERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLL',
    Issuer: 'PROSHARES ULTRASHORT GOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLLI',
    Issuer: 'GLOBALINK INVESTMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLLIR',
    Issuer: 'GLOBALINK INVESTMENT INC-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLLIU',
    Issuer: 'GLOBALINK INVESTMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLLIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLMD',
    Issuer: 'GALMED PHARMACEUTICALS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLNG',
    Issuer: 'GOLAR LNG LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLO',
    Issuer: 'CLOUGH GLBL OPPORTUNITIES FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOB',
    Issuer: 'GLOBANT SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOP',
    Issuer: 'GASLOG PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOP-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOP-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLOV',
    Issuer: 'GS ACTIVE BETA WORLD LVOL PL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLP',
    Issuer: 'GLOBAL PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLP-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLPG',
    Issuer: 'GALAPAGOS NV-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLPI',
    Issuer: 'GAMING AND LEISURE PROPERTIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLQ',
    Issuer: 'CLOUGH GLOBAL EQUITY FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLRE',
    Issuer: 'GREENLIGHT CAPITAL RE LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLRY',
    Issuer: 'INSPIRE FAITHWARD MIDCAP MOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLS',
    Issuer: 'GELESIS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLSI',
    Issuer: 'GREENWICH LIFESCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLSPT',
    Issuer: 'GLOBAL SPAC PARTNERS CO-SUB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLSPU',
    Issuer: 'GLOBAL SPAC PARTNERS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLSPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLT',
    Issuer: 'GLATFELTER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLTA',
    Issuer: 'GALATA ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLTA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLTA=',
    Issuer: 'GALATA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLTO',
    Issuer: 'GALECTO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLTR',
    Issuer: 'ABRDN PRECIOUS METALS BASKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLU',
    Issuer: 'GABELLI GLOBAL UTIL & INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLU-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLU-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLUE',
    Issuer: 'MONTE ROSA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLU^',
    Issuer: 'GABELLI GLOBAL UTIL-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLV',
    Issuer: 'CLOUGH GLOBAL DIVIDEND AND I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLW',
    Issuer: 'CORNING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GLYC',
    Issuer: 'GLYCOMIMETICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GM',
    Issuer: 'GENERAL MOTORS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMAB',
    Issuer: 'GENMAB A/S -SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMBL',
    Issuer: 'ESPORTS ENTERTAINMENT GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMBLP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMBLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMBLZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMDA',
    Issuer: 'GAMIDA CELL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GME',
    Issuer: 'GAMESTOP CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMED',
    Issuer: 'GLOBUS MEDICAL INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMET',
    Issuer: 'VANECK GREEN METALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMF',
    Issuer: 'SPDR S&P EMERGING ASIA PACIF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMFI',
    Issuer: 'AETHERIUM ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMFIU',
    Issuer: 'AETHERIUM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMFIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMGI',
    Issuer: 'GOLDEN MATRIX GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMOM',
    Issuer: 'CAMBRIA GLOBAL MOMENTUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMRE',
    Issuer: 'GLOBAL MEDICAL REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMRE-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMS',
    Issuer: 'GMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMTX',
    Issuer: 'GEMINI THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMVD',
    Issuer: 'G MEDICAL INNOVATION HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GMVDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNAC',
    Issuer: 'GROUP NINE ACQUISITION -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNACU',
    Issuer: 'GROUP NINE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNCA',
    Issuer: 'GENOCEA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNE',
    Issuer: 'GENIE ENERGY LTD-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNE-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNFT',
    Issuer: 'GENFIT-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNK',
    Issuer: 'GENCO SHIPPING & TRADING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNL',
    Issuer: 'GLOBAL NET LEASE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNL-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNLN',
    Issuer: 'GREENLANE HOLDINGS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNMA',
    Issuer: 'ISHARES GNMA BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNOM',
    Issuer: 'GLOBAL X GENOMICS & BIOTECHN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNPX',
    Issuer: 'GENPREX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNR',
    Issuer: 'SPDR S&P GL NAT RESOURCES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNRC',
    Issuer: 'GENERAC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNS',
    Issuer: 'GENIUS GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNSS',
    Issuer: 'GENASYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNT',
    Issuer: 'GAMCO NATURAL RESOURCES GOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNTA',
    Issuer: 'GENENTA SCIENCE SPA - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNTX',
    Issuer: 'GENTEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNTY',
    Issuer: 'GUARANTY BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNUS',
    Issuer: 'GENIUS BRANDS INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GNW',
    Issuer: 'GENWORTH FINANCIAL INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GO',
    Issuer: 'GROCERY OUTLET HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOAC',
    Issuer: 'GO ACQUISITION CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOAC=',
    Issuer: 'GO ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOAU',
    Issuer: 'US GLB GLD & METAL MNRS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOBI',
    Issuer: 'GOBI ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOCO',
    Issuer: 'GOHEALTH INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOED',
    Issuer: '1847 GOEDEKER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOED+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOEV',
    Issuer: 'CANOO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOEVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOEX',
    Issuer: 'GLOBAL X GOLD EXPLORERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOF',
    Issuer: 'GUGGENHEIM STRATEGIC OPPORTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOGL',
    Issuer: 'GOLDEN OCEAN GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOGN',
    Issuer: 'GOGREEN INVESTMENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOGN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOGN=',
    Issuer: 'GOGREEN INVESTMENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOGO',
    Issuer: 'GOGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOL',
    Issuer: 'GOL LINHAS AEREAS INTEL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOLD',
    Issuer: 'BARRICK GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOLF',
    Issuer: 'ACUSHNET HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOOD',
    Issuer: 'GLADSTONE COMMERCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOODN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOODO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOOG',
    Issuer: 'ALPHABET INC-CL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOOGL',
    Issuer: 'ALPHABET INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOOS',
    Issuer: 'CANADA GOOSE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GORO',
    Issuer: 'GOLD RESOURCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOSS',
    Issuer: 'GOSSAMER BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOTU',
    Issuer: 'GAOTU TECHEDU INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOVT',
    Issuer: 'ISHARES US TREASURY BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOVX',
    Issuer: 'GEOVAX LABS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOVXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GOVZ',
    Issuer: 'ISHARES 25+ YR TREAS STRIPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GP',
    Issuer: 'GREENPOWER MOTOR CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPAC',
    Issuer: 'GLOBAL PARTNER ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPACU',
    Issuer: 'GLOBAL PARTNER ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPAL',
    Issuer: 'GS ACTIVEBETA PARIS AC US LC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPC',
    Issuer: 'GENUINE PARTS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPCO',
    Issuer: 'GOLDEN PATH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPCOR',
    Issuer: 'GOLDEN PATH ACQUISITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPCOU',
    Issuer: 'GOLDEN PATH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPCOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPI',
    Issuer: 'GROUP 1 AUTOMOTIVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPJA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPK',
    Issuer: 'GRAPHIC PACKAGING HOLDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPL',
    Issuer: 'GREAT PANTHER MINING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPMT',
    Issuer: 'GRANITE POINT MORTGAGE TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPMT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPN',
    Issuer: 'GLOBAL PAYMENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPOR',
    Issuer: 'GULFPORT ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPP',
    Issuer: 'GREEN PLAINS PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPRE',
    Issuer: 'GREEN PLAINS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPRK',
    Issuer: 'GEOPARK LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPRO',
    Issuer: 'GOPRO INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GPS',
    Issuer: 'GAP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GQRE',
    Issuer: 'FLEXSHARES GLOBAL QUALITY RE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRAB',
    Issuer: 'GRAB HOLDINGS LTD - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRABW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRAY',
    Issuer: 'GRAYBUG VISION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRBK',
    Issuer: 'GREEN BRICK PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRBK-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRC',
    Issuer: 'GORMAN-RUPP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRCL',
    Issuer: 'GRACELL BIOTECHNOLOGIES-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRCY',
    Issuer: 'GREENCITY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRCYU',
    Issuer: 'GREENCITY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRCYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GREE',
    Issuer: 'GREENIDGE GENERATION HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GREEL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GREI',
    Issuer: 'GOLDMAN SACHS FUT REAL ESTAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GREK',
    Issuer: 'GLOBAL X MSCI GREECE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRES',
    Issuer: 'IQ GLOBAL RESOURCES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRF',
    Issuer: 'EAGLE CAPITAL GROWTH FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRFS',
    Issuer: 'GRIFOLS SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRID',
    Issuer: 'FIRST TRST NASD CL EDG SGIIF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRIL',
    Issuer: 'MUSCLE MAKER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRIN',
    Issuer: 'GRINDROD SHIPPING HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRMN',
    Issuer: 'GARMIN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRN',
    Issuer: 'IPATH SERIES B CARBON ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRNA',
    Issuer: 'GREENLIGHT BIOSCIENCES HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRNAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRNB',
    Issuer: 'VANECK GREEN BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRNQ',
    Issuer: 'GREENPRO CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRNR',
    Issuer: 'GLOBAL X GREEN BUILDING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GROM',
    Issuer: 'GROM SOCIAL ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GROMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GROW',
    Issuer: 'U.S. GLOBAL INVESTORS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GROY',
    Issuer: 'GOLD ROYALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GROY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRP=',
    Issuer: 'GRANITE REAL ESTATE INVESTME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRPH',
    Issuer: 'GRAPHITE BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRPN',
    Issuer: 'GROUPON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRTS',
    Issuer: 'GRITSTONE BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRTX',
    Issuer: 'GALERA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRU',
    Issuer: 'ELEMENTS ICE EXTRA GRAINS TO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRVI',
    Issuer: 'GROVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRVY',
    Issuer: 'GRAVITY CO LTD-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRWG',
    Issuer: 'GROWGENERATION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRX',
    Issuer: 'GABELLI HEALTHCARE&WELLNESS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GRZZ',
    Issuer: 'GRIZZLE GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS',
    Issuer: 'GOLDMAN SACHS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GS-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSAQ',
    Issuer: 'GLOBAL SYNERGY ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSAQU',
    Issuer: 'GLOBAL SYNERGY ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSAT',
    Issuer: 'GLOBALSTAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSBC',
    Issuer: 'GREAT SOUTHERN BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSBD',
    Issuer: 'GOLDMAN SACHS BDC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEE',
    Issuer: 'GOLDMAN SACHS MARKETBETA EME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEU',
    Issuer: 'GOLDMAN ACTIVEBTA EUR EQ ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEV',
    Issuer: 'GORES HOLDINGS VII INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEVU',
    Issuer: 'GORES HOLDINGS VII INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSEW',
    Issuer: 'GOLDMAN SACHS EQL WGHT LARGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSFP',
    Issuer: 'GS FUTURE PLANET EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSG',
    Issuer: 'ISHARES S&P GSCI COMMODITY I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSHD',
    Issuer: 'GOOSEHEAD INSURANCE INC -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSID',
    Issuer: 'GOLDMAN SACHS MARKETBETA INT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSIE',
    Issuer: 'GOLDMAN SACHS ACTIVEBETA INT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSIG',
    Issuer: 'GOLDMAN SACHS ACCESS INVESTM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSIT',
    Issuer: 'GSI TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSJY',
    Issuer: 'GOLDMAN ACTIVEBETA JP EQ ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSK',
    Issuer: 'GSK PLC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSL',
    Issuer: 'GLOBAL SHIP LEASE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSLC',
    Issuer: 'GOLDMAN ACTIVEBETA US LC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSLD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSM',
    Issuer: 'FERROGLOBE PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSMG',
    Issuer: 'GLORY STAR NEW MEDIA GROUP H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSMGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSP',
    Issuer: 'IPATH GSCI TOTAL RETURN INDX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSPY',
    Issuer: 'GOTHAM ENHANCED 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQB',
    Issuer: 'G SQUARED ASCEND II INC -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQB=',
    Issuer: 'G SQUARED ASCEND II INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQD',
    Issuer: 'G SQUARED ASCEND I INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSQD=',
    Issuer: 'G SQUARED ASCEND I INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSRM',
    Issuer: 'GSR II METEORA ACQUISIT-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSRMR',
    Issuer: 'GSR II METEORA ACQUISIT -RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSRMU',
    Issuer: 'GSR II METEORA ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSRMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSSC',
    Issuer: 'GOLDMAN SACHS ACTIVEBETA US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSST',
    Issuer: 'GOLDMAN SACHS ACCESS U/SHORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSUS',
    Issuer: 'GOLDMAN SACHS MARKETBETA US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSV',
    Issuer: 'GOLD STANDARD VENTURES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GSY',
    Issuer: 'INVESCO ULTRA SHORT DURATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GT',
    Issuer: 'GOODYEAR TIRE & RUBBER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTAC',
    Issuer: 'GLOBAL TECHNOLOGY ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTACU',
    Issuer: 'GLOBAL TECHNOLOGY ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTBP',
    Issuer: 'GT BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTE',
    Issuer: 'GRAN TIERRA ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTEC',
    Issuer: 'GREENLAND TECHNOLOGIES HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTEK',
    Issuer: 'GS FUTURE TECH LEADERS EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTES',
    Issuer: 'GATES INDUSTRIAL CORP PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTH',
    Issuer: 'GENETRON HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTHX',
    Issuer: 'G1 THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTIM',
    Issuer: 'GOOD TIMES RESTAURANTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTIP',
    Issuer: 'GOLDMAN SACHS ACCESS INFLATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTLB',
    Issuer: 'GITLAB INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTLS',
    Issuer: 'CHART INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTN',
    Issuer: 'GRAY TELEVISION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTN.A',
    Issuer: 'GRAY TELEVISION INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTO',
    Issuer: 'INVESCO TOTAL RETURN BOND ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPA',
    Issuer: 'GORES TECHNOLOGY PARTNERS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPAU',
    Issuer: 'GORES TECHNOLOGY PARTNERS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPB',
    Issuer: 'GORES TECHNOLOGY PRTNR II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPBU',
    Issuer: 'GORES TECHNOLOGY PARTNERS II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTPBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTR',
    Issuer: 'WISDOMTREE TARGET RANGE FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTX',
    Issuer: 'GARRETT MOTION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTXAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTY',
    Issuer: 'GETTY REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GTYH',
    Issuer: 'GTY TECHNOLOGY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUG',
    Issuer: 'GUGGENHEIM ACTIVE ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUNR',
    Issuer: 'FLEXSHARES GLOBAL UPSTREAM N',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GURE',
    Issuer: 'GULF RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GURU',
    Issuer: 'GLOBAL X GURU INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUSA',
    Issuer: 'GOLDMAN SACHS MARKETBETA US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUSH',
    Issuer: 'DIREXION DAILY S&P OIL & GAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUT',
    Issuer: 'GABELLI UTILITY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GUT-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVA',
    Issuer: 'GRANITE CONSTRUCTION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVAL',
    Issuer: 'CAMBRIA GLOBAL VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVCI',
    Issuer: 'GREEN VISOR FINANCIAL TECH-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVCIU',
    Issuer: 'GREEN VISOR FINANCIAL TECHNO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVCIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVI',
    Issuer: 'ISHARES INTERMEDIATE GOVERNM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVIP',
    Issuer: 'GOLD SACHS HEDGE IND VIP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GVP',
    Issuer: 'GSE SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWH',
    Issuer: 'ESS TECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWII',
    Issuer: 'GOOD WORKS II ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWRE',
    Issuer: 'GUIDEWIRE SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWRS',
    Issuer: 'GLOBAL WATER RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWW',
    Issuer: 'WW GRAINGER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GWX',
    Issuer: 'SPDR S&P INTL SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXC',
    Issuer: 'SPDR S&P CHINA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXG',
    Issuer: 'GLOBAL X MSCI COLOMBIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXII',
    Issuer: 'GX ACQUISITION CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXIIU',
    Issuer: 'GX ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXO',
    Issuer: 'GXO LOGISTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GXTG',
    Issuer: 'GLOBAL X THEMATIC GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GYLD',
    Issuer: 'ARROW DOW JONES GLOBAL YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'GYRO',
    Issuer: 'GYRODYNE LLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'H',
    Issuer: 'HYATT HOTELS CORP - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HA',
    Issuer: 'HAWAIIAN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAAC',
    Issuer: 'HEALTH ASSURANCE ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAACU',
    Issuer: 'HEALTH ASSURANCE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HACK',
    Issuer: 'ETFMG PRIME CYBER SECURITY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAE',
    Issuer: 'HAEMONETICS CORP/MASS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAFC',
    Issuer: 'HANMI FINANCIAL CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAIA',
    Issuer: 'HEALTHCARE AI ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAIAU',
    Issuer: 'HEALTHCARE AI ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAIAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAIL',
    Issuer: 'SPDR S&P KENSHO SMART MOBILI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAIN',
    Issuer: 'HAIN CELESTIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAL',
    Issuer: 'HALLIBURTON CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HALL',
    Issuer: 'HALLMARK FINL SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HALO',
    Issuer: 'HALOZYME THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAP',
    Issuer: 'VANECK NATURAL RESOURCES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAPP',
    Issuer: 'HAPPINESS DEVELOPMENT GROU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAPY',
    Issuer: 'HARBOR CORP CULT LEADERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HARP',
    Issuer: 'HARPOON THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HART',
    Issuer: 'IQ HEALTHY HEARTS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAS',
    Issuer: 'HASBRO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HASI',
    Issuer: 'HANNON ARMSTRONG SUSTAINABLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAUS',
    Issuer: 'HOME APPRECIATION US REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAUZ',
    Issuer: 'XTRACKERS INTL REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAWX',
    Issuer: 'ISHARES CUR HDG MSCI ACWI-X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAYN',
    Issuer: 'HAYNES INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HAYW',
    Issuer: 'HAYWARD HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBAN',
    Issuer: 'HUNTINGTON BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBANM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBANP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBB',
    Issuer: 'HAMILTON BEACH BRAND-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBCP',
    Issuer: 'HOME BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBI',
    Issuer: 'HANESBRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBIO',
    Issuer: 'HARVARD BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBM',
    Issuer: 'HUDBAY MINERALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBNC',
    Issuer: 'HORIZON BANCORP INC/IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HBT',
    Issuer: 'HBT FINANCIAL INC/DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCA',
    Issuer: 'HCA HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCAR',
    Issuer: 'HEALTHCARE SERVICES ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCARU',
    Issuer: 'HEALTHCARE SERVICES ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCARW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCAT',
    Issuer: 'HEALTH CATALYST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCC',
    Issuer: 'WARRIOR MET COAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCCI',
    Issuer: 'HERITAGE-CRYSTAL CLEAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCDI',
    Issuer: 'HARBOR CUSTOM DEVELOPMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCDIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCDIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCDIZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCI',
    Issuer: 'HCI GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCIC',
    Issuer: 'HENNESSY CAPITAL INVESTMEN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCICU',
    Issuer: 'HENNESSY CAPITAL INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCII',
    Issuer: 'HUDSON EXECUTIVE INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCIIU',
    Issuer: 'HUDSON EXECUTIVE INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCKT',
    Issuer: 'HACKETT GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCM',
    Issuer: 'HUTCHMED CHINA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCMA',
    Issuer: 'HCM ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCMAU',
    Issuer: 'HCM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCMAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCNE',
    Issuer: 'JAWS HURRICANE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCNEU',
    Issuer: 'JAWS HURRICANE ACQUISITON CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCNEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCOM',
    Issuer: 'HARTFORD SCHRODERS COMMODITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCP',
    Issuer: 'HASHICORP INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCRB',
    Issuer: 'HARTFORD CORE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCSG',
    Issuer: 'HEALTHCARE SERVICES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCTI',
    Issuer: 'HEALTHCARE TRIANGLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCVI',
    Issuer: 'HENNESSY CAPITAL INVEST-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCVIU',
    Issuer: 'HENNESSY CAPITAL INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCVIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCWB',
    Issuer: 'HCW BIOLOGICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HCXY',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HD',
    Issuer: 'HOME DEPOT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDAW',
    Issuer: 'XTRACKERS MSCI ALL WORLD EX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDB',
    Issuer: 'HDFC BANK LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDEF',
    Issuer: 'XTRACKERS MSCI EAFE HIGH DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDG',
    Issuer: 'PROSHARES HEDGE REPLICAT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDGE',
    Issuer: 'ADVISORSHARES RANGER EQ BEAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDIV',
    Issuer: 'QRAFT AI-ENHANCED US HIGH DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDLB',
    Issuer: 'ETRACS 2X HI DIV L-VOL ETN-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDMV',
    Issuer: 'FT HORIZON MGD VOL D INT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDRO',
    Issuer: 'DEFIANCE NEXT GEN H2 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDSN',
    Issuer: 'HUDSON TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HDV',
    Issuer: 'ISHARES CORE HIGH DIVIDEND E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HE',
    Issuer: 'HAWAIIAN ELECTRIC INDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEAR',
    Issuer: 'TURTLE BEACH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEDJ',
    Issuer: 'WISDOMTREE EUROPE HEDGED EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEEM',
    Issuer: 'ISHARES CRNCY HEDGD MSCI EM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEES',
    Issuer: 'H&E EQUIPMENT SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEET',
    Issuer: 'HARTFORD SCHRODERS ESG US EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEFA',
    Issuer: 'ISHA CURR HEDGED MSCI EAFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEGD',
    Issuer: 'SWAN HEDGED EQUITY US LG CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEI',
    Issuer: 'HEICO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEI.A',
    Issuer: 'HEICO CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HELE',
    Issuer: 'HELEN OF TROY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HELX',
    Issuer: 'FRANKLIN GENOMIC ADVANCEMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEP',
    Issuer: 'HOLLY ENERGY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEPA',
    Issuer: 'HEPION PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEPS',
    Issuer: 'D-MARKET ELECTRONIC SERV-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEQ',
    Issuer: 'JOHN HANCOCK HEDGED EQUITY &',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEQT',
    Issuer: 'SIMPLIFY HEDGED EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HERA',
    Issuer: 'FTAC HERA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HERAU',
    Issuer: 'FTAC HERA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HERAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HERD',
    Issuer: 'PACER CASH COWS FUND OF FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HERO',
    Issuer: 'GLOBAL X VIDEO GAMES& ESPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HES',
    Issuer: 'HESS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HESM',
    Issuer: 'HESS MIDSTREAM LP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEWC',
    Issuer: 'ISHARES CURR HDG MSCI CANADA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEWG',
    Issuer: 'ISHA HEDGED MSCI GERMANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEWJ',
    Issuer: 'ISHA CURR HEDGED MSCI JAPAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEWU',
    Issuer: 'ISHARES CURR HEDGED MSCI UK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEXO',
    Issuer: 'HEXO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HEZU',
    Issuer: 'ISHARES CURRENCY HEDGED MSCI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFBL',
    Issuer: 'HOME FEDERAL BANCORP INC/LA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFFG',
    Issuer: 'HF FOODS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFGO',
    Issuer: 'HARTFORD LARGE CAP GROWTH ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFRO',
    Issuer: 'HIGHLAND INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFRO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFWA',
    Issuer: 'HERITAGE FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HFXI',
    Issuer: 'IQ 50PCT HEDGED FTSE INT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGBL',
    Issuer: 'HERITAGE GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGEN',
    Issuer: 'HUMANIGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGER',
    Issuer: 'HARBOR ALL WEATHER-INFLA FOC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGLB',
    Issuer: 'HIGHLAND GLOBAL ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGTY',
    Issuer: 'HAGERTY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGTY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HGV',
    Issuer: 'HILTON GRAND VACATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHC',
    Issuer: 'HOWARD HUGHES CORP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHGC',
    Issuer: 'HHG CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHGCR',
    Issuer: 'HHG CAPITAL CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHGCU',
    Issuer: 'HHG CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHGCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHH',
    Issuer: 'ETFMG REAL ESTATE TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHLA',
    Issuer: 'HH&L ACQUISITION CO -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHLA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHLA=',
    Issuer: 'HH&L ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHR',
    Issuer: 'HEADHUNTER GROUP PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HHS',
    Issuer: 'HARTE-HANKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HI',
    Issuer: 'HILLENBRAND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIBB',
    Issuer: 'HIBBETT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIBL',
    Issuer: 'DIREXION DAILY S&P 500 HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIBS',
    Issuer: 'DIREXION DAILY S&P 500 HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIE',
    Issuer: 'MILLER/HOWARD HIGH INCOME EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIFS',
    Issuer: 'HINGHAM INSTITUTION FOR SVGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIG',
    Issuer: 'HARTFORD FINANCIAL SVCS GRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIG-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIGA',
    Issuer: 'HIG ACQUISITION CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIGA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIGA=',
    Issuer: 'HIG ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIHO',
    Issuer: 'HIGHWAY HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HII',
    Issuer: 'HUNTINGTON INGALLS INDUSTRIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIII',
    Issuer: 'HUDSON EXECUTIVE INVESTMEN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIIIU',
    Issuer: 'HUDSON EXECUTIV INV CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIL',
    Issuer: 'HILL INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HILS',
    Issuer: 'HILLSTREAM BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIMS',
    Issuer: 'HIMS & HERS HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIMX',
    Issuer: 'HIMAX TECHNOLOGIES INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIO',
    Issuer: 'WESTERN ASSET HI INC OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIPO',
    Issuer: 'HIPPO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIPO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIPS',
    Issuer: 'GRANITESHARES HIPS US HIGH I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HISF',
    Issuer: 'FIRST TRUST EXCHANGE-TRADED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HITI',
    Issuer: 'HIGH TIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIVE',
    Issuer: 'HIVE BLOCKCHAIN TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIW',
    Issuer: 'HIGHWOODS PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HIX',
    Issuer: 'WESTERN ASSET HIGH INC II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HJEN',
    Issuer: 'DIREXION HYDROGEN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HJPX',
    Issuer: 'ISHARES CUR HEDG JPX-NIK 400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HKND',
    Issuer: 'HUMANKIND US STOCK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HL',
    Issuer: 'HECLA MINING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLAH',
    Issuer: 'HAMILTON LANE ALL-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLAHU',
    Issuer: 'HAMILTON LANE ALLIANCE HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLAHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLAL',
    Issuer: 'WAHED FTSE USA SHARIAH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLBZ',
    Issuer: 'HELBIZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLBZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLF',
    Issuer: 'HERBALIFE NUTRITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLG',
    Issuer: 'HAILIANG EDUCATION GROUP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLGE',
    Issuer: 'HARTFORD LONGEVITY ECONOMY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLGN',
    Issuer: 'HELIOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLGN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLI',
    Issuer: 'HOULIHAN LOKEY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLIO',
    Issuer: 'HELIOS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLIT',
    Issuer: 'HARMONIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLLY',
    Issuer: 'HOLLEY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLLY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLMN',
    Issuer: 'HILLMAN SOLUTIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLNE',
    Issuer: 'HAMILTON LANE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLT',
    Issuer: 'HILTON WORLDWIDE HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLTH',
    Issuer: 'CUE HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLVX',
    Issuer: 'HILLEVAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HLX',
    Issuer: 'HELIX ENERGY SOLUTIONS GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMA',
    Issuer: 'HEARTLAND MEDIA ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMA=',
    Issuer: 'HEARTLAND MEDIA ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMC',
    Issuer: 'HONDA MOTOR CO LTD-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMCO',
    Issuer: 'HUMANCO ACQUISITION COR-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMCOU',
    Issuer: 'HUMANCO ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMCOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMLP',
    Issuer: 'HOEGH LNG PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMLP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMN',
    Issuer: 'HORACE MANN EDUCATORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMNF',
    Issuer: 'HMN FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMOP',
    Issuer: 'HARTFORD MUNI OPPORTUNITY ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMPT',
    Issuer: 'HOME POINT CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMST',
    Issuer: 'HOMESTREET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMTV',
    Issuer: 'HEMISPHERE MEDIA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HMY',
    Issuer: 'HARMONY GOLD MNG-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNDL',
    Issuer: 'NASDAQ 7 HANDL INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNGR',
    Issuer: 'HANGER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNI',
    Issuer: 'HNI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNNA',
    Issuer: 'HENNESSY ADVISORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNNAZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNP',
    Issuer: 'HUANENG POWER INTL-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNRA',
    Issuer: 'HNR ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNRA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNRG',
    Issuer: 'HALLADOR ENERGY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNST',
    Issuer: 'HONEST CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNVR',
    Issuer: 'HANOVER BANCORP INC/NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HNW',
    Issuer: 'PIONEER DIVERSIFIED HIGH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOFT',
    Issuer: 'HOOKER FURNISHINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOFV',
    Issuer: 'HALL OF FAME RESORT & ENTERT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOFVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOG',
    Issuer: 'HARLEY-DAVIDSON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOLD',
    Issuer: 'ADVISORSHARES NORTH SQUARE M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOLI',
    Issuer: 'HOLLYSYS AUTOMATION TECHNOLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOLX',
    Issuer: 'HOLOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOM',
    Issuer: 'LIFEGOAL HOME DOWN PAYMENT I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOMB',
    Issuer: 'HOME BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOMZ',
    Issuer: 'HOYA CAPITAL HOUSING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HON',
    Issuer: 'HONEYWELL INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HONE',
    Issuer: 'HARBORONE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOOD',
    Issuer: 'ROBINHOOD MARKETS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOOK',
    Issuer: 'HOOKIPA PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOPE',
    Issuer: 'HOPE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HORI',
    Issuer: 'EMERGING MARKETS HORIZON -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HORIU',
    Issuer: 'EMERGING MARKETS HORIZON COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HORIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOTH',
    Issuer: 'HOTH THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOTL',
    Issuer: 'KELLY HOTEL & LODGING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOUR',
    Issuer: 'HOUR LOOP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOV',
    Issuer: 'HOVNANIAN ENTERPRISES-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOVNP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HOWL',
    Issuer: 'WEREWOLF THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HP',
    Issuer: 'HELMERICH & PAYNE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPE',
    Issuer: 'HEWLETT PACKARD ENTERPRISE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPF',
    Issuer: 'JOHN HANCOCK PFD INCOME II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPI',
    Issuer: 'JOHN HANCOCK PFD INCOME FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPK',
    Issuer: 'HIGHPEAK ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPKEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPLT',
    Issuer: 'HOME PLATE ACQUISITION -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPLTU',
    Issuer: 'HOME PLATE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPLTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPP',
    Issuer: 'HUDSON PACIFIC PROPERTIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPP-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPQ',
    Issuer: 'HP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPS',
    Issuer: 'JOHN HANCOCK PFD INCOME III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPX',
    Issuer: 'HPX CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HPX=',
    Issuer: 'HPX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HQH',
    Issuer: 'TEKLA HEALTHCARE INVESTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HQI',
    Issuer: 'HIREQUEST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HQL',
    Issuer: 'TEKLA LIFE SCIENCES INVESTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HQY',
    Issuer: 'HEALTHEQUITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HR',
    Issuer: 'HEALTHCARE REALTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRB',
    Issuer: 'H&R BLOCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRI',
    Issuer: 'HERC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRL',
    Issuer: 'HORMEL FOODS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRMY',
    Issuer: 'HARMONY BIOSCIENCES HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HROW',
    Issuer: 'HARROW HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HROWL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRT',
    Issuer: 'HIRERIGHT HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRTG',
    Issuer: 'HERITAGE INSURANCE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRTX',
    Issuer: 'HERON THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HRZN',
    Issuer: 'HORIZON TECHNOLOGY FINANCE C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSAQ',
    Issuer: 'HEALTH SCIENCES ACQUISITIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSBC',
    Issuer: 'HSBC HOLDINGS PLC-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSC',
    Issuer: 'HARSCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSCZ',
    Issuer: 'ISHARES CUR HDG MSCI EAFE SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSDT',
    Issuer: 'HELIUS MEDICAL TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSIC',
    Issuer: 'HENRY SCHEIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSII',
    Issuer: 'HEIDRICK & STRUGGLES INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSKA',
    Issuer: 'HESKA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSMV',
    Issuer: 'FIRST TRUST HORIZON MANAGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSON',
    Issuer: 'HUDSON GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSRT',
    Issuer: 'HARTFORD SHORT DURATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HST',
    Issuer: 'HOST HOTELS & RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSTM',
    Issuer: 'HEALTHSTREAM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSTO',
    Issuer: 'HISTOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSUN',
    Issuer: 'HARTFORD SUSTAINABLE INC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HSY',
    Issuer: 'HERSHEY CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HT',
    Issuer: 'HERSHA HOSPITALITY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HT-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HT-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HT-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTA',
    Issuer: 'HEALTHCARE TRUST OF AME-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTAB',
    Issuer: 'HARTFORD SCHRODERS TAX AWARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTAQ',
    Issuer: 'HUNT COS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTAQ=',
    Issuer: 'HUNT COS ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTBI',
    Issuer: 'HOMETRUST BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTBK',
    Issuer: 'HERITAGE COMMERCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTCR',
    Issuer: 'HEARTCORE ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTD',
    Issuer: 'JOHN HANCOCK T/A DVD INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTEC',
    Issuer: 'ROBO GLOBAL HEALTHCARE TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTFB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTGC',
    Issuer: 'HERCULES CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTGM',
    Issuer: 'HTG MOLECULAR DIAGNOSTICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTH',
    Issuer: 'HILLTOP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTHT',
    Issuer: 'HUAZHU GROUP LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTIA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTIBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTLD',
    Issuer: 'HEARTLAND EXPRESS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTLF',
    Issuer: 'HEARTLAND FINANCIAL USA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTLFP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTOO',
    Issuer: 'FUSION FUEL GREEN PLC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTOOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTPA',
    Issuer: 'HIGHLAND TRANSCEND PART-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTPA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTPA=',
    Issuer: 'HIGHLAND TRANSCEND PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTRB',
    Issuer: 'HARTFORD TOTAL RTRN BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTUS',
    Issuer: 'HULL TACTICAL US ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTY',
    Issuer: 'JOHN HANCOCK TAX-ADVANTAGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTZ',
    Issuer: 'HERTZ GLOBAL HLDGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HTZWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUBB',
    Issuer: 'HUBBELL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUBG',
    Issuer: 'HUB GROUP INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUBS',
    Issuer: 'HUBSPOT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUDI',
    Issuer: 'HUADI INTERNATIONAL GROUP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUGE',
    Issuer: 'FSD PHARMA INC-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUGS',
    Issuer: 'USHG ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUGS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUGS=',
    Issuer: 'USHG ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUIZ',
    Issuer: 'HUIZE HOLDING LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUM',
    Issuer: 'HUMANA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUMA',
    Issuer: 'HUMACYTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUMAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUN',
    Issuer: 'HUNTSMAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HURC',
    Issuer: 'HURCO COMPANIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HURN',
    Issuer: 'HURON CONSULTING GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUSA',
    Issuer: 'HOUSTON AMERICAN ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUSN',
    Issuer: 'HUDSON CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUSV',
    Issuer: 'FT HORIZON MNGD VOL DOM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUT',
    Issuer: 'HUT 8 MINING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HUYA',
    Issuer: 'HUYA INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HVAL',
    Issuer: 'ALPS HILLMAN ACTIVE VALUE ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HVBC',
    Issuer: 'HV BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HVT',
    Issuer: 'HAVERTY FURNITURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HVT.A',
    Issuer: 'HAVERTY FURNITURE COS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWBK',
    Issuer: 'HAWTHORN BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWC',
    Issuer: 'HANCOCK WHITNEY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWCPZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWEL',
    Issuer: 'HEALTHWELL ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWELU',
    Issuer: 'HEALTHWELL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWELW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWKN',
    Issuer: 'HAWKINS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWKZ',
    Issuer: 'HAWKS ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWKZ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWKZ=',
    Issuer: 'HAWKS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWM',
    Issuer: 'HOWMET AEROSPACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HWM-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HXL',
    Issuer: 'HEXCEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HY',
    Issuer: 'HYSTER-YALE MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYAC',
    Issuer: 'HAYMAKER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYACU',
    Issuer: 'HAYMAKER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYB',
    Issuer: 'NEW AMERICA HIGH INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYBB',
    Issuer: 'ISHARES BB RATED CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYBL',
    Issuer: 'SPDR BLACKSTONE HIGH INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYD',
    Issuer: 'VANECK HIGH YIELD MUNI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYDB',
    Issuer: 'ISHARES HIGH YIELD BOND FACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYDR',
    Issuer: 'GLOBAL X HYDROGEN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYDW',
    Issuer: 'XTRS LOW BETA HI YIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYEM',
    Issuer: 'VANECK EMRG MKTS HI YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYFM',
    Issuer: 'HYDROFARM HOLDINGS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYG',
    Issuer: 'ISHARES IBOXX HIGH YLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYGH',
    Issuer: 'ISHARES INT RATE HEDG HY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYGV',
    Issuer: 'FLEXSHARES HIGH YIELD VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYHG',
    Issuer: 'PROSHARES HIGH YIELD INTERES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYI',
    Issuer: 'WESTERN ASSET HIGH YIELD DEF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYIN',
    Issuer: 'WisdomTree Alternative Incom',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYLB',
    Issuer: 'XTRACKERS USD HIGH YIELD COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYLD',
    Issuer: 'HIGH YIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYLN',
    Issuer: 'HYLIION HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYLS',
    Issuer: 'FT TACTICAL HIGH YIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYLV',
    Issuer: 'IQ S&P HY LOW VOL BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMB',
    Issuer: 'SPDR NUVEEN BLOOMBERG HIGH Y',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMC',
    Issuer: 'HYCROFT MINING HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMCL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMCZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYMU',
    Issuer: 'BLACKROCK HIGH YIELD MUNI IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYPR',
    Issuer: 'HYPERFINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYRE',
    Issuer: 'HYRECAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYRM',
    Issuer: 'XTRACKERS R/M USD HI YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYS',
    Issuer: 'PIMCO 0-5 YEAR H/Y CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYT',
    Issuer: 'BLACKROCK CORP HI YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYTR',
    Issuer: 'CP HIGH YIELD TREND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYUP',
    Issuer: 'XTRS HI BETA HI YIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYW',
    Issuer: 'HYWIN HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYXF',
    Issuer: 'ISHARES ESG ADV HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYXU',
    Issuer: 'ISHARES INTERNATIONAL HIGH Y',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYZD',
    Issuer: 'WISDOMTREE INTEREST RATE HED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYZN',
    Issuer: 'HYZON MOTORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HYZNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZN',
    Issuer: 'HORIZON GLOBAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZNP',
    Issuer: 'HORIZON THERAPEUTICS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZO',
    Issuer: 'MARINEMAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZON',
    Issuer: 'HORIZON ACQUIS CORP II -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZON+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'HZON=',
    Issuer: 'HORIZON ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAA',
    Issuer: 'IAA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAC',
    Issuer: 'IAC/INTERACTIVECORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IACC',
    Issuer: 'ION ACQUISITION CORP 3 LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAE',
    Issuer: 'VOYA ASIA PAC HI DVD EQ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAF',
    Issuer: 'ABERDEEN AUSTRALIA EQUITY FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAG',
    Issuer: 'IAMGOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAGG',
    Issuer: 'ISHARES INTL AGGREGATE BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAI',
    Issuer: 'ISHARES U.S. BROKER-DEALERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAK',
    Issuer: 'ISHARES U.S. INSURANCE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAPR',
    Issuer: 'INNOVATOR INTERNATIONAL DEVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IART',
    Issuer: 'INTEGRA LIFESCIENCES HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAS',
    Issuer: 'INTEGRAL AD SCIENCE HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAT',
    Issuer: 'ISHARES US REGIONAL BANKS ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAU',
    Issuer: 'ISHARES GOLD TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAUF',
    Issuer: 'ISHARES GOLD STRATEGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAUM',
    Issuer: 'ISHARES GOLD TRUST MICRO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IAUX',
    Issuer: 'I-80 GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBA',
    Issuer: 'INDUSTRIAS BACHOCO SAB SP AD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBB',
    Issuer: 'ISHARES BIOTECHNOLOGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBBQ',
    Issuer: 'INVESCO NASDAQ BIOTECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBCE',
    Issuer: 'ISHARES IBONDS MAR 2023 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBCP',
    Issuer: 'INDEPENDENT BANK CORP - MICH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBD',
    Issuer: 'INSPIRE CORPORATE BOND ESG E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDD',
    Issuer: 'ISHARES IBONDS MAR 2023 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDN',
    Issuer: 'ISHARES IBONDS DEC 2022 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDO',
    Issuer: 'ISHARES IBONDS DEC 2023 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDP',
    Issuer: 'ISHARES IBONDS DEC 2024 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDQ',
    Issuer: 'ISHARES IBONDS DEC 2025 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDR',
    Issuer: 'ISHARES IBONDS DEC 2026 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDS',
    Issuer: 'ISHRS IBNDS DEC 27 CORP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDT',
    Issuer: 'ISHARES IBONDS DEC 2028 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDU',
    Issuer: 'ISHARES IBONDS DEC 2029 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDV',
    Issuer: 'ISHARES IBONDS DEC 2030 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBDW',
    Issuer: 'ISHARES IBONDS DEC 2031 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBER',
    Issuer: 'IBERE PHARMACEUTICALS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBER+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBER=',
    Issuer: 'IBERE PHARMACEUTICALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBET',
    Issuer: 'IBET SPORTS BETTING & GAMING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBEX',
    Issuer: 'IBEX LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHB',
    Issuer: 'ISHARES IBONDS 2022 H/Y INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHC',
    Issuer: 'ISHARES IBONDS 2023 H/Y INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHD',
    Issuer: 'ISHARES IBONDS 2024 H/Y INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHE',
    Issuer: 'ISHARES IBONDS 2025 H/Y INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHF',
    Issuer: 'ISHARES IBOND 2026 HY & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHG',
    Issuer: 'ISHARES IBONDS 2027 HY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHH',
    Issuer: 'ISHARES IBONDS 2028 TM HY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBHI',
    Issuer: 'ISHARES IBONDS 2029 TM HY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBIO',
    Issuer: 'IBIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBKR',
    Issuer: 'INTERACTIVE BROKERS GRO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBLC',
    Issuer: 'ISHARES BLOCKCHAIN & TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBM',
    Issuer: 'INTL BUSINESS MACHINES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMK',
    Issuer: 'ISHARES IBONDS DEC 2022 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBML',
    Issuer: 'ISHARES DEC 2023 MUNI BD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMM',
    Issuer: 'ISHARES IBONDS DEC 2024 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMN',
    Issuer: 'ISHARES IBONDS DEC 2025 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMO',
    Issuer: 'ISHARES IBONDS DEC 2026 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMP',
    Issuer: 'ISHARES IBONDS DEC 2027 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBMQ',
    Issuer: 'ISHARES IBONDS DEC 2028 MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBN',
    Issuer: 'ICICI BANK LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBND',
    Issuer: 'SPDR BLOOMBERG INT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBOC',
    Issuer: 'INTERNATIONAL BANCSHARES CRP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBP',
    Issuer: 'INSTALLED BUILDING PRODUCTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBRX',
    Issuer: 'IMMUNITYBIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTB',
    Issuer: 'ISHARES IBONDS DEC 2022 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTD',
    Issuer: 'ISHARES IBONDS DEC 2023 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTE',
    Issuer: 'ISHARES IBONDS DEC 2024 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTF',
    Issuer: 'ISHARES IBONDS DEC 2025 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTG',
    Issuer: 'ISHARES IBONDS DEC 2026 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTH',
    Issuer: 'ISHARES IBONDS DEC 2027 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTI',
    Issuer: 'ISHARES IBONDS DEC 2028 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTJ',
    Issuer: 'ISHARES IBONDS DEC 2029 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTK',
    Issuer: 'ISHARES IBONDS DEC 2030 TREA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTL',
    Issuer: 'ISHARES IBONDS DEC 2031 TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBTX',
    Issuer: 'INDEPENDENT BANK GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IBUY',
    Issuer: 'AMPLIFY ONLINE RETAIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICAD',
    Issuer: 'ICAD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICAP',
    Issuer: 'INFRACAP EQTY INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICCC',
    Issuer: 'IMMUCELL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICCH',
    Issuer: 'ICC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICCM',
    Issuer: 'ICECURE MEDICAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICD',
    Issuer: 'INDEPENDENCE CONTRACT DRILLI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICE',
    Issuer: 'INTERCONTINENTAL EXCHANGE IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICF',
    Issuer: 'ISHARES COHEN & STEERS REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICFI',
    Issuer: 'ICF INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICHR',
    Issuer: 'ICHOR HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICL',
    Issuer: 'ICL GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICLK',
    Issuer: 'ICLICK INTERACTIVE ASIA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICLN',
    Issuer: 'ISHARES GLOBAL CLEAN ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICLR',
    Issuer: 'ICON PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICMB',
    Issuer: 'INVESTCORP CREDIT MANAGEMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICNC',
    Issuer: 'ICONIC SPORTS ACQ CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICNC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICNC=',
    Issuer: 'ICONIC SPORTS ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICOL',
    Issuer: 'ISHARES MSCI COLOMBIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICOW',
    Issuer: 'PACER DEVELOPED MARKETS INTE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICPT',
    Issuer: 'INTERCEPT PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICR-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICSH',
    Issuer: 'BLACKROCK ULTRA SHORT-TERM B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICUI',
    Issuer: 'ICU MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICVT',
    Issuer: 'ISHARES CONVERTIBLE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ICVX',
    Issuer: 'ICOSAVAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ID',
    Issuer: 'PARTS ID INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDA',
    Issuer: 'IDACORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDAI',
    Issuer: 'T STAMP INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDAT',
    Issuer: 'ISHARES CLOUD & 5G TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDBA',
    Issuer: 'IDEX BIOMETRICS ASA -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDCC',
    Issuer: 'INTERDIGITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDE',
    Issuer: 'VOYA INFRASTRUCTURE INDUSTRI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDEV',
    Issuer: 'ISHARES CORE MSCI DEV MKTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDEX',
    Issuer: 'IDEANOMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDHD',
    Issuer: 'INVESCO S&P INTERNATIONAL DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDHQ',
    Issuer: 'INVESCO S&P INTERNATIONAL DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDIV',
    Issuer: 'METAURUS US EQUITY CUMULATIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDLB',
    Issuer: 'INVESCO FTSE INTERNATIONAL L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDLV',
    Issuer: 'INVESCO S&P INTERNATIONAL DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDME',
    Issuer: 'INTERNATIONAL DRAWDOWN MANAG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDMO',
    Issuer: 'INVESCO S&P INTERNATIONAL DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDN',
    Issuer: 'INTELLICHECK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDNA',
    Issuer: 'ISHARES GEN-IMMUNOLOGY HLTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDOG',
    Issuer: 'ALPS INTERNATIONAL SECTOR DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDR',
    Issuer: 'IDAHO STRATEGIC RESOURCES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDRA',
    Issuer: 'IDERA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDRV',
    Issuer: 'ISHARES SELF-DRIVING EV&TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDT',
    Issuer: 'IDT CORP-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDU',
    Issuer: 'ISHARES US UTILITIES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDV',
    Issuer: 'ISHARES INTERNATIONAL SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDW',
    Issuer: 'IDW MEDIA HOLDINGS INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDX',
    Issuer: 'VANECK INDONESIA INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDXX',
    Issuer: 'IDEXX LABORATORIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IDYA',
    Issuer: 'IDEAYA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEA',
    Issuer: 'INFRASTRUCTURE AND ENERGY AL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEAWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IECS',
    Issuer: 'ISHARES EVOLVED US CONSUMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEDI',
    Issuer: 'ISHARES EVOLVED US DISCRETIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEF',
    Issuer: 'ISHARES 7-10 YEAR TREASURY B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEFA',
    Issuer: 'ISHARES CORE MSCI EAFE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEFN',
    Issuer: 'ISHARES EVOLVED US FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEHS',
    Issuer: 'ISHARES EVOLVED US HEALTHCAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEI',
    Issuer: 'ISHARES 3-7 YEAR TREASURY BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEIH',
    Issuer: 'ISHARES EVOLVED US INNOVATIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEME',
    Issuer: 'ISHARES EVOLVED US MEDIA AND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEMG',
    Issuer: 'ISHARES CORE MSCI EMERGING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEO',
    Issuer: 'ISHARES U.S. OIL & GAS EXPLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEP',
    Issuer: 'ICAHN ENTERPRISES LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IESC',
    Issuer: 'IES HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IETC',
    Issuer: 'ISHARES EVOLVED US TECHNOLOG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEUR',
    Issuer: 'ISHARES CORE MSCI EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEUS',
    Issuer: 'ISHARES MSCI EUROPE SMALL-CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEV',
    Issuer: 'ISHARES EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEX',
    Issuer: 'IDEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IEZ',
    Issuer: 'ISHARES U.S. OIL EQUIPMENT &',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFBD',
    Issuer: 'INFOBIRD CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFED',
    Issuer: 'ETRACS IFED INDEX ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFF',
    Issuer: 'INTL FLAVORS & FRAGRANCES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFGL',
    Issuer: 'ISHARES INTERNATIONAL DEVELO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFIN',
    Issuer: 'INFINT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFIN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFIN=',
    Issuer: 'INFINT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFN',
    Issuer: 'INDIA FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFRA',
    Issuer: 'ISHARES US INFRASTRUCTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFRX',
    Issuer: 'INFLARX NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFS',
    Issuer: 'INTERCORP FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IFV',
    Issuer: 'FIRST TRUST DW FOCUS 5 INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IG',
    Issuer: 'PRINCIPAL INVESTMENT GRADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGA',
    Issuer: 'VOYA GLOBAL ADVANTAGE AND PR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGAC',
    Issuer: 'IG ACQUISITION CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGACU',
    Issuer: 'IG ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGBH',
    Issuer: 'ISHARES INTEREST RATE HEDGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGC',
    Issuer: 'INDIA GLOBALIZATION CAPITAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGD',
    Issuer: 'VOYA GLBL EQTY DVD & PRM OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGE',
    Issuer: 'ISHARES NORTH AMERICAN NATUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGEB',
    Issuer: 'ISHARES INVESTMENT GRADE BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGF',
    Issuer: 'ISHARES GLOBAL INFRASTRUCTUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGHG',
    Issuer: 'PROSHARES IG HEDGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGI',
    Issuer: 'WESTERN ASSET INV GRA DEF OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGIB',
    Issuer: 'ISHARES 5-10Y INV GRADE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGIC',
    Issuer: 'INTERNATIONAL GENERAL INSURA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGLB',
    Issuer: 'ISHARES 10+ YEAR INV GR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGLD',
    Issuer: 'FT CBOE VEST GOLD STRATEGY T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGM',
    Issuer: 'ISHARES EXPANDED TECH SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGMS',
    Issuer: 'IGM BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGN',
    Issuer: 'ISHARES NORTH AMERICAN TECH-',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGNY',
    Issuer: 'IGNYTE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGNYU',
    Issuer: 'IGNYTE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGNYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGOV',
    Issuer: 'ISHARES INTERNATIONAL TREASU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGR',
    Issuer: 'CBRE GLOBAL REAL ESTATE INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGRO',
    Issuer: 'ISHARES INTL DIV GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGSB',
    Issuer: 'ISHARES 1-5Y INV GRADE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGT',
    Issuer: 'INTERNATIONAL GAME TECHNOLOG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGTA',
    Issuer: 'INCEPTION GROWTH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGTAR',
    Issuer: 'INCEPTION GROWTH ACQ LTD -RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGTAU',
    Issuer: 'INCEPTION GROWTH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGTAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IGV',
    Issuer: 'ISHARES EXPANDED TECH-SOFTWA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IH',
    Issuer: 'IHUMAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHAK',
    Issuer: 'ISHARES CYBERSECURITY & TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHD',
    Issuer: 'VOYA EMRG MRKTS HI INC DVD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHDG',
    Issuer: 'WISDOMTREE INTERNATIONAL HED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHE',
    Issuer: 'ISHARES US PHARMACEUTICALS E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHF',
    Issuer: 'ISHARES U.S. HEALTHCARE PROV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHG',
    Issuer: 'INTERCONTINENTAL HOTELS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHI',
    Issuer: 'ISHARES U.S. MEDICAL DEVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHIT',
    Issuer: 'INVESCO HI INC 2023 TRGT TRM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHRT',
    Issuer: 'IHEARTMEDIA INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHS',
    Issuer: 'IHS HOLDING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHT',
    Issuer: 'INNSUITES HOSPITALITY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHTA',
    Issuer: 'INVESCO HI INC 2024 TRGT TRM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHY',
    Issuer: 'VANECK INT HIGH YIELD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IHYF',
    Issuer: 'INVESCO HIGH YIELD BOND FACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIF',
    Issuer: 'MORGAN STANLEY INDIA INVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIGD',
    Issuer: 'INVESCO INV GRADE DEFENSIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIGV',
    Issuer: 'INVESCO INVEST GRADE VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'III',
    Issuer: 'INFORMATION SERVICES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIII',
    Issuer: 'INSU ACQUISITION CORP III-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIIIU',
    Issuer: 'INSU ACQUISITION CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIIN',
    Issuer: 'INSTEEL INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIIV',
    Issuer: 'I3 VERTICALS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIM',
    Issuer: 'INVESCO VALUE MUNICIPAL INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IINN',
    Issuer: 'INSPIRA TECHNOLOGIES OXY BHN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IINNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIPR',
    Issuer: 'INNOVATIVE INDUSTRIAL PROPER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIPR-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIVI',
    Issuer: 'II-VI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IIVIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJAN',
    Issuer: 'INNOVATOR INTERNATIONAL DEVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJH',
    Issuer: 'ISHARES CORE S&P MIDCAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJJ',
    Issuer: 'ISHARES S&P MID-CAP 400 VALU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJK',
    Issuer: 'ISHARES S&P MID-CAP 400 GROW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJR',
    Issuer: 'ISHARES CORE S&P SMALL-CAP E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJS',
    Issuer: 'ISHARES S&P SMALL-CAP 600 VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJT',
    Issuer: 'ISHARES S&P SMALL-CAP 600 GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IJUL',
    Issuer: 'INNOVATOR INTERNATIONAL DEVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IKNA',
    Issuer: 'IKENA ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IKT',
    Issuer: 'INHIBIKASE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILCB',
    Issuer: 'ISHARES MORNINGSTAR U.S. EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILCG',
    Issuer: 'ISHARES MORNINGSTAR GROWTH E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILCV',
    Issuer: 'ISHARES MORNINGSTAR VALUE ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILDR',
    Issuer: 'FIRST TRUST INNOVATION LEADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILF',
    Issuer: 'ISHARES LATIN AMERICA 40 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILMN',
    Issuer: 'ILLUMINA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILPT',
    Issuer: 'INDUSTRIAL LOGISTICS PROPERT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ILTB',
    Issuer: 'ISHARES CORE 10+ YEAR USD BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAB',
    Issuer: 'I-MAB-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAC',
    Issuer: 'IMAC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAQ',
    Issuer: 'INTERNATIONAL MEDIA ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAQR',
    Issuer: 'INTERNATIONAL MEDIA ACQ-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAQU',
    Issuer: 'INTERNATIONAL MEDIA ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMAX',
    Issuer: 'IMAX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMBI',
    Issuer: 'IMEDIA BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMBIL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMCB',
    Issuer: 'ISHARES MORNINGSTAR MID-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMCC',
    Issuer: 'IM CANNABIS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMCG',
    Issuer: 'ISHARES MORNINGSTAR MID-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMCR',
    Issuer: 'IMMUNOCORE HOLDINGS PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMCV',
    Issuer: 'ISHARES MORNINGSTAR MID-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMFL',
    Issuer: 'INVESCO INT DVLP DYN MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMGN',
    Issuer: 'IMMUNOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMGO',
    Issuer: 'IMAGO BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMH',
    Issuer: 'IMPAC MORTGAGE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMKTA',
    Issuer: 'INGLES MARKETS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMLP',
    Issuer: 'IPATH S&P MLP ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMMP',
    Issuer: 'IMMUTEP LTD-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMMR',
    Issuer: 'IMMERSION CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMMX',
    Issuer: 'IMMIX BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMNM',
    Issuer: 'IMMUNOME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMO',
    Issuer: 'IMPERIAL OIL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMOM',
    Issuer: 'ALPHA INTL QUANT MOM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMOS',
    Issuer: 'CHIPMOS TECHNOLOGIES INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPL',
    Issuer: 'IMPEL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPP',
    Issuer: 'IMPERIAL PETROLEUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPX',
    Issuer: 'AEA-BRIDGES IMPACT CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMPX=',
    Issuer: 'AEA-BRIDGES IMPACT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMRA',
    Issuer: 'IMARA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMRN',
    Issuer: 'IMMURON LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMRNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMRX',
    Issuer: 'IMMUNEERING CORP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMTB',
    Issuer: 'ISHARES CORE 5-10 YEAR USD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMTE',
    Issuer: 'INTEGRATED MEDIA TECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMTM',
    Issuer: 'ISHARES MSCI INTL MOMENTUM F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMTX',
    Issuer: 'IMMATICS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMTXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMUX',
    Issuer: 'IMMUNIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMV',
    Issuer: 'IMV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMVT',
    Issuer: 'IMMUNOVANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IMXI',
    Issuer: 'INTERNATIONAL MONEY EXPRESS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INAB',
    Issuer: 'IN8BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INAQ',
    Issuer: 'INSIGHT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INAQ=',
    Issuer: 'INSIGHT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INBK',
    Issuer: 'FIRST INTERNET BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INBKZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INBX',
    Issuer: 'INHIBRX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INCO',
    Issuer: 'COLUMBIA INDIA CONSUMER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INCR',
    Issuer: 'INTERCURE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INCY',
    Issuer: 'INCYTE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDA',
    Issuer: 'ISHARES MSCI INDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDB',
    Issuer: 'INDEPENDENT BANK CORP/MA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDF',
    Issuer: 'NIFTY INDIA FINANCIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDI',
    Issuer: 'INDIE SEMICONDUCTOR INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDL',
    Issuer: 'DIREXION DAILY MSCI INDIA BU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDO',
    Issuer: 'INDONESIA ENERGY CORP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDP',
    Issuer: 'INDAPTUS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDS',
    Issuer: 'PACER BENCHMARK INDUSTRIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDT',
    Issuer: 'INDUS REALTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INDY',
    Issuer: 'ISHARES INDIA 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFA',
    Issuer: 'INFORMATICA INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFI',
    Issuer: 'INFINITY PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFL',
    Issuer: 'HORIZON KINETICS INFL BENEF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFN',
    Issuer: 'INFINERA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFU',
    Issuer: 'INFUSYSTEM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INFY',
    Issuer: 'INFOSYS LTD-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ING',
    Issuer: 'ING GROEP N.V.-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INGN',
    Issuer: 'INOGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INGR',
    Issuer: 'INGREDION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INKA',
    Issuer: 'KLUDEIN I ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INKAU',
    Issuer: 'KLUDEIN I ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INKAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INKM',
    Issuer: 'SPDR SSGA INCOME ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INKT',
    Issuer: 'MINK THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INM',
    Issuer: 'INMED PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INMB',
    Issuer: 'INMUNE BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INMD',
    Issuer: 'INMODE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INMU',
    Issuer: 'BLACKROCK INTER MUNI INC BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INN',
    Issuer: 'SUMMIT HOTEL PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INN-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INN-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INNO',
    Issuer: 'HARBOR DISRUPTIVE INNOVATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INNV',
    Issuer: 'INNOVAGE HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INO',
    Issuer: 'INOVIO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INOD',
    Issuer: 'INNODATA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INPX',
    Issuer: 'INPIXON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INQQ',
    Issuer: 'INQQ INDIA INTERNET AND ECOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSE',
    Issuer: 'INSPIRED ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSG',
    Issuer: 'INSEEGO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSI',
    Issuer: 'INSIGHT SELECT INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSM',
    Issuer: 'INSMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSP',
    Issuer: 'INSPIRE MEDICAL SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INST',
    Issuer: 'INSTRUCTURE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSW',
    Issuer: 'INTERNATIONAL SEAWAYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INSW-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INT',
    Issuer: 'WORLD FUEL SERVICES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTA',
    Issuer: 'INTAPP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTC',
    Issuer: 'INTEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTE',
    Issuer: 'INTEGRAL ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTEU',
    Issuer: 'INTEGRAL ACQUISITION CORP 1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTF',
    Issuer: 'ISHARES MSCI INTERNATIONAL M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTG',
    Issuer: 'INTERGROUP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTS',
    Issuer: 'INTENSITY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTT',
    Issuer: 'INTEST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTU',
    Issuer: 'INTUIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INTZ',
    Issuer: 'INTRUSION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INUV',
    Issuer: 'INUVO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVA',
    Issuer: 'INNOVIVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVE',
    Issuer: 'IDENTIV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVH',
    Issuer: 'INVITATION HOMES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVO',
    Issuer: 'INVO BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVZ',
    Issuer: 'INNOVIZ TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INVZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'INZY',
    Issuer: 'INOZYME PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOAC',
    Issuer: 'INNOVATIVE INTERNATIONAL A-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOACU',
    Issuer: 'INNOVATIVE INTERNATIONAL ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOBT',
    Issuer: 'IO BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOCT',
    Issuer: 'INNOVATOR INT DEV POWER BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IONM',
    Issuer: 'ASSURE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IONQ',
    Issuer: 'IONQ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IONQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IONS',
    Issuer: 'IONIS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOO',
    Issuer: 'ISHARES GLOBAL 100 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOR',
    Issuer: 'INCOME OPP REALTY INVESTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOSP',
    Issuer: 'INNOSPEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOT',
    Issuer: 'SAMSARA INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IOVA',
    Issuer: 'IOVANCE BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IP',
    Issuer: 'INTERNATIONAL PAPER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPA',
    Issuer: 'IMMUNOPRECISE ANTIBODIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAC',
    Issuer: 'ISHARES CORE MSCI PACIFIC ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAR',
    Issuer: 'INTER PARFUMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAX',
    Issuer: 'INFLECTION POINT ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAXU',
    Issuer: 'INFLECTION POINT ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPAY',
    Issuer: 'ETFMG PRIME MOBILE PAYMENTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPDN',
    Issuer: 'PROFESSIONAL DIVERSITY NETWO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPDP',
    Issuer: 'DIVIDEND PERFORMERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPG',
    Issuer: 'INTERPUBLIC GROUP OF COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPGP',
    Issuer: 'IPG PHOTONICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPHA',
    Issuer: 'INNATE PHARMA SA-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPI',
    Issuer: 'INTREPID POTASH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPKW',
    Issuer: 'INVESCO INTERNATIONAL BUYBAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPO',
    Issuer: 'RENAISSANCE IPO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOD',
    Issuer: 'SOCIAL CAPITAL HEDOSOPH- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOD=',
    Issuer: 'SOCIAL CAPITAL HEDOSOPHIA HO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOF',
    Issuer: 'SOCIAL CAPITAL HEDOSOPH VI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOF+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOF=',
    Issuer: 'SOCIAL CAPITAL HEDOSOPHIA HO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPOS',
    Issuer: 'RENAISSANCE INTL IPO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPPP',
    Issuer: 'PREFERRED-PLUS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPSC',
    Issuer: 'CENTURY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVA',
    Issuer: 'INTERPRIVATE II ACQU-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVA=',
    Issuer: 'INTERPRIVATE II ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVF',
    Issuer: 'INTERPRIVATE III FINANCIAL-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVF+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVF=',
    Issuer: 'INTERPRIVATE III FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVI',
    Issuer: 'INTERPRIVATE IV INFRATECH-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVIU',
    Issuer: 'INTERPRIVATE IV INFRATECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPVIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPW',
    Issuer: 'IPOWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IPWR',
    Issuer: 'IDEAL POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQ',
    Issuer: 'IQIYI INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQDE',
    Issuer: 'FLEXSHARES-INT QUAL DVD DEFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQDF',
    Issuer: 'FLEXSHARES-INT QUAL DVD INDE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQDG',
    Issuer: 'WISDOMTREE INTL QLTY DVD GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQDY',
    Issuer: 'FLEXSHARES INT QUAL DVD DYN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQI',
    Issuer: 'INVESCO QUALITY MUNI INC TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQIN',
    Issuer: 'IQ 500 INTERNATIONAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQLT',
    Issuer: 'ISHARES MSCI INTERNATIONAL Q',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQM',
    Issuer: 'FRANKLIN INTELLIGENT MACHINE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQMD',
    Issuer: 'INTELLIGENT MEDICINE ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQMDU',
    Issuer: 'INTELLIGENT MEDICINE ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQMDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQSI',
    Issuer: 'IQ CANDRIAM ESG INTERNATIONA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQSU',
    Issuer: 'IQ CANDRIAM ESG US EQUITY ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IQV',
    Issuer: 'IQVIA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IR',
    Issuer: 'INGERSOLL-RAND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRBA',
    Issuer: 'RESPONSIBLE GLOBAL ALLOCATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRBO',
    Issuer: 'ISHARES ROBOTICS & ARTIFICIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRBT',
    Issuer: 'IROBOT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRCP',
    Issuer: 'IRSA PROPIEDADES COMERCI-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRDM',
    Issuer: 'IRIDIUM COMMUNICATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IREN',
    Issuer: 'IRIS ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRIX',
    Issuer: 'IRIDEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRL',
    Issuer: 'NEW IRELAND FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRM',
    Issuer: 'IRON MOUNTAIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRMD',
    Issuer: 'IRADIMED CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRNT',
    Issuer: 'IRONNET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRNT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IROQ',
    Issuer: 'IF BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRRX',
    Issuer: 'INTEGRATED RAIL AND -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRRX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRRX=',
    Issuer: 'INTEGRATED RAIL AND RESOURCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRS',
    Issuer: 'IRSA -SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRT',
    Issuer: 'INDEPENDENCE REALTY TRUST IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRTC',
    Issuer: 'IRHYTHM TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IRWD',
    Issuer: 'IRONWOOD PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IS',
    Issuer: 'IRONSOURCE LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISAA',
    Issuer: 'IRON SPARK I INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISCB',
    Issuer: 'ISHARES MORNINGSTAR SMALL-CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISCF',
    Issuer: 'ISHARES MSCI INTERNATIONAL S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISCG',
    Issuer: 'ISHARES MORNINGSTAR SMALL-CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISCV',
    Issuer: 'ISHARES MORNINGSTAR SMALL-CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISD',
    Issuer: 'PGIM HIGH YIELD BOND FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISDR',
    Issuer: 'ISSUER DIRECT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISDX',
    Issuer: 'INVESCO RAFI STRATEGIC DEVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISEE',
    Issuer: 'IVERIC BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISEM',
    Issuer: 'INVESCO RAFI STRATEGIC EMERG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISHG',
    Issuer: 'ISHARES -3 YEAR INTERNATIONA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISHP',
    Issuer: 'FIRST TRUST S-NETWORK E-COMM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISIG',
    Issuer: 'INSIGNIA SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISLE',
    Issuer: 'ISLEWORTH HEALTHCARE ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISLEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISMD',
    Issuer: 'INSPIRE SMALL/MID CAP ESG ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISO',
    Issuer: 'ISOPLEXIS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISPC',
    Issuer: 'ISPECIMEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISPO',
    Issuer: 'INSPIRATO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISPOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISR',
    Issuer: 'ISORAY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISRA',
    Issuer: 'VANECK ISRAEL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISRG',
    Issuer: 'INTUITIVE SURGICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISSC',
    Issuer: 'INNOVATIVE SOLUTIONS & SUPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISTB',
    Issuer: 'ISHARES CORE 1-5 YEAR USD BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISTR',
    Issuer: 'INVESTAR HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISUN',
    Issuer: 'ISUN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISVL',
    Issuer: 'ISHARES INTERNATIONAL DEVELO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISWN',
    Issuer: 'AMPLIFY INTERNATIONAL BLACKS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ISZE',
    Issuer: 'ISHARES MSCI INTERNATIONAL S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IT',
    Issuer: 'GARTNER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITA',
    Issuer: 'ISHARES U.S. AEROSPACE & DEF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITAN',
    Issuer: 'SPARKLINE INTANGIBLE VAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITAQ',
    Issuer: 'INDUSTRIAL TECH ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITAQU',
    Issuer: 'INDUSTRIAL TECH ACQUISITIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITB',
    Issuer: 'ISHARES U.S. HOME CONSTRUCTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITCB',
    Issuer: 'ITAU CORPBANCA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITCI',
    Issuer: 'INTRA-CELLULAR THERAPIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITEQ',
    Issuer: 'BLUESTAR ISRAEL TECHNOLOGY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITGR',
    Issuer: 'INTEGER HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITHX',
    Issuer: 'ITHAX ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITHXU',
    Issuer: 'ITHAX ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITHXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITI',
    Issuer: 'ITERIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITIC',
    Issuer: 'INVESTORS TITLE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITM',
    Issuer: 'VANECK INTERMEDIATE MUNI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITOS',
    Issuer: 'ITEOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITOT',
    Issuer: 'ISHARES CORE S&P TOTAL U.S.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITP',
    Issuer: 'IT TECH PACKAGING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITQ',
    Issuer: 'ITIQUIRA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITQRU',
    Issuer: 'ITIQUIRA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITQRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITRG',
    Issuer: 'INTEGRA RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITRI',
    Issuer: 'ITRON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITRM',
    Issuer: 'ITERUM THERAPEUTICS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITRN',
    Issuer: 'ITURAN LOCATION AND CONTROL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITT',
    Issuer: 'ITT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITUB',
    Issuer: 'ITAU UNIBANCO H-SPON PRF ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ITW',
    Issuer: 'ILLINOIS TOOL WORKS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUS',
    Issuer: 'INVESCO RAFI STRATEGIC US ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUSA',
    Issuer: 'AMBERWAVE INVEST USA JSG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUSB',
    Issuer: 'ISHARES CORE TOTAL BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUSG',
    Issuer: 'ISHARES CORE S&P U.S. GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUSS',
    Issuer: 'INVESCO RAFI STRATEGIC US SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IUSV',
    Issuer: 'ISHARES CORE S&P U.S. VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVA',
    Issuer: 'INVENTIVA SA - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVAC',
    Issuer: 'INTEVAC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVAL',
    Issuer: 'ALPHA ARCHI INTL QT VLU ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVC',
    Issuer: 'INVACARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCAU',
    Issuer: 'INVESTCORP INDIA ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCB',
    Issuer: 'INVESTCORP EUROPE ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCBU',
    Issuer: 'INVESTCORP EUROPE ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCP',
    Issuer: 'SWIFTMERGE ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCPU',
    Issuer: 'SWIFTMERGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVCPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVDA',
    Issuer: 'IVEDA SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVDAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVDG',
    Issuer: 'INVESCO FOCUSED DISCOVERY GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVE',
    Issuer: 'ISHARES S&P 500 VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVEG',
    Issuer: 'ISHARES EM FOOD & AGTECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVES',
    Issuer: 'WEDBUSH ETFMG GLOBAL CLOUD T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVH',
    Issuer: 'DELAWARE IVY HIGH INC OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVLC',
    Issuer: 'INVESCO US LARGE CAP CORE ES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVLU',
    Issuer: 'ISHARES MSCI INTERNATIONAL V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVOG',
    Issuer: 'VANGUARD S&P MID-CAP 400 GRO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVOL',
    Issuer: 'QUADRATIC INT RTE VOL INFL H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVOO',
    Issuer: 'VANGUARD S&P MID-CAP 400 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVOV',
    Issuer: 'VANGUARD S&P MID-CAP 400 VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVR',
    Issuer: 'INVESCO MORTGAGE CAPITAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVRA',
    Issuer: 'INVESCO REAL ASSETS ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVSG',
    Issuer: 'INVESCO SELECT GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVT',
    Issuer: 'INVENTRUST PROPERTIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVV',
    Issuer: 'ISHARES CORE S&P 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVW',
    Issuer: 'ISHARES S&P 500 GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IVZ',
    Issuer: 'INVESCO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWB',
    Issuer: 'ISHARES RUSSELL 1000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWC',
    Issuer: 'ISHARES MICRO-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWD',
    Issuer: 'ISHARES RUSSELL 1000 VALUE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWDL',
    Issuer: 'ETRACS 2X VALUE FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWF',
    Issuer: 'ISHARES RUSSELL 1000 GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWFH',
    Issuer: 'ISHARES VIRTUAL WORK & LIFE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWFL',
    Issuer: 'ETRACS 2X GROWTH FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWIN',
    Issuer: 'AMPLIFY INFLATION FIGHTER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWL',
    Issuer: 'ISHARES RUSSELL TOP 200 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWM',
    Issuer: 'ISHARES RUSSELL 2000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWML',
    Issuer: 'ETRACS 2X SIZE FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWN',
    Issuer: 'ISHARES RUSSELL 2000 VALUE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWO',
    Issuer: 'ISHARES RUSSELL 2000 GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWP',
    Issuer: 'ISHARES RUSSELL MID-CAP GROW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWR',
    Issuer: 'ISHARES RUSSELL MID-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWS',
    Issuer: 'ISHARES RUSSELL MID-CAP VALU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWV',
    Issuer: 'ISHARES RUSSELL 3000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWX',
    Issuer: 'ISHARES RUSSELL TOP 200 VALU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IWY',
    Issuer: 'ISHARES RUSSELL TOP 200 GROW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IX',
    Issuer: 'ORIX  - SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXAQ',
    Issuer: 'IX ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXAQU',
    Issuer: 'IX ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXC',
    Issuer: 'ISHARES GLOBAL ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXG',
    Issuer: 'ISHARES GLOBAL FINANCIALS ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXHL',
    Issuer: 'INCANNEX HEALTHCARE LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXJ',
    Issuer: 'ISHARES GLOBAL HEALTHCARE ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXN',
    Issuer: 'ISHARES GLOBAL TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXP',
    Issuer: 'ISHARES GLOBAL COMM SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXSE',
    Issuer: 'WISDOMTREE INDIA EX-STATE FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IXUS',
    Issuer: 'ISHARES CORE INTL STOCK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYC',
    Issuer: 'ISHARES US CONSUMER DISCRETI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYE',
    Issuer: 'ISHARES U.S. ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYF',
    Issuer: 'ISHARES US FINANCIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYG',
    Issuer: 'ISHARES U.S. FINANCIAL SERVI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYH',
    Issuer: 'ISHARES U.S. HEALTHCARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYJ',
    Issuer: 'ISHARES U.S. INDUSTRIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYK',
    Issuer: 'ISHARES US CONSUMER STAPLES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYLD',
    Issuer: 'ISHARES MORNINGSTAR MULTI-AS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYM',
    Issuer: 'ISHARES U.S. BASIC MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYR',
    Issuer: 'ISHARES US REAL ESTATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYT',
    Issuer: 'ISHARES US TRANSPORTATION ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYW',
    Issuer: 'ISHARES USTECHNOLOGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYY',
    Issuer: 'ISHARES DOW JONES U.S. ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IYZ',
    Issuer: 'ISHARES US TELECOMMUNICATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IZEA',
    Issuer: 'IZEA WORLDWIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'IZRL',
    Issuer: 'ARK ISRAEL INNOVATIVE TECHNO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'J',
    Issuer: 'JACOBS ENGINEERING GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAAA',
    Issuer: 'JANUS HENDERSON AAA CLO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JACK',
    Issuer: 'JACK IN THE BOX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAGG',
    Issuer: 'JPM US AGG BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAGX',
    Issuer: 'JAGUAR HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAKK',
    Issuer: 'JAKKS PACIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAMF',
    Issuer: 'JAMF HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAN',
    Issuer: 'JANONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JANX',
    Issuer: 'JANUX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JANZ',
    Issuer: 'TRUESHARES STRUCT OUTC JAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAQC',
    Issuer: 'JUPITER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAQCU',
    Issuer: 'JUPITER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAQCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JATT',
    Issuer: 'JATT ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JATT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JATT=',
    Issuer: 'JATT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAVA',
    Issuer: 'JPMORGAN ACTIVE VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JAZZ',
    Issuer: 'JAZZ PHARMACEUTICALS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBBB',
    Issuer: 'JANUS HENDERSON B-BBB CLO ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBGS',
    Issuer: 'JBG SMITH PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBHT',
    Issuer: 'HUNT (JB) TRANSPRT SVCS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBI',
    Issuer: 'JANUS INTERNATIONAL GROUP IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBK',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBL',
    Issuer: 'JABIL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBLU',
    Issuer: 'JETBLUE AIRWAYS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBSS',
    Issuer: 'JOHN B. SANFILIPPO & SON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JBT',
    Issuer: 'JOHN BEAN TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCE',
    Issuer: 'NUVEEN CORE EQU ALPHA FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCI',
    Issuer: 'JOHNSON CONTROLS INTERNATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCIC',
    Issuer: 'JACK CREEK INVESTMENT C-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCICU',
    Issuer: 'JACK CREEK INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCPB',
    Issuer: 'JPMORGAN CORE PLUS BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCPI',
    Issuer: 'JP MORGAN INFLATION MGD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCSE',
    Issuer: 'JE CLEANTECH HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCTCF',
    Issuer: 'JEWETT-CAMERON TRADING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JCTR',
    Issuer: 'JPMORGAN CARBON TRANSITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JD',
    Issuer: 'JD.COM INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JDIV',
    Issuer: 'JPMORGAN US DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JDST',
    Issuer: 'DIREXION DAILY JUNIOR GOLD M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEF',
    Issuer: 'JEFFERIES FINANCIAL GROUP IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JELD',
    Issuer: 'JELD-WEN HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEMA',
    Issuer: 'JPMORGAN ACTIVEBUILDERS EMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEMD',
    Issuer: 'NUVEEN EMERGING MARKETS DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEPI',
    Issuer: 'JPMORGAN EQUITY PREMIUM INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEPQ',
    Issuer: 'JPM NASDAQ EQUITY PREMIUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JEQ',
    Issuer: 'ABERDEEN JAPAN EQUITY FUND I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JETS',
    Issuer: 'US GLOBAL JETS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JFIN',
    Issuer: 'JIAYIN GROUP INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JFR',
    Issuer: 'NUVEEN FLOAT RATE INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JFU',
    Issuer: '9F INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JFWD',
    Issuer: 'JACOB FORWARD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JG',
    Issuer: 'AURORA MOBILE LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGGC',
    Issuer: 'JAGUAR GLOBAL GROWTH CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGGCR',
    Issuer: 'JAGUAR GLOBAL GROWTH CO-RGTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGGCU',
    Issuer: 'JAGUAR GLOBAL GROWTH CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGGCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGH',
    Issuer: 'NUVEEN GLOBAL H-I FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JGLD',
    Issuer: 'AMPLIFY PURE JR GOLD MINERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHAA',
    Issuer: 'NUVEEN CORPORATE INCOME 2023',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHCB',
    Issuer: 'JOHN HANCOCK CORPORATE BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHCS',
    Issuer: 'JOHN HANCOCK MULTI MEDIA COM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHEM',
    Issuer: 'JOHN HANCOCK MULTI EM MRK ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHG',
    Issuer: 'JANUS HENDERSON GROUP PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHI',
    Issuer: 'JOHN HANCOCK INVEST TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMA',
    Issuer: 'JOHN HANCOCK MULT FACT MATER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMB',
    Issuer: 'JOHN HANCOCK MORTGAGE-BACKED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMC',
    Issuer: 'JOHN HANCOCK MULT FACT CONSU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMD',
    Issuer: 'JOHN HANCOCK MF DEV INTL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHME',
    Issuer: 'JOHN HANCOCK MULT FACT ENRGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMF',
    Issuer: 'JOHN HANCOCK MULTI FACT FIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMH',
    Issuer: 'JOHN HANCOCK MULT FACT HEALT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMI',
    Issuer: 'JOHN HANCOCK MULT FACT INDUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHML',
    Issuer: 'JOHN HANCOCK MULTI FACT LRG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMM',
    Issuer: 'JOHN HANCOCK MULTI FACT MID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMS',
    Issuer: 'JOHN HANCOCK MULT FACT CONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMT',
    Issuer: 'JOHN HANCOCK MULTI FACT TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHMU',
    Issuer: 'JOHN HANCOCK MULT FACT UTIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHPI',
    Issuer: 'JOHN HANCOCK PREFERRED INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHS',
    Issuer: 'JOHN HANCOCK INCOME SECS TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHSC',
    Issuer: 'JOHN HANCOCK MULTI SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JHX',
    Issuer: 'JAMES HARDIE IND PLC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JIB',
    Issuer: 'JANUS HENDERSON SUST IMP C/B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JIDA',
    Issuer: 'JPMORGAN ACTBUILD INT EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JIG',
    Issuer: 'JPMORGAN INTERNATIONAL GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JIGB',
    Issuer: 'JPM CORP BOND RES EHD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JILL',
    Issuer: 'J. JILL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJA',
    Issuer: 'IPATH SERIES B BLOOMBERG AGR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJC',
    Issuer: 'IPATH SERIES B BLOOMBERG COP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJE',
    Issuer: 'IPATH SERIES B BLOOMBERG ENE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJG',
    Issuer: 'IPATH SERIES B BLOOMBERG GRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJM',
    Issuer: 'IPATH SER B BLOOMBERG INDUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJN',
    Issuer: 'IPATH SERIES B BLOOMBERG NIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJP',
    Issuer: 'IPATH SERIES B BBG PRECIOUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJS',
    Issuer: 'IPATH SERIES B BBG SOFTS SUB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJSF',
    Issuer: 'J & J SNACK FOODS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJT',
    Issuer: 'IPATH SERIES B BBG TIN SUBIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JJU',
    Issuer: 'IPATH SERIES B BLOOMBERG ALU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JKHY',
    Issuer: 'JACK HENRY & ASSOCIATES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JKS',
    Issuer: 'JINKOSOLAR HOLDING CO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JLL',
    Issuer: 'JONES LANG LASALLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JLS',
    Issuer: 'NUVEEN MORTGAGE & INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMAC',
    Issuer: 'MAXPRO CAPITAL ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMACU',
    Issuer: 'MAXPRO CAPITAL ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMBS',
    Issuer: 'JANUS HENDERSON MORTG BACKED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMEE',
    Issuer: 'JPMORGAN MKT EXP ENH EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMIA',
    Issuer: 'JUMIA TECHNOLOGIES AG-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMIN',
    Issuer: 'JPMORGAN US MIN VOLATILITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMM',
    Issuer: 'NUVEEN MULTI-MKT INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMOM',
    Issuer: 'JPMORGAN US MOMENTUM FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMSB',
    Issuer: 'JOHN MARSHALL BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMST',
    Issuer: 'JPM ULTRA-SHORT MUNI INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JMUB',
    Issuer: 'JPMORGAN MUNICIPAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JNCE',
    Issuer: 'JOUNCE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JNJ',
    Issuer: 'JOHNSON & JOHNSON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JNK',
    Issuer: 'SPDR BLOOMBERG HIGH YIELD BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JNPR',
    Issuer: 'JUNIPER NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JNUG',
    Issuer: 'DIREXION DAILY JUNIOR GOLD M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JO',
    Issuer: 'IPATH SERIES B BLOOMBERG COF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOAN',
    Issuer: 'JOANN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOB',
    Issuer: 'GEE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOBY',
    Issuer: 'JOBY AVIATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOBY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOE',
    Issuer: 'ST JOE CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOET',
    Issuer: 'VIRTUS TERRANOVA US QUAL MOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOF',
    Issuer: 'JAPAN SMALLER CAPITALIZATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOFF',
    Issuer: 'JOFF FINTECH ACQ CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOFFU',
    Issuer: 'JOFF FINTECH ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOFFW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOJO',
    Issuer: 'ATAC CREDIT ROTATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOUT',
    Issuer: 'JOHNSON OUTDOORS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JOYY',
    Issuer: 'INFUSIVE COMPOUNDING GLB EQY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JP',
    Issuer: 'JUPAI HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPC',
    Issuer: 'NUVEEN PREFERRED & INCOME OP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPEM',
    Issuer: 'JPM DIVERSIFIED RET EM EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPHY',
    Issuer: 'JPM HY RESEARCH ENHANCED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPI',
    Issuer: 'NUVEEN PFD AND INC TERM FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPIB',
    Issuer: 'JPMORGAN INTL BND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPIE',
    Issuer: 'JPMORGAN INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPIN',
    Issuer: 'JPM DIVERSIFIED RET INTL EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM',
    Issuer: 'JPMORGAN CHASE & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPM-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPMB',
    Issuer: 'JPMORGAN USD EMERGING MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPME',
    Issuer: 'JPM DIVER RET US MC EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPRE',
    Issuer: 'JPMORGAN REALTY INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPS',
    Issuer: 'NUVEEN PREFERRED & INCOME SE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPSE',
    Issuer: 'JPM DIVERSIFIED RT SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPST',
    Issuer: 'JPMORGAN ULTRA-SHORT INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPT',
    Issuer: 'NUVEEN PREFERRED AND INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPUS',
    Issuer: 'JPMORGAN DIV RET US EQ ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JPXN',
    Issuer: 'ISHARES JPX-NIKKEI 400 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JQC',
    Issuer: 'NUVEEN CREDIT STRAT INCM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JQUA',
    Issuer: 'JPMORGAN US QUALITY FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRE',
    Issuer: 'JANUS HENDERSON US REAL EST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRI',
    Issuer: 'NUVEEN RL ASST INC & GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRNY',
    Issuer: 'ALPS GLOBAL TRAVEL BENEF ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRO',
    Issuer: 'NUVEEN FLT RATE INC OPP FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRS',
    Issuer: 'NUVEEN REAL EST INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRSH',
    Issuer: 'JERASH HOLDINGS US INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JRVR',
    Issuer: 'JAMES RIVER GROUP HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSCP',
    Issuer: 'JPMORGAN SHORT DURATION CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSD',
    Issuer: 'NUVEEN SHT DUR CRED OPP FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSMD',
    Issuer: 'JANUS SMALL MID CAP GR ALP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSML',
    Issuer: 'JANUS DETROIT STREET TRUST J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSPR',
    Issuer: 'JASPER THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSPRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JSTC',
    Issuer: 'ADASINA SOCIAL JUSTICE GLB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JT',
    Issuer: 'JIANPU TECHNOLOGY INC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUGG',
    Issuer: 'JAWS JUGGERNAUT ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUGGU',
    Issuer: 'JAWS JUGGERNAUT ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUGGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JULZ',
    Issuer: 'TRUESHARES STRUCT OUTCOME JU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUN',
    Issuer: 'JUNIPER II CORP -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUN=',
    Issuer: 'JUNIPER II CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUNZ',
    Issuer: 'TRUESHARES STRUCTURED OUTCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUPW',
    Issuer: 'JUPITER WELLNESS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUPWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUSA',
    Issuer: 'JPM ACTBUILD US LRG CAP EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JUST',
    Issuer: 'GOLDMAN SACHS JUST US LRG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JVA',
    Issuer: 'COFFEE HOLDING CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JVAL',
    Issuer: 'JPMORGAN US VALUE FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWAC',
    Issuer: 'JUPITER WELLNESS ACQUIS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWACR',
    Issuer: 'JUPITER WELLNESS ACQUIS-RGTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWEL',
    Issuer: 'JOWELL GLOBAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWN',
    Issuer: 'NORDSTROM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWSM',
    Issuer: 'JAWS MUSTANG ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWSM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JWSM=',
    Issuer: 'JAWS MUSTANG ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JXI',
    Issuer: 'ISHARES GLOBAL UTILITIES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JXN',
    Issuer: 'JACKSON FINANCIAL INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JYAC',
    Issuer: 'JIYA ACQUISITION CORP -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JYNT',
    Issuer: 'JOINT CORP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JZRO',
    Issuer: 'JANUS HENDERSON NET ZERO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'JZXN',
    Issuer: 'JIUZI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'K',
    Issuer: 'KELLOGG CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KACL',
    Issuer: 'KAIROUS ACQUISITION CORP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KACLR',
    Issuer: 'KAIROUS ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KACLU',
    Issuer: 'KAIROUS ACQUISITION CORP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KACLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAHC',
    Issuer: 'KKR ACQUISITION HOLDINGS I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAHC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAHC=',
    Issuer: 'KKR ACQUISITION HOLDINGS I C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAI',
    Issuer: 'KADANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAII',
    Issuer: 'KISMET ACQUISITION TWO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAIIU',
    Issuer: 'KISMET ACQUISITION TWO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAIR',
    Issuer: 'KAIROS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAIRU',
    Issuer: 'KAIROS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAIRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KALA',
    Issuer: 'KALA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KALL',
    Issuer: 'KRANESHARES MSCI ALL CHINA I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KALU',
    Issuer: 'KAISER ALUMINUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KALV',
    Issuer: 'KALVISTA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAMN',
    Issuer: 'KAMAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAPR',
    Issuer: 'INNOVATOR U.S. SMALL CAP POW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAR',
    Issuer: 'KAR AUCTION SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KARO',
    Issuer: 'KAROOOOO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KARS',
    Issuer: 'KRANESHARES ELECTRIC VEHICLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KAVL',
    Issuer: 'KAIVAL BRANDS INNOVATIONS GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KB',
    Issuer: 'KB FINANCIAL GROUP INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBA',
    Issuer: 'KRANESHARES BOSERA MSCI CHIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBAL',
    Issuer: 'KIMBALL INTERNATIONAL-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBE',
    Issuer: 'SPDR S&P BANK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBH',
    Issuer: 'KB HOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBND',
    Issuer: 'KRANESHARES BLOOMBERG CHINA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBNT',
    Issuer: 'KUBIENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBNTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBR',
    Issuer: 'KBR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBUY',
    Issuer: 'KRANESHARES CICC CHINA CONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBWB',
    Issuer: 'INVESCO KBW BANK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBWD',
    Issuer: 'INVESCO KBW HIGH DIVIDEND YI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBWP',
    Issuer: 'INVESCO KBW PROPERTY & CASUA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBWR',
    Issuer: 'INVESCO KBW REGIONAL BANKING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KBWY',
    Issuer: 'INVESCO KBW PREMIUM YIELD EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KC',
    Issuer: 'KINGSOFT CLOUD HOLDINGS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCA=',
    Issuer: 'KENSINGTON CAPITAL ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCAC=',
    Issuer: 'KENSINGTON CAPITAL ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCCA',
    Issuer: 'KRANESHARES CALIFORNIA CARBO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCE',
    Issuer: 'SPDR S&P CAPITAL MARKETS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCGI',
    Issuer: 'KENSINGTON CAPITAL ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCGI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KCGI=',
    Issuer: 'KENSINGTON CAPITAL ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KD',
    Issuer: 'KYNDRYL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KDNY',
    Issuer: 'CHINOOK THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KDP',
    Issuer: 'KEURIG DR PEPPER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KDRN',
    Issuer: 'KINGSBARN TACTICAL BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KE',
    Issuer: 'KIMBALL ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEJI',
    Issuer: 'GLB X CHINA INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KELYA',
    Issuer: 'KELLY SERVICES INC -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KELYB',
    Issuer: 'KELLY SERVICES INC -CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEMQ',
    Issuer: 'KRANESHARES EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEMX',
    Issuer: 'KRANESHARES MSCI E-MKT EX-CH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEN',
    Issuer: 'KENON HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEP',
    Issuer: 'KOREA ELEC POWER CORP-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEQU',
    Issuer: 'KEWAUNEE SCIENTIFIC CP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KERN',
    Issuer: 'AKERNA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KERNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KESG',
    Issuer: 'KRANESHARES MSCI CHINA ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEUA',
    Issuer: 'KRANESHARES EUROPEAN CARBON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEX',
    Issuer: 'KIRBY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEY',
    Issuer: 'KEYCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEY-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEY-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEY-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KEYS',
    Issuer: 'KEYSIGHT TECHNOLOGIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KF',
    Issuer: 'KOREA FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFFB',
    Issuer: 'KENTUCKY FIRST FEDERAL BANCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFRC',
    Issuer: 'KFORCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFS',
    Issuer: 'KINGSWAY FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFVG',
    Issuer: 'KRANESHARES CICC CHINA 5G',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFY',
    Issuer: 'KORN FERRY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KFYP',
    Issuer: 'KRANESHARES CICC CHINA LEADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KGC',
    Issuer: 'KINROSS GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KGHG',
    Issuer: 'KRANESHARES GLOBAL CARBON TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KGRN',
    Issuer: 'KRANESHARES MSCI CHINA CLEAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KGRO',
    Issuer: 'KRANESHARES CHINA INNOVATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KHC',
    Issuer: 'KRAFT HEINZ CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KHYB',
    Issuer: 'KRANESHARES ASIA PACIFIC HIG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIDS',
    Issuer: 'ORTHOPEDIATRICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIE',
    Issuer: 'SPDR S&P INSURANCE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIII',
    Issuer: 'KISMET ACQUISITION THREE - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIIIU',
    Issuer: 'KISMET ACQUISITION THREE COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIM',
    Issuer: 'KIMCO REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIM-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIM-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIND',
    Issuer: 'NEXTDOOR HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KINS',
    Issuer: 'KINGSTONE COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KINZ',
    Issuer: 'KINS TECHNOLOGY GROUP INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KINZU',
    Issuer: 'KINS TECHNOLOGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KINZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIO',
    Issuer: 'KKR INCOME OPPORTUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIQ',
    Issuer: 'KELSO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KIRK',
    Issuer: "KIRKLAND'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KJAN',
    Issuer: 'INNOVATOR U.S. SMALL CAP POW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KJUL',
    Issuer: 'INNOVATOR U.S. SMALL CAP POW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KKR',
    Issuer: 'KKR & CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KKR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KKRS',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLAC',
    Issuer: 'KLA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLAQ',
    Issuer: 'KL ACQUISITION CORP/MO-CLS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLAQU',
    Issuer: 'KL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLCD',
    Issuer: 'KFA LRG CAP QUAL DIV NDX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLDW',
    Issuer: 'KNOWLEDGE LEADERS DEVELOPED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLIC',
    Issuer: 'KULICKE & SOFFA INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLNE',
    Issuer: 'DIREXION DAILY GLOBAL CLEAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLR',
    Issuer: 'KALEYRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLTR',
    Issuer: 'KALTURA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KLXE',
    Issuer: 'KLX ENERGY SERVICES HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMB',
    Issuer: 'KIMBERLY-CLARK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMDA',
    Issuer: 'KAMADA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMED',
    Issuer: 'KRANESHARES EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMF',
    Issuer: 'KAYNE ANDERSON NEXTGEN ENERG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMI',
    Issuer: 'KINDER MORGAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMLM',
    Issuer: 'KFA MOUNT LUCAS INDEX ST ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMPB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMPH',
    Issuer: 'KEMPHARM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMPR',
    Issuer: 'KEMPER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMT',
    Issuer: 'KENNAMETAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KMX',
    Issuer: 'CARMAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KN',
    Issuer: 'KNOWLES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNBE',
    Issuer: 'KNOWBE4 INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNDI',
    Issuer: 'KANDI TECHNOLOGIES GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNG',
    Issuer: 'FT CBOE VEST S&P 500 DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNGS',
    Issuer: 'UPHOLDINGS COMPOUND KINGS ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNOP',
    Issuer: 'KNOT OFFSHORE PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNSA',
    Issuer: 'KINIKSA PHARMACEUTICALS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNSL',
    Issuer: 'KINSALE CAPITAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNSW',
    Issuer: 'KNIGHTSWAN ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNSW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNSW=',
    Issuer: 'KNIGHTSWAN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNTE',
    Issuer: 'KINNATE BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNTK',
    Issuer: 'KINETIK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KNX',
    Issuer: 'KNIGHT-SWIFT TRANSPORTATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KO',
    Issuer: 'COCA-COLA CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOCG',
    Issuer: 'FIS KNIGHTS OF COL GLO BELIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOCT',
    Issuer: 'INNOVATOR U.S. SMALL CAP POW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOD',
    Issuer: 'KODIAK SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KODK',
    Issuer: 'EASTMAN KODAK CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOF',
    Issuer: 'COCA-COLA FEMSA SAB-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOIN',
    Issuer: 'CAPITAL LINK GLOBAL FINTECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOKU',
    Issuer: 'XTRACKERS MSCI KOKUSAI EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOLD',
    Issuer: 'PROSHARES ULTRASHORT BLOOMBE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOMP',
    Issuer: 'SPDR S&P KENSHO NEW ECONOMIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KONG',
    Issuer: 'FORMIDABLE FORTRESS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOP',
    Issuer: 'KOPPERS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOPN',
    Issuer: 'KOPIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KORE',
    Issuer: 'KORE GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KORE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KORP',
    Issuer: 'AMERICAN CENTURY DIVERSIFIED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KORU',
    Issuer: 'DIREXION DLY S KOREA BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOS',
    Issuer: 'KOSMOS ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KOSS',
    Issuer: 'KOSS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KPLT',
    Issuer: 'KATAPULT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KPLTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KPRX',
    Issuer: 'KIORA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KPTI',
    Issuer: 'KARYOPHARM THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KR',
    Issuer: 'KROGER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRBN',
    Issuer: 'KS GLOBAL CARBON STRATGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRBP',
    Issuer: 'KIROMIC BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRC',
    Issuer: 'KILROY REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRE',
    Issuer: 'SPDR S&P REGIONAL BANKING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KREF',
    Issuer: 'KKR REAL ESTATE FINANCE TRUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KREF-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRG',
    Issuer: 'KITE REALTY GROUP TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRKR',
    Issuer: '36KR HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRMA',
    Issuer: 'GLOBAL X CONSCIOUS COMPANIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRMD',
    Issuer: 'REPRO MEDSYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRNL',
    Issuer: 'KERNEL GROUP HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRNLU',
    Issuer: 'KERNEL GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRNLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRNT',
    Issuer: 'KORNIT DIGITAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRNY',
    Issuer: 'KEARNY FINANCIAL CORP/MD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRO',
    Issuer: 'KRONOS WORLDWIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRON',
    Issuer: 'KRONOS BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KROP',
    Issuer: 'GLOBAL X AGTECH & FOOD INNOV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KROS',
    Issuer: 'KEROS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRP',
    Issuer: 'KIMBELL ROYALTY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRT',
    Issuer: 'KARAT PACKAGING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRTX',
    Issuer: 'KARUNA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRUS',
    Issuer: 'KURA SUSHI USA INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KRYS',
    Issuer: 'KRYSTAL BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSA',
    Issuer: 'ISHARES MSCI SAUDI ARABIA ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSCD',
    Issuer: 'KFA SML CAP QUAL DIV NDX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSCP',
    Issuer: 'KNIGHTSCOPE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSET',
    Issuer: 'KRANESHARES GL CARBON OFF ST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSI',
    Issuer: 'KADEM SUSTAINABLE IMPAC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSICU',
    Issuer: 'KADEM SUSTAINABLE IMPACT COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSM',
    Issuer: 'DWS STRATEGIC MUNICIPAL INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSPN',
    Issuer: 'KASPIEN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSS',
    Issuer: 'KOHLS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KSTR',
    Issuer: 'KRANESHARES SSE STAR MKT 50',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KT',
    Issuer: 'KT CORP-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTB',
    Issuer: 'KONTOOR BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTCC',
    Issuer: 'KEY TRONIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTEC',
    Issuer: 'KRANESHARES HANG SENG TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTF',
    Issuer: 'DWS MUNICIPAL INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTOS',
    Issuer: 'KRATOS DEFENSE & SECURITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTRA',
    Issuer: 'KINTARA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTTA',
    Issuer: 'PASITHEA THERAPEUTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KTTAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KUKE',
    Issuer: 'KUKE MUSIC HOLDING LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KULR',
    Issuer: 'KULR TECHNOLOGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KURA',
    Issuer: 'KURA ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KURE',
    Issuer: 'KRANESHARES MSCI ALL CHINA H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KVHI',
    Issuer: 'KVH INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KVLE',
    Issuer: 'KFA VALUE LINE DYNAMIC CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KVSA',
    Issuer: 'KHOSLA VENTURES ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KVSC',
    Issuer: 'KHOSLA VENTURES ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KW',
    Issuer: 'KENNEDY-WILSON HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWAC',
    Issuer: 'KINGSWOOD ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWAC=',
    Issuer: 'KINGSWOOD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWEB',
    Issuer: 'KRANESHARES CSI CHINA INTERN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWR',
    Issuer: 'QUAKER CHEMICAL CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KWT',
    Issuer: 'ISHARES MSCI KUWAIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KXI',
    Issuer: 'ISHARES GLOBAL CONSUMER STAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KXIN',
    Issuer: 'KAIXIN AUTO HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYCH',
    Issuer: 'KEYARCH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYCHR',
    Issuer: 'KEYARCH ACQUISITION CORP-RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYCHU',
    Issuer: 'KEYARCH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYCHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYMR',
    Issuer: 'KYMERA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KYN',
    Issuer: 'KAYNE ANDERSON ENERGY INFRAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KZIA',
    Issuer: 'KAZIA THERAPEUTICS-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'KZR',
    Issuer: 'KEZAR LIFE SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'L',
    Issuer: 'LOEWS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAAA',
    Issuer: 'LAKESHORE ACQUISITION I CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAAAU',
    Issuer: 'LAKESHORE ACQUISITION I CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAB',
    Issuer: 'STANDARD BIOTOOLS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LABD',
    Issuer: 'DRX DLY S&P BIOTECH BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LABP',
    Issuer: 'LANDOS BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LABU',
    Issuer: 'DRX DLY S&P BIOTECH BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAC',
    Issuer: 'LITHIUM AMERICAS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAD',
    Issuer: 'LITHIA MOTORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LADR',
    Issuer: 'LADDER CAPITAL CORP-REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAKE',
    Issuer: 'LAKELAND INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAMR',
    Issuer: 'LAMAR ADVERTISING CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LANC',
    Issuer: 'LANCASTER COLONY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAND',
    Issuer: 'GLADSTONE LAND CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LANDM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LANDO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LARK',
    Issuer: 'LANDMARK BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LASR',
    Issuer: 'NLIGHT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LATG',
    Issuer: 'LATAMGROWTH SPAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LATGU',
    Issuer: 'LATAMGROWTH SPAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LATGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAUR',
    Issuer: 'LAUREATE EDUCATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAW',
    Issuer: 'CS DISCO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAX',
    Issuer: '8I ACQUISITION 2 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAXXR',
    Issuer: '8I ACQUISITION 2 CORP-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAXXU',
    Issuer: '8I ACQUISITION 2 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAXXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAZ',
    Issuer: 'LAZARD LTD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAZR',
    Issuer: 'LUMINAR TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LAZY',
    Issuer: 'LAZYDAYS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBAI',
    Issuer: 'LAKELAND BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBAY',
    Issuer: 'LEATHERBACK LONG/SHORT ALT Y',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBBB',
    Issuer: 'LAKESHORE ACQUISITION II COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBBBR',
    Issuer: 'LAKESHORE ACQUISITION -RIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBBBU',
    Issuer: 'LAKESHORE ACQUISITION II COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBBBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBC',
    Issuer: 'LUTHER BURBANK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBPH',
    Issuer: 'LONGBOARD PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBPS',
    Issuer: '4D PHARMA PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBPSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBRDA',
    Issuer: 'LIBERTY BROADBAND-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBRDK',
    Issuer: 'LIBERTY BROADBAND-C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBRDP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBRT',
    Issuer: 'LIBERTY ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBTYA',
    Issuer: 'LIBERTY GLOBAL PLC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBTYB',
    Issuer: 'LIBERTY GLOBAL PLC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LBTYK',
    Issuer: 'LIBERTY GLOBAL PLC- C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LC',
    Issuer: 'LENDINGCLUB CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCA',
    Issuer: 'LANDCADIA HOLDINGS IV INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCAA',
    Issuer: 'L CATTERTON ASIA ACQ-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCAAU',
    Issuer: 'L CATTERTON ASIA ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCAHU',
    Issuer: 'LANDCADIA HOLDINGS IV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCAHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCFY',
    Issuer: 'LOCAFY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCFYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCG',
    Issuer: 'STERLING CAPITAL FOCUS EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCI',
    Issuer: 'LANNETT CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCID',
    Issuer: 'LUCID GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCII',
    Issuer: 'LCI INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCNB',
    Issuer: 'LCNB CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCR',
    Issuer: 'LEUTHOLD CORE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCTD',
    Issuer: 'BLACKROCK WRLD X US CARBON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCTU',
    Issuer: 'BLACKROCK US CARBON TR READ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCTX',
    Issuer: 'LINEAGE CELL THERAPEUTICS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCUT',
    Issuer: 'LIFETIME BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCW',
    Issuer: 'LEARN CW INVESTMENT CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LCW=',
    Issuer: 'LEARN CW INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LD',
    Issuer: 'IPATH BLOOMBERG LEAD SUBINDE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDEM',
    Issuer: 'ISHARES ESG MSCI EM LEADERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDHA',
    Issuer: 'LDH GROWTH CORP I-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDHAU',
    Issuer: 'LDH GROWTH CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDHAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDI',
    Issuer: 'LOANDEPOT INC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDOS',
    Issuer: 'LEIDOS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDP',
    Issuer: 'COHEN & STEERS LIMITED DURAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDSF',
    Issuer: 'FIRST TR LOW DURATION ST-ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LDUR',
    Issuer: 'PIMCO ENHANCED LOW DURATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LE',
    Issuer: "LANDS' END INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEA',
    Issuer: 'LEAR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEAD',
    Issuer: 'SIREN DIVCON LEADERS DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEAP',
    Issuer: 'RIBBIT LEAP LTD - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEAP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEAP=',
    Issuer: 'RIBBIT LEAP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LECO',
    Issuer: 'LINCOLN ELECTRIC HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEDS',
    Issuer: 'SEMILEDS CORP/TW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEE',
    Issuer: 'LEE ENTERPRISES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEG',
    Issuer: 'LEGGETT & PLATT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGA',
    Issuer: 'LEAD EDGE GROWTH OPPORTUNI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGAU',
    Issuer: 'LEAD EDGE GROWTH OPPORTUNITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGH',
    Issuer: 'LEGACY HOUSING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGN',
    Issuer: 'LEGEND BIOTECH CORP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEGR',
    Issuer: 'FIRST TRUST INDXX INNOVATIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEJU',
    Issuer: 'LEJU HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEMB',
    Issuer: 'ISHARES JP MORGAN EM LOCAL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEN',
    Issuer: 'LENNAR CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEN.B',
    Issuer: 'LENNAR CORP - B SHS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEO',
    Issuer: 'BNYM STRAT MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LESL',
    Issuer: "LESLIE'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LETB',
    Issuer: 'ADVISOR LET BOB AI POWERED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEU',
    Issuer: 'CENTRUS ENERGY CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEV',
    Issuer: 'LION ELECTRIC CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEVI',
    Issuer: 'LEVI STRAUSS & CO- CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEXI',
    Issuer: 'ALEXIS PRACTICAL TACTICAL ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEXX',
    Issuer: 'LEXARIA BIOSCIENCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LEXXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFAC',
    Issuer: 'LF CAPITAL ACQUISITION -CLA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFACU',
    Issuer: 'LF CAPITAL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFC',
    Issuer: 'CHINA LIFE INSURANCE CO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFEQ',
    Issuer: 'VANECK LONG/FLAT TREND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFG',
    Issuer: 'ARCHAEA ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFLY',
    Issuer: 'LEAFLY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFLYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFMD',
    Issuer: 'LIFEMD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFMDP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFST',
    Issuer: 'LIFESTANCE HEALTH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFT',
    Issuer: 'LUMENT FINANCE TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFTR',
    Issuer: 'LEFTERIS ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFTRU',
    Issuer: 'LEFTERIS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFTRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFUS',
    Issuer: 'LITTELFUSE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LFVN',
    Issuer: 'LIFEVANTAGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGAC',
    Issuer: 'LAZARD GROWTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGACU',
    Issuer: 'LAZARD GROWTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGF.A',
    Issuer: 'LIONS GATE ENTERTAINMENT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGF.B',
    Issuer: 'LIONS GATE ENTERTAINMENT-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGH',
    Issuer: 'HCM DEFENDER 500 INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGHL',
    Issuer: 'LION GROUP HOLDING LTD-S ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGHLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGI',
    Issuer: 'LAZARD GLOBAL TOT RT & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGIH',
    Issuer: 'LGI HOMES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGL',
    Issuer: 'LGL GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGLV',
    Issuer: 'SPDR SSGA US LARGE CAP LOW V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGMK',
    Issuer: 'LOGICMARK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGND',
    Issuer: 'LIGAND PHARMACEUTICALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGO',
    Issuer: 'LARGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGOV',
    Issuer: 'FIRST TR LONG DURATION O-ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGST',
    Issuer: 'SEMPER PARATUS ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGSTU',
    Issuer: 'SEMPER PARATUS ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGSTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGTO',
    Issuer: 'LEGATO MERGER CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGTOU',
    Issuer: 'LEGATO MERGER CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGTOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGV',
    Issuer: 'LONGVIEW ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGV=',
    Issuer: 'LONGVIEW ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGVC',
    Issuer: 'LAMF GLOBAL VENTURES CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGVCU',
    Issuer: 'LAMF GLOBAL VENTURES CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGVCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LGVN',
    Issuer: 'LONGEVERON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LH',
    Issuer: 'LABORATORY CRP OF AMER HLDGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHAA',
    Issuer: 'LERER HIPPEAU ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHC',
    Issuer: 'LEO HOLDINGS CORP II-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHC=',
    Issuer: 'LEO HOLDINGS CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHCG',
    Issuer: 'LHC GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHDX',
    Issuer: 'LUCIRA HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LHX',
    Issuer: 'L3HARRIS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LI',
    Issuer: 'LI AUTO INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIAN',
    Issuer: 'LIANBIO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIBY',
    Issuer: 'LIBERTY RESOURCES ACQUI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIBYU',
    Issuer: 'LIBERTY RESOURCES ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIBYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LICY',
    Issuer: 'LI-CYCLE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIDR',
    Issuer: 'AEYE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIDRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIFE',
    Issuer: 'ATYR PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LII',
    Issuer: 'LENNOX INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LILA',
    Issuer: 'LIBERTY LATIN AMERIC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LILAK',
    Issuer: 'LIBERTY LATIN AMERIC-CL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LILM',
    Issuer: 'LILIUM NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LILMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIN',
    Issuer: 'LINDE PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LINC',
    Issuer: 'LINCOLN EDUCATIONAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIND',
    Issuer: 'LINDBLAD EXPEDITIONS HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LINK',
    Issuer: 'INTERLINK ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LION',
    Issuer: 'LIONHEART III CORP -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIONU',
    Issuer: 'LIONHEART III CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIONW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIQT',
    Issuer: 'LIQTECH INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIT',
    Issuer: 'GLOBAL X LITHIUM & BATTERY T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITB',
    Issuer: 'LIGHTINTHEBOX HOLDING-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITE',
    Issuer: 'LUMENTUM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITM',
    Issuer: 'SNOW LAKE RESOURCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITT',
    Issuer: 'LOGISTICS INNOVATION TECH-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITTU',
    Issuer: 'LOGISTICS INNOVATION TECHNO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LITTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIV',
    Issuer: 'EMLES @HOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIVB',
    Issuer: 'LIV CAPITAL ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIVBU',
    Issuer: 'LIV CAPITAL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIVBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIVE',
    Issuer: 'LIVE VENTURES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIVN',
    Issuer: 'LIVANOVA PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIXT',
    Issuer: 'LIXTE BIOTECHNOLOGY HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIXTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LIZI',
    Issuer: 'LIZHI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LJAQ',
    Issuer: 'LIGHTJUMP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LJAQU',
    Issuer: 'LIGHTJUMP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LJAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LJPC',
    Issuer: 'LA JOLLA PHARMACEUTICAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LKCO',
    Issuer: 'LUOKUNG TECHNOLOGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LKFN',
    Issuer: 'LAKELAND FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LKOR',
    Issuer: 'FLEXSHARES CREDIT-SCORED LON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LKQ',
    Issuer: 'LKQ CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LL',
    Issuer: 'LL FLOORING HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LLAP',
    Issuer: 'TERRAN ORBITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LLAP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LLL',
    Issuer: 'JX LUXVENTURE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LLNW',
    Issuer: 'LIMELIGHT NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LLY',
    Issuer: 'ELI LILLY & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMACA',
    Issuer: 'LIBERTY MEDIA ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMACU',
    Issuer: 'LIBERTY MEDIA ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMAO',
    Issuer: 'LMF ACQUISITION OPPORTUNIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMAOU',
    Issuer: 'LMF ACQUISITION OPPORTUNITIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMAOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMAT',
    Issuer: 'LEMAITRE VASCULAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMB',
    Issuer: 'LIMBACH HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMBS',
    Issuer: 'FIRST TRUST LOW DURATION OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMDX',
    Issuer: 'LUMIRADX LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMDXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMFA',
    Issuer: 'LM FUNDING AMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMND',
    Issuer: 'LEMONADE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMNL',
    Issuer: 'LIMINAL BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMNR',
    Issuer: 'LIMONEIRA CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMPX',
    Issuer: 'LMP AUTOMOTIVE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMST',
    Issuer: 'LIMESTONE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LMT',
    Issuer: 'LOCKHEED MARTIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNC',
    Issuer: 'LINCOLN NATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LND',
    Issuer: 'BRASILAGRO-CIA BRA - SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNDC',
    Issuer: 'LANDEC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNFA',
    Issuer: 'L&F ACQUISITION CORP/IL -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNFA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNFA=',
    Issuer: 'L&F ACQUISITION CORP/IL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNG',
    Issuer: 'CHENIERE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNN',
    Issuer: 'LINDSAY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNSR',
    Issuer: 'LENSAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNT',
    Issuer: 'ALLIANT ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNTH',
    Issuer: 'LANTHEUS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LNW',
    Issuer: 'LIGHT & WONDER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOAN',
    Issuer: 'MANHATTAN BRIDGE CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOB',
    Issuer: 'LIVE OAK BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCC',
    Issuer: 'LIVE OAK CRESTVIEW CLIMATE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCC=',
    Issuer: 'LIVE OAK CRESTVIEW CLIMATE A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCL',
    Issuer: 'LOCAL BOUNTI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOCO',
    Issuer: 'EL POLLO LOCO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LODE',
    Issuer: 'COMSTOCK MINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOGC',
    Issuer: 'LOGICBIO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOGI',
    Issuer: 'LOGITECH INTERNATIONAL-REG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOKM',
    Issuer: 'LIVE OAK MOBILITY ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOKM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOKM=',
    Issuer: 'LIVE OAK MOBILITY ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOMA',
    Issuer: 'LOMA NEGRA CIA IND-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOOP',
    Issuer: 'LOOP INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOPE',
    Issuer: 'GRAND CANYON EDUCATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOPP',
    Issuer: 'Gabelli Love Our Planet & Pe',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOPX',
    Issuer: 'DIREXION LOW PRICED STOCK ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOTZ',
    Issuer: 'CARLOTZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOTZW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOUP',
    Issuer: 'INNOVATOR LOUP FRONTIER TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOV',
    Issuer: 'SPARK NETWORKS SE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOVE',
    Issuer: 'LOVESAC CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LOW',
    Issuer: "LOWE'S COS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPCN',
    Issuer: 'LIPOCINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPG',
    Issuer: 'DORIAN LPG LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPI',
    Issuer: 'LAREDO PETROLEUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPL',
    Issuer: 'LG DISPLAY CO LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPLA',
    Issuer: 'LPL FINANCIAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPRO',
    Issuer: 'OPEN LENDING CORP -  CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPSN',
    Issuer: 'LIVEPERSON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPTH',
    Issuer: 'LIGHTPATH TECHNOLOGIES INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPTX',
    Issuer: 'LEAP THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LPX',
    Issuer: 'LOUISIANA-PACIFIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQD',
    Issuer: 'ISHARES IBOXX INVESTMENT GRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQDA',
    Issuer: 'LIQUIDIA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQDB',
    Issuer: 'ISHARES BBB RATE CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQDH',
    Issuer: 'ISHARES INT HEDG CORP BD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQDI',
    Issuer: 'ISHARES INFLATION HEDGED COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQDT',
    Issuer: 'LIQUIDITY SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LQIG',
    Issuer: 'SPDR MARKETAXESS IG 400 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRCX',
    Issuer: 'LAM RESEARCH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRFC',
    Issuer: 'LOGAN RIDGE FINANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRGE',
    Issuer: 'CLRBRDG LRG CAP GWTH ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRGF',
    Issuer: 'ISHARES MSCI USA MULTIFACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRMR',
    Issuer: 'LARIMAR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRN',
    Issuer: 'STRIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRND',
    Issuer: 'IQ US LRG CAP R&D LEAD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LRNZ',
    Issuer: 'TRUESHARES TECHNOLOGY AI & D',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSAF',
    Issuer: 'LEADERSHARES ALPHAFACTOR US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSAK',
    Issuer: 'NET 1 UEPS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSAT',
    Issuer: 'LEADERSHARES ALPHAFACT TACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSBK',
    Issuer: 'LAKE SHORE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSCC',
    Issuer: 'LATTICE SEMICONDUCTOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSEA',
    Issuer: 'LANDSEA HOMES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSEAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSF',
    Issuer: 'LAIRD SUPERFOOD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSI',
    Issuer: 'LIFE STORAGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSPD',
    Issuer: 'LIGHTSPEED COMMERCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSPR',
    Issuer: 'LARKSPUR HEALTH ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSPRU',
    Issuer: 'LARKSPUR HEALTH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSPRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSST',
    Issuer: 'NATIXIS LOOMIS SAYLES SHRT D',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSTR',
    Issuer: 'LANDSTAR SYSTEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSXMA',
    Issuer: 'LIBERTY MEDIA COR-SIRIUSXM A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSXMB',
    Issuer: 'LIBERTY MEDIA COR-SIRIUSXM B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LSXMK',
    Issuer: 'LIBERTY MEDIA COR-SIRIUSXM C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTBR',
    Issuer: 'LIGHTBRIDGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTC',
    Issuer: 'LTC PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTCH',
    Issuer: 'LATCH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTCHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTH',
    Issuer: 'LIFE TIME GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTHM',
    Issuer: 'LIVENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTL',
    Issuer: 'PROSHARES ULTRA TELECOMMUNIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTPZ',
    Issuer: 'PIMCO 15+ YR US TIPS INDX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRN',
    Issuer: 'LANTERN PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRPA',
    Issuer: 'LIBERTY TRIPADVISOR HDG-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRPB',
    Issuer: 'LIBERTY TRIPADVISOR HDG-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRX',
    Issuer: 'LANTRONIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRY',
    Issuer: 'LOTTERY.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LTRYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LU',
    Issuer: 'LUFAX HOLDING LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUB',
    Issuer: "LUBY'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUCD',
    Issuer: 'LUCID DIAGNOSTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUCY',
    Issuer: 'INNOVATIVE EYEWEAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUCYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LULU',
    Issuer: 'LULULEMON ATHLETICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUMN',
    Issuer: 'LUMEN TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUMO',
    Issuer: 'LUMOS PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUNA',
    Issuer: 'LUNA INNOVATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUNG',
    Issuer: 'PULMONX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUV',
    Issuer: 'SOUTHWEST AIRLINES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUXA',
    Issuer: 'LUX HEALTH TECH ACQUIS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUXAU',
    Issuer: 'LUX HEALTH TECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUXAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LUXE',
    Issuer: 'EMLES LUXURY GOODS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVAC',
    Issuer: 'LAVA MEDTECH ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVACU',
    Issuer: 'LAVA MEDTECH ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVHD',
    Issuer: 'LEGG MASON LO VOL HI DIV ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVHI',
    Issuer: 'LEGG MASON INTL LOW VOL DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVLU',
    Issuer: "LULU'S FASHION LOUNGE HOLDIN",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVO',
    Issuer: 'LIVEONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVOL',
    Issuer: 'AMERICAN CENTURY LOW VOL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVOX',
    Issuer: 'LIVEVOX HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVOXU',
    Issuer: 'CRESCENT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVOXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVRA',
    Issuer: 'LEVERE HOLDINGS CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVRAU',
    Issuer: 'LEVERE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVRAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVS',
    Issuer: 'LAS VEGAS SANDS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LVTX',
    Issuer: 'LAVA THERAPEUTICS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LW',
    Issuer: 'LAMB WESTON HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LWAY',
    Issuer: 'LIFEWAY FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LWLG',
    Issuer: 'LIGHTWAVE LOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LX',
    Issuer: 'LEXINFINTECH HOLDINGS L-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXEH',
    Issuer: 'LIXIANG EDUCATION HOLDIN-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXFR',
    Issuer: 'LUXFER HOLDINGS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXP',
    Issuer: 'LXP INDUSTRIAL TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXP-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXRX',
    Issuer: 'LEXICON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LXU',
    Issuer: 'LSB INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYB',
    Issuer: 'LYONDELLBASELL INDU-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYEL',
    Issuer: 'LYELL IMMUNOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYFE',
    Issuer: '2NDVOTE LIFE NEUTRAL PLUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYFT',
    Issuer: 'LYFT INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYG',
    Issuer: 'LLOYDS BANKING GROUP PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYL',
    Issuer: 'DRAGON VICTORY INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYLT',
    Issuer: 'LOYALTY VENTURES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYRA',
    Issuer: 'LYRA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYTS',
    Issuer: 'LSI INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LYV',
    Issuer: 'LIVE NATION ENTERTAINMENT IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LZ',
    Issuer: 'LEGALZOOMCOM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'LZB',
    Issuer: 'LA-Z-BOY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'M',
    Issuer: "MACY'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MA',
    Issuer: 'MASTERCARD INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAA',
    Issuer: 'MID-AMERICA APARTMENT COMM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAA-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAAQ',
    Issuer: 'MANA CAPITAL ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAAQR',
    Issuer: 'MANA CAPITAL ACQUISITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAAQU',
    Issuer: 'MANA CAPITAL ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAAX',
    Issuer: 'VANECK MUNI ALLOCATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAC',
    Issuer: 'MACERICH CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACA',
    Issuer: 'MORINGA ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACAU',
    Issuer: 'MORINGA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACC',
    Issuer: 'MISSION ADVANCEMENT CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACC=',
    Issuer: 'MISSION ADVANCEMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MACK',
    Issuer: 'MERRIMACK PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAG',
    Issuer: 'MAG SILVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAGA',
    Issuer: 'POINT BRIDGE GOP STOCK T ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAIN',
    Issuer: 'MAIN STREET CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAKX',
    Issuer: 'PROSHARES S&P KENSHO SMRT FA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAMB',
    Issuer: 'MONARCH AMBASSADOR INCOME ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAN',
    Issuer: 'MANPOWERGROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MANH',
    Issuer: 'MANHATTAN ASSOCIATES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MANT',
    Issuer: 'MANTECH INTERNATIONAL CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MANU',
    Issuer: 'MANCHESTER UNITED PLC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAPS',
    Issuer: 'WM TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAPSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAQC',
    Issuer: 'MAQUIA CAPITAL ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAQCU',
    Issuer: 'MAQUIA CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAQCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAR',
    Issuer: 'MARRIOTT INTERNATIONAL -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MARA',
    Issuer: 'MARATHON DIGITAL HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MARB',
    Issuer: 'FIRST TRUST MERGER ARBITRAGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MARK',
    Issuer: 'REMARK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MARPS',
    Issuer: 'MARINE PETROLEUM TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MARZ',
    Issuer: 'TRUESHARES STRUC OUTCOME MAR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAS',
    Issuer: 'MASCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MASI',
    Issuer: 'MASIMO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MASS',
    Issuer: '908 DEVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAT',
    Issuer: 'MATTEL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MATW',
    Issuer: 'MATTHEWS INTL CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MATX',
    Issuer: 'MATSON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAV',
    Issuer: 'PIONEER MUNICIPAL HIGH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAX',
    Issuer: 'MEDIAALPHA INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAXN',
    Issuer: 'MAXEON SOLAR TECHNOLOGIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAXR',
    Issuer: 'MAXAR TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAYS',
    Issuer: 'MAYS (J.W.) INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MAYZ',
    Issuer: 'TS STR OUTCOME MAY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBAC',
    Issuer: 'M3-BRIGADE ACQUISITION II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBAC=',
    Issuer: 'M3-BRIGADE ACQUISITION II CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBB',
    Issuer: 'ISHARES MBS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBBB',
    Issuer: "VANECK MOODY'S ANALYTICS BBB",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBCC',
    Issuer: 'MONARCH BLUE CHIPS CORE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBCN',
    Issuer: 'MIDDLEFIELD BANC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBI',
    Issuer: 'MBIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBII',
    Issuer: 'MARRONE BIO INNOVATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBIN',
    Issuer: 'MERCHANTS BANCORP/IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBINN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBINO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBINP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBIO',
    Issuer: 'MUSTANG BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBND',
    Issuer: 'SPDR NUVEEN MUNICIPAL BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBNE',
    Issuer: 'SPDR NUVEEN MUNI BOND ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBNKP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBOT',
    Issuer: 'MICROBOT MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBOX',
    Issuer: 'FREEDOM DAY DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBRX',
    Issuer: 'MOLECULIN BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBSC',
    Issuer: 'M3-BRIGADE ACQUISITION -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBSC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBSC=',
    Issuer: 'M3-BRIGADE ACQUISITION III C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBSD',
    Issuer: 'FLEXSHARES DISCIPLINED DURAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBT',
    Issuer: 'MOBILE TELESYSTEMS PUBLIC JO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBTC',
    Issuer: 'NOCTURNE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBTCR',
    Issuer: 'NOCTURNE ACQUISITION-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBTCU',
    Issuer: 'NOCTURNE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBUU',
    Issuer: 'MALIBU BOATS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MBWM',
    Issuer: 'MERCANTILE BANK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MC',
    Issuer: 'MOELIS & CO - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAA',
    Issuer: 'MOUNTAIN & CO I ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAAU',
    Issuer: 'MOUNTAIN & CO I ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCACU',
    Issuer: 'MONTEREY CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAE',
    Issuer: 'MOUNTAIN CREST ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAER',
    Issuer: 'MOUNTAIN CREST ACQUISITI-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAEU',
    Issuer: 'MOUNTAIN CREST ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAF',
    Issuer: 'MOUNTAIN CREST ACQ CORP IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAFR',
    Issuer: 'MOUNTAIN CREST ACQ CORP -RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAFU',
    Issuer: 'MOUNTAIN CREST ACQ CORP IV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAG',
    Issuer: 'MOUNTAIN CREST ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAGR',
    Issuer: 'MOUNTAIN CREST ACQUISITI-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCAGU',
    Issuer: 'MOUNTAIN CREST ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCB',
    Issuer: 'METROPOLITAN BANK HOLDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCBC',
    Issuer: 'MACATAWA BANK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCBS',
    Issuer: 'METROCITY BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCD',
    Issuer: "MCDONALD'S CORP",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCFT',
    Issuer: 'MASTERCRAFT BOAT HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCG',
    Issuer: 'MEMBERSHIP COLLECTIVE GRP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCHI',
    Issuer: 'ISHARES MSCI CHINA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCHP',
    Issuer: 'MICROCHIP TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCHX',
    Issuer: 'MARCHEX INC-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCI',
    Issuer: 'BARINGS CORPORATE INVESTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCK',
    Issuer: 'MCKESSON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCLD',
    Issuer: 'MCLOUD TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCLDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCN',
    Issuer: 'MADISON COVERED CALL & EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCO',
    Issuer: "MOODY'S CORP",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCR',
    Issuer: 'MFS CHARTER INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCRB',
    Issuer: 'SERES THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCRI',
    Issuer: 'MONARCH CASINO & RESORT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCRO',
    Issuer: 'IQ HEDGE MACRO TRACKER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCS',
    Issuer: 'MARCUS CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCW',
    Issuer: 'MISTER CAR WASH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MCY',
    Issuer: 'MERCURY GENERAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MD',
    Issuer: 'MEDNAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDB',
    Issuer: 'MONGODB INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDC',
    Issuer: 'MDC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDCP',
    Issuer: 'VICTORYSHARES THB MID ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDEV',
    Issuer: 'FIRST TRUST INDXX MEDDEV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDGL',
    Issuer: 'MADRIGAL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDGS',
    Issuer: 'MEDIGUS LTD - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDGSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDH',
    Issuer: 'MDH ACQUISITION CORP -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDH=',
    Issuer: 'MDH ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDIA',
    Issuer: 'MEDIACO HOLDING INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDIV',
    Issuer: 'FT MULTI-ASSET DIVERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDJH',
    Issuer: 'MDJM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDLZ',
    Issuer: 'MONDELEZ INTERNATIONAL INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDNA',
    Issuer: 'MEDICENNA THERAPEUTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDRR',
    Issuer: 'MEDALIST DIVERSIFIED REIT IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDRRP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDRX',
    Issuer: 'ALLSCRIPTS HEALTHCARE SOLUTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDT',
    Issuer: 'MEDTRONIC PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDU',
    Issuer: 'MDU RESOURCES GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDV',
    Issuer: 'MODIV INC - CLASS C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDV-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDVL',
    Issuer: 'MEDAVAIL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDWD',
    Issuer: 'MEDIWOUND LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDWT',
    Issuer: 'MIDWEST HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDXG',
    Issuer: 'MIMEDX GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDXH',
    Issuer: 'MDXHEALTH SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDY',
    Issuer: 'SPDR S&P MIDCAP 400 ETF TRST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDYG',
    Issuer: 'SPDR S&P 400 MID CAPGROWTH E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MDYV',
    Issuer: 'SPDR S&P 400 MID CAP VALUE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ME',
    Issuer: '23ANDME HOLDING CO -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEAC',
    Issuer: 'MERCURY ECOMMERCE ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEACU',
    Issuer: 'MERCURY ECOMMERCE ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEAR',
    Issuer: 'BLACKROCK SHORT MATURITY MUN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEC',
    Issuer: 'MAYVILLE ENGINEERING CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MED',
    Issuer: 'MEDIFAST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEDP',
    Issuer: 'MEDPACE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEDS',
    Issuer: 'TRXADE HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEG',
    Issuer: 'MONTROSE ENVIRONMENTAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEGI',
    Issuer: 'MAINSTAY CBRE GLBL INFR MEGA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEI',
    Issuer: 'METHODE ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEIP',
    Issuer: 'MEI PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEKA',
    Issuer: 'MELI KASZEK PIONEER CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MELI',
    Issuer: 'MERCADOLIBRE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEME',
    Issuer: 'ROUNDHILL MEME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MENV',
    Issuer: 'ADVISORSHARES NORTH SQUARE M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEOA',
    Issuer: 'MINORITY EQUALITY OPPORTUN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEOAU',
    Issuer: 'MINORITY EQUALITY OPPORTUNIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEOAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEOH',
    Issuer: 'METHANEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MER-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MERC',
    Issuer: 'MERCER INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MESA',
    Issuer: 'MESA AIR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MESO',
    Issuer: 'MESOBLAST LTD- SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MET',
    Issuer: 'METLIFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MET-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MET-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MET-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'METC',
    Issuer: 'RAMACO RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'METCL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'METV',
    Issuer: 'ROUNDHILL BALL METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'METX',
    Issuer: 'METEN HOLDING GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'METXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MEXX',
    Issuer: 'DIREXION DLY MEXICO BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MF',
    Issuer: 'MISSFRESH LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFA',
    Issuer: 'MFA FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFA-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFA-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFC',
    Issuer: 'MANULIFE FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFD',
    Issuer: 'MACQUARIE/FT GL INT/UT DV IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFDX',
    Issuer: 'PIMCO RAFI DYNAMIC MULTI-FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFEM',
    Issuer: 'PIMCO RAFI DYNAMIC MULTI-FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFG',
    Issuer: 'MIZUHO FINANCIAL GROUP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFGP',
    Issuer: 'MICRO FOCUS INTL-SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFH',
    Issuer: 'MERCURITY FINTECH HOLDING IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFIN',
    Issuer: 'MEDALLION FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFLX',
    Issuer: 'FIRST TRUST EXCHANGE-TRADED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFM',
    Issuer: 'MFS MUNICIPAL INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFUL',
    Issuer: 'MINDFUL CONSERVATIVE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFUS',
    Issuer: 'PIMCO RAFI DYNAMIC MULTI-FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MFV',
    Issuer: 'MFS SPECIAL VALUE TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MG',
    Issuer: 'MISTRAS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGA',
    Issuer: 'MAGNA INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGC',
    Issuer: 'VANGUARD MEGA CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGEE',
    Issuer: 'MGE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGF',
    Issuer: 'MFS GOVT MARKETS INC TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGI',
    Issuer: 'MONEYGRAM INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGIC',
    Issuer: 'MAGIC SOFTWARE ENTERPRISES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGK',
    Issuer: 'VANGUARD MEGA CAP GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGLD',
    Issuer: 'MARYGOLD COMPANIES INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGM',
    Issuer: 'MGM RESORTS INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGMT',
    Issuer: 'BALLAST SMALL/MID CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGNI',
    Issuer: 'MAGNITE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGNX',
    Issuer: 'MACROGENICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGPI',
    Issuer: 'MGP INGREDIENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGR',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGRB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGRC',
    Issuer: 'MCGRATH RENTCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGRD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGTA',
    Issuer: 'MAGENTA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGTX',
    Issuer: 'MEIRAGTX HOLDINGS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGU',
    Issuer: 'MACQUARIE GLOBAL INFR TOT RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGV',
    Issuer: 'VANGUARD MEGA CAP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGY',
    Issuer: 'MAGNOLIA OIL & GAS CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MGYR',
    Issuer: 'MAGYAR BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MH-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MH-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHD',
    Issuer: 'BLACKROCK MUNIHOLDINGS FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHF',
    Issuer: 'WESTERN ASSET MUNICIPAL HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHH',
    Issuer: 'MASTECH DIGITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHI',
    Issuer: 'PIONEER MUNI HIGH INC TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHK',
    Issuer: 'MOHAWK INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHLA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHLD',
    Issuer: 'MAIDEN HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHN',
    Issuer: 'BLACKROCK MUNIHOLDINGS NY QU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHNC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHO',
    Issuer: 'M/I HOMES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MHUA',
    Issuer: 'MEIHUA INTERNATIONAL MEDICAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIC',
    Issuer: 'MACQUARIE INFRASTRUCTURE HOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MICS',
    Issuer: 'SINGING MACHINE CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MICT',
    Issuer: 'MICT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MID',
    Issuer: 'AMERICAN CENTURY MID CAP GRO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIDD',
    Issuer: 'MIDDLEBY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIDE',
    Issuer: 'XTRACKERS S&P MIDCAP 400 ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIDF',
    Issuer: 'ISHARES MSCI USA MID-CAP MUL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIDU',
    Issuer: 'DIREXION DLY MID CAP BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIG',
    Issuer: "VANECK MOODY'S ANALYTICS IG",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIGI',
    Issuer: 'MAWSON INFRASTRUCTURE GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MILE',
    Issuer: 'METROMILE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MILEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MILN',
    Issuer: 'GLOBAL X MILLENNIAL CONSUMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIMO',
    Issuer: 'AIRSPAN NETWORKS HOLDINGS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIMO+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIMO+A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIMO+B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIMO+C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIN',
    Issuer: 'MFS INTERMEDIATE INC TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINC',
    Issuer: 'ADVSHRS NEWFLEET MULTSEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIND',
    Issuer: 'MIND TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINDP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINM',
    Issuer: 'MINIM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINN',
    Issuer: 'MAIRS & POWER MN MUNI BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINO',
    Issuer: 'PIMCO MUNICIPAL INCOME OPPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MINT',
    Issuer: 'PIMCO ENHANCED SHORT MATURIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIO',
    Issuer: 'PIONEER MUNI HIGH INC OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIR',
    Issuer: 'MIRION TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIRM',
    Issuer: 'MIRUM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIRO',
    Issuer: 'MIROMATRIX MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIST',
    Issuer: 'MILESTONE PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIT',
    Issuer: 'MASON INDUSTRIAL TECHN-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIT=',
    Issuer: 'MASON INDUSTRIAL TECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITA',
    Issuer: 'COLISEUM ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITAU',
    Issuer: 'COLISEUM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITC',
    Issuer: 'MEAT-TECH 3D LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITK',
    Issuer: 'MITEK SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITO',
    Issuer: 'STEALTH BIOTHERAPEUTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITQ',
    Issuer: 'MOVING IMAGE TECHNOLOGIES IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITT',
    Issuer: 'AG MORTGAGE INVESTMENT TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITT-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MITT-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIXT',
    Issuer: 'MIX TELEMATICS LTD-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MIY',
    Issuer: 'BLACKROCK MUNIYIELD MI QUALI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MJ',
    Issuer: 'ETFMG ALTERNATIVE HARVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MJIN',
    Issuer: 'ETFMG 2X DLY INV ALT HARVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MJUS',
    Issuer: 'ETFMG U.S. ALTERNATIVE HARVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MJXL',
    Issuer: 'ETFMG 2X DAILY ALT HARVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKC',
    Issuer: 'MCCORMICK & CO-NON VTG SHRS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKC.V',
    Issuer: 'MCCORMICK & CO INC VTG COM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKD',
    Issuer: 'MOLECULAR DATA INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKFG',
    Issuer: 'MARKFORGED HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKFG+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKL',
    Issuer: 'MARKEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKSI',
    Issuer: 'MKS INSTRUMENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKTW',
    Issuer: 'MARKETWISE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKTWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MKTX',
    Issuer: 'MARKETAXESS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ML',
    Issuer: 'MONEYLION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ML+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLAB',
    Issuer: 'MESA LABORATORIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLAC',
    Issuer: 'MALACCA STRAITS ACQUISI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLACU',
    Issuer: 'MALACCA STRAITS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLAI',
    Issuer: 'MCLAREN TECHNOLOGY ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLAIU',
    Issuer: 'MCLAREN TECHNOLOGY ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLAIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLCO',
    Issuer: 'MELCO RESORTS & ENTERT-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLI',
    Issuer: 'MUELLER INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLKN',
    Issuer: 'MILLERKNOLL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLM',
    Issuer: 'MARTIN MARIETTA MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLN',
    Issuer: 'VANECK LONG MUNI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLNK',
    Issuer: 'MERIDIANLINK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLP',
    Issuer: 'MAUI LAND & PINEAPPLE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLPA',
    Issuer: 'GLOBAL X MLP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLPB',
    Issuer: 'ETRACS ALERIAN INFRAST SER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLPO',
    Issuer: 'CS S&P MLP INDEX ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLPR',
    Issuer: 'ETRACS 150% ALERIAN MLP ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLPX',
    Issuer: 'GLOBAL X MLP & ENERGY INFRAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLR',
    Issuer: 'MILLER INDUSTRIES INC/TENN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLSS',
    Issuer: 'MILESTONE SCIENTIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLTX',
    Issuer: 'MOONLAKE IMMUNOTHERAPEUTICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MLVF',
    Issuer: 'MALVERN BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMAT',
    Issuer: 'META MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMC',
    Issuer: 'MARSH & MCLENNAN COS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMCA',
    Issuer: 'IQ MACKAY CA MUNI INTERMEDIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMD',
    Issuer: 'MAINSTAY MACKAY DEFINEDTERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMI',
    Issuer: 'MARCUS & MILLICHAP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMIN',
    Issuer: 'IQ MACKAY MUNICIPAL INSURED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMIT',
    Issuer: 'IQ MACKAY MUNICIPAL INTERMED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMLG',
    Issuer: 'FIRST TRUST MULTI-MAN LG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMLP',
    Issuer: 'MARTIN MIDSTREAM PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMM',
    Issuer: '3M CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMMB',
    Issuer: "MAMAMANCINI'S HOLDINGS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMP',
    Issuer: 'MAGELLAN MIDSTREAM PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMS',
    Issuer: 'MAXIMUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMSC',
    Issuer: 'FIRST TRUST MULTI-MANAGER SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMSI',
    Issuer: 'MERIT MEDICAL SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMT',
    Issuer: 'MFS MULTIMARKET INC TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMTM',
    Issuer: 'SPDR S&P1500 MOMENTUM TILT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMU',
    Issuer: 'WESTERN ASSET MANAGED MUNICI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMX',
    Issuer: 'MAVERIX METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MMYT',
    Issuer: 'MAKEMYTRIP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MN',
    Issuer: 'MANNING & NAPIER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNA',
    Issuer: 'IQ MERGER ARBITRAGE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNBD',
    Issuer: 'ALPS INTERMEDIATE MUNI BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNDO',
    Issuer: 'MIND CTI LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNDT',
    Issuer: 'MANDIANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNDY',
    Issuer: 'MONDAY.COM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNKD',
    Issuer: 'MANNKIND CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNM',
    Issuer: 'DIREXION DAILY MM BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNMD',
    Issuer: 'MIND MEDICINE MINDMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNOV',
    Issuer: 'MEDICINOVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNP',
    Issuer: 'WESTERN ASSET MUNICIPAL PART',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNPR',
    Issuer: 'MONOPAR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNRL',
    Issuer: 'BRIGHAM MINERALS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNRO',
    Issuer: 'MONRO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNSB',
    Issuer: 'MAINSTREET BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNSBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNSO',
    Issuer: 'MINISO GROUP HOLDING LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNST',
    Issuer: 'MONSTER BEVERAGE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTK',
    Issuer: 'MONTAUK RENEWABLES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTN',
    Issuer: 'EVEREST CONSOLIDATOR ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTN=',
    Issuer: 'EVEREST CONSOLIDATOR ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTS',
    Issuer: 'MOMENTUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTV',
    Issuer: 'MOMENTIVE GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MNTX',
    Issuer: 'MANITEX INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MO',
    Issuer: 'ALTRIA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOAT',
    Issuer: 'VANECK MORNINGSTAR WIDE MOAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOBQ',
    Issuer: 'MOBIQUITY TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOBQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOD',
    Issuer: 'MODINE MANUFACTURING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MODD',
    Issuer: 'MODULAR MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MODN',
    Issuer: 'MODEL N INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MODV',
    Issuer: 'MODIVCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOFG',
    Issuer: 'MIDWESTONE FINANCIAL GROUP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOG.A',
    Issuer: 'MOOG INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOG.B',
    Issuer: 'MOOG INC-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOGO',
    Issuer: 'MOGO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOGU',
    Issuer: 'MOGU INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOH',
    Issuer: 'MOLINA HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOHO',
    Issuer: 'ECMOHO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOHR',
    Issuer: 'MOHR GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOLN',
    Issuer: 'MOLECULAR PARTNERS AG -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOMO',
    Issuer: 'HELLO GROUP INC -SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MON',
    Issuer: 'MONUMENT CIRCLE ACQUI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MONCU',
    Issuer: 'MONUMENT CIRCLE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MONCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOO',
    Issuer: 'VANECK AGRIBUSINESS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOOD',
    Issuer: 'RELATIVE SENTIMENT TACT ALLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOON',
    Issuer: 'DIREXION MOONSHOT INNOVATORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOR',
    Issuer: 'MORPHOSYS AG ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MORF',
    Issuer: 'MORPHIC HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MORN',
    Issuer: 'MORNINGSTAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MORT',
    Issuer: 'VANECK MORTGAGE REIT INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOS',
    Issuer: 'MOSAIC CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOTE',
    Issuer: 'VANECK MORNINGSTAR ESG MOAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOTG',
    Issuer: 'VANECK MSTAR GL WIDE MOAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOTI',
    Issuer: 'VANECK MSTAR INT MOAT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOTO',
    Issuer: 'SMARTETFS SMART TRANSP/TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOTS',
    Issuer: 'MOTUS GI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOV',
    Issuer: 'MOVADO GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOVE',
    Issuer: 'MOVANO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MOXC',
    Issuer: 'MOXIAN BVI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MP',
    Issuer: 'MP MATERIALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPA',
    Issuer: 'BLACKROCK MUNIYIELD PENNSYLV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPAA',
    Issuer: 'MOTORCAR PARTS OF AMERICA IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPAC',
    Issuer: 'MODEL PERFORMANCE ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPACR',
    Issuer: 'MODEL PERFORMANCE ACQ-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPACU',
    Issuer: 'MODEL PERFORMANCE ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPAY',
    Issuer: 'AKROS MONTHLY PAYOUT ETF',
    date: '2022-05-26',
    isEnabled: '0',
    lit: '1',
  },
  {
    Symbol: 'MPB',
    Issuer: 'MID PENN BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPC',
    Issuer: 'MARATHON PETROLEUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPLN',
    Issuer: 'MULTIPLAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPLN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPLX',
    Issuer: 'MPLX LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPRA',
    Issuer: 'MERCATO PARTNERS ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPRAU',
    Issuer: 'MERCATO PARTNERS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPRAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPRO',
    Issuer: 'MONARCH PROCAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPV',
    Issuer: 'BARINGS PARTICIPATION INVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPW',
    Issuer: 'MEDICAL PROPERTIES TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPWR',
    Issuer: 'MONOLITHIC POWER SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MPX',
    Issuer: 'MARINE PRODUCTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MQ',
    Issuer: 'MARQETA INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MQT',
    Issuer: 'BLACKROCK MUNIYIELD QUAL II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MQY',
    Issuer: 'BLACKROCK MUNIYIELD QUALITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRAD',
    Issuer: 'SMARTETFS ADVERT & MRKT TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRAI',
    Issuer: 'MARPAI INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRAM',
    Issuer: 'EVERSPIN TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRBK',
    Issuer: 'MERIDIAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRC',
    Issuer: 'MRC GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRCC',
    Issuer: 'MONROE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRCY',
    Issuer: 'MERCURY SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MREO',
    Issuer: 'MEREO BIOPHARMA GROUP PL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRGR',
    Issuer: 'PROSHARES MERGER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRIN',
    Issuer: 'MARIN SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRK',
    Issuer: 'MERCK & CO. INC.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRKR',
    Issuer: 'MARKER THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRM',
    Issuer: 'MEDIROM HEALTHCARE TECHNOLOG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRNA',
    Issuer: 'MODERNA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRND',
    Issuer: 'IQ US MID CAP R&D LEADERS ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRNS',
    Issuer: 'MARINUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRO',
    Issuer: 'MARATHON OIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRSK',
    Issuer: 'TOEWS AGILITY SHARES MANAGED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRSN',
    Issuer: 'MERSANA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRTN',
    Issuer: 'MARTEN TRANSPORT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRTX',
    Issuer: 'MIRATI THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRUS',
    Issuer: 'MERUS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRVI',
    Issuer: 'MARAVAI LIFESCIENCES HLDGS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MRVL',
    Issuer: 'MARVELL TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS',
    Issuer: 'MORGAN STANLEY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MS-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSA',
    Issuer: 'MSA SAFETY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSAC',
    Issuer: 'MEDICUS SCIENCES ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSB',
    Issuer: 'MESABI TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSBI',
    Issuer: 'MIDLAND STATES BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSC',
    Issuer: 'STUDIO CITY INTERNATIONA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSCI',
    Issuer: 'MSCI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSD',
    Issuer: 'MORGAN STANLEY EMRG MKT DEBT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSDA',
    Issuer: 'MSD ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSDAU',
    Issuer: 'MSD ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSDAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSEX',
    Issuer: 'MIDDLESEX WATER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSFT',
    Issuer: 'MICROSOFT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSGE',
    Issuer: 'MADISON SQUARE GARDEN ENTERT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSGM',
    Issuer: 'MOTORSPORT GAMES INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSGR',
    Issuer: 'DIREXION MRNA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSGS',
    Issuer: 'MADISON SQUARE GARDEN SPORTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSI',
    Issuer: 'MOTOROLA SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSM',
    Issuer: 'MSC INDUSTRIAL DIRECT CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSMR',
    Issuer: 'M/S MANAGED RISK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSN',
    Issuer: 'EMERSON RADIO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSOS',
    Issuer: 'ADVISORSHARES PURE US CANN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSP',
    Issuer: 'DATTO HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSPR',
    Issuer: 'LIONHEART ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSPRV',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSPRZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSSAU',
    Issuer: 'METAL SKY STAR ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSTB',
    Issuer: 'LHA MARKET STATE TACTICAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSTQ',
    Issuer: 'LHA MARKET STATE TACTICAL Q',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSTR',
    Issuer: 'MICROSTRATEGY INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSVB',
    Issuer: 'MID-SOUTHERN BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MSVX',
    Issuer: 'LHA MARKET STATE ALPHA SEEKE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MT',
    Issuer: 'ARCELORMITTAL-NY REGISTERED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTA',
    Issuer: 'METALLA ROYALTY & STREAMING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTAC',
    Issuer: 'MEDTECH ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTACU',
    Issuer: 'MEDTECH ACQUISITION CORP/NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTAL',
    Issuer: 'METALS ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTAL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTAL=',
    Issuer: 'METALS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTB',
    Issuer: 'M & T BANK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTB-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTBC',
    Issuer: 'CARECLOUD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTBCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTBCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTC',
    Issuer: 'MMTEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTCH',
    Issuer: 'MATCH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTCN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTCR',
    Issuer: 'METACRINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTD',
    Issuer: 'METTLER-TOLEDO INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTDR',
    Issuer: 'MATADOR RESOURCES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTEK',
    Issuer: 'MARIS - TECH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTEKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTEM',
    Issuer: 'MOLECULAR TEMPLATES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTEX',
    Issuer: 'MANNATECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTG',
    Issuer: 'MGIC INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTGP',
    Issuer: 'WISDOMTREE MTGE PLUS BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTH',
    Issuer: 'MERITAGE HOMES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTL',
    Issuer: 'MECHEL PJSC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTL-',
    Issuer: 'MECHEL-PREF SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTLS',
    Issuer: 'MATERIALISE NV-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTMT',
    Issuer: 'MEGA MATRIX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTN',
    Issuer: 'VAIL RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTNB',
    Issuer: 'MATINAS BIOPHARMA HOLDINGS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTOR',
    Issuer: 'MERITOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTP',
    Issuer: 'MIDATECH PHARMA PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTR',
    Issuer: 'MESA ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTRN',
    Issuer: 'MATERION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTRX',
    Issuer: 'MATRIX SERVICE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTRY',
    Issuer: 'MONTEREY BIO ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTRYU',
    Issuer: 'MONTEREY BIO ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTRYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTSI',
    Issuer: 'MACOM TECHNOLOGY SOLUTIONS H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTTR',
    Issuer: 'MATTERPORT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTUL',
    Issuer: 'ETRACS 2X MOMNTM FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTUM',
    Issuer: 'ISHARES MSCI USA MOMENTUM FA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTVC',
    Issuer: 'MOTIVE CAPITAL CORP II-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTVC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTVC=',
    Issuer: 'MOTIVE CAPITAL CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTVR',
    Issuer: 'FOUNT METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTW',
    Issuer: 'MANITOWOC COMPANY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTX',
    Issuer: 'MINERALS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MTZ',
    Issuer: 'MASTEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MU',
    Issuer: 'MICRON TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUA',
    Issuer: 'BLACKROCK MUNIASSETS FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUB',
    Issuer: 'ISHARES NATIONAL MUNI BOND E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUC',
    Issuer: 'BLACKROCK MUNIHOLDINGS CA QU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUDS',
    Issuer: 'MUDRICK CAPITAL ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUDSU',
    Issuer: 'MUDRICK CAPITAL ACQUIS II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUDSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUE',
    Issuer: 'BLACKROCK MUNIHOLDINGS QU II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUFG',
    Issuer: 'MITSUBISHI UFJ FINL-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUI',
    Issuer: 'BLACKROCK MUNICIPAL INCOME F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUJ',
    Issuer: 'BLACKROCK MUNIHOLDINGS NJ QU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MULN',
    Issuer: 'MULLEN AUTOMOTIVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUNI',
    Issuer: 'PIMCO INTERMEDIATE MUNICIPAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUR',
    Issuer: 'MURPHY OIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MURF',
    Issuer: 'MURPHY CANYON ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MURFU',
    Issuer: 'MURPHY CANYON ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MURFW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUSA',
    Issuer: 'MURPHY USA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUSI',
    Issuer: 'AMERICAN CENT MUTLISEC INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUST',
    Issuer: 'COLUMBIA MULTI-SECTOR MUNICI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MUX',
    Issuer: 'MCEWEN MINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVBF',
    Issuer: 'MVB FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVF',
    Issuer: 'BLACKROCK MUNIVEST FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVIS',
    Issuer: 'MICROVISION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVO',
    Issuer: 'MV OIL TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVPS',
    Issuer: 'AMPLIFY THEMATIC ALL STARS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVRL',
    Issuer: 'ETRACS 150% MORTGAG REIT ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVST',
    Issuer: 'MICROVAST HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVSTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVT',
    Issuer: 'BLACKROCK MUNIVEST FUND II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MVV',
    Issuer: 'PROSHARES ULTRA MIDCAP400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MWA',
    Issuer: 'MUELLER WATER PRODUCTS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MX',
    Issuer: 'MAGNACHIP SEMICONDUCTOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXC',
    Issuer: 'MEXCO ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXCT',
    Issuer: 'MAXCYTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXE',
    Issuer: 'MEXICO EQUITY AND INCOME FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXF',
    Issuer: 'MEXICO FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXI',
    Issuer: 'ISHARES GLOBAL MATERIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MXL',
    Issuer: 'MAXLINEAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYD',
    Issuer: 'BLACKROCK MUNIYIELD FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYE',
    Issuer: 'MYERS INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYFW',
    Issuer: 'FIRST WESTERN FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYGN',
    Issuer: 'MYRIAD GENETICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYI',
    Issuer: 'BLACKROCK MUNIYIELD QUALITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYMD',
    Issuer: 'MYMD PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYN',
    Issuer: 'BLACKROCK MUNIYIELD NY QUALI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYNA',
    Issuer: 'MYNARIC AG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYNZ',
    Issuer: 'MAINZ BIOMED BV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYO',
    Issuer: 'MYOMO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYOV',
    Issuer: 'MYOVANT SCIENCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYPS',
    Issuer: 'PLAYSTUDIOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYPSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYRG',
    Issuer: 'MYR GROUP INC/DELAWARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYSZ',
    Issuer: 'MY SIZE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYTE',
    Issuer: 'MYT NETHERLANDS PARENT BV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MYY',
    Issuer: 'PROSHARES SHORT MIDCAP 400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'MZZ',
    Issuer: 'PROSHARES ULTSHRT MIDCAP400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAAC',
    Issuer: 'NORTH ATLANTIC ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAACU',
    Issuer: 'NORTH ATLANTIC ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NABL',
    Issuer: 'N-ABLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAC',
    Issuer: 'NUVEEN CA QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NACP',
    Issuer: 'IMPACT SHARES NAACP MINORITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAD',
    Issuer: 'NUVEEN QUAL MUNI INCOME FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAII',
    Issuer: 'NATURAL ALTERNATIVES INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAIL',
    Issuer: 'DRX DLY HOMEBUILDERS BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAK',
    Issuer: 'NORTHERN DYNASTY MINERALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAN',
    Issuer: 'NUVEEN NY QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NANR',
    Issuer: 'SPDR S&P NORTH AMERICAN NATU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAOV',
    Issuer: 'NANOVIBRONIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAPA',
    Issuer: 'DUCKHORN PORTFOLIO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAPR',
    Issuer: 'INNOVATOR GROWTH 100 POWER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NARI',
    Issuer: 'INARI MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAT',
    Issuer: 'NORDIC AMERICAN TANKERS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NATH',
    Issuer: "NATHAN'S FAMOUS INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NATI',
    Issuer: 'NATIONAL INSTRUMENTS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NATR',
    Issuer: 'NATURES SUNSHINE PRODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAUT',
    Issuer: 'NAUTILUS BIOTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAVB',
    Issuer: 'NAVIDEA BIOPHARMACEUTICALS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAVI',
    Issuer: 'NAVIENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NAZ',
    Issuer: 'NUVEEN AZ QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBB',
    Issuer: 'NUVEEN TAX MUNI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBCC',
    Issuer: 'NB NEXT GEN CONNECT CONS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBCT',
    Issuer: 'NB CARBON TRANS & INFRA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBDS',
    Issuer: 'NB DISRUPTERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBEV',
    Issuer: 'NEWAGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBH',
    Issuer: 'NEUBERGER BERMAN MUNICIPAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBHC',
    Issuer: 'NATIONAL BANK HOLD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBIX',
    Issuer: 'NEUROCRINE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBN',
    Issuer: 'NORTHEAST BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBO',
    Issuer: 'NEUBERGER BERMAN NY MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBR',
    Issuer: 'NABORS INDUSTRIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBRV',
    Issuer: 'NABRIVA THERAPEUTICS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBSE',
    Issuer: 'NEUBASE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBST',
    Issuer: 'NEWBURY STREET ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBSTU',
    Issuer: 'NEWBURY STREET ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBSTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBTB',
    Issuer: 'N B T BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBTX',
    Issuer: 'NANOBIOTIX SA - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBW',
    Issuer: 'NEUBERGER BERMAN CA MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBXG',
    Issuer: 'NBRGR BRMN NEX GEN CONNECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NBY',
    Issuer: 'NOVABAY PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NC',
    Issuer: 'NACCO INDUSTRIES-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCA',
    Issuer: 'NUVEEN CALIFORNIA MUNICIPAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCAC',
    Issuer: 'NEWCOURT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCACU',
    Issuer: 'NEWCOURT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCLH',
    Issuer: 'NORWEGIAN CRUISE LINE HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCMI',
    Issuer: 'NATIONAL CINEMEDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCNA',
    Issuer: 'NUCANA PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCNO',
    Issuer: 'NCINO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCR',
    Issuer: 'NCR CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCSM',
    Issuer: 'NCS MULTISTAGE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCTY',
    Issuer: 'THE9 LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCV',
    Issuer: 'VIRTUS ALLIANZGI CN & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCV-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCZ',
    Issuer: 'VIRTUS ALLIANZGI CN & INC II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NCZ-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDAC',
    Issuer: 'NIGHTDRAGON ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDACU',
    Issuer: 'NIGHTDRAGON ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDAQ',
    Issuer: 'NASDAQ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDJI',
    Issuer: 'NATIONWIDE DOW JONES RISK MA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDLS',
    Issuer: 'NOODLES & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDMO',
    Issuer: 'NUVEEN DYNAMIC MUNI OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDP',
    Issuer: 'TORTOISE ENERGY INDEPENDENCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDRA',
    Issuer: 'ENDRA LIFE SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDSN',
    Issuer: 'NORDSON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NDVG',
    Issuer: 'NUVEEN DIVIDEND GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NE',
    Issuer: 'NOBLE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEA',
    Issuer: 'NUVEEN AMT-FR QLTY MUNI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEAR',
    Issuer: 'BLACKROCK SHORT MATURITY BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NECB',
    Issuer: 'NORTHEAST COMMUNITY BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEE',
    Issuer: 'NEXTERA ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEE-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEE-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEE-P',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEE-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEGG',
    Issuer: 'NEWEGG COMMERCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEM',
    Issuer: 'NEWMONT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEN',
    Issuer: 'NEW ENGLAND REALTY ASSOC-LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEO',
    Issuer: 'NEOGENOMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEOG',
    Issuer: 'NEOGEN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEON',
    Issuer: 'NEONODE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEP',
    Issuer: 'NEXTERA ENERGY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEPH',
    Issuer: 'NEPHROS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEPT',
    Issuer: 'NEPTUNE WELLNESS SOLUTIONS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NERD',
    Issuer: 'ROUNDHILL BITKRAFT ESPORTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NERV',
    Issuer: 'MINERVA NEUROSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NESR',
    Issuer: 'NATIONAL ENERGY SERVICES REU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NESRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NET',
    Issuer: 'CLOUDFLARE INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETC',
    Issuer: 'NABORS ENERGY TRANSITION - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETC=',
    Issuer: 'NABORS ENERGY TRANSITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETI',
    Issuer: 'ENETI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETL',
    Issuer: 'NETLEASE CORPORATE REAL ESTA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NETZ',
    Issuer: 'ENGINE 1 TRANSFORM CLIMATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEU',
    Issuer: 'NEWMARKET CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEV',
    Issuer: 'NUVEEN ENH MUNI VALUE FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEWP',
    Issuer: 'NEW PACIFIC METALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEWR',
    Issuer: 'NEW RELIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEWT',
    Issuer: 'NEWTEK BUSINESS SERVICES COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEWTL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEWTZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEX',
    Issuer: 'NEXTIER OILFIELD SOLUTIONS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEXA',
    Issuer: 'NEXA RESOURCES SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEXI',
    Issuer: 'NEXIMMUNE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NEXT',
    Issuer: 'NEXTDECADE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFBK',
    Issuer: 'NORTHFIELD BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFE',
    Issuer: 'NEW FORTRESS ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFG',
    Issuer: 'NATIONAL FUEL GAS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFGC',
    Issuer: 'NEW FOUND GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFJ',
    Issuer: 'VIRTUS DVD INTRST & PRM STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFLT',
    Issuer: 'VIRTUS NEWFLEET MULTI-SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFLX',
    Issuer: 'NETFLIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFNT',
    Issuer: 'INFINITE ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFNT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFNT=',
    Issuer: 'INFINITE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFRA',
    Issuer: 'FLEXSHARES STOXX GLOBAL BROA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFTY',
    Issuer: 'FIRST TRUST INDIA NIFTY 50 E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFTZ',
    Issuer: 'Defiance Digital Revolution',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFYS',
    Issuer: 'ENPHYS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFYS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NFYS=',
    Issuer: 'ENPHYS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NG',
    Issuer: 'NOVAGOLD RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGC',
    Issuer: 'NORTHERN GENESIS ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGC=',
    Issuer: 'NORTHERN GENESIS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGD',
    Issuer: 'NEW GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGE',
    Issuer: 'GLOBAL X MSCI NIGERIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGG',
    Issuer: 'NATIONAL GRID PLC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGL',
    Issuer: 'NGL ENERGY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGL-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGM',
    Issuer: 'NGM BIOPHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGMS',
    Issuer: 'NEOGAMES SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGS',
    Issuer: 'NATURAL GAS SERVICES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGVC',
    Issuer: 'NATURAL GROCERS BY VITAMIN C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NGVT',
    Issuer: 'INGEVITY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NH',
    Issuer: 'NANTHEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHC',
    Issuer: 'NATIONAL HEALTHCARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHI',
    Issuer: 'NATL HEALTH INVESTORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHIC',
    Issuer: 'NEWHOLD INVESTMENT CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHICU',
    Issuer: 'NEWHOLD INVESTMENT CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHS',
    Issuer: 'NEUBERGER BERMAN HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHTC',
    Issuer: 'NATURAL HEALTH TRENDS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NHWK',
    Issuer: 'NIGHTHAWK BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NI',
    Issuer: 'NISOURCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NI-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIB',
    Issuer: 'IPATH BLOOMBERG COCOA SUBIND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIC',
    Issuer: 'NICOLET BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NICE',
    Issuer: 'NICE LTD - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NICK',
    Issuer: 'NICHOLAS FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NID',
    Issuer: 'NUVEEN INT DUR MUNI TERM FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIE',
    Issuer: 'VIRTUS ALLIANZGI EQ & CONV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIFE',
    Issuer: 'DIREXION FALLEN KNIVES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NILE',
    Issuer: 'BITNILE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIM',
    Issuer: 'NUVEEN SEL MAT MUNI FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIMC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NINE',
    Issuer: 'NINE ENERGY SERVICE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIO',
    Issuer: 'NIO INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIQ',
    Issuer: 'NUVEEN INT DUR QU MUN TRM FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NISN',
    Issuer: 'NISUN INTERNATIONAL ENTERPRI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NIU',
    Issuer: 'NIU TECHNOLOGIES-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NJAN',
    Issuer: 'INNOVATOR GROWTH 100 POWER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NJR',
    Issuer: 'NEW JERSEY RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NJUL',
    Issuer: 'INNOVATOR GROWTH 100 POWER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKE',
    Issuer: 'NIKE INC -CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKG',
    Issuer: 'NUVEEN GA QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKLA',
    Issuer: 'NIKOLA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKSH',
    Issuer: 'NATIONAL BANKSHARES INC/VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKTR',
    Issuer: 'NEKTAR THERAPEUTICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKTX',
    Issuer: 'NKARTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NKX',
    Issuer: 'NUVEEN CA AMT-FR MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NL',
    Issuer: 'NL INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLIT',
    Issuer: 'NORTHERN LIGHTS ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLITU',
    Issuer: 'NORTHERN LIGHTS ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLITW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLOK',
    Issuer: 'NORTONLIFELOCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLR',
    Issuer: 'VANECK URANIUM + NUCLEAR ENE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLS',
    Issuer: 'NAUTILUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLSN',
    Issuer: 'NIELSEN HOLDINGS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLSP',
    Issuer: 'NLS PHARMACEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLSPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLTX',
    Issuer: 'NEOLEUKIN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLY',
    Issuer: 'ANNALY CAPITAL MANAGEMENT IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLY-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLY-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NLY-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NM',
    Issuer: 'NAVIOS MARITIME HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NM-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NM-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMAI',
    Issuer: 'NUVEEN MULTI-ASSET INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMCO',
    Issuer: 'NUVEEN MUNICIPAL CREDIT OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMFC',
    Issuer: 'NEW MOUNTAIN FINANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMG',
    Issuer: 'NOUVEAU MONDE GRAPHITE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMI',
    Issuer: 'NUVEEN MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMIH',
    Issuer: 'NMI HOLDINGS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMK-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMK-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NML',
    Issuer: 'NB MLP & ENERGY INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMM',
    Issuer: 'NAVIOS MARITIME PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMMC',
    Issuer: 'NORTH MOUNTAIN MERGER CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMMCU',
    Issuer: 'NORTH MOUNTAIN MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMMCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMR',
    Issuer: 'NOMURA HOLDINGS INC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMRD',
    Issuer: 'NEMAURA MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMRK',
    Issuer: 'NEWMARK GROUP INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMS',
    Issuer: 'NUVEEN MN QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMT',
    Issuer: 'NUVEEN MA QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMTC',
    Issuer: 'NEUROONE MEDICAL TECHNOLOGIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMTR',
    Issuer: '9 METERS BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NMZ',
    Issuer: 'NUVEEN MUNI HIGH INC OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NN',
    Issuer: 'NEXTNAV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNAVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNBR',
    Issuer: 'NN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNDM',
    Issuer: 'NANO DIMENSION LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNI',
    Issuer: 'NELNET INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNN',
    Issuer: 'NATIONAL RETAIL PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNOX',
    Issuer: 'NANO-X IMAGING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNVC',
    Issuer: 'NANOVIRICIDES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NNY',
    Issuer: 'NUVEEN NEW YORK MUNICIPAL VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOA',
    Issuer: 'NORTH AMERICAN CONSTRUCTION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOAC',
    Issuer: 'NATURAL ORDER ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOACU',
    Issuer: 'NATURAL ORDER ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOAH',
    Issuer: 'NOAH HOLDINGS LTD-SPON ADS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOBL',
    Issuer: 'PROSHARES S&P 500 DIVIDEND A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOC',
    Issuer: 'NORTHROP GRUMMAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOCT',
    Issuer: 'INNOVATOR GROWTH-100 POWER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NODK',
    Issuer: 'NI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOG',
    Issuer: 'NORTHERN OIL AND GAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOK',
    Issuer: 'NOKIA CORP-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOM',
    Issuer: 'NUVEEN MO QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOMD',
    Issuer: 'NOMAD FOODS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NORW',
    Issuer: 'GLOBAL X MSCI NORWAY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOTV',
    Issuer: 'INOTIV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOV',
    Issuer: 'NOV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVA',
    Issuer: 'SUNNOVA ENERGY INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVN',
    Issuer: 'NOVAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVT',
    Issuer: 'NOVANTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVV',
    Issuer: 'NOVA VISION ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVVR',
    Issuer: 'NOVA VISION ACQUISITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVVU',
    Issuer: 'NOVA VISION ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOVZ',
    Issuer: 'TRUESHARES STRUC OUTCOME NOV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NOW',
    Issuer: 'SERVICENOW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NP',
    Issuer: 'NEENAH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPAB',
    Issuer: 'NEW PROVIDENCE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPABU',
    Issuer: 'NEW PROVIDENCE ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPABW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPCE',
    Issuer: 'NEUROPACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPCT',
    Issuer: 'NUVEEN CORE PLUS IMPACT FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPFD',
    Issuer: 'NUVEEN VAR RT PREF & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPK',
    Issuer: 'NATIONAL PRESTO INDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPO',
    Issuer: 'ENPRO INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPTN',
    Issuer: 'NEOPHOTONICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NPV',
    Issuer: 'NUVEEN VA QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NQP',
    Issuer: 'NUVEEN PA QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NR',
    Issuer: 'NEWPARK RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRAC',
    Issuer: 'NOBLE ROCK ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRACU',
    Issuer: 'NOBLE ROCK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRBO',
    Issuer: 'NEUROBO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRC',
    Issuer: 'NATIONAL RESEARCH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRDS',
    Issuer: 'NERDWALLET INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRDY',
    Issuer: 'NERDY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRDY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NREF',
    Issuer: 'NEXPOINT REAL ESTATE FINANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NREF-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRG',
    Issuer: 'NRG ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRGD',
    Issuer: 'MICROSECTORS US BIG OIL -3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRGU',
    Issuer: 'MICROSECTORS US BIG OIL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRGV',
    Issuer: 'ENERGY VAULT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRGV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRGX',
    Issuer: 'PIMCO ENRGY & TACT CRDT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRIM',
    Issuer: 'NORTHRIM BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRIX',
    Issuer: 'NURIX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRK',
    Issuer: 'NUVEEN NY AMT-FR MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRO',
    Issuer: 'NEUBERGER BERMAN REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRP',
    Issuer: 'NATURAL RESOURCE PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRSN',
    Issuer: 'NEUROSENSE THERAPEUTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRSNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRT',
    Issuer: 'NORTH EUROPEAN OIL RTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRUC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRXP',
    Issuer: 'NRX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRXPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRZ',
    Issuer: 'NEW RESIDENTIAL INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRZ-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRZ-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRZ-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NRZ-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NS',
    Issuer: 'NUSTAR ENERGY LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NS-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NS-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NS-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSA',
    Issuer: 'NATIONAL STORAGE AFFILIATES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSA-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSC',
    Issuer: 'NORFOLK SOUTHERN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSCS',
    Issuer: 'NUVEEN SMALL CAP SELECT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSEC',
    Issuer: 'NATIONAL SECURITY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSIT',
    Issuer: 'INSIGHT ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSL',
    Issuer: 'NUVEEN SENIOR INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSP',
    Issuer: 'INSPERITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSPI',
    Issuer: 'NATIONWIDE S&P 500 RISK-MAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSPR',
    Issuer: 'INSPIREMD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSR',
    Issuer: 'NOMAD ROYALTY CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSS',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSSC',
    Issuer: 'NAPCO SECURITY TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTB',
    Issuer: 'NORTHERN STAR INVESTMENT C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTB=',
    Issuer: 'NORTHERN STAR INVESTMENT COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTC',
    Issuer: 'NORTHERN STAR INVESTMENT -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTC=',
    Issuer: 'NORTHERN STAR INVESTMENT III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTD',
    Issuer: 'NORTHERN STAR INVESTMENT -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTD=',
    Issuer: 'NORTHERN STAR INVESTMENT COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTG',
    Issuer: 'NANOSTRING TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSTS',
    Issuer: 'NSTS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NSYS',
    Issuer: 'NORTECH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTAP',
    Issuer: 'NETAPP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTB',
    Issuer: 'BANK OF N.T. BUTTERFIELD&SON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTCO',
    Issuer: 'NATURA &CO HOLDING-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTCT',
    Issuer: 'NETSCOUT SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTES',
    Issuer: 'NETEASE INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTEST',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTEST.A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTEST.B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTEST.C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTG',
    Issuer: 'TORTOISE MIDSTREAM ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTGR',
    Issuer: 'NETGEAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTIC',
    Issuer: 'NORTHERN TECHNOLOGIES INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTIP',
    Issuer: 'NETWORK-1 TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTKI',
    Issuer: 'NATIONWIDE RUSSELL 2000 RISK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTLA',
    Issuer: 'INTELLIA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTNX',
    Issuer: 'NUTANIX INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTP',
    Issuer: 'NAM TAI PROPERTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTR',
    Issuer: 'NUTRIEN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTRA',
    Issuer: 'NATERA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTRB',
    Issuer: 'NUTRIBAND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTRBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTRS',
    Issuer: 'NORTHERN TRUST CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTRSO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTSE',
    Issuer: 'WISDOMTREE EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTSI',
    Issuer: 'WISDOMTREE INTERNATIONAL EFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTST',
    Issuer: 'NETSTREIT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTSX',
    Issuer: 'WISDOMTREE US EFFICIENT CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTUS',
    Issuer: 'NATUS MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTWK',
    Issuer: 'NETSOL TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTZ',
    Issuer: 'NATUZZI SPA-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NTZO',
    Issuer: 'IMPACT SHARES MSCI GL CLIM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NU',
    Issuer: 'NU HOLDINGS LTD/CAYMAN ISL-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUAG',
    Issuer: 'NUVEEN ENHANCED YIELD U.S. A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUBD',
    Issuer: 'NUVEEN ESG US AGGREGATE BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUBI',
    Issuer: 'NUBIA BRAND INTERNATION-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUBIU',
    Issuer: 'NUBIA BRAND INTERNATIONAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUBIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUDM',
    Issuer: 'NUVEEN ESG INTERNATIONAL DEV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUDV',
    Issuer: 'NUVEEN ESG DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUE',
    Issuer: 'NUCOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUEM',
    Issuer: 'NUVEEN ESG EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUGO',
    Issuer: 'NUVEEN GROWTH OPPORTUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUGT',
    Issuer: 'DIREXION DAILY GOLD MINERS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUHY',
    Issuer: 'NUVEEN ESG HIGH YIELD CORP B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NULC',
    Issuer: 'NUVEEN ESG LARGE-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NULG',
    Issuer: 'NUVEEN ESG LARGE-CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NULV',
    Issuer: 'NUVEEN ESG LARGE-CAP VALUE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUMG',
    Issuer: 'NUVEEN ESG MIDCAP GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUMV',
    Issuer: 'NUVEEN ESG MID-CAP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUO',
    Issuer: 'NUVEEN OH QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NURE',
    Issuer: 'NUVEEN SHORTTERM REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NURO',
    Issuer: 'NEUROMETRIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUS',
    Issuer: 'NU SKIN ENTERPRISES INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUSA',
    Issuer: 'NUVEEN ENHANCED YIELD 1-5 YE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUSC',
    Issuer: 'NUVEEN ESG SMALL-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUSI',
    Issuer: 'NATIONWIDE NASDAQ-100 RISK-M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUTX',
    Issuer: 'NUTEX HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUV',
    Issuer: 'NUVEEN MUNI VALUE FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUVA',
    Issuer: 'NUVASIVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUVB',
    Issuer: 'NUVATION BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUVB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUVL',
    Issuer: 'NUVALENT INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUW',
    Issuer: 'NUVEEN AMT-FREE MUNI VAL FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUWE',
    Issuer: 'NUWELLIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NUZE',
    Issuer: 'NUZEE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVAC',
    Issuer: 'NORTHVIEW ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVACR',
    Issuer: 'NORTHVIEW ACQUISITION CO-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVAX',
    Issuer: 'NOVAVAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVCN',
    Issuer: 'NEOVASC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVCR',
    Issuer: 'NOVOCURE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVCT',
    Issuer: 'NUVECTIS PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVDA',
    Issuer: 'NVIDIA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVEC',
    Issuer: 'NVE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVEE',
    Issuer: 'NV5 GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVEI',
    Issuer: 'NUVEI CORP-SUBORDINATE VTG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVFY',
    Issuer: 'NOVA LIFESTYLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVG',
    Issuer: 'NUVEEN AMT-FR MUNI CREDIT FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVGS',
    Issuer: 'NAVIGATOR HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVIV',
    Issuer: 'INVIVO THERAPEUTICS HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVMI',
    Issuer: 'NOVA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVNO',
    Issuer: 'ENVVENO MEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVNOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVO',
    Issuer: 'NOVO-NORDISK A/S-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVOS',
    Issuer: 'NOVO INTEGRATED SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVQ',
    Issuer: 'QRAFT AI-ENH US NEXT VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVR',
    Issuer: 'NVR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVRO',
    Issuer: 'NEVRO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVS',
    Issuer: 'NOVARTIS AG-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVSA',
    Issuer: 'NEW VISTA ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVSAU',
    Issuer: 'NEW VISTA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVST',
    Issuer: 'ENVISTA HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVT',
    Issuer: 'NVENT ELECTRIC PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVTA',
    Issuer: 'INVITAE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVTS',
    Issuer: 'NAVITAS SEMICONDUCTOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVVE',
    Issuer: 'NUVVE HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVVEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NVX',
    Issuer: 'NOVONIX LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWBI',
    Issuer: 'NORTHWEST BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWE',
    Issuer: 'NORTHWESTERN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWFL',
    Issuer: 'NORWOOD FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWG',
    Issuer: 'NATWEST GROUP PLC -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWL',
    Issuer: 'NEWELL BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWLG',
    Issuer: 'NUVEEN WINSLOW LG CAP GR ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWLI',
    Issuer: 'NATIONAL WESTERN LIFE GROU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWN',
    Issuer: 'NORTHWEST NATURAL HOLDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWPX',
    Issuer: 'NORTHWEST PIPE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWS',
    Issuer: 'NEWS CORP - CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NWSA',
    Issuer: 'NEWS CORP - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NX',
    Issuer: 'QUANEX BUILDING PRODUCTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXC',
    Issuer: 'NUVEEN CA SEL TX-FR INC PORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXDT',
    Issuer: 'NEXPOINT DIVERSIFIED REAL ES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXDT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXE',
    Issuer: 'NEXGEN ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXGL',
    Issuer: 'NEXGEL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXGLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXGN',
    Issuer: 'NEXTGEN HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXJ',
    Issuer: 'NUVEEN NJ QUAL MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXN',
    Issuer: 'NUVEEN NY SEL TX-FR INC PORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXP',
    Issuer: 'NUVEEN SEL TX-FR INC PORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXPI',
    Issuer: 'NXP SEMICONDUCTORS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXPL',
    Issuer: 'NEXTPLAT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXPLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXRT',
    Issuer: 'NEXPOINT RESIDENTIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXST',
    Issuer: 'NEXSTAR MEDIA GROUP INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXTC',
    Issuer: 'NEXTCURE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXTG',
    Issuer: 'FIRST TRUST INDXX NEXTG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NXTP',
    Issuer: 'NEXTPLAY TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYC',
    Issuer: 'NEW YORK CITY REIT INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYCB',
    Issuer: 'NEW YORK COMMUNITY BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYCB-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYCB-U',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYF',
    Issuer: 'ISHARES NEW YORK MUNI BOND E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMT',
    Issuer: 'NEW YORK MORTGAGE TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMTL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMTM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMTN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMTZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYMX',
    Issuer: 'NYMOX PHARMACEUTICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYT',
    Issuer: 'NEW YORK TIMES CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NYXH',
    Issuer: 'NYXOAH SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NZAC',
    Issuer: 'SPDR MSCI ACWI CLIMATE PARIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NZF',
    Issuer: 'NUVEEN MUNI CREDIT INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NZRO',
    Issuer: 'STRATEGY SHARES HALT CLIMATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'NZUS',
    Issuer: 'SPDR MSCI USA CLIMATE PARIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'None',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '0',
    lit: '1',
  },
  {
    Symbol: 'O',
    Issuer: 'REALTY INCOME CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OACB',
    Issuer: 'OAKTREE ACQ CORP II - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OACB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OACB=',
    Issuer: 'OAKTREE ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OACP',
    Issuer: 'ONEASCENT CORE PLUS BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OAK-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OAK-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OALC',
    Issuer: 'ONEASCENT LARGE CAP CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OAS',
    Issuer: 'OASIS PETROLEUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OB',
    Issuer: 'OUTBRAIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBCI',
    Issuer: 'OCEAN BIO-CHEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBE',
    Issuer: 'OBSIDIAN ENERGY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBLG',
    Issuer: 'OBLONG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBND',
    Issuer: 'SPDR LOOMIS SAYLES OPP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBNK',
    Issuer: 'ORIGIN BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBOR',
    Issuer: 'KRANESHARES MSCI ONE BELT ON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBSV',
    Issuer: 'OBSEVA SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OBT',
    Issuer: 'ORANGE COUNTY BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OC',
    Issuer: 'OWENS CORNING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCA',
    Issuer: 'OMNICHANNEL ACQUISITION-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCA=',
    Issuer: 'OMNICHANNEL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCAX',
    Issuer: 'OCA ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCAXU',
    Issuer: 'OCA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCC',
    Issuer: 'OPTICAL CABLE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCCI',
    Issuer: 'OFS CREDIT CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCCIN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCCIO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCDX',
    Issuer: 'ORTHO CLINICAL DIAGNOSTICS H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCEN',
    Issuer: 'IQ CLEAN OCEANS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCFC',
    Issuer: 'OCEANFIRST FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCFCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCFT',
    Issuer: 'ONECONNECT FINANCIAL TECHNO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCG',
    Issuer: 'ORIENTAL CULTURE HOLDING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCGN',
    Issuer: 'OCUGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCIO',
    Issuer: 'CLEARSHARES OCIO ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCN',
    Issuer: 'OCWEN FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCSL',
    Issuer: 'OAKTREE SPECIALTY LENDING CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCTZ',
    Issuer: 'TRUESHARES STRUC OUTCOME OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCUL',
    Issuer: 'OCULAR THERAPEUTIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCUP',
    Issuer: 'OCUPHIRE PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OCX',
    Issuer: 'ONCOCYTE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ODC',
    Issuer: 'OIL-DRI CORP OF AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ODDS',
    Issuer: 'PACER BLUESTAR DIG ENTERTAIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ODFL',
    Issuer: 'OLD DOMINION FREIGHT LINE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ODP',
    Issuer: 'ODP CORP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEC',
    Issuer: 'ORION ENGINEERED CARBONS SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEF',
    Issuer: 'ISHARES S&P 100 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEG',
    Issuer: 'ORBITAL ENERGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEPW',
    Issuer: 'ONE EQUITY PARTNERS OPEN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEPWU',
    Issuer: 'ONE EQUITY PARTNERS OPEN WAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEPWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OESX',
    Issuer: 'ORION ENERGY SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OEUR',
    Issuer: 'OSHARES EUROPE QUALITY DIVID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFC',
    Issuer: 'CORPORATE OFFICE PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFED',
    Issuer: 'OCONEE FEDERAL FINANCIAL COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFG',
    Issuer: 'OFG BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFIX',
    Issuer: 'ORTHOFIX MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFLX',
    Issuer: 'OMEGA FLEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFS',
    Issuer: 'OFS CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OFSSH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OG',
    Issuer: 'ONION GLOBAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGCP',
    Issuer: 'EMPIRE STATE REALTY OP-S60',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGE',
    Issuer: 'OGE ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGEN',
    Issuer: 'ORAGENICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGI',
    Issuer: 'ORGANIGRAM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGIG',
    Issuer: "O'SHARES GLOBAL INTERNET GIA",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGN',
    Issuer: 'ORGANON & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OGS',
    Issuer: 'ONE GAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHAA',
    Issuer: 'OPY ACQUISITION CORP I - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHAAU',
    Issuer: 'OPY ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHI',
    Issuer: 'OMEGA HEALTHCARE INVESTORS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHPA',
    Issuer: 'ORION ACQUISITION CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHPAU',
    Issuer: 'ORION ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OHPAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OI',
    Issuer: 'O-I GLASS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OIA',
    Issuer: 'INVESCO MUNICIPAL INCOME OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OIH',
    Issuer: 'VANECK OIL SERVICES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OII',
    Issuer: 'OCEANEERING INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OIIM',
    Issuer: 'O2MICRO INTERNATIONAL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OIL',
    Issuer: 'IPATH PURE BETA CRUDE OIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OILD',
    Issuer: 'MICRO OG EXP PROD 3X INV LEV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OILK',
    Issuer: 'PROSHARES K-1 FREE CRUDE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OILU',
    Issuer: 'MICRO OG EXP PROD 3X LEVG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OIS',
    Issuer: 'OIL STATES INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OKE',
    Issuer: 'ONEOK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OKTA',
    Issuer: 'OKTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OKYO',
    Issuer: 'OKYO PHARMA LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLB',
    Issuer: 'OLB GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLED',
    Issuer: 'UNIVERSAL DISPLAY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLIT',
    Issuer: 'OMNILIT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLITU',
    Issuer: 'OMNILIT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLITW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLK',
    Issuer: 'OLINK HOLDING AB - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLLI',
    Issuer: "OLLIE'S BARGAIN OUTLET HOLDI",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLMA',
    Issuer: 'OLEMA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLN',
    Issuer: 'OLIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLO',
    Issuer: 'OLO INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLP',
    Issuer: 'ONE LIBERTY PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OLPX',
    Issuer: 'OLAPLEX HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OM',
    Issuer: 'OUTSET MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMAB',
    Issuer: 'GRUPO AEROPORTUARIO CEN-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMC',
    Issuer: 'OMNICOM GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMCL',
    Issuer: 'OMNICELL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMEG',
    Issuer: 'OMEGA ALPHA SPAC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMER',
    Issuer: 'OMEROS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMEX',
    Issuer: 'ODYSSEY MARINE EXPLORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMF',
    Issuer: 'ONEMAIN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMFL',
    Issuer: 'INVESCO RUSSELL 1000 DYN M/F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMFS',
    Issuer: 'INVESCO RSL 2000 DYN MLTFCTR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMGA',
    Issuer: 'OMEGA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMI',
    Issuer: 'OWENS & MINOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMIC',
    Issuer: 'SINGULAR GENOMICS SYSTEMS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OMQS',
    Issuer: 'OMNIQ CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ON',
    Issuer: 'ON SEMICONDUCTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONB',
    Issuer: 'OLD NATIONAL BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONBPO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONBPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONCR',
    Issuer: 'ONCORUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONCS',
    Issuer: 'ONCOSEC MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONCT',
    Issuer: 'ONCTERNAL THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONCY',
    Issuer: 'ONCOLYTICS BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OND',
    Issuer: 'PROSHARES ON-DEMAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONDS',
    Issuer: 'ONDAS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEM',
    Issuer: '1LIFE HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEO',
    Issuer: 'SPDR RUSSELL 1000 MOMEN FOCU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEQ',
    Issuer: 'FIDELITY NASDAQ COMPOSITE IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEV',
    Issuer: 'SPDR RUSSELL LOW VOL FOCUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEW',
    Issuer: 'ONEWATER MARINE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONEY',
    Issuer: 'SPDR RUSSELL 1000 YIELD FOCU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONG',
    Issuer: 'DIREXION DAILY OIL BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONL',
    Issuer: 'ORION OFFICE REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONLN',
    Issuer: 'PROSHARES ONLINE RETAIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONOF',
    Issuer: 'GLOBAL X ADAPTIVE U.S. RISK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONON',
    Issuer: 'ON HOLDING AG-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONTF',
    Issuer: 'ON24 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONTO',
    Issuer: 'ONTO INNOVATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONTX',
    Issuer: 'ONCONOVA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONVO',
    Issuer: 'ORGANOVO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONYX',
    Issuer: 'ONYX ACQUISITION CO I-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONYXU',
    Issuer: 'ONYX ACQUISITION CO I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ONYXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OOMA',
    Issuer: 'OOMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OOTO',
    Issuer: 'DIREXION DAILY TRVL VACA 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OP',
    Issuer: 'OCEANPAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPA',
    Issuer: 'MAGNUM OPUS ACQUISITION LT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPA=',
    Issuer: 'MAGNUM OPUS ACQUISITION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPAD',
    Issuer: 'OFFERPAD SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPAD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPBK',
    Issuer: 'OP BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPCH',
    Issuer: 'OPTION CARE HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPEN',
    Issuer: 'OPENDOOR TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPER',
    Issuer: 'CLEARSHARES ULTRA-SHORT MATU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPFI',
    Issuer: 'OPPFI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPFI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPGN',
    Issuer: 'OPGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPHC',
    Issuer: 'OPTIMUMBANK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPI',
    Issuer: 'OFFICE PROPERTIES INCOME TRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPINL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPK',
    Issuer: 'OPKO HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPNT',
    Issuer: 'OPIANT PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPOF',
    Issuer: 'OLD POINT FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPP',
    Issuer: 'RIVERNRTH/DOUBLELNE STR OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPP-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPPX',
    Issuer: 'CORBETT ROAD TACTICAL OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPRA',
    Issuer: 'OPERA LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPRT',
    Issuer: 'OPORTUN FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPRX',
    Issuer: 'OPTIMIZERX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPT',
    Issuer: 'OPTHEA LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPTN',
    Issuer: 'OPTINOSE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPTT',
    Issuer: 'OCEAN POWER TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OPY',
    Issuer: 'OPPENHEIMER HOLDINGS-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OR',
    Issuer: 'OSISKO GOLD ROYALTIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORA',
    Issuer: 'ORMAT TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORAN',
    Issuer: 'ORANGE-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORC',
    Issuer: 'ORCHID ISLAND CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORCC',
    Issuer: 'OWL ROCK CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORCL',
    Issuer: 'ORACLE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORFN',
    Issuer: 'CONSTRAINED CAPITAL ESG ORPH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORGN',
    Issuer: 'ORIGIN MATERIALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORGNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORGO',
    Issuer: 'ORGANOGENESIS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORGS',
    Issuer: 'ORGENESIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORI',
    Issuer: 'OLD REPUBLIC INTL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORIA',
    Issuer: 'ORION BIOTECH OPPORTUNITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORIAU',
    Issuer: 'ORION BIOTECH OPPORTUNITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORIAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORIC',
    Issuer: 'ORIC PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORLA',
    Issuer: 'ORLA MINING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORLY',
    Issuer: "O'REILLY AUTOMOTIVE INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORMP',
    Issuer: 'ORAMED PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORN',
    Issuer: 'ORION GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORRF',
    Issuer: 'ORRSTOWN FINL SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ORTX',
    Issuer: 'ORCHARD THERAPEUTICS PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSBC',
    Issuer: 'OLD SECOND BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSCR',
    Issuer: 'OSCAR HEALTH INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSCV',
    Issuer: 'OPUS SMALL CAP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSG',
    Issuer: 'OVERSEAS SHIPHOLDING GROUP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSH',
    Issuer: 'OAK STREET HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSI',
    Issuer: 'OSIRIS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSI=',
    Issuer: 'OSIRIS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSIS',
    Issuer: 'OSI SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSK',
    Issuer: 'OSHKOSH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSPN',
    Issuer: 'ONESPAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSS',
    Issuer: 'ONE STOP SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OST',
    Issuer: 'OSTIN TECHNOLOGY GROUP CO LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSTK',
    Issuer: 'OVERSTOCK.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSTR',
    Issuer: 'OYSTER ENTERPRISES-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSTRU',
    Issuer: 'OYSTER ENTERPRISES ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSTRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSUR',
    Issuer: 'ORASURE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OSW',
    Issuer: 'ONESPAWORLD HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTEC',
    Issuer: 'OCEANTECH ACQUISITIONS- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTECU',
    Issuer: 'OCEANTECH ACQUISITIONS I COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTECW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTEX',
    Issuer: 'OPEN TEXT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTIC',
    Issuer: 'OTONOMY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTIS',
    Issuer: 'OTIS WORLDWIDE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTLK',
    Issuer: 'OUTLOOK THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTLY',
    Issuer: 'OATLY GROUP AB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTMO',
    Issuer: 'OTONOMO TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTMOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTRK',
    Issuer: 'ONTRAK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTRKP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OTTR',
    Issuer: 'OTTER TAIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUNZ',
    Issuer: 'VANECK MERK GOLD TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUSA',
    Issuer: 'OSHARES U.S QUALITY DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUSM',
    Issuer: 'OSHARES U.S. SMALL-CAP QUALI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUST',
    Issuer: 'OUSTER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUST+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OUT',
    Issuer: 'OUTFRONT MEDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVB',
    Issuer: 'OVERLAY SHARES CORE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVBC',
    Issuer: 'OHIO VALLEY BANC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVF',
    Issuer: 'OVERLAY SHARES FOREIGN EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVID',
    Issuer: 'OVID THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVL',
    Issuer: 'OVERLAY SHARES LARGE CAP EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVLH',
    Issuer: 'OVERLAY SHRS HDG LRG CAP EQY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVLY',
    Issuer: 'OAK VALLEY BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVM',
    Issuer: 'OVERLAY SHARES MUNICIPAL BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVS',
    Issuer: 'OVERLAY SHARES SMALL CAP EQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVT',
    Issuer: 'OVERLAY SHARES SHRT TERM BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OVV',
    Issuer: 'OVINTIV INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OWL',
    Issuer: 'BLUE OWL CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OWL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OWLT',
    Issuer: 'OWLET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OWLT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OWNS',
    Issuer: 'IMPACT SHARES AFFORDABLE HOU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXAC',
    Issuer: 'OXBRIDGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXACU',
    Issuer: 'OXBRIDGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXBR',
    Issuer: 'OXBRIDGE RE HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXBRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLC',
    Issuer: 'OXFORD LANE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLCL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLCM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLCO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXLCZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXM',
    Issuer: 'OXFORD INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXSQ',
    Issuer: 'OXFORD SQUARE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXSQG',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXSQL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXSQZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXUS',
    Issuer: 'OXUS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXUSU',
    Issuer: 'OXUS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXUSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXY',
    Issuer: 'OCCIDENTAL PETROLEUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OXY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OYST',
    Issuer: 'OYSTER POINT PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OZ',
    Issuer: 'BELPOINTE PREP LLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OZK',
    Issuer: 'BANK OZK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OZKAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'OZON',
    Issuer: 'OZON HOLDINGS PLC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAA',
    Issuer: 'PLAINS ALL AMER PIPELINE LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAAS',
    Issuer: 'PAN AMERICAN SILVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAB',
    Issuer: 'PGIM ACT AGGRG BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PABU',
    Issuer: 'ISHARES PARIS - ALIG CLI MUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAC',
    Issuer: 'GRUPO AEROPORTUARIO PAC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACB',
    Issuer: 'PACIFIC BIOSCIENCES OF CALIF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACI',
    Issuer: 'PROOF ACQUISITION CORP I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACI=',
    Issuer: 'PROOF ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACK',
    Issuer: 'RANPAK HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACW',
    Issuer: 'PACWEST BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACX',
    Issuer: 'PIONEER MERGER CORP -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACXU',
    Issuer: 'PIONEER MERGER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PACXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAFO',
    Issuer: 'PACIFICO ACQUISTION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAFOR',
    Issuer: 'PACIFICO ACQUISITION COR-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAFOU',
    Issuer: 'PACIFICO ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAG',
    Issuer: 'PENSKE AUTOMOTIVE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAGP',
    Issuer: 'PLAINS GP HOLDINGS LP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAGS',
    Issuer: 'PAGSEGURO DIGITAL LTD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAHC',
    Issuer: 'PHIBRO ANIMAL HEALTH CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAI',
    Issuer: 'WESTERN ASSET INVESTMENT GRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAK',
    Issuer: 'GLOBAL X MSCI PAKISTAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PALC',
    Issuer: 'PACER LUNT LRG CAP MULTI-FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PALI',
    Issuer: 'PALISADE BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PALL',
    Issuer: 'ABRDN PALLADIUM ETF TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PALT',
    Issuer: 'PALTALK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAM',
    Issuer: 'PAMPA ENERGIA SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAMC',
    Issuer: 'PACER LUNT MIDCAP MULT-FACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PANA',
    Issuer: 'PANACEA ACQUISITION CORPII-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PANL',
    Issuer: 'PANGAEA LOGISTICS SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PANW',
    Issuer: 'PALO ALTO NETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAPR',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAQC',
    Issuer: 'PROVIDENT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAQCU',
    Issuer: 'PROVIDENT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAQCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAR',
    Issuer: 'PAR TECHNOLOGY CORP/DEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PARA',
    Issuer: 'PARAMOUNT GLOBAL-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PARAA',
    Issuer: 'PARAMOUNT GLOBAL-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PARAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PARR',
    Issuer: 'PAR PACIFIC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PASG',
    Issuer: 'PASSAGE BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PATH',
    Issuer: 'UIPATH INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PATI',
    Issuer: 'PATRIOT TRANSPORTATION HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PATK',
    Issuer: 'PATRICK INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAUG',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAVE',
    Issuer: 'GLOBAL X US INFRASTRUCTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAVM',
    Issuer: 'PAVMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAVMZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAWZ',
    Issuer: 'PROSHARES PET CARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAX',
    Issuer: 'PATRIA INVESTMENTS LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAXS',
    Issuer: 'PIMCO ACCESS INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAY',
    Issuer: 'PAYMENTUS HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYA',
    Issuer: 'PAYA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYC',
    Issuer: 'PAYCOM SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYO',
    Issuer: 'PAYONEER GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYS',
    Issuer: 'PAYSIGN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PAYX',
    Issuer: 'PAYCHEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PB',
    Issuer: 'PROSPERITY BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBA',
    Issuer: 'PEMBINA PIPELINE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBAX',
    Issuer: 'PHOENIX BIOTECH ACQUISI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBAXU',
    Issuer: 'PHOENIX BIOTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBBK',
    Issuer: 'PB BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBD',
    Issuer: 'INVESCO GLOBAL CLEAN ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBDM',
    Issuer: 'INVESCO PUREBETA FTSE DEVELO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBE',
    Issuer: 'INVESCO DYNAMIC BIOTECHNOLOG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBEE',
    Issuer: 'INVESCO PUREBETA FTSE EMERGI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBF',
    Issuer: 'PBF ENERGY INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBFS',
    Issuer: 'PIONEER BANCORP INC/NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBFX',
    Issuer: 'PBF LOGISTICS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBH',
    Issuer: 'PRESTIGE CONSUMER HEALTHCARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBHC',
    Issuer: 'PATHFINDER BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBI',
    Issuer: 'PITNEY BOWES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBI-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBIP',
    Issuer: 'PRUDENTIAL BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBJ',
    Issuer: 'INVESCO DYNAMIC FOOD & BEVER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBLA',
    Issuer: 'PANBELA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBND',
    Issuer: 'INVESCO PUREBETA US AGGREGAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBP',
    Issuer: 'INVESCO S&P 500 BUYWRITE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBPB',
    Issuer: 'POTBELLY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBR',
    Issuer: 'PETROLEO BRASILEIRO-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBR.A',
    Issuer: 'PETROLEO BRASIL-SP PREF  ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBS',
    Issuer: 'INVESCO DYNAMIC MEDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBSM',
    Issuer: 'INVESCO PUREBETA MSCI USA SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBT',
    Issuer: 'PERMIAN BASIN ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBTP',
    Issuer: 'INVESCO PUREBETA 0-5 YR US T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBTS',
    Issuer: 'POWERBRIDGE TECHNOLOGIES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBUG',
    Issuer: 'PACER IPATH GOLD TRENDPILOT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBUS',
    Issuer: 'INVESCO PUREBETA MSCI USA ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBW',
    Issuer: 'INVESCO WILDERHILL CLEAN ENE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PBYI',
    Issuer: 'PUMA BIOTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCAR',
    Issuer: 'PACCAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCB',
    Issuer: 'PCB BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCCT',
    Issuer: 'PERCEPTION CAPITAL CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCCTU',
    Issuer: 'PERCEPTION CAPITAL CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCCTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCEF',
    Issuer: 'INVESCO CEF INCOME COMPOSITE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCF',
    Issuer: 'HIGH INCOME SECURITIES FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG',
    Issuer: 'P G & E CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCG-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCGU',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCH',
    Issuer: 'POTLATCHDELTIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCK',
    Issuer: 'PIMCO CALIFORNIA MUNICIPA II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCM',
    Issuer: 'PCM FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCN',
    Issuer: 'PIMCO CORPORATE & INCOME STR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCOM',
    Issuer: 'POINTS.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCOR',
    Issuer: 'PROCORE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCPC',
    Issuer: 'PERIPHAS CAPITAL PARTNR-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCPC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCPC=',
    Issuer: 'PERIPHAS CAPITAL PARTNERING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCQ',
    Issuer: 'PIMCO CALIFORNIA MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCRX',
    Issuer: 'PACIRA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCSA',
    Issuer: 'PROCESSA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCSB',
    Issuer: 'PCSB FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCT',
    Issuer: 'PURECYCLE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCTI',
    Issuer: 'PCTEL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCTTU',
    Issuer: 'PURECYCLE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCTTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCTY',
    Issuer: 'PAYLOCITY HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCVX',
    Issuer: 'VAXCYTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCX',
    Issuer: 'PARSEC CAPITAL ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCXCU',
    Issuer: 'PARSEC CAPITAL ACQUISITIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCXCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCY',
    Issuer: 'INVESCO EMERGING MARKETS SOV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCYG',
    Issuer: 'PARK CITY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PCYO',
    Issuer: 'PURE CYCLE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PD',
    Issuer: 'PAGERDUTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDBC',
    Issuer: 'INVESCO OPTIMUM YIELD DIVERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDCE',
    Issuer: 'PDC ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDCO',
    Issuer: 'PATTERSON COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDD',
    Issuer: 'PINDUODUO INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDEC',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDEX',
    Issuer: 'PRO-DEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDFS',
    Issuer: 'PDF SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDI',
    Issuer: 'PIMCO DYNAMIC INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDLB',
    Issuer: 'PONCE FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDM',
    Issuer: 'PIEDMONT OFFICE REALTY TRU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDN',
    Issuer: 'INVESCO FTSE RAFI DEVELOPED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDO',
    Issuer: 'PIMCO DYNAMIC INCOME OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDOT',
    Issuer: 'PERIDOT ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDOT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDOT=',
    Issuer: 'PERIDOT ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDP',
    Issuer: 'INVESCO DWA MOMENTUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDS',
    Issuer: 'PRECISION DRILLING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDSB',
    Issuer: 'PDS BIOTECHNOLOGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PDT',
    Issuer: 'JOHN HAN PREMIUM DIVIDEND FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEAK',
    Issuer: 'HEALTHPEAK PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEAR',
    Issuer: 'PEAR THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEARW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEB',
    Issuer: 'PEBBLEBROOK HOTEL TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEB-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEB-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEB-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEB-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEBK',
    Issuer: 'PEOPLES BANCORP OF NC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEBO',
    Issuer: 'PEOPLES BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PECO',
    Issuer: 'PHILLIPS EDISON & COMPANY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PED',
    Issuer: 'PEDEVCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEG',
    Issuer: 'PUBLIC SERVICE ENTERPRISE GP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEGA',
    Issuer: 'PEGASYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEGR',
    Issuer: 'PROJECT ENERGY REIMAGINED AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEGRU',
    Issuer: 'PROJECT ENERGY REIMAGINED AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEGRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEGY',
    Issuer: 'PINEAPPLE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEI',
    Issuer: 'PENN REAL ESTATE INVEST TST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEI-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEI-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEI-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEJ',
    Issuer: 'INVESCO DYNAMIC LEISURE AND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEN',
    Issuer: 'PENUMBRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PENN',
    Issuer: 'PENN NATIONAL GAMING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEO',
    Issuer: 'ADAMS NATURAL RESOURCES FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEP',
    Issuer: 'PEPSICO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEPG',
    Issuer: 'PEPGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEPL',
    Issuer: 'PEPPERLIME HEALTH ACQ - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEPLU',
    Issuer: 'PEPPERLIME HEALTH ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEPLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PERI',
    Issuer: 'PERION NETWORK LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PESI',
    Issuer: 'PERMA-FIX ENVIRONMENTAL SVCS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PETQ',
    Issuer: 'PETIQ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PETS',
    Issuer: 'PETMED EXPRESS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PETV',
    Issuer: 'PETVIVO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PETVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PETZ',
    Issuer: 'TDH HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEX',
    Issuer: 'PROSHARES GLOBAL LISTED PRIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEXL',
    Issuer: 'PACER US EXPORT LEADERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEY',
    Issuer: 'INVESCO HIGH YIELD EQUITY DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PEZ',
    Issuer: 'INVESCO DWA CONSUMER CYCLICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFBC',
    Issuer: 'PREFERRED BANK/LOS ANGELES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFC',
    Issuer: 'PREMIER FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFD',
    Issuer: 'FLAHERTY & CRUMRINE PREFERRE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFDR',
    Issuer: 'PATHFINDER ACQUISITION -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFDRU',
    Issuer: 'PATHFINDER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFDRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFE',
    Issuer: 'PFIZER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFEB',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFF',
    Issuer: 'ISHARES PREFERRED & INCOME S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFFA',
    Issuer: 'VIRTUS INFRACAP US PFD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFFD',
    Issuer: 'GLOBAL X US PREFERRED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFFL',
    Issuer: 'ETRACS MON PAY 2XLEV PREFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFFR',
    Issuer: 'INFRACAP REIT PREFERRED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFFV',
    Issuer: 'GLOBAL X VARIABLE RATE PREF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFG',
    Issuer: 'PRINCIPAL FINANCIAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFGC',
    Issuer: 'PERFORMANCE FOOD GROUP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFH',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFHC',
    Issuer: 'PROFRAC HOLDING CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFHD',
    Issuer: 'PROFESSIONAL HOLDING CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFI',
    Issuer: 'INVESCO DWA FINANCIAL MOMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFIE',
    Issuer: 'PROFIRE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFIG',
    Issuer: 'INVESCO FUNDAMENTAL INVESTME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFIN',
    Issuer: 'P & F INDUSTRIES -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFIS',
    Issuer: 'PEOPLES FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFIX',
    Issuer: 'SIMPLIFY INTEREST RATE HEDGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFL',
    Issuer: 'PIMCO INCOME STRATEGY FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFLD',
    Issuer: 'AAM LOW DUR PREF & INC SEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFLT',
    Issuer: 'PENNANTPARK FLOATING RATE CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFM',
    Issuer: 'INVESCO DIVIDEND ACHIEVERS E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFMT',
    Issuer: 'PERFORMANT FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFN',
    Issuer: 'PIMCO INCOME STRATEGY FD II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFO',
    Issuer: 'FLAHERTY & CRUMRINE PREFERRE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFRL',
    Issuer: 'PGIM FLOATING RATE INCOME ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFS',
    Issuer: 'PROVIDENT FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFSI',
    Issuer: 'PENNYMAC FINANCIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFSW',
    Issuer: 'PFSWEB INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFTA',
    Issuer: 'PORTAGE FINTECH ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFTAU',
    Issuer: 'PORTAGE FINTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFTAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFUT',
    Issuer: 'PUTNAM SUSTAINABLE FUTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFX',
    Issuer: 'PHENIXFIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFXF',
    Issuer: 'VANECK PREF SEC X-FINANCIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFXNL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PFXNZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PG',
    Issuer: 'PROCTER & GAMBLE CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGAL',
    Issuer: 'GLOBAL X MSCI PORTUGAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGC',
    Issuer: 'PEAPACK GLADSTONE FINL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGEN',
    Issuer: 'PRECIGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGF',
    Issuer: 'INVESCO FINANCIAL PREFERRED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGHY',
    Issuer: 'INVESCO GLOBAL SHORT TERM HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGJ',
    Issuer: 'INVESCO GOLDEN DRAGON CHINA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGM',
    Issuer: 'IPATH SERIES B BBG PLATINUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGNY',
    Issuer: 'PROGYNY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGP',
    Issuer: 'PIMCO GLOBAL STOCKSPLUS & IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGR',
    Issuer: 'PROGRESSIVE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRE',
    Issuer: 'PARAMOUNT GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRO',
    Issuer: 'PUTNAM FOCUSED LRG CAP GROW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRU',
    Issuer: 'PROPERTYGURU GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRW',
    Issuer: 'PROGRESS ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRWU',
    Issuer: 'PROGRESS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGRWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGSS',
    Issuer: 'PEGASUS DIGITAL MOBILITY A-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGSS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGSS=',
    Issuer: 'PEGASUS DIGITAL MOBILITY ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGTI',
    Issuer: 'PGT INNOVATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGX',
    Issuer: 'INVESCO PREFERRED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PGZ',
    Issuer: 'PRINCIPAL REAL ESTATE INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PH',
    Issuer: 'PARKER HANNIFIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHAR',
    Issuer: 'PHARMING GROUP NV - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHAS',
    Issuer: 'PHASEBIO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHAT',
    Issuer: 'PHATHOM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHB',
    Issuer: 'INVESCO FUNDAMENTAL HIGH YIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHCF',
    Issuer: 'PUHUI WEALTH INVESTMENT MANA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHD',
    Issuer: 'PIONEER FLOATING RATE FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHDG',
    Issuer: 'INVESCO S&P 500 DOWNSIDE HED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHG',
    Issuer: 'KONINKLIJKE PHILIPS NVR- NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHGE',
    Issuer: 'BIOMX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHGE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHGE=',
    Issuer: 'BIOMX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHI',
    Issuer: 'PLDT INC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHIC',
    Issuer: 'POPULATION HEALTH INVEST-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHICU',
    Issuer: 'POPULATION HEALTH INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHIO',
    Issuer: 'PHIO PHARMACEUTICALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHK',
    Issuer: 'PIMCO HIGH INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHM',
    Issuer: 'PULTEGROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHO',
    Issuer: 'INVESCO WATER RESOURCES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHR',
    Issuer: 'PHREESIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHT',
    Issuer: 'PIONEER HIGH INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHUN',
    Issuer: 'PHUNWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHUNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHVS',
    Issuer: 'PHARVARIS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHX',
    Issuer: 'PHX MINERALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHYL',
    Issuer: 'PGIM ACTIVE HIGH YIELD BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHYS',
    Issuer: 'SPROTT PHYSICAL GOLD TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHYT',
    Issuer: 'PYROPHYTE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHYT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PHYT=',
    Issuer: 'PYROPHYTE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PI',
    Issuer: 'IMPINJ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIAI',
    Issuer: 'PRIME IMPACT ACQU I -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIAI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIAI=',
    Issuer: 'PRIME IMPACT ACQUISITION I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PICB',
    Issuer: 'INVESCO INTERNATIONAL CORPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PICC',
    Issuer: 'PIVOTAL INVESTMENT CORPIII-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PICC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PICC=',
    Issuer: 'PIVOTAL INVESTMENT CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PICK',
    Issuer: 'ISHARES MSCI GLOBAL METALS &',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PID',
    Issuer: 'INVESCO INTERNATIONAL DIVIDE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIE',
    Issuer: 'INVESCO DWA EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIFI',
    Issuer: 'CLEARSHARES PITON INT FI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PII',
    Issuer: 'POLARIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIII',
    Issuer: 'P3 HEALTH PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIK',
    Issuer: 'KIDPIK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PILL',
    Issuer: 'DIREXION DLY PHARMA BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIM',
    Issuer: 'PUTNAM MASTER INTER INC TST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIN',
    Issuer: 'INVESCO INDIA EXCHANGE-TRADE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PINC',
    Issuer: 'PREMIER INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PINE',
    Issuer: 'ALPINE INCOME PROPERTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PING',
    Issuer: 'PING IDENTITY HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PINK',
    Issuer: 'SIMPLIFY HEALTH CARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PINS',
    Issuer: 'PINTEREST INC- CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIO',
    Issuer: 'INVESCO GLOBAL WATER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIPP',
    Issuer: 'PINE ISLAND ACQUISITION-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIPP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIPP=',
    Issuer: 'PINE ISLAND ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIPR',
    Issuer: 'PIPER SANDLER COS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIRS',
    Issuer: 'PIERIS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIXY',
    Issuer: 'SHIFTPIXY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PIZ',
    Issuer: 'INVESCO DWA DEVELOPED MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PJAN',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PJP',
    Issuer: 'INVESCO DYNAMIC PHARMACEUTIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PJT',
    Issuer: 'PJT PARTNERS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PJUL',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PJUN',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PK',
    Issuer: 'PARK HOTELS & RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKB',
    Issuer: 'INVESCO DYNAMIC BUILDING & C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKBK',
    Issuer: 'PARKE BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKE',
    Issuer: 'PARK AEROSPACE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKG',
    Issuer: 'PACKAGING CORP OF AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKI',
    Issuer: 'PERKINELMER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKOH',
    Issuer: 'PARK-OHIO HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKW',
    Issuer: 'INVESCO BUYBACK ACHIEVERS ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PKX',
    Issuer: 'POSCO HOLDINGS INC -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PL',
    Issuer: 'PLANET LABS PBC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAB',
    Issuer: 'PHOTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAG',
    Issuer: 'PLANET GREEN HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAN',
    Issuer: 'ANAPLAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAO',
    Issuer: 'PATRIA LATIN AMERICAN OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAOU',
    Issuer: 'PATRIA LATIN AMERICAN OPPORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAT',
    Issuer: 'WISDOMTREE GROWTH LEADERS FU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLAY',
    Issuer: "DAVE & BUSTER'S ENTERTAINMEN",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLBC',
    Issuer: 'PLUMAS BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLBY',
    Issuer: 'PLBY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLCE',
    Issuer: "CHILDREN'S PLACE INC/THE",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLD',
    Issuer: 'PROLOGIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLDR',
    Issuer: 'PUTNAM SUSTAINABLE LEADERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLG',
    Issuer: 'PLATINUM GROUP METALS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLL',
    Issuer: 'PIEDMONT LITHIUM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLM',
    Issuer: 'POLYMET MINING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLMI',
    Issuer: 'PLUM ACQUISITION CORP I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLMIU',
    Issuer: 'PLUM ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLMIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLMR',
    Issuer: 'PALOMAR HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLNT',
    Issuer: 'PLANET FITNESS INC - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLOW',
    Issuer: 'DOUGLAS DYNAMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLPC',
    Issuer: 'PREFORMED LINE PRODUCTS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLRG',
    Issuer: 'PRINCIPAL US LC ADAPT MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLRX',
    Issuer: 'PLIANT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLSE',
    Issuer: 'PULSE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLTK',
    Issuer: 'PLAYTIKA HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLTL',
    Issuer: 'PRINCIPAL US SC ADAPT MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLTM',
    Issuer: 'GRANITESHARES PLATINUM TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLTR',
    Issuer: 'PALANTIR TECHNOLOGIES INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLUG',
    Issuer: 'PLUG POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLUS',
    Issuer: 'EPLUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLW',
    Issuer: 'INVESCO 1-30 LADDERED TREASU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLX',
    Issuer: 'PROTALIX BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLXP',
    Issuer: 'PLX PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLXS',
    Issuer: 'PLEXUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLYA',
    Issuer: 'PLAYA HOTELS & RESORTS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLYM',
    Issuer: 'PLYMOUTH INDUSTRIAL REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PLYM-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PM',
    Issuer: 'PHILIP MORRIS INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMAR',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMAY',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMCB',
    Issuer: 'PHARMACYTE BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMD',
    Issuer: 'PSYCHEMEDICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PME',
    Issuer: 'PINGTAN MARINE ENTERPRISE LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMF',
    Issuer: 'PIMCO MUNICIPAL INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMGM',
    Issuer: 'PRIVETERRA ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMGMU',
    Issuer: 'PRIVETERRA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMGMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PML',
    Issuer: 'PIMCO MUNICIPAL INCOME FD II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMM',
    Issuer: 'PUTNAM MANAGED MUNI INCM TRS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMO',
    Issuer: 'PUTNAM MUNI OPPORTUNITIES TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMT',
    Issuer: 'PENNYMAC MORTGAGE INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMT-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMT-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMTS',
    Issuer: 'CPI CARD GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMVC',
    Issuer: 'PMV CONSUMER ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMVC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMVC=',
    Issuer: 'PMV CONSUMER ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMVP',
    Issuer: 'PMV PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PMX',
    Issuer: 'PIMCO MUNI INCOME FUND III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNACU',
    Issuer: 'PRIME NUMBER ACQUISITION I C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNBK',
    Issuer: 'PATRIOT NATIONAL BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNC',
    Issuer: 'PNC FINANCIAL SERVICES GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNC-P',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNF',
    Issuer: 'PIMCO NEW YORK MUNI INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNFP',
    Issuer: 'PINNACLE FINANCIAL PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNFPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNI',
    Issuer: 'PIMCO NEW YORK MUNICIPAL II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNM',
    Issuer: 'PNM RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNNT',
    Issuer: 'PENNANTPARK INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNOV',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNQI',
    Issuer: 'INVESCO NASDAQ INTERNET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNR',
    Issuer: 'PENTAIR PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNRG',
    Issuer: 'PRIMEENERGY RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNT',
    Issuer: 'POINT BIOPHARMA GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNTG',
    Issuer: 'PENNANT GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNTM',
    Issuer: 'PONTEM CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNTM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNTM=',
    Issuer: 'PONTEM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PNW',
    Issuer: 'PINNACLE WEST CAPITAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POAI',
    Issuer: 'PREDICTIVE ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POCT',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PODD',
    Issuer: 'INSULET CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POET',
    Issuer: 'POET TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POLA',
    Issuer: 'POLAR POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POLY',
    Issuer: 'PLANTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POND',
    Issuer: 'ANGEL POND HOLDINGS CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POND+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POND=',
    Issuer: 'ANGEL POND HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PONO',
    Issuer: 'PONO CAPITAL CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PONOU',
    Issuer: 'PONO CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PONOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POOL',
    Issuer: 'POOL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POR',
    Issuer: 'PORTLAND GENERAL ELECTRIC CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PORT',
    Issuer: 'SOUTHPORT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PORT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PORT=',
    Issuer: 'SOUTHPORT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POSH',
    Issuer: 'POSHMARK INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POST',
    Issuer: 'POST HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POTX',
    Issuer: 'GLOBAL X CANNABIS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POW',
    Issuer: 'POWERED BRANDS - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWI',
    Issuer: 'POWER INTEGRATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWL',
    Issuer: 'POWELL INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWRU',
    Issuer: 'POWERED BRANDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWW',
    Issuer: 'AMMO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'POWWP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPA',
    Issuer: 'INVESCO AEROSPACE & DEFENSE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPBI',
    Issuer: 'PACIFIC PREMIER BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPBT',
    Issuer: 'PURPLE BIOTECH LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPC',
    Issuer: "PILGRIM'S PRIDE CORP",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPG',
    Issuer: 'PPG INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPH',
    Issuer: 'VANECK PHARMACEUTICAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPHP',
    Issuer: 'PHP VENTURES ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPHPR',
    Issuer: 'PHP VENTURES ACQUISITION-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPHPU',
    Issuer: 'PHP VENTURES ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPHPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPI',
    Issuer: 'AXS ASTORIA INFLATION SENS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPIH',
    Issuer: 'PERMA-PIPE INTERNATIONAL HOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPL',
    Issuer: 'PPL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPLT',
    Issuer: 'ABRDN PLATINUM ETF TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPSI',
    Issuer: 'PIONEER POWER SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPT',
    Issuer: 'PUTNAM PREMIER INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPTA',
    Issuer: 'PERPETUA RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPTY',
    Issuer: 'US DIVERSIFIED REAL ESTATE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPYA',
    Issuer: 'PAPAYA GROWTH OPPORTUNI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPYAU',
    Issuer: 'PAPAYA GROWTH OPPORTUNITY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PPYAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PQDI',
    Issuer: 'PRINCIPAL SPECTRUM TAX-ADVAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PQIN',
    Issuer: 'PGIM QUANT SOLUTIONS STRATEG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRA',
    Issuer: 'PROASSURANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRAA',
    Issuer: 'PRA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRAX',
    Issuer: 'PRAXIS PRECISION MEDICINES I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRAY',
    Issuer: 'FIS BIBLICALLY RESPONSIBLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRBM',
    Issuer: 'PARABELLUM ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRBM+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRBM=',
    Issuer: 'PARABELLUM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRCH',
    Issuer: 'PORCH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRCT',
    Issuer: 'PROCEPT BIOROBOTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRDO',
    Issuer: 'PERDOCEO EDUCATION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRDS',
    Issuer: 'PARDES BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRE',
    Issuer: 'PRENETICS GLOBAL LTD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRE-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PREF',
    Issuer: 'PRNCPAL SPCTRM PREF SEC ACTV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRENW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRF',
    Issuer: 'INVESCO FTSE RAFI US 1000 ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRFT',
    Issuer: 'PERFICIENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRFX',
    Issuer: 'PAINREFORM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRFZ',
    Issuer: 'INVESCO FTSE RAFI US 1500 SM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRG',
    Issuer: 'PROG HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRGO',
    Issuer: 'PERRIGO CO PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRGS',
    Issuer: 'PROGRESS SOFTWARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRI',
    Issuer: 'PRIMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIF-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRIM',
    Issuer: 'PRIMORIS SERVICES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRK',
    Issuer: 'PARK NATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRLB',
    Issuer: 'PROTO LABS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRLD',
    Issuer: 'PRELUDE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRLH',
    Issuer: 'PEARL HOLDINGS ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRLHU',
    Issuer: 'PEARL HOLDINGS ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRLHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRM',
    Issuer: 'PERIMETER SOLUTIONS SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRMW',
    Issuer: 'PRIMO WATER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRN',
    Issuer: 'INVESCO DWA INDUSTRIALS MOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRNT',
    Issuer: 'THE 3D PRINTING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRO',
    Issuer: 'PROS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PROC',
    Issuer: 'PROCAPS GROUP SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PROCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PROF',
    Issuer: 'PROFOUND MEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PROV',
    Issuer: 'PROVIDENT FINANCIAL HLDGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPB',
    Issuer: 'CC NEUBERGER PRINCIPAL II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPB=',
    Issuer: 'CC NEUBERGER PRINCIPAL HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPC',
    Issuer: 'CC NEUBERGER PRINCIPAL III-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPC=',
    Issuer: 'CC NEUBERGER PRINCIPAL HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPH',
    Issuer: 'PROPHASE LABS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPL',
    Issuer: 'PURPLE INNOVATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRPO',
    Issuer: 'PRECIPIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRQR',
    Issuer: 'PROQR THERAPEUTICS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRS',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRSO',
    Issuer: 'PERASO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRSR',
    Issuer: 'PROSPECTOR CAPITAL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRSRU',
    Issuer: 'PROSPECTOR CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRSRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRT',
    Issuer: 'PERMROCK ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTA',
    Issuer: 'PROTHENA CORP PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTC',
    Issuer: 'PURETECH HEALTH PLC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTG',
    Issuer: 'PORTAGE BIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTH',
    Issuer: 'PRIORITY TECHNOLOGY HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTK',
    Issuer: 'PARATEK PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTS',
    Issuer: 'CARPARTS.COM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRTY',
    Issuer: 'PARTY CITY HOLDCO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRU',
    Issuer: 'PRUDENTIAL FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRVA',
    Issuer: 'PRIVIA HEALTH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PRVB',
    Issuer: 'PROVENTION BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA',
    Issuer: 'PUBLIC STORAGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-P',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-R',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSA-S',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSAG',
    Issuer: 'PROPERTY SOLUTIONS ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSAGU',
    Issuer: 'PROPERTY SOLUTIONS ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSAGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSB',
    Issuer: 'PS BUSINESS PARKS INC/MD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSB-X',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSB-Y',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSB-Z',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSC',
    Issuer: 'PRINCIPAL US SMALL-CAP MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCC',
    Issuer: 'INVESCO S&P SMALLCAP CONSUME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCD',
    Issuer: 'INVESCO S&P SMALLCAP CONSUME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCE',
    Issuer: 'INVESCO S&P SMALLCAP ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCF',
    Issuer: 'INVESCO S&P SMALLCAP FINANCI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCH',
    Issuer: 'INVESCO S&P SMALLCAP HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCI',
    Issuer: 'INVESCO S&P SMALLCAP INDUSTR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCJ',
    Issuer: 'PACER SWAN SOS CONSERVATIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCM',
    Issuer: 'INVESCO S&P SMALLCAP MATERIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCQ',
    Issuer: 'PACER SWAN SOS CONS OCT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCT',
    Issuer: 'INVESCO S&P SMALLCAP INFORMA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCU',
    Issuer: 'INVESCO S&P S C U&C SER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCW',
    Issuer: 'PACER SWAN SOS CONSERV APR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSCX',
    Issuer: 'PACER SWAN SOS CONSERVATIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSDN',
    Issuer: 'ADVISORSHARES POS DYN CANNAB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSEC',
    Issuer: 'PROSPECT CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSEC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSEP',
    Issuer: 'INNOVATOR U.S. EQUITY POWER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSET',
    Issuer: 'PRINCIPAL QUALITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSF',
    Issuer: 'COHEN & STEERS SELECT PREFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFD',
    Issuer: 'PACER SWAN SOS FLEX JANUARY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFE',
    Issuer: 'PAYSAFE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFF',
    Issuer: 'PACER SWAN SOS FUND OF FUNDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFJ',
    Issuer: 'PACER SWAN SOS FLEX JULY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFM',
    Issuer: 'PACER SWAN SOS FLEX APRIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSFO',
    Issuer: 'PACER SWAN SOS FLEX OCT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSHG',
    Issuer: 'PERFORMANCE SHIPPING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSI',
    Issuer: 'INVESCO DYNAMIC SEMICONDUCTO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSIL',
    Issuer: 'ADVISORSHARES PSYCHEDELICS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSJ',
    Issuer: 'INVESCO DYNAMIC SOFTWARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSK',
    Issuer: 'SPDR ICE PREFERRED SECURITIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSL',
    Issuer: 'INVESCO DWA CONSUMER STAPLES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSLV',
    Issuer: 'SPROTT PHYSICAL SILVER TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMB',
    Issuer: 'INVESCO BALANCED MULTI-ASSET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMC',
    Issuer: 'INVESCO CONSERVATIVE MULTI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMD',
    Issuer: 'PACER SWAN SOS MODERATE JANU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMG',
    Issuer: 'INVESCO GROWTH MULTI-ASSET A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMJ',
    Issuer: 'PACER SWAN SOS MODERATE JULY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMM',
    Issuer: 'INVESCO MODERATELY CONSERVAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMO',
    Issuer: 'PACER SWAN SOS MOD OCT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMR',
    Issuer: 'PACER SWAN SOS MODERATE APR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSMT',
    Issuer: 'PRICESMART INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSN',
    Issuer: 'PARSONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSNL',
    Issuer: 'PERSONALIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSO',
    Issuer: 'PEARSON PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSP',
    Issuer: 'INVESCO GLOBAL LISTED PRIVAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSPC',
    Issuer: 'POST HOLDINGS PARTNERING -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSPC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSPC=',
    Issuer: 'POST HOLDINGS PARTNERING COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSQ',
    Issuer: 'PROSHARES SHORT QQQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSR',
    Issuer: 'INVESCO ACTIVE US REAL ESTAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PST',
    Issuer: 'PROSHARES ULTRASHORT 7-10 YR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTG',
    Issuer: 'PURE STORAGE INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTH',
    Issuer: 'PERSHING SQUARE TONTINE -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTI',
    Issuer: 'PLURISTEM THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTL',
    Issuer: 'POSTAL REALTY TRUST INC- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTP',
    Issuer: 'INNOVATOR PWR BUFF SU ST ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTV',
    Issuer: 'PLUS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSTX',
    Issuer: 'POSEIDA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSX',
    Issuer: 'PHILLIPS 66',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSY',
    Issuer: 'DEFIANCE NEXT GEN ALTERED EX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PSYK',
    Issuer: 'PSYK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PT',
    Issuer: 'PINTEC TECHNOLOGY HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTA',
    Issuer: 'COHEN & STEERS TAX-ADVANTAGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTBD',
    Issuer: 'PACER TRENDPILOT US BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTC',
    Issuer: 'PTC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTCT',
    Issuer: 'PTC THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTE',
    Issuer: 'POLARITYTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTEN',
    Issuer: 'PATTERSON-UTI ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTEU',
    Issuer: 'PACER TRENDPILOT EUROPEAN ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTF',
    Issuer: 'INVESCO DWA TECHNOLOGY MOMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTGX',
    Issuer: 'PROTAGONIST THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTH',
    Issuer: 'INVESCO DWA HEALTHCARE MOMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTIC',
    Issuer: 'PROPTECH INVESTMENT CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTICU',
    Issuer: 'PROPTECH INVESTMENT CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTICW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTIN',
    Issuer: 'PACER TRENDPILOT INTL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTIX',
    Issuer: 'PROTAGENIC THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTIXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTLC',
    Issuer: 'PACER TRENDPILOT US LARGE CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTLO',
    Issuer: "PORTILLO'S INC-CL A",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTMC',
    Issuer: 'PACER TRENDPILOT US MID CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTMN',
    Issuer: 'PORTMAN RIDGE FINANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTN',
    Issuer: 'PALATIN TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTNQ',
    Issuer: 'PACER TRENDPILOT 100 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTNR',
    Issuer: 'PARTNER COMMUNICATIONS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTOC',
    Issuer: 'PINE TECHNOLOGY ACQUISI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTOCU',
    Issuer: 'PINE TECHNOLOGY ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTOCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTON',
    Issuer: 'PELOTON INTERACTIVE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTPI',
    Issuer: 'PETROS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTR',
    Issuer: 'PETROCHINA CO LTD -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTRA',
    Issuer: 'PROTERRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTRB',
    Issuer: 'PGIM TOTAL RETURN BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTRS',
    Issuer: 'PARTNERS BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTSI',
    Issuer: 'P.A.M. TRANSPORTATION SVCS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTVE',
    Issuer: 'PACTIV EVERGREEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PTY',
    Issuer: 'PIMCO CORPORATE & INCOME OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUBM',
    Issuer: 'PUBMATIC INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUCK',
    Issuer: 'GOAL ACQUISITIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUCKU',
    Issuer: 'GOAL ACQUISITIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUCKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUI',
    Issuer: 'INVESCO DWA UTILITIES MOMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUK',
    Issuer: 'PRUDENTIAL PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PULM',
    Issuer: 'PULMATRIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PULS',
    Issuer: 'PGIM ULTRA SHORT BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUMP',
    Issuer: 'PROPETRO HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUNK',
    Issuer: 'SUBVERSIVE METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUTW',
    Issuer: 'WISDOMTREE CBOE S&P 500 PTWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PUYI',
    Issuer: 'PUYI INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PV',
    Issuer: 'PRIMAVERA CAPITAL ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PV=',
    Issuer: 'PRIMAVERA CAPITAL ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PVAL',
    Issuer: 'PUTNAM FOCUSED LRG CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PVBC',
    Issuer: 'PROVIDENT BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PVH',
    Issuer: 'PVH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PVI',
    Issuer: 'INVESCO VRDO TAX-FREE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PVL',
    Issuer: 'PERMIANVILLE ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PW',
    Issuer: 'POWER REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PW-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWB',
    Issuer: 'INVESCO DYNAMIC LARGE CAP GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWC',
    Issuer: 'INVESCO DYNAMIC MARKET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWFL',
    Issuer: 'POWERFLEET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWOD',
    Issuer: 'PENNS WOODS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWP',
    Issuer: 'PERELLA WEINBERG PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWPPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWR',
    Issuer: 'QUANTA SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWS',
    Issuer: 'PACER WEALTHSHIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWSC',
    Issuer: 'POWERSCHOOL HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWUP',
    Issuer: 'POWERUP ACQUISITION COR-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWUPU',
    Issuer: 'POWERUP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWUPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWV',
    Issuer: 'INVESCO DYNAMIC LARGE CAP VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PWZ',
    Issuer: 'INVESCO CALIFORNIA AMT-FREE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PX',
    Issuer: 'P10 INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXD',
    Issuer: 'PIONEER NATURAL RESOURCES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXE',
    Issuer: 'INVESCO DYNAMIC ENERGY EXPLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXF',
    Issuer: 'INVESCO FTSE RAFI DEVELOPED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXH',
    Issuer: 'INVESCO FTSE RAFI EMERGING M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXI',
    Issuer: 'INVESCO DWA ENERGY MOMENTUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXJ',
    Issuer: 'INVESCO DYNAMIC OIL & GAS SE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXLW',
    Issuer: 'PIXELWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXQ',
    Issuer: 'INVESCO DYNAMIC NETWORKING E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXS',
    Issuer: 'PYXIS TANKERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXSAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PXUS',
    Issuer: 'PRINCIPAL INT ADAP MULTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PY',
    Issuer: 'PRINCIPAL VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYCR',
    Issuer: 'PAYCOR HCM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYN',
    Issuer: 'PIMCO NEW YORK MUNICIPAL III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYPD',
    Issuer: 'POLYPID LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYPE',
    Issuer: 'ETRACS NYSE PICKENS CORE ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYPL',
    Issuer: 'PAYPAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYR',
    Issuer: 'PYROGENESIS CANADA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYS',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYXS',
    Issuer: 'PYXIS ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PYZ',
    Issuer: 'INVESCO DWA BASIC MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZA',
    Issuer: 'INVESCO NATIONAL AMT-FREE MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZC',
    Issuer: 'PIMCO CALIFORNIA MUNICIP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZG',
    Issuer: 'PARAMOUNT GOLD NEVADA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZN',
    Issuer: 'PZENA INVESTMENT MANAGM-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZT',
    Issuer: 'INVESCO NEW YORK AMT-FREE MU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'PZZA',
    Issuer: "PAPA JOHN'S INTL INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QABA',
    Issuer: 'FIRST TRUST NASDAQ ABA CBIF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QAI',
    Issuer: 'IQ HEDGE MULTI-STRAT TRACKER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QARP',
    Issuer: 'DBX ETF TRUST - XTRACKERS RU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QAT',
    Issuer: 'ISHARES MSCI QATAR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QCLN',
    Issuer: 'FIRST TRUST NASDAQ CLEAN EDG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QCLR',
    Issuer: 'GLOBAL X NASDAQ 100 COLLAR 9',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QCOM',
    Issuer: 'QUALCOMM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QCON',
    Issuer: 'AMERICAN CENT QUAL CONVT SEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QCRH',
    Issuer: 'QCR HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QD',
    Issuer: 'QUDIAN INC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDEC',
    Issuer: 'FT CBOE VEST NASDAQ-100 BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDEF',
    Issuer: 'FLEXSHARES QUALITY DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDEL',
    Issuer: 'QUIDEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDF',
    Issuer: 'FLEXSHARES QUALITY DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDIV',
    Issuer: 'GLOBAL X S&P 500 QLTY DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDPL',
    Issuer: 'PACER MET US LRG CAP DVD 400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QDYN',
    Issuer: 'FLEXSHARES QUALITY DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QED',
    Issuer: 'IQ HEDGE EVENT-DRIVEN TRACKE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QEFA',
    Issuer: 'SPDR MSCI EAFE STRATEGICFACT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QEMM',
    Issuer: 'SPDR MSCI EMERGING MARKETS S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QFIN',
    Issuer: '360 DIGITECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QFTA',
    Issuer: 'QUANTUM FINTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QFTA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QFTA=',
    Issuer: 'QUANTUM FINTECH ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QGEN',
    Issuer: 'QIAGEN N.V.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QGRO',
    Issuer: 'AMERICAN CENTURY STOXX US QL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QH',
    Issuer: 'QUHUO LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QID',
    Issuer: 'PROSHARES ULTRASHORT QQQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QINT',
    Issuer: 'AMERICAN CENTURY QLTY DIVER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QIPT',
    Issuer: 'QUIPT HOME MEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QIWI',
    Issuer: 'QIWI PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QJUN',
    Issuer: 'FT CBOE VEST NASDAQ-100 BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QK',
    Issuer: 'Q&K INTERNATIONAL GROUP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLC',
    Issuer: 'FLEXSHARES US QUALITY LG CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLD',
    Issuer: 'PROSHARES ULTRA QQQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLGN',
    Issuer: 'QUALIGEN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLI',
    Issuer: 'QILIAN INTERNATIONAL HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLS',
    Issuer: 'IQ HEDGE LONG/SHORT TRACKER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLTA',
    Issuer: 'ISHARES AAA - A RATED CORPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLV',
    Issuer: 'FLEXSHARES US QUALITY LOW VO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLVD',
    Issuer: 'FLEXSHARES DEVELOPED MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLVE',
    Issuer: 'FLEXSHARES EMERGING MARKETS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QLYS',
    Issuer: 'QUALYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QMAR',
    Issuer: 'FT CBOE VEST NASDAQ-100 BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QMCO',
    Issuer: 'QUANTUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QMN',
    Issuer: 'IQ HEDGE MARKET NEUT TRACK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QMOM',
    Issuer: 'ALPHA US QUANT MOM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QNGY',
    Issuer: 'QUANERGY SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QNGY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QNRX',
    Issuer: 'QUOIN PHARMACEUTICALS LT-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QNST',
    Issuer: 'QUINSTREET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QPFF',
    Issuer: 'AMERICAN CENTURY QUAL PREF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QPT',
    Issuer: 'ADVISORSHARES Q PORT BL ALLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QPX',
    Issuer: 'ADVISORSHARES Q DYN GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQC',
    Issuer: 'SIMPLIFY EXCHANGE TRADED FUN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQD',
    Issuer: 'SIMPLIFY EXCHANGE TRADED FUN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQEW',
    Issuer: 'FIRST TRUST NASDQ 100 EQ WEI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQH',
    Issuer: 'HCM DEFENDER 100 INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQJG',
    Issuer: 'INVESCO ESG NASDAQ NEXT GEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQMG',
    Issuer: 'INVESCO ESG NASDAQ 100',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQ',
    Issuer: 'INVESCO QQQ TRUST SERIES 1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQA',
    Issuer: 'PROSHARES NSDQ 100 D/W MOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQE',
    Issuer: 'DIREXION NASDAQ-100 EQ WEIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQJ',
    Issuer: 'INVESCO NASDAQ NEXT GEN 100',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQM',
    Issuer: 'INVESCO NASDAQ 100 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQN',
    Issuer: 'VICTORYSHARES NASDAQ NEXT 50',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQQX',
    Issuer: 'NUVEEN NAS100 DYN OVERWRT FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QQXT',
    Issuer: 'FIRST TRUST NASDAQ-100 EX-TE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRFT',
    Issuer: 'QRAFT AI-ENH US LRG CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRHC',
    Issuer: 'QUEST RESOURCE HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRMI',
    Issuer: 'GLOBAL X NASDAQ 100 RISK MAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRTEA',
    Issuer: 'QURATE RETAIL INC-SERIES A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRTEB',
    Issuer: 'QURATE RETAIL GROUP INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRTEP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QRVO',
    Issuer: 'QORVO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QS',
    Issuer: 'QUANTUMSCAPE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QSI',
    Issuer: 'QUANTUM-SI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QSIAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QSPT',
    Issuer: 'FT CBOE VEST GROWTH-100 BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QSR',
    Issuer: 'RESTAURANT BRANDS INTERN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QSWN',
    Issuer: 'AMP BLACKSWAN TECH & TREASUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTAP',
    Issuer: 'INNOVATOR GRW 100 ACCL PLUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTEC',
    Issuer: 'FIRST TRUST NASDQ 100 TECH I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTEK',
    Issuer: 'QUALTEK SERVICES INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTEKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTJA',
    Issuer: 'INNOVATOR GROWTH ACC PLUS-J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTJL',
    Issuer: 'INN GROWTH ACCEL PLUS JULY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTNT',
    Issuer: 'QUOTIENT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTOC',
    Issuer: 'INNOVATOR GROWTH ACCEL PL-OC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTR',
    Issuer: 'GLOBAL X NASDAQ 100 TAIL RIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTRX',
    Issuer: 'QUANTERIX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTT',
    Issuer: 'QUTOUTIAO INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTUM',
    Issuer: 'DEFIANCE QUANTUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QTWO',
    Issuer: 'Q2 HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUAD',
    Issuer: 'QUAD GRAPHICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUAL',
    Issuer: 'ISHARES MSCI USA QUALITY FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUBT',
    Issuer: 'QUANTUM COMPUTING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUIK',
    Issuer: 'QUICKLOGIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QULL',
    Issuer: 'ETRACS 2X QUALITY FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUMU',
    Issuer: 'QUMU CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUOT',
    Issuer: 'QUOTIENT TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QURE',
    Issuer: 'UNIQURE NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QUS',
    Issuer: 'SPDR MSCI USA STRATEGICFACTO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVAL',
    Issuer: 'ALPHA ARCH US QNT VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVCC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVCD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVML',
    Issuer: 'INVESCO S&P 500 QVM MULTI-FA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVMM',
    Issuer: 'INVESCO S&P MIDCAP 400 QVM M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QVMS',
    Issuer: 'INVESCO S&P SMALLCAP 600 QVM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QWLD',
    Issuer: 'SPDR MSCI WORLD STRATEGICFAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QYLD',
    Issuer: 'GLOBAL X NASD 100 COV CALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'QYLG',
    Issuer: 'GLOBAL X NASDAQ 100 COVC GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'R',
    Issuer: 'RYDER SYSTEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RA',
    Issuer: 'BROOKFIELD REAL ASSETS INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAAS',
    Issuer: 'CLOOPEN GROUP HOLDING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAAX',
    Issuer: 'VANECK INFLATION ALLOCATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RACB',
    Issuer: 'RESEARCH ALLIANCE CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RACE',
    Issuer: 'FERRARI NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RACY',
    Issuer: 'RELATIVITY ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RACYU',
    Issuer: 'RELATIVITY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RACYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAD',
    Issuer: 'RITE AID CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RADA',
    Issuer: 'RADA ELECTRONIC INDS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RADI',
    Issuer: 'RADIUS GLOBAL INFRASTRUCTU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAFE',
    Issuer: 'PIMCO RAFI ESG US ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAIL',
    Issuer: 'FREIGHTCAR AMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAIN',
    Issuer: 'RAIN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAM',
    Issuer: 'ARIES I ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAMMU',
    Issuer: 'ARIES I ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAMMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAMP',
    Issuer: 'LIVERAMP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAND',
    Issuer: 'RAND CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RANI',
    Issuer: 'RANI THERAPEUTICS HOLDINGS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAPT',
    Issuer: 'RAPT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RARE',
    Issuer: 'ULTRAGENYX PHARMACEUTICAL IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAVE',
    Issuer: 'RAVE RESTAURANT GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAVI',
    Issuer: 'FLEXSHARES READY ACCESS VARI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAYC',
    Issuer: 'RAYLIANT QUANTAMENTAL CHINA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAYD',
    Issuer: 'RAYLIANT QUANT DEV MKT EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAYE',
    Issuer: 'RAYLIANT QUANT EMERGING MKT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RAYS',
    Issuer: 'GLOBAL X SOLAR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBA',
    Issuer: 'RITCHIE BROS AUCTIONEERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBAC',
    Issuer: 'REDBALL ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBAC=',
    Issuer: 'REDBALL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBB',
    Issuer: 'RBB BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBBN',
    Issuer: 'RIBBON COMMUNICATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBCAA',
    Issuer: 'REPUBLIC BANCORP INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBCN',
    Issuer: 'RUBICON TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBKB',
    Issuer: 'RHINEBECK BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBLX',
    Issuer: 'ROBLOX CORP -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBND',
    Issuer: 'SPDR BLOOMBERG CORP ESG SELT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBOT',
    Issuer: 'VICARIOUS SURGICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RBOT+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RC',
    Issuer: 'READY CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RC-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RC-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCAC',
    Issuer: 'REVELSTONE CAPITAL ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCACU',
    Issuer: 'REVELSTONE CAPITAL ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCAT',
    Issuer: 'RED CAT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCD',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCEL',
    Issuer: 'AVITA MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCFA',
    Issuer: 'RCF ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCFA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCFA=',
    Issuer: 'RCF ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCG',
    Issuer: 'RENN FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCHG',
    Issuer: 'RECHARGE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCHGU',
    Issuer: 'RECHARGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCHGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCI',
    Issuer: 'ROGERS COMMUNICATIONS INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCII',
    Issuer: 'RENT-A-CENTER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCKT',
    Issuer: 'ROCKET PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCKY',
    Issuer: 'ROCKY BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCL',
    Issuer: 'ROYAL CARIBBEAN CRUISES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCLF',
    Issuer: 'ROSECLIFF ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCLFU',
    Issuer: 'ROSECLIFF ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCLFW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCM',
    Issuer: 'R1 RCM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCMT',
    Issuer: 'RCM TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCON',
    Issuer: 'RECON TECHNOLOGY LTD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCOR',
    Issuer: 'RENOVACOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCOR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCRT',
    Issuer: 'RECRUITER.COM GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCRTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCS',
    Issuer: 'PIMCO STRATEGIC INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RCUS',
    Issuer: 'ARCUS BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDBX',
    Issuer: 'REDBOX ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDBXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDCM',
    Issuer: 'RADCOM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDFI',
    Issuer: 'RAREVIEW DYNAMIC FIXED INCOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDFN',
    Issuer: 'REDFIN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDHL',
    Issuer: 'REDHILL BIOPHARMA LTD-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDI',
    Issuer: 'READING INTERNATIONAL INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDIB',
    Issuer: 'READING INTERNATIONAL INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDIV',
    Issuer: 'INVESCO S&P ULTRA DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDMX',
    Issuer: 'SPDR BBG SASB DEV X-US ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDN',
    Issuer: 'RADIAN GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDNT',
    Issuer: 'RADNET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDOG',
    Issuer: 'ALPS REIT DIVIDEND DOGS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDUS',
    Issuer: 'RADIUS HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDVT',
    Issuer: 'RED VIOLET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDVY',
    Issuer: 'FIRST TRUST RISING DIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDW',
    Issuer: 'REDWIRE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDWR',
    Issuer: 'RADWARE LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RDY',
    Issuer: "DR. REDDY'S LABORATORIES-ADR",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RE',
    Issuer: 'EVEREST RE GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REAL',
    Issuer: 'REALREAL INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REAX',
    Issuer: 'REAL BROKERAGE INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REC',
    Issuer: 'EMLES REAL ESTATE CREDIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RECS',
    Issuer: 'COLUMBIA RESRH ENHANCED CORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REDU',
    Issuer: 'RISE EDUCATION CAYMAN - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REE',
    Issuer: 'REE AUTOMOTIVE LTD - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REEAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REED',
    Issuer: "REED'S INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REET',
    Issuer: 'ISHARES GLOBAL REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REFI',
    Issuer: 'CHICAGO ATLANTIC REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REFR',
    Issuer: 'RESEARCH FRONTIERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REG',
    Issuer: 'REGENCY CENTERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REGI',
    Issuer: 'RENEWABLE ENERGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REGL',
    Issuer: 'PRSHRS S&P MID 400 DVD ARIST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REGN',
    Issuer: 'REGENERON PHARMACEUTICALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REI',
    Issuer: 'RING ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REIT',
    Issuer: 'ALPS ACTIVE REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REK',
    Issuer: 'PROSHARES SHORT REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REKR',
    Issuer: 'REKOR SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RELI',
    Issuer: 'RELIANCE GLOBAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RELIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RELL',
    Issuer: 'RICHARDSON ELEC LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RELX',
    Issuer: 'RELX PLC - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RELY',
    Issuer: 'REMITLY GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REM',
    Issuer: 'ISHARES MORTGAGE REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REMG',
    Issuer: 'SPDR BBG SASB E/M ESG SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REMX',
    Issuer: 'VANECK RARE EARTH/STRAT MET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RENEU',
    Issuer: 'CARTESIAN GROWTH CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RENN',
    Issuer: 'RENREN INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RENO',
    Issuer: 'RENOVARE ENVIRONMENTAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RENT',
    Issuer: 'RENT THE RUNWAY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REPL',
    Issuer: 'REPLIMUNE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REPX',
    Issuer: 'RILEY EXPLORATION PERMIAN IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RERE',
    Issuer: 'ATRENEW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RES',
    Issuer: 'RPC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RESD',
    Issuer: 'WISDOMTREE INTERNATIONAL ESG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RESE',
    Issuer: 'WISDOMTREE EM MKT ESG FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RESI',
    Issuer: 'KELLY RESIDENTIAL & APARTMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RESP',
    Issuer: 'WISDOMTREE US ESG FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RETA',
    Issuer: 'REATA PHARMACEUTICALS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RETL',
    Issuer: 'DIREXION DLY RETAIL BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RETO',
    Issuer: 'RETO ECO-SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REV',
    Issuer: 'REVLON INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVB',
    Issuer: 'REVELATION BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVBU',
    Issuer: 'PETRA ACQUISITION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVE',
    Issuer: 'ALPINE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVEU',
    Issuer: 'ALPINE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVG',
    Issuer: 'REV GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVH',
    Issuer: 'REVOLUTION HEALTHCARE ACQU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVHU',
    Issuer: 'REVOLUTION HEALTHCARE ACQUIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REVS',
    Issuer: 'COLUMBIA RESEARCH ENHANCED V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REW',
    Issuer: 'PROSHARES ULTRASHORT TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REX',
    Issuer: 'REX AMERICAN RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REXR',
    Issuer: 'REXFORD INDUSTRIAL REALTY IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REXR-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REXR-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REYN',
    Issuer: 'REYNOLDS CONSUMER PRODUCTS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REZ',
    Issuer: 'ISHARS RES AND MULTI REALES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'REZI',
    Issuer: 'RESIDEO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RF',
    Issuer: 'REGIONS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RF-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RF-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RF-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFAC',
    Issuer: 'RF ACQUISITION CORP - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFACR',
    Issuer: 'RF ACQUISITION CORP- RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFACU',
    Issuer: 'RF ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFCI',
    Issuer: 'RIVERFRONT DYNAMIC CORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFDA',
    Issuer: 'RIVERFRONT DYNAMIC US DV ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFDI',
    Issuer: 'FIRST TRST DYN DEVEL INT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFEM',
    Issuer: 'FIRST TRUST RIVERFRONT DYNAM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFEU',
    Issuer: 'FIRST TR DYNAMIC EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFFC',
    Issuer: 'RIVERFRONT DYNAMIC US FC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFG',
    Issuer: 'INVESCO S&P MIDCAP 400 PURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFI',
    Issuer: 'COHEN & STEERS TOT RET RLTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFIL',
    Issuer: 'RF INDUSTRIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFL',
    Issuer: 'RAFAEL HOLDINGS INC-CLASS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFM',
    Issuer: 'RIVERNORTH FLEXIBLE MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFMZ',
    Issuer: 'RIVERNORTH FLEX MUNI II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFP',
    Issuer: 'RESOLUTE FOREST PRODUCTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RFV',
    Issuer: 'INVESCO S&P MIDCAP 400 PURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGA',
    Issuer: 'REINSURANCE GROUP OF AMERICA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGC',
    Issuer: 'REGENCELL BIOSCIENCE HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGCO',
    Issuer: 'RGC RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGEN',
    Issuer: 'REPLIGEN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGF',
    Issuer: 'REAL GOOD FOOD CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGI',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGLD',
    Issuer: 'ROYAL GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGLS',
    Issuer: 'REGULUS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGNX',
    Issuer: 'REGENXBIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGP',
    Issuer: 'RESOURCES CONNECTION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGR',
    Issuer: 'STURM RUGER & CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGS',
    Issuer: 'REGIS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGT',
    Issuer: 'ROYCE GLOBAL VALUE TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGTI',
    Issuer: 'RIGETTI COMPUTING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RGTIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RH',
    Issuer: 'RH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHCB',
    Issuer: 'BNY RESPONSIBLE HORIZONS CB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHE',
    Issuer: 'REGIONAL HEALTH PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHE-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHI',
    Issuer: 'ROBERT HALF INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHP',
    Issuer: 'RYMAN HOSPITALITY PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHRX',
    Issuer: 'RH TACTICAL ROTATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHS',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RHTX',
    Issuer: 'RH TACTICAL OUTLOOK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIBT',
    Issuer: 'RICEBRAN TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RICK',
    Issuer: 'RCI HOSPITALITY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RICO',
    Issuer: 'AGRICO ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RICOU',
    Issuer: 'AGRICO ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RICOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIDE',
    Issuer: 'LORDSTOWN MOTORS CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIET',
    Issuer: 'HOYA CAPITAL HI DVD YLD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIG',
    Issuer: 'TRANSOCEAN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIGL',
    Issuer: 'RIGEL PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIGS',
    Issuer: 'RIVERFRONT STRATEGIC INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIGZ',
    Issuer: 'VIRIDI BITCOIN MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILY',
    Issuer: 'B. RILEY FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYG',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYK',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RILYZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RINF',
    Issuer: 'PROSHARES INFLATION EXPECTAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RING',
    Issuer: 'ISHARES MSCI GLOBAL GOLD MIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIO',
    Issuer: 'RIO TINTO PLC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIOT',
    Issuer: 'RIOT BLOCKCHAIN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RISN',
    Issuer: 'INSPIRE TACTICAL BALANCED ES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RISR',
    Issuer: 'FOLIOBEYOND RISING RATES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RITA',
    Issuer: 'ETFB GREEN SRI REITS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIV',
    Issuer: 'RIVERNORTH OPPORTUNITIES FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIV-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RIVN',
    Issuer: 'RIVIAN AUTOMOTIVE INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJA',
    Issuer: 'ELEMENTS ROGERS AGRI TOT RET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJAC',
    Issuer: 'JACKSON ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJAC=',
    Issuer: 'JACKSON ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJF',
    Issuer: 'RAYMOND JAMES FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJI',
    Issuer: 'ELEMENTS ROGERS TOTAL RETURN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJN',
    Issuer: 'ELEMENTS ROGERS ENERGY TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RJZ',
    Issuer: 'ELEMENTS ROGERS METALS TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKDA',
    Issuer: 'ARCADIA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKLB',
    Issuer: 'ROCKET LAB USA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKLY',
    Issuer: 'ROCKLEY PHOTONICS HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKLY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKT',
    Issuer: 'ROCKET COS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKTA',
    Issuer: 'ROCKET INTERNET GROWTH OPP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKTA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RKTA=',
    Issuer: 'ROCKET INTERNET GROWTH OPPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RL',
    Issuer: 'RALPH LAUREN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLAY',
    Issuer: 'RELAY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLGT',
    Issuer: 'RADIANT LOGISTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLGY',
    Issuer: 'REALOGY HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLI',
    Issuer: 'RLI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLJ',
    Issuer: 'RLJ LODGING TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLJ-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLMD',
    Issuer: 'RELMADA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLTY',
    Issuer: 'COHEN & STEERS RL EST OPPRT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLX',
    Issuer: 'RLX TECHNOLOGY INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLY',
    Issuer: 'SPDR SSGA MULTI-ASSET REAL R',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RLYB',
    Issuer: 'RALLYBIO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RM',
    Issuer: 'REGIONAL MANAGEMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMAX',
    Issuer: 'RE/MAX HOLDINGS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMBI',
    Issuer: 'RICHMOND MUTUAL BANCORPORATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMBL',
    Issuer: 'RUMBLEON INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMBS',
    Issuer: 'RAMBUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMCF',
    Issuer: 'ROCKY MOUNTAIN CHOC FACT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMD',
    Issuer: 'RESMED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMED',
    Issuer: 'RA MEDICAL SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMGC',
    Issuer: 'RMG ACQUISITION CORP III -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMGCU',
    Issuer: 'RMG ACQUISITION CORP III',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMGCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMI',
    Issuer: 'RIVERNORTH OPPORT MUNI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMM',
    Issuer: 'RIVERNORTH MANAGED DURATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMMZ',
    Issuer: 'RIVERNORTH MANAGED DURATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMNI',
    Issuer: 'RIMINI STREET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMO',
    Issuer: 'ROMEO POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMPL-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMR',
    Issuer: 'RMR GROUP INC/THE - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMT',
    Issuer: 'ROYCE MICRO-CAP TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RMTI',
    Issuer: 'ROCKWELL MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNA',
    Issuer: 'AVIDITY BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNAZ',
    Issuer: 'TRANSCODE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNDB',
    Issuer: 'RANDOLPH BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNDM',
    Issuer: 'DEVELOPED INT SELECT EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNDV',
    Issuer: 'US EQUITY DIVIDEND SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNEM',
    Issuer: 'EMERGING MARKETS EQTY SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNER',
    Issuer: 'MOUNT RAINIER ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNERU',
    Issuer: 'MOUNT RAINIER ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNERW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNG',
    Issuer: 'RINGCENTRAL INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNGR',
    Issuer: 'RANGER ENERGY SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNLC',
    Issuer: 'LARGE CAP US EQUITY SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNLX',
    Issuer: 'RENALYTIX AI PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNMC',
    Issuer: 'MID CAP US EQUITY SELECT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNP',
    Issuer: 'COHEN & STEERS REIT AND PREF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNR',
    Issuer: 'RENAISSANCERE HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNR-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNR-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNRG',
    Issuer: 'GLOBAL X RENEWABLE ENER PROD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNSC',
    Issuer: 'SMALL CAP US EQUITY SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNST',
    Issuer: 'RENASANT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNW',
    Issuer: 'RENEW ENERGY GLOBAL PLC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNWK',
    Issuer: 'REALNETWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNWWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RNXT',
    Issuer: 'RENOVORX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROAD',
    Issuer: 'CONSTRUCTION PARTNERS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROAM',
    Issuer: 'HARTFORD MULTIFACTOR EMERGIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROBO',
    Issuer: 'ROBO GLOBAL ROBOTICS AND AUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROBT',
    Issuer: 'FIRST TRUST NASDAQ ARTIFICIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROC',
    Issuer: 'ROC ENERGY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCAR',
    Issuer: 'ROC Energy Acquisition-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCAU',
    Issuer: 'ROC ENERGY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCC',
    Issuer: 'RANGER OIL CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCG',
    Issuer: 'ROTH CH ACQUISITION IV CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCGU',
    Issuer: 'ROTH CH ACQUISITION IV CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCI',
    Issuer: 'ROC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCK',
    Issuer: 'GIBRALTAR INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCL',
    Issuer: 'ROTH CH ACQUISITION V CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCLU',
    Issuer: 'ROTH CH ACQUISITION V CO.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROCLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RODE',
    Issuer: 'HARTFORD MULTIFACTOR DIVERSI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RODI',
    Issuer: 'IPATH RETURN ON DISABILITY E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RODM',
    Issuer: 'HARTFORD MULTIFACTOR DEVELOP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROG',
    Issuer: 'ROGERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROIC',
    Issuer: 'RETAIL OPPORTUNITY INVESTMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROIV',
    Issuer: 'ROIVANT SCIENCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROIVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROK',
    Issuer: 'ROCKWELL AUTOMATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROKT',
    Issuer: 'SPDR S&P KENSHO FINAL FRONTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROKU',
    Issuer: 'ROKU INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROL',
    Issuer: 'ROLLINS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROLL',
    Issuer: 'RBC BEARINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROLLP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROM',
    Issuer: 'PROSHARES ULTRA TECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROMO',
    Issuer: 'STRATEGY SHARES NEWFOUND/RES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RONI',
    Issuer: 'RICE ACQUISITION CORP II -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RONI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RONI=',
    Issuer: 'RICE ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROOF',
    Issuer: 'IQ US REAL ESTATE SMALL CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROOT',
    Issuer: 'ROOT INC/OH -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROP',
    Issuer: 'ROPER TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RORO',
    Issuer: 'ATAC US ROTATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSC',
    Issuer: 'HARTFORD MULTIFACTOR SMALL C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSE',
    Issuer: 'ROSE HILL ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSEU',
    Issuer: 'ROSE HILL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSS',
    Issuer: 'ROSS ACQUISITION CORP II -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROSS=',
    Issuer: 'ROSS ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROST',
    Issuer: 'ROSS STORES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROUS',
    Issuer: 'HARTFORD MULTIFACTOR US EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ROVR',
    Issuer: 'ROVER GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPAR',
    Issuer: 'RPAR RISK PARITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPAY',
    Issuer: 'REPAY HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPD',
    Issuer: 'RAPID7 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPG',
    Issuer: 'INVESCO S&P 500 PURE GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPHM',
    Issuer: 'RENEO PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPHS',
    Issuer: 'REGENTS PARK HEDGED MARKET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPID',
    Issuer: 'RAPID MICRO BIOSYSTEMS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPM',
    Issuer: 'RPM INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPRX',
    Issuer: 'ROYALTY PHARMA PLC- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPT',
    Issuer: 'RPT REALTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPT-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPTX',
    Issuer: 'REPARE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RPV',
    Issuer: 'INVESCO S&P 500 PURE VALUE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RQI',
    Issuer: 'COHEN & STEERS QUAL INC RLTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRAC',
    Issuer: 'RIGEL RESOURCE ACQUISIT-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRAC=',
    Issuer: 'RIGEL RESOURCE ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRBI',
    Issuer: 'RED RIVER BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRC',
    Issuer: 'RANGE RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRGB',
    Issuer: 'RED ROBIN GOURMET BURGERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRH',
    Issuer: 'ADVOCATE RISING RATE HDG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRR',
    Issuer: 'RED ROCK RESORTS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RRX',
    Issuer: 'REGAL REXNORD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RS',
    Issuer: 'RELIANCE STEEL & ALUMINUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSEE',
    Issuer: 'RAREVIEW SYSTEMATIC EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSF',
    Issuer: 'RIVERNORTH SPECIALTY FINANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSG',
    Issuer: 'REPUBLIC SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSI',
    Issuer: 'RUSH STREET INTERACTIVE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSKD',
    Issuer: 'RISKIFIED LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSLS',
    Issuer: 'RESHAPE LIFESCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSP',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSPE',
    Issuer: 'INVESCO ESG SP 500 EQ WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSPY',
    Issuer: 'REVERE SECTOR OPPORTUNITY ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSSS',
    Issuer: 'RESEARCH SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSVR',
    Issuer: 'RESERVOIR MEDIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSVRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSX',
    Issuer: 'VANECK RUSSIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RSXJ',
    Issuer: 'VANECK RUSSIA SMALL-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTAI',
    Issuer: 'RAREVIEW TAX ADVANTAGED INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTH',
    Issuer: 'VANECK RETAIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTL',
    Issuer: 'NECESSITY RETAIL REIT INC/TH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTLPO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTLPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTLR',
    Issuer: 'RATTLER MIDSTREAM LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTM',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTX',
    Issuer: 'RAYTHEON TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RTYD',
    Issuer: 'SIMPLIFY US SCAP PL DN CONV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUBY',
    Issuer: 'RUBIUS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUFF',
    Issuer: 'ALPHA DOG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RULE',
    Issuer: 'ADAPTIVE CORE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUN',
    Issuer: 'SUNRUN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUSHA',
    Issuer: 'RUSH ENTERPRISES INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUSHB',
    Issuer: 'RUSH ENTERPRISES INC - CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RUTH',
    Issuer: "RUTH'S HOSPITALITY GROUP INC",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVAC',
    Issuer: 'RIVERVIEW ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVACU',
    Issuer: 'RIVERVIEW ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVLP',
    Issuer: 'RVL PHARMACEUTICALS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVLV',
    Issuer: 'REVOLVE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVMD',
    Issuer: 'REVOLUTION MEDICINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVNC',
    Issuer: 'REVANCE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVNU',
    Issuer: 'XTRACKERS MUNICIPAL INFRASTR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVP',
    Issuer: 'RETRACTABLE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVPH',
    Issuer: 'REVIVA PHARMACEUTICALS HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVPHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVSB',
    Issuer: 'RIVERVIEW BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVSN',
    Issuer: 'RAIL VISION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVSNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RVT',
    Issuer: 'ROYCE VALUE TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWAY',
    Issuer: 'RUNWAY GROWTH FINANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWGV',
    Issuer: 'DIREXION RUSSELL G/V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWJ',
    Issuer: 'INVESCO S&P SMALLCAP 600',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWK',
    Issuer: 'INVESCO S&P MIDCAP 400 REV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWL',
    Issuer: 'INVESCO S&P 500 REVENUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWLK',
    Issuer: 'REWALK ROBOTICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWM',
    Issuer: 'PROSHARES SHORT RUSSELL2000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWO',
    Issuer: 'SPDR DJ GLOBAL REAL ESTATE E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWOD',
    Issuer: 'REDWOODS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWODR',
    Issuer: 'REDWOODS ACQUISITION-RIGHTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWODU',
    Issuer: 'REDWOODS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWODW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWR',
    Issuer: 'SPDR DOW JONES REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWT',
    Issuer: 'REDWOOD TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWVG',
    Issuer: 'DIREXION RUSSELL V/G',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RWX',
    Issuer: 'SPDR DR INTERNATIONAL RL EST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXD',
    Issuer: 'PROSHARES ULTRASHORT HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXDX',
    Issuer: 'PROMETHEUS BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXI',
    Issuer: 'ISHARES GLOBAL CONSUMER DISC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXL',
    Issuer: 'PROSHARES ULTRA HEALTH CARE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXRA',
    Issuer: 'RXR ACQUISITION CORP- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXRAU',
    Issuer: 'RXR ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXRAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXRX',
    Issuer: 'RECURSION PHARMACEUTICALS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXST',
    Issuer: 'RXSIGHT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RXT',
    Issuer: 'RACKSPACE TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RY',
    Issuer: 'ROYAL BANK OF CANADA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RY-T',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYAAY',
    Issuer: 'RYANAIR HOLDINGS PLC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYAM',
    Issuer: 'RAYONIER ADVANCED MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYAN',
    Issuer: 'RYAN SPECIALTY GROUP HLDGS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYE',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYF',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYH',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYI',
    Issuer: 'RYERSON HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYJ',
    Issuer: 'INVESCO RAYMOND JAMES SB-1 E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYLD',
    Issuer: 'GLOBAL X RUSSELL 2000 COV CL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYN',
    Issuer: 'RAYONIER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYT',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYTM',
    Issuer: 'RHYTHM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RYU',
    Issuer: 'INVESCO S&P 500 EQUAL WEIGHT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RZA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RZB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RZG',
    Issuer: 'INVESCO S&P SMALLCAP 600 PUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RZLT',
    Issuer: 'REZOLUTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'RZV',
    Issuer: 'INVESCO S&P SMALLCAP 600 PUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'S',
    Issuer: 'SENTINELONE INC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SA',
    Issuer: 'SEABRIDGE GOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAA',
    Issuer: 'PROSHARES ULTRA SMALLCAP600',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SABR',
    Issuer: 'SABRE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SABRP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SABS',
    Issuer: 'SAB BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SABSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SACC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SACH',
    Issuer: 'SACHEM CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SACH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAEF',
    Issuer: 'SCHWAB ARIEL ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAFE',
    Issuer: 'SAFEHOLD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAFM',
    Issuer: 'SANDERSON FARMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAFT',
    Issuer: 'SAFETY INSURANCE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAGA',
    Issuer: 'SAGALIAM ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAGAR',
    Issuer: 'SAGALIAM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAGAU',
    Issuer: 'SAGALIAM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAGE',
    Issuer: 'SAGE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAGP',
    Issuer: 'STRATEGAS GLOBAL POLICY OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAH',
    Issuer: 'SONIC AUTOMOTIVE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAI',
    Issuer: 'SAITECH GLOBAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAIA',
    Issuer: 'SAIA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAIC',
    Issuer: 'SCIENCE APPLICATIONS INTE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAIL',
    Issuer: 'SAILPOINT TECHNOLOGIES HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAITW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAK',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAL',
    Issuer: 'SALISBURY BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SALM',
    Issuer: 'SALEM MEDIA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAM',
    Issuer: 'BOSTON BEER COMPANY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAMA',
    Issuer: 'SCHULTZE SPECIAL PURPOSE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAMAU',
    Issuer: 'SCHULTZE SPECIAL PURPOSE ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAMAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAMG',
    Issuer: 'SILVERCREST ASSET MANAGEME-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAMT',
    Issuer: 'STRATEGAS MACRO THEM OPPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAN',
    Issuer: 'BANCO SANTANDER SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANA',
    Issuer: 'SANA BIOTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANB',
    Issuer: 'SANABY HEALTH ACQ CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANBU',
    Issuer: 'SANABY HEALTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAND',
    Issuer: 'SANDSTORM GOLD LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANG',
    Issuer: 'SANGOMA TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANM',
    Issuer: 'SANMINA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SANW',
    Issuer: 'S&W SEED CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAP',
    Issuer: 'SAP SE-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAR',
    Issuer: 'SARATOGA INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SARK',
    Issuer: 'TUTTLE CAP SHORT INNOVATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SASI',
    Issuer: 'SIGMA LABS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SASR',
    Issuer: 'SANDY SPRING BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SATL',
    Issuer: 'SATELLOGIC INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SATLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SATO',
    Issuer: 'INVESCO ALERIAN GALAXY CRYPT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SATS',
    Issuer: 'ECHOSTAR CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAVA',
    Issuer: 'CASSAVA SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAVE',
    Issuer: 'SPIRIT AIRLINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SAVN',
    Issuer: 'LIFEGOAL CONSERVATIVE WEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SB',
    Issuer: 'SAFE BULKERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SB-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SB-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBAC',
    Issuer: 'SBA COMMUNICATIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBB',
    Issuer: 'PROSHARES SHORT SMALLCAP600',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBBA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBCF',
    Issuer: 'SEACOAST BANKING CORP/FL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBET',
    Issuer: 'SHARPLINK GAMING LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBEV',
    Issuer: 'SPLASH BEVERAGE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBEV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBFG',
    Issuer: 'SB FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBFM',
    Issuer: 'SUNSHINE BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBFMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBGI',
    Issuer: 'SINCLAIR BROADCAST GROUP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBH',
    Issuer: 'SALLY BEAUTY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBI',
    Issuer: 'WESTERN ASSET INTERMEDIATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBII',
    Issuer: 'SANDBRIDGE X2 CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBII+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBII=',
    Issuer: 'SANDBRIDGE X2 CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBIO',
    Issuer: 'ALPS MEDICAL BREAKTHROUGHS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBLK',
    Issuer: 'STAR BULK CARRIERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBND',
    Issuer: 'COLUMBIA SHORT DURATION BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBNY',
    Issuer: 'SIGNATURE BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBNYP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBOW',
    Issuer: 'SILVERBOW RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBR',
    Issuer: 'SABINE ROYALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBRA',
    Issuer: 'SABRA HEALTH CARE REIT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBS',
    Issuer: 'CIA SANEAMENTO BASICO DE-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBSI',
    Issuer: 'SOUTHSIDE BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBSW',
    Issuer: 'SIBANYE-STILLWATER LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBT',
    Issuer: 'STERLING BANCORP INC/MI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBTX',
    Issuer: 'SILVERBACK THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBUG',
    Issuer: 'IPATH SILVER ETN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SBUX',
    Issuer: 'STARBUCKS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCAQ',
    Issuer: 'STRATIM CLOUD ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCAQU',
    Issuer: 'STRATIM CLOUD ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCC',
    Issuer: 'PROSHARES ULTRASHORT CONS SV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCF',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCCO',
    Issuer: 'SOUTHERN COPPER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCD',
    Issuer: 'LMP CAPITAL AND INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCDL',
    Issuer: 'ETRACS 2X DIVID FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCE-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCE-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCE-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCE-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCE-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHA',
    Issuer: 'SCHWAB US SMALL-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHB',
    Issuer: 'SCHWAB US BROAD MARKET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHC',
    Issuer: 'SCHWAB INTL SMALL-CAP EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHD',
    Issuer: 'SCHWAB US DVD EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHE',
    Issuer: 'SCHWAB EMERGING MARKETS EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHF',
    Issuer: 'SCHWAB INTL EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHG',
    Issuer: 'SCHWAB U.S. LARGE-CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHH',
    Issuer: 'SCHWAB US REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHI',
    Issuer: 'SCHWAB 5-10 YEAR CORPORATE B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHJ',
    Issuer: 'SCHWAB 1-5 YEAR CORPORATE BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHK',
    Issuer: 'SCHWAB 1000 INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHL',
    Issuer: 'SCHOLASTIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHM',
    Issuer: 'SCHWAB US MID CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHN',
    Issuer: 'SCHNITZER STEEL INDS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHO',
    Issuer: 'SCHWAB SHORT-TERM US TREAS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHP',
    Issuer: 'SCHWAB U.S. TIPS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHQ',
    Issuer: 'SCHWAB LONG-TERM US TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHR',
    Issuer: 'SCHWAB INTERMEDIATE-TERM US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHV',
    Issuer: 'SCHWAB US LARGE-CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHW',
    Issuer: 'SCHWAB (CHARLES) CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHW-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHW-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHX',
    Issuer: 'SCHWAB US LARGE-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHY',
    Issuer: 'SCHWAB INTERNATIONAL DVD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCHZ',
    Issuer: 'SCHWAB US AGGREGATE BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCI',
    Issuer: 'SERVICE CORP INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCJ',
    Issuer: 'ISHARES MSCI JAPAN SMALL-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCKT',
    Issuer: 'SOCKET MOBILE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCL',
    Issuer: 'STEPAN CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCLE',
    Issuer: 'BROADSCALE ACQUISITION -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCLEU',
    Issuer: 'BROADSCALE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCLEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCM',
    Issuer: 'STELLUS CAPITAL INVESTMENT C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCMA',
    Issuer: 'SEAPORT CALIBRE MATERIALS AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCMAU',
    Issuer: 'SEAPORT CALIBRE MATERIALS AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCMAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCO',
    Issuer: 'PROSHARES ULTRASHORT BLOOMBE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOA',
    Issuer: 'SCION TECH GROWTH I-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOAU',
    Issuer: 'SCION TECH GROWTH I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOB',
    Issuer: 'SCION TECH GROWTH II-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOBU',
    Issuer: 'SCION TECH GROWTH II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCOR',
    Issuer: 'COMSCORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCPH',
    Issuer: 'SCPHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCPL',
    Issuer: 'SCIPLAY CORP-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCPS',
    Issuer: 'SCOPUS BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCRD',
    Issuer: 'JANUS HENDERSON SUST CORP BD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCRM',
    Issuer: 'SCREAMING EAGLE ACQ -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCRMU',
    Issuer: 'SCREAMING EAGLE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCRMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCS',
    Issuer: 'STEELCASE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCSC',
    Issuer: 'SCANSOURCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCTL',
    Issuer: 'SOCIETAL CDMO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCU',
    Issuer: 'SCULPTOR CAPITAL MANAGEMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCUA',
    Issuer: 'SCULPTOR ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCUA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCUA=',
    Issuer: 'SCULPTOR ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCVL',
    Issuer: 'SHOE CARNIVAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCWX',
    Issuer: 'SECUREWORKS CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCX',
    Issuer: 'STARRETT (L.S.) CO  -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCYX',
    Issuer: 'SCYNEXIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SCZ',
    Issuer: 'ISHARES MSCI EAFE SMALL-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SD',
    Issuer: 'SANDRIDGE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDAC',
    Issuer: 'SUSTAINABLE DEVELOPMENT AC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDACU',
    Issuer: 'SUSTAINABLE DEVELOPMENT ACQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDC',
    Issuer: 'SMILEDIRECTCLUB INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDCI',
    Issuer: 'USCF SUMMERHAVEN DYNAMIC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDD',
    Issuer: 'PROSHARES ULTRASHORT SC600',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDEF',
    Issuer: 'SOUND ENHANCED FIXED INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDEI',
    Issuer: 'SOUND EQUITY INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDEM',
    Issuer: 'GLOBAL X MSCI SUPERDIVIDEND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDG',
    Issuer: 'ISH MSCI GLOB SUST DEVE GOAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDGA',
    Issuer: 'IMPACT SHARES SUSTAINABLE DE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDGR',
    Issuer: 'SCHRODINGER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDH',
    Issuer: 'GLOBAL INTERNET OF PEOPLE IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDHY',
    Issuer: 'PGIM SHRT DURAT HI YLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDIG',
    Issuer: 'STRONGHOLD DIGITAL MINING-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDIV',
    Issuer: 'GLOBAL X SUPERDIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDOG',
    Issuer: 'ALPS SECTOR DIVIDEND DOGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDOW',
    Issuer: 'PROSHARES ULTPRO SHRT DOW30',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDP',
    Issuer: 'PROSHARES ULTSHRT UTILITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDPI',
    Issuer: 'SUPERIOR DRILLING PRODUCTS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDS',
    Issuer: 'PROSHARES ULTRASHORT S&P500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDVY',
    Issuer: 'FIRST TRUST SMID CAP RISING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SDY',
    Issuer: 'SPDR S&P DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SE',
    Issuer: 'SEA LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEA',
    Issuer: 'US GLOBAL SEA TO SKY CARGO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEAC',
    Issuer: 'SEACHANGE INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEAL-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEAL-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEAS',
    Issuer: 'SEAWORLD ENTERTAINMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEAT',
    Issuer: 'VIVID SEATS INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEATW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEB',
    Issuer: 'SEABOARD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SECO',
    Issuer: 'SECOO HOLDING LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SECT',
    Issuer: 'MAIN SECTOR ROTATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEDA',
    Issuer: 'SDCL EDGE ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEDA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEDA=',
    Issuer: 'SDCL EDGE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEDG',
    Issuer: 'SOLAREDGE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEE',
    Issuer: 'SEALED AIR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEED',
    Issuer: 'ORIGIN AGRITECH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEEL',
    Issuer: 'SEELOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEER',
    Issuer: 'SEER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEF',
    Issuer: 'PROSHARES SHORT FINANCIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEIC',
    Issuer: 'SEI INVESTMENTS COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEIM',
    Issuer: 'SEI ENHANCED US LARGE CAP MO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEIQ',
    Issuer: 'SEI ENHANCED US LARGE CAP QU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEIV',
    Issuer: 'SEI ENHANCED US LRG CAP VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEIX',
    Issuer: 'VIRTUS SEIX SENIOR LOAN ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SELB',
    Issuer: 'SELECTA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SELF',
    Issuer: 'GLOBAL SELF STORAGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SELV',
    Issuer: 'SEI ENHANCED LOW VOL US LRG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEM',
    Issuer: 'SELECT MEDICAL HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEMI',
    Issuer: 'COLUMBIA SELIG SEMICON AN TE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEMR',
    Issuer: 'SEMRUSH HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SENEA',
    Issuer: 'SENECA FOODS CORP - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SENEB',
    Issuer: 'SENECA FOODS CORP - CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SENS',
    Issuer: 'SENSEONICS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SENT',
    Issuer: 'ADVISORSHARES ALPHA DNA EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEPZ',
    Issuer: 'TRUESHARES STRUC OUT SEP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SERA',
    Issuer: 'SERA PROGNOSTICS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SES',
    Issuer: 'SES AI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SES+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SESN',
    Issuer: 'SESEN BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEV',
    Issuer: 'SONO GROUP NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SEVN',
    Issuer: 'SEVEN HILLS REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SF',
    Issuer: 'STIFEL FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SF-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SF-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SF-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFBC',
    Issuer: 'SOUND FINANCIAL BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFBS',
    Issuer: 'SERVISFIRST BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFE',
    Issuer: 'SAFEGUARD SCIENTIFICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFET',
    Issuer: 'SAFE-T GROUP LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFIG',
    Issuer: 'WISDOMTREE US SHORT TERM COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFIX',
    Issuer: 'STITCH FIX INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFL',
    Issuer: 'SFL CORP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFM',
    Issuer: 'SPROUTS FARMERS MARKET INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFNC',
    Issuer: 'SIMMONS FIRST NATL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFST',
    Issuer: 'SOUTHERN FIRST BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFT',
    Issuer: 'SHIFT TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFY',
    Issuer: 'SOFI SELECT 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFYF',
    Issuer: 'SOFI SOCIAL 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SFYX',
    Issuer: 'SOFI NEXT 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SG',
    Issuer: 'SWEETGREEN INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGA',
    Issuer: 'SAGA COMMUNICATIONS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGBX',
    Issuer: 'SG BLOCKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGC',
    Issuer: 'SUPERIOR GROUP OF COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGDJ',
    Issuer: 'SPROTT JR. GOLD MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGDM',
    Issuer: 'SPROTT GOLD MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGEN',
    Issuer: 'SEAGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGFY',
    Issuer: 'SIGNIFY HEALTH INC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGG',
    Issuer: 'IPATH SERIES B BBG SUGAR SUB',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGH',
    Issuer: 'SMART GLOBAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHC',
    Issuer: 'SUPER GROUP SGHC LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHL',
    Issuer: 'SIGNAL HILL ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHLU',
    Issuer: 'SIGNAL HILL ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGHT',
    Issuer: 'SIGHT SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGII',
    Issuer: 'SEAPORT GLOBAL ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGIIU',
    Issuer: 'SEAPORT GLOBAL ACQUISITION I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGLY',
    Issuer: 'SINGULARITY FUTURE TECHNOLOG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGMA',
    Issuer: 'SIGMATRON INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGML',
    Issuer: 'SIGMA LITHIUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGMO',
    Issuer: 'SANGAMO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGOL',
    Issuer: 'ABRDN GOLD ETF TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGOV',
    Issuer: 'ISHARES 0-3 MONTH TREASURY B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGRP',
    Issuer: 'SPAR GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGRY',
    Issuer: 'SURGERY PARTNERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGTX',
    Issuer: 'SIGILON THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SGU',
    Issuer: 'STAR GROUP LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SH',
    Issuer: 'PROSHARES SHORT S&P500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAC',
    Issuer: 'SCP & CO HEALTHCARE ACQUIS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHACU',
    Issuer: 'SCP & CO HEALTHCARE ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAG',
    Issuer: 'WSDMTREE YLD EN US ST AGG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAK',
    Issuer: 'SHAKE SHACK INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAP',
    Issuer: 'SPREE ACQUISITION CORP 1 LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHAP=',
    Issuer: 'SPREE ACQUISITION CORP 1 LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHBI',
    Issuer: 'SHORE BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHC',
    Issuer: 'SOTERA HEALTH CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHCA',
    Issuer: 'SPINDLETOP HEALTH ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHCAU',
    Issuer: 'SPINDLETOP HEALTH ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHCR',
    Issuer: 'SHARECARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHCRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHE',
    Issuer: 'SPDR GENDER DIVERSITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHEL',
    Issuer: 'SHELL PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHEN',
    Issuer: 'SHENANDOAH TELECOMMUNICATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHFT',
    Issuer: 'ICLIMA DISTRIBUTED SMART ENE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHG',
    Issuer: 'SHINHAN FINANCIAL GROUP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHI',
    Issuer: 'SINOPEC SHANGHAI-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHIP',
    Issuer: 'SEANERGY MARITIME HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHLS',
    Issuer: 'SHOALS TECHNOLOGIES GROUP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHLX',
    Issuer: 'SHELL MIDSTREAM PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHM',
    Issuer: 'SPDR NUVEEN BLOOMBERG SHORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHO',
    Issuer: 'SUNSTONE HOTEL INVESTORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHO-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHO-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHOO',
    Issuer: 'STEVEN MADDEN LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHOP',
    Issuer: 'SHOPIFY INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHPW',
    Issuer: 'SHAPEWAYS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHPW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHQA',
    Issuer: 'SHELTER ACQUISITION CORP I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHQAU',
    Issuer: 'SHELTER ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHQAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHUA',
    Issuer: 'SHUAA PARTNERS ACQUISIT-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHUAU',
    Issuer: 'SHUAA PARTNERS ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHUAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHUS',
    Issuer: 'SYNTAX STRAT US TOT MKT HDG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHV',
    Issuer: 'ISHARES SHORT TREASURY BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHW',
    Issuer: 'SHERWIN-WILLIAMS CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHY',
    Issuer: 'ISHARES 1-3 YEAR TREASURY BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHYD',
    Issuer: 'VANECK SH HI YLD MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHYF',
    Issuer: 'SHYFT GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHYG',
    Issuer: 'ISHARES 0-5 YR HY CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SHYL',
    Issuer: 'XTRACKERS SHRT DUR HIGH YIEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SI',
    Issuer: 'SILVERGATE CAPITAL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SI-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIBN',
    Issuer: 'SI-BONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SID',
    Issuer: 'CIA SIDERURGICA NACL-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIDU',
    Issuer: 'SIDUS SPACE INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIEB',
    Issuer: 'SIEBERT FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIEN',
    Issuer: 'SIENTRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIER',
    Issuer: 'SIERRA LAKE ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIERU',
    Issuer: 'SIERRA LAKE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIERW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIF',
    Issuer: 'SIFCO INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIFI',
    Issuer: 'HARBOR SCIENTIFIC ALPHA INCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIFY',
    Issuer: 'SIFY TECHNOLOGIES-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIG',
    Issuer: 'SIGNET JEWELERS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIGA',
    Issuer: 'SIGA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIGI',
    Issuer: 'SELECTIVE INSURANCE GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIGIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIHY',
    Issuer: 'HARBOR SCIENTIFIC ALPHA HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SII',
    Issuer: 'SPROTT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIJ',
    Issuer: 'PROSHARES ULTSHRT INDUSTRIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIL',
    Issuer: 'GLOBAL X SILVER MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SILC',
    Issuer: 'SILICOM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SILJ',
    Issuer: 'ETFMG PRIME JUNIOR SILVER MI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SILK',
    Issuer: 'SILK ROAD MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SILV',
    Issuer: 'SILVERCREST METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SILX',
    Issuer: 'ETFMG PRIME 2X DAILY JUNIOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIM',
    Issuer: 'GRUPO SIMEC SAB-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIMO',
    Issuer: 'SILICON MOTION TECHNOL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIMS',
    Issuer: 'SPDR S&P KENSHO INTELLIGENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SINT',
    Issuer: 'SINTX TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SINV',
    Issuer: 'ETFMG PRIME 2X DAILY INVERSE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIOX',
    Issuer: 'SIO GENE THERAPIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIRE',
    Issuer: 'SISECAM RESOURCES LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIRI',
    Issuer: 'SIRIUS XM HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SISI',
    Issuer: 'SHINECO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SITC',
    Issuer: 'SITE CENTERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SITC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SITE',
    Issuer: 'SITEONE LANDSCAPE SUPPLY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SITM',
    Issuer: 'SITIME CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIVB',
    Issuer: 'SVB FINANCIAL GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIVBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIVR',
    Issuer: 'ABRDN SILVER ETF TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIX',
    Issuer: 'SIX FLAGS ENTERTAINMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXA',
    Issuer: 'ETC 6 MERIDIAN MEGA CAP EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXH',
    Issuer: 'ETC 6 MERIDIAN HEDGED EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXJ',
    Issuer: 'ALINZ US LRG 6 MT BUF JANJUL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXL',
    Issuer: 'ETC 6 MERIDIAN LOW BETA EQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXO',
    Issuer: 'ALLIANZIM US LARGE CAP 6 MON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIXS',
    Issuer: 'ETC 6 MERIDIAN SMALL CAP EQU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SIZE',
    Issuer: 'ISHARES MSCI USA SIZE FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJ',
    Issuer: 'SCIENJOY HOLDING CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJB',
    Issuer: 'PROSHARES SHORT HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJI',
    Issuer: 'SOUTH JERSEY INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJIJ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJIV',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJM',
    Issuer: 'JM SMUCKER CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJNK',
    Issuer: 'SPDR BLOOMBERG SHORT TERM HI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJR',
    Issuer: 'SHAW COMMUNICATIONS INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJT',
    Issuer: 'SAN JUAN BASIN ROYALTY TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SJW',
    Issuer: 'SJW GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKE',
    Issuer: 'SKEENA RESOURCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKF',
    Issuer: 'PROSHARES ULTSHRT FINANCIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKIL',
    Issuer: 'SKILLSOFT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKIL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKIN',
    Issuer: 'BEAUTY HEALTH CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKLZ',
    Issuer: 'SKILLZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKM',
    Issuer: 'SK TELECOM CO LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKOR',
    Issuer: 'FLEXSHARES CREDIT-SCORED US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKT',
    Issuer: 'TANGER FACTORY OUTLET CENTER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKX',
    Issuer: 'SKECHERS USA INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKY',
    Issuer: 'SKYLINE CHAMPION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYA',
    Issuer: 'SKYDECK ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYAU',
    Issuer: 'SKYDECK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYH',
    Issuer: 'SKY HARBOUR GROUP CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYT',
    Issuer: 'SKYWATER TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYU',
    Issuer: 'PROSHARES ULTRA CLOUD COMP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYW',
    Issuer: 'SKYWEST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYX',
    Issuer: 'SQL TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SKYY',
    Issuer: 'FIRST TRUST CLOUD COMPUTING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAB',
    Issuer: 'SILICON LABORATORIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAC',
    Issuer: 'SOCIAL LEVERAGE ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAC=',
    Issuer: 'SOCIAL LEVERAGE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAM',
    Issuer: 'SLAM CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAMU',
    Issuer: 'SLAM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLAMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLB',
    Issuer: 'SCHLUMBERGER LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLCA',
    Issuer: 'US SILICA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLCR',
    Issuer: 'SILVER CREST ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLCRU',
    Issuer: 'SILVER CREST ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLCRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLDB',
    Issuer: 'SOLID BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLDP',
    Issuer: 'SOLID POWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLDPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLF',
    Issuer: 'SUN LIFE FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLG',
    Issuer: 'SL GREEN REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLG-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLGC',
    Issuer: 'SOMALOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLGCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLGG',
    Issuer: 'SUPER LEAGUE GAMING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLGL',
    Issuer: 'SOL-GEL TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLGN',
    Issuer: 'SILGAN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLHG',
    Issuer: 'SKYLIGHT HEALTH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLHGP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLI',
    Issuer: 'STANDARD LITHIUM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLM',
    Issuer: 'SLM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLMBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLN',
    Issuer: 'SILENCE THERAPEUTICS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLNG',
    Issuer: 'STABILIS SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLNH',
    Issuer: 'SOLUNA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLNHP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLNO',
    Issuer: 'SOLENO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLP',
    Issuer: 'SIMULATIONS PLUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLQD',
    Issuer: 'ISHARES 0-5 YR INV GRD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLQT',
    Issuer: 'SELECTQUOTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLRC',
    Issuer: 'SLR INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLRX',
    Issuer: 'SALARIUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLS',
    Issuer: 'SELLAS LIFE SCIENCES GROUP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLV',
    Issuer: 'ISHARES SILVER TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVM',
    Issuer: 'SYLVAMO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVO',
    Issuer: 'X-LINKS SLVR SHRS COVRD CALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVP',
    Issuer: 'ISHARES MSCI GLOBAL SILVER A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVR',
    Issuer: 'SILVERSPAC INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVRU',
    Issuer: 'SILVERSPAC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLVRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLX',
    Issuer: 'VANECK STEEL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLY',
    Issuer: 'SPDR S&P 600 SMALL CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLYG',
    Issuer: 'SPDR S&P 600 SMALL CAP GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SLYV',
    Issuer: 'SPDR S&P 600 SMALL CAP VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SM',
    Issuer: 'SM ENERGY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMAP',
    Issuer: 'SPORTSMAP TECH ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMAPU',
    Issuer: 'SPORTSMAP TECH ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMAPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMAR',
    Issuer: 'SMARTSHEET INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMB',
    Issuer: 'VANECK SHORT MUNI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMBC',
    Issuer: 'SOUTHERN MISSOURI BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMBK',
    Issuer: 'SMARTFINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMCI',
    Issuer: 'SUPER MICRO COMPUTER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMCP',
    Issuer: 'ALPHAMARK ACT MANAGED SMALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMDD',
    Issuer: 'PROSHARES ULTPRO SHRT MC400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMDV',
    Issuer: 'PROSHRS RSL 2000 DVD GRW ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMDY',
    Issuer: 'SYNTAX STRATIFIED MIDCAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMED',
    Issuer: 'SHARPS COMPLIANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMFG',
    Issuer: 'SUMITOMO MITSUI-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMFL',
    Issuer: 'SMART FOR LIFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMFR',
    Issuer: 'SEMA4 HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMFRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMG',
    Issuer: 'SCOTTS MIRACLE-GRO CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMH',
    Issuer: 'VANECK SEMICONDUCTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMHB',
    Issuer: 'ETRACS MON PAY 2X LEV US -B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMHI',
    Issuer: 'SEACOR MARINE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMI',
    Issuer: 'VANECK HIP SUSTAINABLE MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMID',
    Issuer: 'SMITH-MIDLAND CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIG',
    Issuer: 'AAM B&G SM/MID CAP INC GRWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIH',
    Issuer: 'SUMMIT HEALTHCARE ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIHU',
    Issuer: 'SUMMIT HEALTHCARE ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIN',
    Issuer: 'ISHARES MSCI INDIA SMALL-CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMIT',
    Issuer: 'SCHMITT INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMLE',
    Issuer: 'XTRACKERS S&P SMALLCAP 600',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMLF',
    Issuer: 'ISHARES MSCI USA SMALL-CAP M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMLP',
    Issuer: 'SUMMIT MIDSTREAM PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMLR',
    Issuer: 'SEMLER SCIENTIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMLV',
    Issuer: 'SPDR SSGA US SMALL CAP LOW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMM',
    Issuer: 'SALIENT MIDSTREAM & MLP FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMMD',
    Issuer: 'ISHARES RUSSELL 2500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMMF',
    Issuer: 'SUMMIT FINANCIAL GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMMT',
    Issuer: 'SUMMIT THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMMU',
    Issuer: 'PIMCO SHORT TERM MUNICIPAL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMMV',
    Issuer: 'ISHARES MSCI USA SMALL-CAP M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMN',
    Issuer: 'PROSHARES ULTSHRT BASIC MAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMOG',
    Issuer: 'VANECK LOW CARBON ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMP',
    Issuer: 'STANDARD MOTOR PRODS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMPL',
    Issuer: 'SIMPLY GOOD FOODS CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMR',
    Issuer: 'NUSCALE POWER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMRT',
    Issuer: 'SMARTRENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMSI',
    Issuer: 'SMITH MICRO SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMTC',
    Issuer: 'SEMTECH CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMTI',
    Issuer: 'SANARA MEDTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMTS',
    Issuer: 'SIERRA METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SMWB',
    Issuer: 'SIMILARWEB LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNA',
    Issuer: 'SNAP-ON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNAP',
    Issuer: 'SNAP INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNAX',
    Issuer: 'STRYVE FOODS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNBR',
    Issuer: 'SLEEP NUMBER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNCE',
    Issuer: 'SCIENCE 37 HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNCR',
    Issuer: 'SYNCHRONOSS TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNCRL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNCY',
    Issuer: 'SUN COUNTRY AIRLINES HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SND',
    Issuer: 'SMART SAND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNDA',
    Issuer: 'SONIDA SENIOR LIVING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNDL',
    Issuer: 'SUNDIAL GROWERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNDR',
    Issuer: 'SCHNEIDER NATIONAL INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNDX',
    Issuer: 'SYNDAX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNES',
    Issuer: 'SENESTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNEX',
    Issuer: 'STONEX GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNFCA',
    Issuer: 'SECURITY NATL FINL CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNGX',
    Issuer: 'SOLIGENIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNLN',
    Issuer: 'HIGHLAND/IBOXX SENIOR LOAN E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNMP',
    Issuer: 'EVOLVE TRANSITION INFRASTRUC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNN',
    Issuer: 'SMITH & NEPHEW PLC -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNOA',
    Issuer: 'SONOMA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNOW',
    Issuer: 'SNOWFLAKE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNP',
    Issuer: 'CHINA PETROLEUM & CHEM-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNPE',
    Issuer: 'XTRACKERS S&P 500 ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNPO',
    Issuer: 'SNAP ONE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNPS',
    Issuer: 'SYNOPSYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNPX',
    Issuer: 'SYNAPTOGENIX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNRH',
    Issuer: 'SENIOR CONNECT ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNRHU',
    Issuer: 'SENIOR CONNECT ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNRHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNSE',
    Issuer: 'SENSEI BIOTHERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNSR',
    Issuer: 'GLOBAL X INTERNET OF THINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNT',
    Issuer: 'SENSTAR TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNTG',
    Issuer: 'SENTAGE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNUG',
    Issuer: 'MERLYN AI TACTICAL GRW & INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNV',
    Issuer: 'SYNOVUS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNV-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNV-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNX',
    Issuer: 'TD SYNNEX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SNY',
    Issuer: 'SANOFI-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SO',
    Issuer: 'SOUTHERN CO/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOBR',
    Issuer: 'SOBR SAFE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOCL',
    Issuer: 'GLOBAL X SOCIAL MEDIA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOFI',
    Issuer: 'SOFI TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOFO',
    Issuer: 'SONIC FOUNDRY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOGU',
    Issuer: 'THE SHORT DE-SPAC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOHO',
    Issuer: 'SOTHERLY HOTELS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOHOB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOHON',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOHOO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOHU',
    Issuer: 'SOHU.COM LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOI',
    Issuer: 'SOLARIS OILFIELD INFRAST-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOJC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOJD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOJE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOL',
    Issuer: 'RENESOLA LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOLN',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOLO',
    Issuer: 'ELECTRAMECCANICA VEHICLES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOLOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOLR',
    Issuer: 'SMARTETFS SUSTAINABLE ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SON',
    Issuer: 'SONOCO PRODUCTS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOND',
    Issuer: 'SONDER HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONM',
    Issuer: 'SONIM TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONN',
    Issuer: 'SONNET BIOTHERAPEUTICS HOLDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONO',
    Issuer: 'SONOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONX',
    Issuer: 'SONENDO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SONY',
    Issuer: 'SONY GROUP CORP - SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOPA',
    Issuer: 'SOCIETY PASS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOPH',
    Issuer: 'SOPHIA GENETICS SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOR',
    Issuer: 'SOURCE CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOS',
    Issuer: 'SOS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOSH',
    Issuer: 'SOS HYDRATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOSHW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOTK',
    Issuer: 'SONO-TEK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOUN',
    Issuer: 'SOUNDHOUND AI INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOUNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOVO',
    Issuer: 'SOVOS BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOXL',
    Issuer: 'DIREXION DAILY SEMI BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOXQ',
    Issuer: 'INVESCO PHLX SEMICONDUCTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOXS',
    Issuer: 'DIREXION DAILY SEMI BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOXX',
    Issuer: 'ISHARES SEMICONDUCTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SOYB',
    Issuer: 'TEUCRIUM SOYBEAN FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SP',
    Issuer: 'SP PLUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPAB',
    Issuer: 'SPDR PORTFOLIO AGGREGATE BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPAK',
    Issuer: 'DEFIANCE NEXTGEN SPAC DERIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPAX',
    Issuer: 'ROBINSON ALT YLD PREMERG SP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPB',
    Issuer: 'SPECTRUM BRANDS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPBC',
    Issuer: 'SIMPLIFY US EQ PLUS GBTC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPBO',
    Issuer: 'SPDR PORTFOLIO CORPORATE BON',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPC',
    Issuer: 'CROSSINGBRIDGE PRE-MERGER SP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCB',
    Issuer: 'SUPERCOM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCE',
    Issuer: 'VIRGIN GALACTIC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCM',
    Issuer: 'SOUND POINT ACQUISITION CO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCMU',
    Issuer: 'SOUND POINT ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPCX',
    Issuer: 'SPAC & NEW ISSUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPD',
    Issuer: 'SIMPLIFY US EQUITY PLUS DOWN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPDN',
    Issuer: 'DIREXION DLY S&P 500 BEAR 1X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPDV',
    Issuer: 'AAM S&P 500 HIGH DIV VAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPDW',
    Issuer: 'SPDR PORTFOLIO DEVELOPED WOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPE',
    Issuer: 'SPECIAL OPPORTUNITIES FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPE-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPEM',
    Issuer: 'SPDR PORTFOLIO EMERGING MARK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPEU',
    Issuer: 'SPDR PORTFOLIO EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPFF',
    Issuer: 'GLOBAL X SUPERINCOME PREFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPFI',
    Issuer: 'SOUTH PLAINS FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPG',
    Issuer: 'SIMON PROPERTY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPG-J',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGI',
    Issuer: 'S&P GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGM',
    Issuer: 'SPDR PORTFOLIO MSCI GLOBAL S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGP',
    Issuer: 'INVESCO S&P 500 GARP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGS',
    Issuer: 'SIMON PROPERTY GROUP ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPGS=',
    Issuer: 'SIMON PROPERTY GROUP ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPH',
    Issuer: 'SUBURBAN PROPANE PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPHB',
    Issuer: 'INVESCO S&P 500 HIGH BETA ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPHD',
    Issuer: 'INVESCO S&P 500 HIGH DIVIDEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPHQ',
    Issuer: 'INVESCO S&P 500 QUALITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPHY',
    Issuer: 'SPDR PORTFOLIO HIGH YIELD BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPI',
    Issuer: 'SPI ENERGY CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPIB',
    Issuer: 'SPDR PORT INT CORP BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPIP',
    Issuer: 'SPDR PORTFOLIO TIPS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPIR',
    Issuer: 'SPIRE GLOBAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPIR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPK',
    Issuer: 'SPK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPKAR',
    Issuer: 'SPK ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPKAU',
    Issuer: 'SPK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPKB',
    Issuer: 'SILVER SPIKE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPKBU',
    Issuer: 'SILVER SPIKE ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPKBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLB',
    Issuer: 'SPDR PORT LNG TRM CORP BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLG',
    Issuer: 'SPDR PORTFOLIO S&P 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLK',
    Issuer: 'SPLUNK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLP',
    Issuer: 'STEEL PARTNERS HOLDINGS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLP-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPLV',
    Issuer: 'INVESCO S&P 500 LOW VOLATILI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPMB',
    Issuer: 'SPDR PORTFOLIO MORTGAGE BACK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPMD',
    Issuer: 'SPDR PORTFOLIO S&P 400 MID C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPMO',
    Issuer: 'INVESCO S&P 500 MOMENTUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPMV',
    Issuer: 'INVESCO S&P 500 MINIMUM VARI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPNE',
    Issuer: 'SEASPINE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPNS',
    Issuer: 'SAPIENS INTERNATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPNT',
    Issuer: 'SIRIUSPOINT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPNT-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPOK',
    Issuer: 'SPOK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPOT',
    Issuer: 'SPOTIFY TECHNOLOGY SA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPPI',
    Issuer: 'SPECTRUM PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPPP',
    Issuer: 'SPROTT PHYSICAL PLATINUM AND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPR',
    Issuer: 'SPIRIT AEROSYSTEMS HOLD-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPRB',
    Issuer: 'SPRUCE BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPRC',
    Issuer: 'SCISPARC LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPRE',
    Issuer: 'SP/F S&P GLOBAL REIT SHARIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPRO',
    Issuer: 'SPERO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPRX',
    Issuer: 'SPEAR ALPHA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPSB',
    Issuer: 'SPDR PORT SHRT TRM CORP BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPSC',
    Issuer: 'SPS COMMERCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPSK',
    Issuer: 'SP FUNDS DOW JONES GLOBAL SU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPSM',
    Issuer: 'SPDR PORTFOLIO S&P 600 SMALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPT',
    Issuer: 'SPROUT SOCIAL INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTI',
    Issuer: 'SPDR PORT INT TREASURY TERM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTK',
    Issuer: 'SPORTSTEK ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTKU',
    Issuer: 'SPORTSTEK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTL',
    Issuer: 'SPDR PORT LNG TRM TRSRY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTM',
    Issuer: 'SPDR PORTFOLIO S&P 1500 COMP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTN',
    Issuer: 'SPARTANNASH CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPTS',
    Issuer: 'SPDR PORT SHRT TRM TRSRY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPUC',
    Issuer: 'SIMPLIFY US EQUITY PLUS UPSI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPUS',
    Issuer: 'SP FUNDS S&P SHARIA INDUSTRY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPUU',
    Issuer: 'DIREXION DLY S&P 500 BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPVM',
    Issuer: 'INVESCO S&P 500 VALUE WITH M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPVU',
    Issuer: 'INVESCO S&P 500 ENHANCED VAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPWH',
    Issuer: "SPORTSMAN'S WAREHOUSE HOLDIN",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPWR',
    Issuer: 'SUNPOWER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXB',
    Issuer: 'PROSHARES S&P 500 BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXC',
    Issuer: 'SPX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXE',
    Issuer: 'PROSHARES S&P 500 EX-ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXL',
    Issuer: 'DIREXION DLY S&P 500 BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXN',
    Issuer: 'PROSHARES S&P 500 EX-FINANCI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXS',
    Issuer: 'DIREXION DLY S&P 500 BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXT',
    Issuer: 'PROSHARES S&P 500 EX-TECHNOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXU',
    Issuer: 'PROSH ULTRAPRO SHORT S&P 500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXV',
    Issuer: 'PROSHARES TRUST-S&P 500 EX-H',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXX',
    Issuer: 'NUVEEN S&P500 DYNAM OVERWR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPXZ',
    Issuer: 'MORGAN CREEK-EXOS SPAC ORGIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPY',
    Issuer: 'SPDR S&P 500 ETF TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPYC',
    Issuer: 'SIMPLIFY US EQUITY PLUS CONV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPYD',
    Issuer: 'SPDR PORTFOLIO S&P 500 HIGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPYG',
    Issuer: 'SPDR PORTFOLIO S&P 500 GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPYV',
    Issuer: 'SPDR PORT S&P 500 VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SPYX',
    Issuer: 'SPDR S&P 500 FOSSIL FUEL RES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQ',
    Issuer: 'BLOCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQEW',
    Issuer: 'LEADERSHARES EQUITY SKEW ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQFT',
    Issuer: 'PRESIDIO PROPERTY TRUST - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQFTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQFTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQL',
    Issuer: 'SEQLL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQLLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQLV',
    Issuer: 'ROYCE QUANT SMALL-CAP QUALIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQM',
    Issuer: 'QUIMICA Y MINERA CHIL-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQNS',
    Issuer: 'SEQUANS COMMUNICATIONS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQQQ',
    Issuer: 'PROSHARES ULTRAPRO SHORT QQQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQSP',
    Issuer: 'SQUARESPACE INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SQZ',
    Issuer: 'SQZ BIOTECHNOLOGIES CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SR',
    Issuer: 'SPIRE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SR-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRAD',
    Issuer: 'SPORTRADAR GROUP AG-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRAX',
    Issuer: 'SRAX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRC',
    Issuer: 'SPIRIT REALTY CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRCE',
    Issuer: '1ST SOURCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRCL',
    Issuer: 'STERICYCLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRDX',
    Issuer: 'SURMODICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRE',
    Issuer: 'SEMPRA ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SREA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRET',
    Issuer: 'GLOBAL X SUPERDIVIDEND REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SREV',
    Issuer: 'SERVICESOURCE INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRG',
    Issuer: 'SERITAGE GROWTH PROP- A REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRG-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRGA',
    Issuer: 'SURGALIGN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRI',
    Issuer: 'STONERIDGE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRL',
    Issuer: 'SCULLY ROYALTY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRLN',
    Issuer: 'SPDR BLACKSTONE SENIOR LOAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRLP',
    Issuer: 'SPRAGUE RESOURCES LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRNE',
    Issuer: 'SORRENTO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRPT',
    Issuer: 'SAREPTA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRRA',
    Issuer: 'SIERRA ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRRK',
    Issuer: 'SCHOLAR ROCK HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRS',
    Issuer: 'PROSHARES ULTRASHORT RE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRSA',
    Issuer: 'SARISSA CAPITAL ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRSAU',
    Issuer: 'SARISSA CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRT',
    Issuer: 'STARTEK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRTS',
    Issuer: 'SENSUS HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRTY',
    Issuer: 'PROSHARES ULTRAPRO SHRT R2K',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRV',
    Issuer: 'CUSHING MLP & INFRASTRUCTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRVR',
    Issuer: 'PACER BENCHMARK DATA INFRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRZN',
    Issuer: 'SURROZEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SRZNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSAA',
    Issuer: 'SCIENCE STRATEGIC ACQUISIT-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSAAU',
    Issuer: 'SCIENCE STRATEGIC ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSB',
    Issuer: 'SOUTHSTATE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSBI',
    Issuer: 'SUMMIT STATE BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSBK',
    Issuer: 'SOUTHERN STATES BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSD',
    Issuer: 'SIMPSON MANUFACTURING CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSFI',
    Issuer: 'DAY HAG NED DVS RES S SEC FI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSG',
    Issuer: 'PROSHARES ULTSHRT SEMICONDUC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSIC',
    Issuer: 'SILVER SPIKE INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSKN',
    Issuer: 'STRATA SKIN SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSL',
    Issuer: 'SASOL LTD-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSLY',
    Issuer: 'SYNTAX STRATIFIED SMALLCAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSNC',
    Issuer: 'SS&C TECHNOLOGIES HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSNT',
    Issuer: 'SILVERSUN TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSO',
    Issuer: 'PROSHARES ULTRA S&P500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSP',
    Issuer: 'EW SCRIPPS CO/THE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSPX',
    Issuer: 'JANUS HENDERSON US SUST EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSPY',
    Issuer: 'SYNTAX STRATIFIED LARGE CAP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSRM',
    Issuer: 'SSR MINING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSSS',
    Issuer: 'SURO CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSSSL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SST',
    Issuer: 'SYSTEM1 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SST+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSTI',
    Issuer: 'SHOTSPOTTER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSTK',
    Issuer: 'SHUTTERSTOCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSU',
    Issuer: 'SIGNA SPORTS UNITED NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSU+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSUS',
    Issuer: 'DAY HAGAN/NED DAVIS RESEARCH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSY',
    Issuer: 'SUNLINK HEALTH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SSYS',
    Issuer: 'STRATASYS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ST',
    Issuer: 'SENSATA TECHNOLOGIES HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAA',
    Issuer: 'STAAR SURGICAL CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAB',
    Issuer: 'STATERA BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAF',
    Issuer: 'STAFFING 360 SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAG',
    Issuer: 'STAG INDUSTRIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAR',
    Issuer: 'ISTAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAR-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAR-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STAR-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STBA',
    Issuer: 'S & T BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STBL',
    Issuer: 'DRIVEWEALTH STEADY SAVER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STC',
    Issuer: 'STEWART INFORMATION SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STCN',
    Issuer: 'STEEL CONNECT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STE',
    Issuer: 'STERIS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STEM',
    Issuer: 'STEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STEP',
    Issuer: 'STEPSTONE GROUP INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STER',
    Issuer: 'STERLING CHECK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STET',
    Issuer: 'ST ENERGY TRANSITION I LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STET+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STET=',
    Issuer: 'ST ENERGY TRANSITION I LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STEW',
    Issuer: 'SRH TOTAL RETURN FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STG',
    Issuer: 'SUNLANDS TECHNOLOGY- SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STGF',
    Issuer: 'MERK STAGFLATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STGW',
    Issuer: 'STAGWELL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STIM',
    Issuer: 'NEURONETICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STIP',
    Issuer: 'ISHARES 0-5 YEAR TIPS BOND E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STK',
    Issuer: 'COLUMBIA SELIG PREM TECH GW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STKL',
    Issuer: 'SUNOPTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STKS',
    Issuer: 'ONE GROUP HOSPITALITY INC/TH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STLA',
    Issuer: 'STELLANTIS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STLD',
    Issuer: 'STEEL DYNAMICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STLG',
    Issuer: 'ISHARES FACTORS US GWTH STYL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STLV',
    Issuer: 'ISHARES FACTORS US VAL STYLE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STM',
    Issuer: 'STMICROELECTRONICS NV-NY SHS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STN',
    Issuer: 'STANTEC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STNC',
    Issuer: 'STANCE EQUITY ESG LRG CAP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STNE',
    Issuer: 'STONECO LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STNG',
    Issuer: 'SCORPIO TANKERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STOK',
    Issuer: 'STOKE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STON',
    Issuer: 'STONEMOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STOR',
    Issuer: 'STORE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STOT',
    Issuer: 'SPDR DL SHRT DURATION TR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STPZ',
    Issuer: 'PIMCO 1-5 YEAR US TIPS INDEX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRA',
    Issuer: 'STRATEGIC EDUCATION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRC',
    Issuer: 'SARCOS TECHNOLOGY AND ROBOTI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRE',
    Issuer: 'SUPERNOVA PARTNERS ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRE=',
    Issuer: 'SUPERNOVA PARTNERS ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRL',
    Issuer: 'STERLING CONSTRUCTION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRM',
    Issuer: 'STREAMLINE HEALTH SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRN',
    Issuer: 'STRAN & CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRNW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRO',
    Issuer: 'SUTRO BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRR',
    Issuer: 'STAR EQUITY HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRRP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRS',
    Issuer: 'STRATUS PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRT',
    Issuer: 'STRATTEC SECURITY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRY',
    Issuer: 'STARRY GROUP HOLDINGS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STRY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STSA',
    Issuer: 'SATSUMA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STSS',
    Issuer: 'SHARPS TECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STSSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STT',
    Issuer: 'STATE STREET CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STT-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STT-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STTK',
    Issuer: 'SHATTUCK LABS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STVN',
    Issuer: 'STEVANATO GROUP SPA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STWD',
    Issuer: 'STARWOOD PROPERTY TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STX',
    Issuer: 'SEAGATE TECHNOLOGY HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STXS',
    Issuer: 'STEREOTAXIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STZ',
    Issuer: 'CONSTELLATION BRANDS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'STZ.B',
    Issuer: 'CONSTELLATION BRANDS INC-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SU',
    Issuer: 'SUNCOR ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUAC',
    Issuer: 'SHOULDERUP TECHNOLOGY ACQU-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUAC=',
    Issuer: 'SHOULDERUP TECHNOLOGY ACQUIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUB',
    Issuer: 'ISHARES SHORT-TERM NATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUBS',
    Issuer: 'FOUNT SUBSCRIPTION ECONOMY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUI',
    Issuer: 'SUN COMMUNITIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUM',
    Issuer: 'SUMMIT MATERIALS INC -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUMO',
    Issuer: 'SUMO LOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUMR',
    Issuer: 'SUMMER INFANT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUN',
    Issuer: 'SUNOCO LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUNL',
    Issuer: 'SUNLIGHT FINANCIAL HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUNL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUNW',
    Issuer: 'SUNWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUP',
    Issuer: 'SUPERIOR INDUSTRIES INTL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUPL',
    Issuer: 'PROSHARES SUPPLY CHAIN LOGIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUPN',
    Issuer: 'SUPERNUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUPV',
    Issuer: 'GRUPO SUPERVIELLE SA-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SURF',
    Issuer: 'SURFACE ONCOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SURG',
    Issuer: 'SURGEPAYS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SURGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUSA',
    Issuer: 'ISHARES MSCI USA ESG SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUSB',
    Issuer: 'ISHARES ESG AWARE 1-5 YEAR U',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUSC',
    Issuer: 'ISHARES ESG AWARE USD CORPOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUSL',
    Issuer: 'ISHARES ESG MSCI USA LEADERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SUZ',
    Issuer: 'SUZANO SA - SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVA',
    Issuer: 'SINOVAC BIOTECH LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVAL',
    Issuer: 'ISHARES US SMALL CAP VAL FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVC',
    Issuer: 'SERVICE PROPERTIES TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFA',
    Issuer: 'SVF INVESTMENT CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFAU',
    Issuer: 'SVF INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFB',
    Issuer: 'SVF INVESTMENT CORP 2-CLS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFC',
    Issuer: 'SVF INVESTMENT CORP 3-CLS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVFD',
    Issuer: 'SAVE FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVIX',
    Issuer: '-1X SHORT VIX FUTURES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVM',
    Issuer: 'SILVERCORP METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVNA',
    Issuer: '7 ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVNAU',
    Issuer: '7 ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVNAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVOL',
    Issuer: 'SIMPLIFY VOLATILITY PREMIUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVRA',
    Issuer: 'SAVARA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVRE',
    Issuer: 'SAVERONE 2014 LTD -ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVREW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVT',
    Issuer: 'SERVOTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVVC',
    Issuer: 'FIRSTHAND TECHNOLOGY VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SVXY',
    Issuer: 'PROSHARES SHORT VIX ST FUTUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAG',
    Issuer: 'SOFTWARE ACQUISITION GROUP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAGU',
    Issuer: 'SOFTWARE ACQUISITION GROUP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAN',
    Issuer: 'AMPLIFY BLACKSWAN GROWTH TSY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAR',
    Issuer: 'DIREXION DAILY SOFT BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWAV',
    Issuer: 'SHOCKWAVE MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWBI',
    Issuer: 'SMITH & WESSON BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWCH',
    Issuer: 'SWITCH INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWEB',
    Issuer: 'AXS SHORT CHINA INTERNET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWET',
    Issuer: 'ATHLON ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWETU',
    Issuer: 'ATHLON ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWETW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWI',
    Issuer: 'SOLARWINDS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWIM',
    Issuer: 'LATHAM GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWIR',
    Issuer: 'SIERRA WIRELESS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWK',
    Issuer: 'STANLEY BLACK & DECKER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWKH',
    Issuer: 'SWK HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWKS',
    Issuer: 'SKYWORKS SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWM',
    Issuer: 'SCHWEITZER-MAUDUIT INTL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWN',
    Issuer: 'SOUTHWESTERN ENERGY CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWSS',
    Issuer: 'SPRINGWATER SPECIAL SITUATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWSSU',
    Issuer: 'SPRINGWATER SPECIAL SITUATIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWSSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWTX',
    Issuer: 'SPRINGWORKS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWVL',
    Issuer: 'SWVL HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWVLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWX',
    Issuer: 'SOUTHWEST GAS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SWZ',
    Issuer: 'SWISS HELVETIA FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXC',
    Issuer: 'SUNCOKE ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXI',
    Issuer: 'STANDEX INTERNATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXQG',
    Issuer: 'ETC 6 MERIDIAN QUALITY GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXT',
    Issuer: 'SENSIENT TECHNOLOGIES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXTC',
    Issuer: 'CHINA SXT PHARMACEUTICALS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SXUS',
    Issuer: 'JANUS HENDERSON INT SUSTAIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SY',
    Issuer: 'SO-YOUNG INTERNATIONAL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYBT',
    Issuer: 'STOCK YARDS BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYBX',
    Issuer: 'SYNLOGIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYF',
    Issuer: 'SYNCHRONY FINANCIAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYF-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYK',
    Issuer: 'STRYKER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYLD',
    Issuer: 'CAMBRIA SHAREHOLDER YIELD ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYN',
    Issuer: 'SYNTHETIC BIOLOGICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYNA',
    Issuer: 'SYNAPTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYNH',
    Issuer: 'SYNEOS HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYNL',
    Issuer: 'SYNALLOY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYPR',
    Issuer: 'SYPRIS SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYRS',
    Issuer: 'SYROS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYTA',
    Issuer: 'SIYATA MOBILE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYTAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYUS',
    Issuer: 'SYNTAX STRATIFIED US TOTAL M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SYY',
    Issuer: 'SYSCO CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZC',
    Issuer: 'CUSHING NEXTGEN INFRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZK',
    Issuer: 'PROSHARES ULTSHRT CONS GOODS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZNE',
    Issuer: 'PACER CFRA STOVALL EQUAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZZL',
    Issuer: 'SIZZLE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZZLU',
    Issuer: 'SIZZLE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'SZZLW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'T',
    Issuer: 'AT&T INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'T-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'T-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TA',
    Issuer: 'TRAVELCENTERS OF AMERICA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAC',
    Issuer: 'TRANSALTA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TACA',
    Issuer: 'TREPONT ACQUISITION CORP I-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TACA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TACA=',
    Issuer: 'TREPONT ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TACK',
    Issuer: 'FAIRLEAD TACTICAL SECTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TACT',
    Issuer: 'TRANSACT TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAGG',
    Issuer: 'T ROWE PRICE QM US BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAGS',
    Issuer: 'TEUCRIUM AGRICULTURAL FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAIL',
    Issuer: 'CAMBRIA TAIL RISK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAIT',
    Issuer: 'TAITRON COMPONENTS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAK',
    Issuer: 'TAKEDA PHARMACEUTIC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAL',
    Issuer: 'TAL EDUCATION GROUP- ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TALK',
    Issuer: 'TALKSPACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TALKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TALO',
    Issuer: 'TALOS ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TALS',
    Issuer: 'TALARIS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAN',
    Issuer: 'INVESCO SOLAR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TANH',
    Issuer: 'TANTECH HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TANNI',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TANNL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TANNZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAOP',
    Issuer: 'TAOPING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAP',
    Issuer: 'MOLSON COORS BEVERAGE CO - B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAP.A',
    Issuer: 'MOLSON COORS BEVERAGE CO - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TARA',
    Issuer: 'PROTARA THERAPEUTIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TARK',
    Issuer: 'AXS 2X INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TARO',
    Issuer: 'TARO PHARMACEUTICAL INDUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TARS',
    Issuer: 'TARSUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TASK',
    Issuer: 'TASKUS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAST',
    Issuer: 'CARROLS RESTAURANT GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TATT',
    Issuer: 'TAT TECHNOLOGIES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAXF',
    Issuer: 'AMERICAN CENTURY DIVER MUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TAYD',
    Issuer: 'TAYLOR DEVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBBK',
    Issuer: 'BANCORP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBCP',
    Issuer: 'THUNDER BRIDGE CAPITAL PAR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBCPU',
    Issuer: 'THUNDER BRIDGE CAPITAL PARTN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBCPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBF',
    Issuer: 'PROSHARES SHORT 20+ TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBI',
    Issuer: 'TRUEBLUE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBJL',
    Issuer: 'INNOVATOR 20 YR T BOND 9 BUF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBK',
    Issuer: 'TRIUMPH BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBKCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBLA',
    Issuer: 'TABOOLA.COM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBLAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBLD',
    Issuer: 'THORNBURG INCOME BUILDER OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBLT',
    Issuer: 'TOUGHBUILT INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBLTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBNK',
    Issuer: 'TERRITORIAL BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBPH',
    Issuer: 'THERAVANCE BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBSA',
    Issuer: 'TB SA ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBSAU',
    Issuer: 'TB SA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBSAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBT',
    Issuer: 'PROSHARES ULTRASHORT 20+Y TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBUX',
    Issuer: 'T ROWE PRICE ULTRA SHORT-TER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TBX',
    Issuer: 'PROSHARES SHORT 7-10 YR TSY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TC',
    Issuer: 'TUANCHE LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCAC',
    Issuer: 'TUATARA CAPITAL ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCACU',
    Issuer: 'TUATARA CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBC',
    Issuer: 'TC BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBI',
    Issuer: 'TEXAS CAPITAL BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBIO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBK',
    Issuer: 'TRICO BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBP',
    Issuer: 'TC BIOPHARM HOLDINGS PLC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBS',
    Issuer: 'TEXAS COMMUNITY BANCSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCBX',
    Issuer: 'THIRD COAST BANCSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCDA',
    Issuer: 'TRICIDA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCFC',
    Issuer: 'COMMUNITY FINANCIAL CORP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCHI',
    Issuer: 'ISHARES MSCI CHINA TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCHP',
    Issuer: 'T ROWE PRICE BLUE CHIP GROWT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCI',
    Issuer: 'TRANSCONTINENTAL REALTY INV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCMD',
    Issuer: 'TACTILE SYSTEMS TECHNOLOGY I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCN',
    Issuer: 'TRICON RESIDENTIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCOA',
    Issuer: 'TRAJECTORY ALPHA ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCOA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCOA=',
    Issuer: 'TRAJECTORY ALPHA ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCOM',
    Issuer: 'TRIP.COM GROUP LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCON',
    Issuer: 'TRACON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCPC',
    Issuer: 'BLACKROCK TCP CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCRR',
    Issuer: 'TCR2 THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCRT',
    Issuer: 'ALAUNOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCRX',
    Issuer: 'TSCAN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCS',
    Issuer: 'CONTAINER STORE GROUP INC/TH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCTL',
    Issuer: 'PREMISE CAPITAL DIVERSIFIED',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCVA',
    Issuer: 'TCV ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TCX',
    Issuer: 'TUCOWS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TD',
    Issuer: 'TORONTO-DOMINION BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDC',
    Issuer: 'TERADATA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDCX',
    Issuer: 'TDCX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDF',
    Issuer: 'TEMPLETON DRAGON FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDG',
    Issuer: 'TRANSDIGM GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDIV',
    Issuer: 'FT NASDAQ TECH DVD INDEX FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDOC',
    Issuer: 'TELADOC HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDS',
    Issuer: 'TELEPHONE AND DATA SYSTEMS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDS-U',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDS-V',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDSA',
    Issuer: 'CABANA TARGET DRAWDOWN 5 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDSB',
    Issuer: 'CABANA TARGET DRAWDOWN 7 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDSC',
    Issuer: 'CABANA TARGET DRAWDWN 10 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDSD',
    Issuer: 'CABANA TARGET DRAWDWN 13 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDSE',
    Issuer: 'CABANA TARGET DRAWDWN 16 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDTF',
    Issuer: 'FLEXSHARES IBOXX 5-YEAR TARG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDTT',
    Issuer: 'FLEXSHARES IBOXX 3-YEAR TARG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDUP',
    Issuer: 'THREDUP INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDV',
    Issuer: 'PROSHARES S&P TECH DVD ARIST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDVG',
    Issuer: 'T ROWE PRICE DIVIDEND GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDW',
    Issuer: 'TIDEWATER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDW+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDW+A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDW+B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TDY',
    Issuer: 'TELEDYNE TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEAF',
    Issuer: 'ECOFIN SUSTAIN & SOC IMPCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEAM',
    Issuer: 'ATLASSIAN CORP PLC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECB',
    Issuer: 'ISHARES US TECH BREAKTHROUGH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECH',
    Issuer: 'BIO-TECHNE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECK',
    Issuer: 'TECK RESOURCES LTD-CLS B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECL',
    Issuer: 'DIREXION DAILY TECH BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECS',
    Issuer: 'DIREXION DAILY TECH BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TECTP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEDU',
    Issuer: 'TARENA INTERNATIONAL INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEF',
    Issuer: 'TELEFONICA SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEI',
    Issuer: 'TEMPLETON EMERG MKTS INC FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEKK',
    Issuer: 'TEKKORP DIGITAL ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEKKU',
    Issuer: 'TEKKORP DIGITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEKKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEL',
    Issuer: 'TE CONNECTIVITY LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TELA',
    Issuer: 'TELA BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TELL',
    Issuer: 'TELLURIAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TELZ',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEMP',
    Issuer: 'JPMORGAN CLIMATE CHANGE SOLS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEN',
    Issuer: 'TENNECO INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TENB',
    Issuer: 'TENABLE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TENG',
    Issuer: 'DIREXION DLY 5G COMM BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TENKU',
    Issuer: 'TENX KEANE ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TENX',
    Issuer: 'TENAX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEO',
    Issuer: 'TELECOM ARGENTINA SA-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEQI',
    Issuer: 'T ROWE PRICE EQUITY INCOME E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TER',
    Issuer: 'TERADYNE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TERN',
    Issuer: 'TERNS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TESS',
    Issuer: 'TESSCO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETC',
    Issuer: 'TECH AND ENERGY TRANSITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETCU',
    Issuer: 'TECH AND ENERGY TRANSITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETE',
    Issuer: 'TECHNOLOGY & TELECOMMUNICATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETEU',
    Issuer: 'TECHNOLOGY & TELECOMMUNICATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TETEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEVA',
    Issuer: 'TEVA PHARMACEUTICAL-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TEX',
    Issuer: 'TEREX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFC',
    Issuer: 'TRUIST FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFC-I',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFC-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFC-R',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFFP',
    Issuer: 'TFF PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFI',
    Issuer: 'SPDR NUVEEN BLOOMBERG MUNICI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFII',
    Issuer: 'TFI INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFJL',
    Issuer: 'INNOVATOR 20 YR TREAS BOND 5',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFLO',
    Issuer: 'ISHARES TREASURY FLOATING RA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFSA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFSL',
    Issuer: 'TFS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TFX',
    Issuer: 'TELEFLEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TG',
    Issuer: 'TREDEGAR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGA',
    Issuer: 'TRANSGLOBE ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGAA',
    Issuer: 'TARGET GLOBAL ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGAAU',
    Issuer: 'TARGET GLOBAL ACQUISITION I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGAN',
    Issuer: 'TRANSPHORM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGB',
    Issuer: 'TASEKO MINES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGH',
    Issuer: 'TEXTAINER GROUP HOLDINGS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGH-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGH-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGI',
    Issuer: 'TRIUMPH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGIF',
    Issuer: 'SOFI WEEKLY INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGLS',
    Issuer: 'TECNOGLASS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGNA',
    Issuer: 'TEGNA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGR',
    Issuer: 'KIMBELL TIGER ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGR=',
    Issuer: 'KIMBELL TIGER ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGRW',
    Issuer: 'T ROWE PRICE GROWTH STOCK ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGS',
    Issuer: 'TRANSPORTADOR GAS-ADR SP B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGT',
    Issuer: 'TARGET CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGTX',
    Issuer: 'TG THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGVC',
    Issuer: 'TG VENTURE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGVCU',
    Issuer: 'TG VENTURE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TGVCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TH',
    Issuer: 'TARGET HOSPITALITY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THAC',
    Issuer: 'THRIVE ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THACU',
    Issuer: 'THRIVE ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THC',
    Issuer: 'TENET HEALTHCARE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCA',
    Issuer: 'TUSCAN HOLDINGS CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCAU',
    Issuer: 'TUSCAN HOLDINGS CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCP',
    Issuer: 'THUNDER BRIDGE CAPITAL PAR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCPU',
    Issuer: 'THUNDER BRIDGE CAPITAL PARTN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THCX',
    Issuer: 'THE CANNABIS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THD',
    Issuer: 'ISHARES MSCI THAILAND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THFF',
    Issuer: 'FIRST FINANCIAL CORP/INDIANA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THG',
    Issuer: 'HANOVER INSURANCE GROUP INC/',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THM',
    Issuer: 'INTL TOWER HILL MINES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THMO',
    Issuer: 'THERMOGENESIS HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THNQ',
    Issuer: 'ROBO GLOBAL ARTIFICIAL INTEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THO',
    Issuer: 'THOR INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THQ',
    Issuer: 'TEKLA HEALTHCARE OPPORTUNITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THR',
    Issuer: 'THERMON GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THRM',
    Issuer: 'GENTHERM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THRN',
    Issuer: 'THORNE HEALTHTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THRX',
    Issuer: 'THESEUS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THRY',
    Issuer: 'THRYV HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THS',
    Issuer: 'TREEHOUSE FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THTX',
    Issuer: 'THERATECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THW',
    Issuer: 'TEKLA WORLD HEALTHCARE FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THWWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'THY',
    Issuer: 'TOEWS AGILITY SHARES DYNAMIC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIG',
    Issuer: 'TREAN INSURANCE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIGO',
    Issuer: 'MILLICOM INTL CELLULAR S.A.',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIGR',
    Issuer: 'UP FINTECH HOLDING LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIL',
    Issuer: 'INSTIL BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TILE',
    Issuer: 'INTERFACE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TILL',
    Issuer: 'TEUCRIUM AG NO K-1 STRATEGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TILT',
    Issuer: 'FLEXSHARES MORNINGSTAR US MA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIMB',
    Issuer: 'TIM SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIME',
    Issuer: 'CLOCKWISE CAPITAL INNOVATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TINT',
    Issuer: 'PROSHARES SMART MATERIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TINV',
    Issuer: 'TIGA ACQUISITION CORP- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TINV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TINV=',
    Issuer: 'TIGA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TINY',
    Issuer: 'PROSHARES NANOTECHNOLOGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIOA',
    Issuer: 'TIO TECH A- CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIOAU',
    Issuer: 'TIO TECH A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIOAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIP',
    Issuer: 'ISHARES TIPS BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIPD',
    Issuer: 'DIREXION DAILY TIPS BEAR 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIPL',
    Issuer: 'DIREXION DAILY TIPS BULL 2X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIPT',
    Issuer: 'TIPTREE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIPX',
    Issuer: 'SPDR BLOOMBERG 1-10 YEAR TIP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIPZ',
    Issuer: 'PIMCO BROAD US TIPS INDEX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIRX',
    Issuer: 'TIAN RUIXIANG HOLDINGS LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TISI',
    Issuer: 'TEAM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TITN',
    Issuer: 'TITAN MACHINERY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIVC',
    Issuer: 'TIVIC HEALTH SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TIXT',
    Issuer: 'TELUS INTERNATIONAL CDA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TJX',
    Issuer: 'TJX COMPANIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TK',
    Issuer: 'TEEKAY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TKAT',
    Issuer: 'TAKUNG ART CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TKC',
    Issuer: 'TURKCELL ILETISIM HIZMET-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TKLF',
    Issuer: 'YOSHITSU CO LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TKNO',
    Issuer: 'ALPHA TEKNOVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TKR',
    Issuer: 'TIMKEN CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGA',
    Issuer: 'TLG ACQUISITION ONE COR-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGA=',
    Issuer: 'TLG ACQUISITION ONE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGY',
    Issuer: 'TLGY ACQUISITION CORP - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGYU',
    Issuer: 'TLGY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLGYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLH',
    Issuer: 'ISHARES 10-20 YEAR TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLIS',
    Issuer: 'TALIS BIOMEDICAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLK',
    Issuer: 'TELKOM INDONESIA PERSERO-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLRY',
    Issuer: 'TILRAY BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLS',
    Issuer: 'TELOS CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLSA',
    Issuer: 'TIZIANA LIFE SCIENCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLT',
    Issuer: 'ISHARES 20+ YEAR TREASURY BO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLTD',
    Issuer: 'FLEXSHARES MORNINGSTAR DEVEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLTE',
    Issuer: 'FLEXSHARES MORNINGSTAR EMERG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TLYS',
    Issuer: "TILLY'S INC-CLASS A SHRS",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TM',
    Issuer: 'TOYOTA MOTOR CORP -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMAC',
    Issuer: 'MUSIC ACQUISITION CORP/THE-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMAC=',
    Issuer: 'MUSIC ACQUISITION CORP/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMAT',
    Issuer: 'MAIN THEMATIC INNOVATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMBR',
    Issuer: 'TIMBER PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMC',
    Issuer: 'TMC THE METALS CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMCI',
    Issuer: 'TREACE MEDICAL CONCEPTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMCWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMDI',
    Issuer: 'TITAN MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMDV',
    Issuer: 'PROSHARES RUSSELL US DVD GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMDX',
    Issuer: 'TRANSMEDICS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TME',
    Issuer: 'TENCENT MUSIC ENTERTAINM-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMF',
    Issuer: 'DRX DLY 20+ YR TREAS BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFC',
    Issuer: 'MOTLEY FOOL 100 INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFE',
    Issuer: 'MOTLEY FOOL CAPITAL EFFICIE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFG',
    Issuer: 'MOTLEY FOOL GLOBAL OPP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFM',
    Issuer: 'MOTLEY FOOL MID-CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFS',
    Issuer: 'MOTLEY FOOL SMALL-CAP GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMFX',
    Issuer: 'MOTLEY FOOL NEXT INDEX ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMHC',
    Issuer: 'TAYLOR MORRISON HOME CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMKR',
    Issuer: 'TASTEMAKER ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMKRU',
    Issuer: 'TASTEMAKER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMKRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMO',
    Issuer: 'THERMO FISHER SCIENTIFIC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMP',
    Issuer: 'TOMPKINS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMPM',
    Issuer: 'TURMERIC ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMPMU',
    Issuer: 'TURMERIC ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMPMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMQ',
    Issuer: 'TRILOGY METALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMST',
    Issuer: 'TIMKENSTEEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMUS',
    Issuer: 'T-MOBILE US INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMV',
    Issuer: 'DRX DLY 20+ YR TREAS BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TMX',
    Issuer: 'TERMINIX GLOBAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNA',
    Issuer: 'DIREXION DLY SM CAP BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNC',
    Issuer: 'TENNANT CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNDM',
    Issuer: 'TANDEM DIABETES CARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNET',
    Issuer: 'TRINET GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNGX',
    Issuer: 'TANGO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNK',
    Issuer: 'TEEKAY TANKERS LTD-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNL',
    Issuer: 'TRAVEL + LEISURE CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNON',
    Issuer: 'TENON MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNP',
    Issuer: 'TSAKOS ENERGY NAVIGATION LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNP-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNP-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNP-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNXP',
    Issuer: 'TONIX PHARMACEUTICALS HOLDIN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TNYA',
    Issuer: 'TENAYA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOAC',
    Issuer: 'TALON 1 ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOACU',
    Issuer: 'TALON 1 ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOI',
    Issuer: 'ONCOLOGY INSTITUTE INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOIIW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOK',
    Issuer: 'ISHARES MSCI KOKUSAI ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOKE',
    Issuer: 'CAMBRIA CANNABIS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOL',
    Issuer: 'TOLL BROTHERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOLZ',
    Issuer: 'PROSHARES GLB INFRASTRUCTURE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOMZ',
    Issuer: 'TOMI ENVIRONMENTAL SOLUTIONS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOPS',
    Issuer: 'TOP SHIPS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOST',
    Issuer: 'TOAST INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOTL',
    Issuer: 'SPDR DOUBLELINE TR TACT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOTR',
    Issuer: 'T ROWE PRICE TOTAL RETURN ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOUR',
    Issuer: 'TUNIU CORP-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TOWN',
    Issuer: 'TOWNE BANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPAY',
    Issuer: 'ECOFIN DIGITAL PAYMENTS INFR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPB',
    Issuer: 'TURNING POINT BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPBA',
    Issuer: 'TPB ACQUISITION CORP I-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPBAU',
    Issuer: 'TPB ACQUISITION CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPBAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPC',
    Issuer: 'TUTOR PERINI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPG',
    Issuer: 'TPG INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPGY',
    Issuer: 'TPG PACE BENEFICIAL FIN-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPGY+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPGY=',
    Issuer: 'TPG PACE BENEFICIAL FINANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPH',
    Issuer: 'TRI POINTE HOMES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPHD',
    Issuer: 'TIMOTHY PLAN HIGH DVD STOCK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPHE',
    Issuer: 'TIMOTHY PLAN HIGH DIVIDEND S',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPHS',
    Issuer: 'TRINITY PLACE HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPIC',
    Issuer: 'TPI COMPOSITES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPIF',
    Issuer: 'TIMOTHY PLAN INTERNATIONAL E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPL',
    Issuer: 'TEXAS PACIFIC LAND CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPLC',
    Issuer: 'TIMOTHY PLAN US LARGE/MID CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPLE',
    Issuer: 'TIMOTHY PLAN US LARGE/MID CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPOR',
    Issuer: 'DRX DLY TRANSPORTS BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPR',
    Issuer: 'TAPESTRY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPSC',
    Issuer: 'TIMOTHY PLAN US SMALL CAP CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPST',
    Issuer: 'TEMPEST THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPTA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPTX',
    Issuer: 'TURNING POINT THERAPEUTICS I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPVG',
    Issuer: 'TRIPLEPOINT VENTURE GROWTH B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPX',
    Issuer: 'TEMPUR SEALY INTERNATIONAL I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPYP',
    Issuer: 'TORTOISE NORTH AMERICAN PIPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TPZ',
    Issuer: 'TORTOISE POWER & ENRGY INFRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TQQQ',
    Issuer: 'PROSHARES ULTRAPRO QQQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TR',
    Issuer: 'TOOTSIE ROLL INDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRAQ',
    Issuer: 'TRINE II ACQUISITION CORP -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRAQ=',
    Issuer: 'TRINE II ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRC',
    Issuer: 'TEJON RANCH CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRCA',
    Issuer: 'TWIN RIDGE CAPITAL ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRCA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRCA=',
    Issuer: 'TWIN RIDGE CAPITAL ACQUISITI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRDA',
    Issuer: 'ENTRADA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRDF',
    Issuer: 'NEXTGEN TREND AND DEFEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TREC',
    Issuer: 'TRECORA RESOURCES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TREE',
    Issuer: 'LENDINGTREE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TREX',
    Issuer: 'TREX COMPANY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRGP',
    Issuer: 'TARGA RESOURCES CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRHC',
    Issuer: 'TABULA RASA HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRI',
    Issuer: 'THOMSON REUTERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIB',
    Issuer: 'TRINITY BIOTECH PLC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIN',
    Issuer: 'TRINITY CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIP',
    Issuer: 'TRIPADVISOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIS',
    Issuer: 'TRISTAR ACQUISITION I CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIS+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRIS=',
    Issuer: 'TRISTAR ACQUISITION I CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRKA',
    Issuer: 'TROIKA MEDIA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRKAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRMB',
    Issuer: 'TRIMBLE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRMD',
    Issuer: 'TORM PLC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRMK',
    Issuer: 'TRUSTMARK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRMR',
    Issuer: 'TREMOR INTERNATIONAL LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRN',
    Issuer: 'TRINITY INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRND',
    Issuer: 'PACER TRENDPILOT FUNDS OF FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRNO',
    Issuer: 'TERRENO REALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRNS',
    Issuer: 'TRANSCAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRON',
    Issuer: 'CORNER GROWTH ACQUISITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRONU',
    Issuer: 'CORNER GROWTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRONW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TROO',
    Issuer: 'TROOPS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TROW',
    Issuer: 'T ROWE PRICE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TROX',
    Issuer: 'TRONOX HOLDINGS PLC- A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRP',
    Issuer: 'TC ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRPL',
    Issuer: 'PACER MET US LRG CAP DVD 300',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRQ',
    Issuer: 'TURQUOISE HILL RESOURCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRS',
    Issuer: 'TRIMAS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRST',
    Issuer: 'TRUSTCO BANK CORP NY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRT',
    Issuer: 'TRIO-TECH INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTL',
    Issuer: 'TORTOISEECOFIN ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTL=',
    Issuer: 'TORTOISEECOFIN ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN',
    Issuer: 'TRITON INTERNATIONAL LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTN-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTX',
    Issuer: 'TPG RE FINANCE TRUST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTX-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRTY',
    Issuer: 'CAMBRIA TRINITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRU',
    Issuer: 'TRANSUNION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRUE',
    Issuer: 'TRUECAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRUP',
    Issuer: 'TRUPANION INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRV',
    Issuer: 'TRAVELERS COS INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRVG',
    Issuer: 'TRIVAGO NV - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRVI',
    Issuer: 'TREVI THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRVN',
    Issuer: 'TREVENA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRX',
    Issuer: 'TANZANIAN GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TRYP',
    Issuer: 'SONICSHARES AIR HOTEL CRUISE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TS',
    Issuer: 'TENARIS SA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSAT',
    Issuer: 'TELESAT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSBK',
    Issuer: 'TIMBERLAND BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSC',
    Issuer: 'TRISTATE CAPITAL HLDGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSCAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSCBP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSCO',
    Issuer: 'TRACTOR SUPPLY COMPANY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSE',
    Issuer: 'TRINSEO PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSEM',
    Issuer: 'TOWER SEMICONDUCTOR LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSHA',
    Issuer: 'TAYSHA GENE THERAPIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSI',
    Issuer: 'TCW STRATEGIC INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSIB',
    Issuer: 'TISHMAN SPEYER INNOVATI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSIBU',
    Issuer: 'TISHMAN SPEYER INNOVATION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSIBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSJA',
    Issuer: 'INNOVATOR TRIPLE STACKER-JAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSLA',
    Issuer: 'TESLA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSLX',
    Issuer: 'SIXTH STREET SPECIALTY LENDI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSM',
    Issuer: 'TAIWAN SEMICONDUCTOR-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSN',
    Issuer: 'TYSON FOODS INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSOC',
    Issuer: 'INNOVATOR TRIPLE STACKER OCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSP',
    Issuer: 'TUSIMPLE HOLDINGS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSPA',
    Issuer: 'T ROWE PRICE US EQY RESEARCH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSPQ',
    Issuer: 'TCW SPECIAL PURPOSE ACQ-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSPQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSPQ=',
    Issuer: 'TCW SPECIAL PURPOSE ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSQ',
    Issuer: 'TOWNSQUARE MEDIA INC - CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSRI',
    Issuer: 'TSR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TSVT',
    Issuer: '2SEVENTY BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TT',
    Issuer: 'TRANE TECHNOLOGIES PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTAC',
    Issuer: 'FCF US QUALITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTAI',
    Issuer: 'FCF INTERNATIONAL QUALITY ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTC',
    Issuer: 'TORO CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTCF',
    Issuer: 'TATTOOED CHEF INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTD',
    Issuer: 'TRADE DESK INC/THE -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTE',
    Issuer: 'TOTALENERGIES SE -SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTEC',
    Issuer: 'TTEC HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTEK',
    Issuer: 'TETRA TECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTGT',
    Issuer: 'TECHTARGET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTI',
    Issuer: 'TETRA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTM',
    Issuer: 'TATA MOTORS LTD-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTMI',
    Issuer: 'TTM TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTNP',
    Issuer: 'TITAN PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTOO',
    Issuer: 'T2 BIOSYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTP',
    Issuer: 'TORTOISE PIPELINE & ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTSH',
    Issuer: 'TILE SHOP HLDGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTT',
    Issuer: 'PROSHARES ULT -3X 20+ YR TSY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TTWO',
    Issuer: 'TAKE-TWO INTERACTIVE SOFTWRE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TU',
    Issuer: 'TELUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUEM',
    Issuer: 'TUESDAY MORNING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUFN',
    Issuer: 'TUFIN SOFTWARE TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUG',
    Issuer: 'STF TACTICAL GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUGN',
    Issuer: 'STF TACTICAL GROWTH INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUP',
    Issuer: 'TUPPERWARE BRANDS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUR',
    Issuer: 'ISHARES MSCI TURKEY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TURN',
    Issuer: '180 DEGREE CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUSK',
    Issuer: 'MAMMOTH ENERGY SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TUYA',
    Issuer: 'TUYA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TV',
    Issuer: 'GRUPO TELEVISA SA-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TVC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TVE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TVTX',
    Issuer: 'TRAVERE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TVTY',
    Issuer: 'TIVITY HEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TW',
    Issuer: 'TRADEWEB MARKETS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWCB',
    Issuer: 'BILANDER ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWCBU',
    Issuer: 'BILANDER ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWCBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWI',
    Issuer: 'TITAN INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWIN',
    Issuer: 'TWIN DISC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWIO',
    Issuer: 'TRAJAN WEALTH INCOME OPPORTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWKS',
    Issuer: 'THOUGHTWORKS HOLDING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWLO',
    Issuer: 'TWILIO INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWLV',
    Issuer: 'TWELVE SEAS INVTMNT CO II -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWLVU',
    Issuer: 'TWELVE SEAS INVESTMENT CO II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWLVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWM',
    Issuer: 'PROSHARES ULTRASHORT R2000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWN',
    Issuer: 'TAIWAN FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWND',
    Issuer: 'TAILWIND ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWND+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWND=',
    Issuer: 'TAILWIND ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWNI',
    Issuer: 'TAILWIND INTERNATIONAL ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWNI+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWNI=',
    Issuer: 'TAILWIND INTERNATIONAL ACQUI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWNK',
    Issuer: 'HOSTESS BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWO',
    Issuer: 'TWO HARBORS INVESTMENT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWO-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWO-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWO-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWOA',
    Issuer: 'TWO - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWOU',
    Issuer: '2U INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWST',
    Issuer: 'TWIST BIOSCIENCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TWTR',
    Issuer: 'TWITTER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TX',
    Issuer: 'TERNIUM SA-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TXG',
    Issuer: '10X GENOMICS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TXMD',
    Issuer: 'THERAPEUTICSMD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TXN',
    Issuer: 'TEXAS INSTRUMENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TXRH',
    Issuer: 'TEXAS ROADHOUSE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TXT',
    Issuer: 'TEXTRON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TY',
    Issuer: 'TRI-CONTINENTAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TY-',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYA',
    Issuer: 'SIMPLIFY RISK PARITY TREASUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYD',
    Issuer: 'DRX DLY 7-10 Y TREAS BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYDEV',
    Issuer: 'CRYPTYDE INC-W/I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYG',
    Issuer: 'TORTOISE ENERGY INFRASTRUCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYL',
    Issuer: 'TYLER TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYME',
    Issuer: 'TYME TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYNE',
    Issuer: 'DIREXION NANOTECHNOLOGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYO',
    Issuer: 'DRX DLY 7-10 Y TREAS BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TYRA',
    Issuer: 'TYRA BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TZA',
    Issuer: 'DIREXION DLY SM CAP BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TZOO',
    Issuer: 'TRAVELZOO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TZPS',
    Issuer: 'TZP STRATEGIES ACQUISI-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TZPSU',
    Issuer: 'TZP STRATEGIES ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'TZPSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'U',
    Issuer: 'UNITY SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UA',
    Issuer: 'UNDER ARMOUR INC-CLASS C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAA',
    Issuer: 'UNDER ARMOUR INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAE',
    Issuer: 'ISHARES MSCI UAE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAL',
    Issuer: 'UNITED AIRLINES HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAMY',
    Issuer: 'UNITED STATES ANTIMONY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAN',
    Issuer: 'CVR PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAPR',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAUG',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAV',
    Issuer: 'ADVISORSHARES DRONE TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UAVS',
    Issuer: 'AGEAGLE AERIAL SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBA',
    Issuer: 'URSTADT BIDDLE - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBCB',
    Issuer: 'UBC ALGORITHMIC FUNDAMENTALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBCP',
    Issuer: 'UNITED BANCORP INC/OHIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBER',
    Issuer: 'UBER TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBFO',
    Issuer: 'UNITED SECURITY BANCSHARE/CA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBND',
    Issuer: 'VICTORYSHARES ESG CORE PLUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBOH',
    Issuer: 'UNITED BANCSHARES INC/OHIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBOT',
    Issuer: 'DIREXION DAILY ROBOTICS ART',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBP',
    Issuer: 'URSTADT BIDDLE PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBP-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBP-K',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBR',
    Issuer: 'PROSHARES ULTRA MSCI BRAZIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBS',
    Issuer: 'UBS GROUP AG-REG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBSI',
    Issuer: 'UNITED BANKSHARES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBT',
    Issuer: 'PROSHARES ULTRA 20+ YEAR TSY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UBX',
    Issuer: 'UNITY BIOTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCBI',
    Issuer: 'UNITED COMMUNITY BANKS/GA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCBIO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCC',
    Issuer: 'PROSHARES ULTRA CONS SERVICE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCIB',
    Issuer: 'ETRACS UBS BBG CONS MA SER B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCL',
    Issuer: 'UCLOUDLINK GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCO',
    Issuer: 'PROSHARES ULTRA BLOOMBERG CR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCON',
    Issuer: 'FIRST TRUST TCW UNCONSTRAINE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCRD',
    Issuer: 'VICTORYSHARES ESG CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCTT',
    Issuer: 'ULTRA CLEAN HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UCYB',
    Issuer: 'PROSHARES ULTRA NASDAQ CYBR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UDEC',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UDMY',
    Issuer: 'UDEMY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UDN',
    Issuer: 'INVESCO DB US DOLLAR INDEX B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UDOW',
    Issuer: 'PROSHARES ULTRAPRO DOW30',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UDR',
    Issuer: 'UDR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UE',
    Issuer: 'URBAN EDGE PROPERTIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UEC',
    Issuer: 'URANIUM ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UEIC',
    Issuer: 'UNIVERSAL ELECTRONICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UEVM',
    Issuer: 'VICTORYSHARES USAA MSCI EMER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFAB',
    Issuer: 'UNIQUE FABRICATING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFCS',
    Issuer: 'UNITED FIRE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFEB',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFI',
    Issuer: 'UNIFI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFO',
    Issuer: 'PROCURE SPACE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFPI',
    Issuer: 'UFP INDUSTRIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UFPT',
    Issuer: 'UFP TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UG',
    Issuer: 'UNITED GUARDIAN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGA',
    Issuer: 'UNITED STATES GAS FUND LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGCE',
    Issuer: 'UNCOMMON PORT DES CORE EQTY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGE',
    Issuer: 'PROSHARES ULTRA CONSUM GOODS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGI',
    Issuer: 'UGI CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGIC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGL',
    Issuer: 'PROSHARES ULTRA GOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGP',
    Issuer: 'ULTRAPAR PARTICPAC-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UGRO',
    Issuer: 'URBAN-GRO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UHAL',
    Issuer: 'AMERCO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UHS',
    Issuer: 'UNIVERSAL HEALTH SERVICES-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UHT',
    Issuer: 'UNIVERSAL HEALTH RLTY INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UI',
    Issuer: 'UBIQUITI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UIHC',
    Issuer: 'UNITED INSURANCE HOLDINGS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UIS',
    Issuer: 'UNISYS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UITB',
    Issuer: 'VICTORYSHARES USAA CORE INTE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UIVM',
    Issuer: 'VICTORYSHARES USAA MSCI INTE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UJAN',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UJB',
    Issuer: 'PROSHARES ULTRA HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UJUL',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UJUN',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UK',
    Issuer: 'UCOMMUNE INTERNATIONAL LTD-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UKOMW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UL',
    Issuer: 'UNILEVER PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULBI',
    Issuer: 'ULTRALIFE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULCC',
    Issuer: 'FRONTIER GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULE',
    Issuer: 'PROSHARES ULTRA EURO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULH',
    Issuer: 'UNIVERSAL LOGISTICS HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULST',
    Issuer: 'SPDR ULTRA SHORT-TERM BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULTA',
    Issuer: 'ULTA BEAUTY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULTR',
    Issuer: 'IQ ULTRA SHORT DURATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ULVM',
    Issuer: 'VICTORYSHARES USAA MSCI USA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMAR',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMAY',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMBF',
    Issuer: 'UMB FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMC',
    Issuer: 'UNITED MICROELECTRON-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMDD',
    Issuer: 'PROSHARES ULTRAPRO MIDCAP400',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMH',
    Issuer: 'UMH PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMH-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMH-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMI',
    Issuer: 'USCF MIDSTREAM ENERGY INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMMA',
    Issuer: 'WAHED DOW JONES ISLAMIC WRLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UMPQ',
    Issuer: 'UMPQUA HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNAM',
    Issuer: 'UNICO AMERICAN CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNB',
    Issuer: 'UNION BANKSHARES INC /VT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNCY',
    Issuer: 'UNICYCIVE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNF',
    Issuer: 'UNIFIRST CORP/MA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNFI',
    Issuer: 'UNITED NATURAL FOODS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNG',
    Issuer: 'US NATURAL GAS FUND LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNH',
    Issuer: 'UNITEDHEALTH GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNIT',
    Issuer: 'UNITI GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNL',
    Issuer: 'UNITED STATES 12 MONTH NATUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNM',
    Issuer: 'UNUM GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNMA',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNOV',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNP',
    Issuer: 'UNION PACIFIC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNTY',
    Issuer: 'UNITY BANCORP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UNVR',
    Issuer: 'UNIVAR SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UOCT',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UONE',
    Issuer: 'URBAN ONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UONEK',
    Issuer: 'URBAN ONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UP',
    Issuer: 'WHEELS UP EXPERIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UP+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPAR',
    Issuer: 'ULTRA RISK PARITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPC',
    Issuer: 'UNIVERSE PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPH',
    Issuer: 'UPHEALTH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPH+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPLD',
    Issuer: 'UPLAND SOFTWARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPRO',
    Issuer: 'PROSHARES ULTRAPRO S&P 500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPS',
    Issuer: 'UNITED PARCEL SERVICE-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPST',
    Issuer: 'UPSTART HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPTD',
    Issuer: 'TRADEUP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPTDU',
    Issuer: 'TRADEUP ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPTDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPV',
    Issuer: 'PROSHARES ULTRA FTSE EUROPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPW',
    Issuer: 'PROSHARES ULTRA UTILITIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UPWK',
    Issuer: 'UPWORK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URA',
    Issuer: 'GLOBAL X URANIUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URBN',
    Issuer: 'URBAN OUTFITTERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URE',
    Issuer: 'PROSHARES ULTRA REAL ESTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URG',
    Issuer: 'UR-ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URGN',
    Issuer: 'UROGEN PHARMA LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URI',
    Issuer: 'UNITED RENTALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URNM',
    Issuer: 'SPROTT URANIUM MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UROY',
    Issuer: 'URANIUM ROYALTY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URTH',
    Issuer: 'ISHARES MSCI WORLD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'URTY',
    Issuer: 'PROSHARES ULTRAPRO RUSS2000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USA',
    Issuer: 'LIBERTY ALL STAR EQUITY FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAC',
    Issuer: 'USA COMPRESSION PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAI',
    Issuer: 'PACER AMERICAN ENERGY INDEPE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAK',
    Issuer: 'USA TRUCK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAP',
    Issuer: 'UNIVERSAL STAINLESS & ALLOY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAS',
    Issuer: 'AMERICAS GOLD AND SILVER COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USAU',
    Issuer: 'US GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB',
    Issuer: 'US BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-P',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-R',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USB-S',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USBF',
    Issuer: 'ISHARES USD BOND FACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USCB',
    Issuer: 'USCB FINANCIAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USCI',
    Issuer: 'UNITED STATES COMMODITY INDE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USCT',
    Issuer: 'TKB CRITICAL TECHNOLOGIES -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USCTU',
    Issuer: 'TKB CRITICAL TECHNOLOGIES 1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USCTW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USD',
    Issuer: 'PROSHARES ULTRA SEMICONDUCT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USDP',
    Issuer: 'USD PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USDU',
    Issuer: 'WISDOMTREE BBG USD BULLISH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USEG',
    Issuer: 'U S ENERGY CORP - WYOMING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USEP',
    Issuer: 'INNOVATOR U.S. EQUITY ULTRA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USEQ',
    Issuer: 'INVESCO RUSSELL 1000 ENHANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USER',
    Issuer: 'USERTESTING INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USFD',
    Issuer: 'US FOODS HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USFR',
    Issuer: 'WISDOMTREE FLOATING RATE TRE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USHY',
    Issuer: 'ISHARES BROAD USD HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USI',
    Issuer: 'PRINCIPAL ULTRA-SHORT ACTIVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USIG',
    Issuer: 'ISHARES BROAD USD INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USIO',
    Issuer: 'USIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USL',
    Issuer: 'UNITED STATES 12 MONTH OIL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USLB',
    Issuer: 'INVESCO RUSSELL 1000 LOW BET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USLM',
    Issuer: 'UNITED STATES LIME & MINERAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USM',
    Issuer: 'US CELLULAR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USMC',
    Issuer: 'PRINCIPAL US MEGA-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USMF',
    Issuer: 'WISDOMTREE US MULTIFACTOR FU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USML',
    Issuer: 'ETRACS 2X MINVOL FACTR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USMV',
    Issuer: 'ISHARES MSCI USA MIN VOL FAC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USNA',
    Issuer: 'USANA HEALTH SCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USO',
    Issuer: 'UNITED STATES OIL FUND LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USOI',
    Issuer: 'X-LINKS CRUDE OIL COV CALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USPH',
    Issuer: 'U.S. PHYSICAL THERAPY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USRT',
    Issuer: 'ISHARES CORE US REIT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USSG',
    Issuer: 'XTRACKERS MSCI USA ESG LDRS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UST',
    Issuer: 'PROSHARES ULTRA 7-10 YEAR TR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USTB',
    Issuer: 'VICTORYSHARES USAA CORE SHOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USVM',
    Issuer: 'VICTORYSHARES USAA MSCI USA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USVT',
    Issuer: 'US VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USWS',
    Issuer: 'US WELL SERVICES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USWSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USX',
    Issuer: 'US XPRESS ENTERPRISES INC -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'USXF',
    Issuer: 'ISHARES ESG ADVANCE MSCI USA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTAA',
    Issuer: 'UTA ACQUISITION CORPORATIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTAAU',
    Issuer: 'UTA ACQUISITION CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTAAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTES',
    Issuer: 'VIRTUS REAVES UTILITIES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTF',
    Issuer: 'COHEN & STEERS INFRASTRUCTUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTG',
    Issuer: 'REAVES UTILITY INCOME FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTHR',
    Issuer: 'UNITED THERAPEUTICS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTI',
    Issuer: 'UNIVERSAL TECHNICAL INSTITUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTL',
    Issuer: 'UNITIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTMD',
    Issuer: 'UTAH MEDICAL PRODUCTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTME',
    Issuer: 'UTIME LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTRN',
    Issuer: 'VESPER US LARGE CAP SHORT TE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTRS',
    Issuer: 'MINERVA SURGICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTSI',
    Issuer: 'UTSTARCOM HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTSL',
    Issuer: 'DRX DLY UTILITIES BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UTZ',
    Issuer: 'UTZ BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UUP',
    Issuer: 'INVESCO DB US DOLLAR INDEX B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UUU',
    Issuer: 'UNIVERSAL SECURITY INSTRUMNT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UUUU',
    Issuer: 'ENERGY FUELS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVDV',
    Issuer: 'UVA DIVIDEND VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVE',
    Issuer: 'UNIVERSAL INSURANCE HOLDINGS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVIX',
    Issuer: '2X LONG VIX FUTURES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVSP',
    Issuer: 'UNIVEST FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVV',
    Issuer: 'UNIVERSAL CORP/VA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UVXY',
    Issuer: 'PROSHARES ULTRA VIX ST FUTUR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UWM',
    Issuer: 'PROSHARES ULTRA RUSSELL2000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UWMC',
    Issuer: 'UWM HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UWMC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UXI',
    Issuer: 'PROSHARES ULTRA INDUSTRIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UXIN',
    Issuer: 'UXIN LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UYG',
    Issuer: 'PROSHARES ULTRA FINANCIALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UYM',
    Issuer: 'PROSHARES ULTRA BASIC MATERI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UZD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UZE',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'UZF',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'V',
    Issuer: 'VISA INC-CLASS A SHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VABK',
    Issuer: 'VIRGINIA NATIONAL BANKSHARES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VABS',
    Issuer: 'VIRTUS NEWFLEET ABS/MBS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAC',
    Issuer: 'MARRIOTT VACATIONS WORLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VACC',
    Issuer: 'VACCITECH PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAL',
    Issuer: 'VALARIS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VALE',
    Issuer: 'VALE SA-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VALN',
    Issuer: 'VALNEVA SE - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VALQ',
    Issuer: 'AMERICAN CENTURY STOXX US',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VALT',
    Issuer: 'ETFMG SIT ULTRA SHORT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VALU',
    Issuer: 'VALUE LINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAMO',
    Issuer: 'CAMBRIA VALUE & MOMENTUM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAPO',
    Issuer: 'VAPOTHERM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAQC',
    Issuer: 'VECTOR ACQUISITION CORP II-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VATE',
    Issuer: 'INNOVATE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAW',
    Issuer: 'VANGUARD MATERIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VAXX',
    Issuer: 'VAXXINITY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VB',
    Issuer: 'VANGUARD SMALL-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBB',
    Issuer: 'VALKYRIE BALANCE SHEET OPPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBF',
    Issuer: 'INVESCO BOND FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBFC',
    Issuer: 'VILLAGE BANK AND TRUST FINAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBIV',
    Issuer: 'VBI VACCINES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBK',
    Issuer: 'VANGUARD SMALL-CAP GRWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBLT',
    Issuer: 'VASCULAR BIOGENICS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBND',
    Issuer: 'VIDENT CORE US BOND STRATEGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBNK',
    Issuer: 'VERSABANK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBOC',
    Issuer: 'VISCOGLIOSI BROTHERS ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBOCU',
    Issuer: 'VISCOGLIOSI BROTHERS ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBOCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBR',
    Issuer: 'VANGUARD SMALL-CAP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VBTX',
    Issuer: 'VERITEX HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VC',
    Issuer: 'VISTEON CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCAR',
    Issuer: 'SIMPLIFY VOLT ROBOCAR DISRUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCEB',
    Issuer: 'VANGUARD ESG US CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCEL',
    Issuer: 'VERICEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCIF',
    Issuer: 'VERTICAL CAPITAL INCOME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCIT',
    Issuer: 'VANGUARD INT-TERM CORPORATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCKA',
    Issuer: 'VICKERS VANTAGE CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCKAU',
    Issuer: 'VICKERS VANTAGE CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCKAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCLN',
    Issuer: 'VIRTUS DUFF & PHELPS CLEAN E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCLO',
    Issuer: 'S/V CLOUD & CYBERSECURITY DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCLT',
    Issuer: 'VANGUARD LONG-TERM CORP BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCNX',
    Issuer: 'VACCINEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCR',
    Issuer: 'VANGUARD CONSUMER DISCRE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCSA',
    Issuer: 'VACASA INC -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCSH',
    Issuer: 'VANGUARD S/T CORP BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCTR',
    Issuer: 'VICTORY CAPITAL HOLDING - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCV',
    Issuer: 'INVESCO CA V M I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXA',
    Issuer: '10X CAPITAL VENTURE ACQUIS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXAU',
    Issuer: '10X CAPITAL VENTURE ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXB',
    Issuer: '10X CAPITAL VENTURE ACQUIS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCXB=',
    Issuer: '10X CAPITAL VENTURE ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VCYT',
    Issuer: 'VERACYTE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VDC',
    Issuer: 'VANGUARD CONSUMER STAPLE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VDE',
    Issuer: 'VANGUARD ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VDNI',
    Issuer: 'V-SHARES US LEADER DIVERSITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEA',
    Issuer: 'VANGUARD FTSE DEVELOPED ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEC',
    Issuer: 'VECTRUS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VECO',
    Issuer: 'VEECO INSTRUMENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VECT',
    Issuer: 'VECTIVBIO HOLDING AG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEDU',
    Issuer: 'VISIONARY EDUCATION TECHNOLO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEEE',
    Issuer: 'TWIN VEE POWERCATS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEEV',
    Issuer: 'VEEVA SYSTEMS INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEGA',
    Issuer: 'ADVSHRS STAR GBL BUY-WRITE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEGI',
    Issuer: 'ISHARES MSCI GLOBAL AGRICULT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEGN',
    Issuer: 'US VEGAN CLIMATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEL',
    Issuer: 'VELOCITY FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VELO',
    Issuer: 'VELOCITY ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VELOU',
    Issuer: 'VELOCITY ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VELOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VENA',
    Issuer: 'VENUS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VENAR',
    Issuer: 'VENUS ACQUISITION CORP -RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VENAU',
    Issuer: 'VENUS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VENAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEON',
    Issuer: 'VEON LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERA',
    Issuer: 'VERA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERB',
    Issuer: 'VERB TECHNOLOGY CO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERI',
    Issuer: 'VERITONE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERO',
    Issuer: 'VENUS CONCEPT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERS',
    Issuer: 'PROSHARES METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERU',
    Issuer: 'VERU INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERV',
    Issuer: 'VERVE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERX',
    Issuer: 'VERTEX INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VERY',
    Issuer: 'VERICITY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VET',
    Issuer: 'VERMILION ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEU',
    Issuer: 'VANGUARD FTSE ALL-WORLD EX-U',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VEV',
    Issuer: 'VICINITY MOTOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFC',
    Issuer: 'VF CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFF',
    Issuer: 'VILLAGE FARMS INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFH',
    Issuer: 'VANGUARD FINANCIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFIN',
    Issuer: 'SIMPLIFY VOLT FINTECH DISRUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFL',
    Issuer: 'DELAWARE INV NATL MUNI INC F',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFLQ',
    Issuer: 'VANGUARD US LIQUIDITY FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFMF',
    Issuer: 'VANGUARD US MULTIFACTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFMO',
    Issuer: 'VANGUARD US MOMENTUM FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFMV',
    Issuer: 'VANGUARD US MINIMUM VOLATILI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFQY',
    Issuer: 'VANGUARD U.S. QUALITY FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VFVA',
    Issuer: 'VANGUARD U.S. VALUE FACTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VG',
    Issuer: 'VONAGE HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGFC',
    Issuer: 'VERY GOOD FOOD CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGI',
    Issuer: 'VIRTUS GLOBAL MULTI-SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGII',
    Issuer: 'VIRGIN GROUP ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGII+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGII=',
    Issuer: 'VIRGIN GROUP ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGIT',
    Issuer: 'VANGUARD INTERMEDIATE-TERM T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGK',
    Issuer: 'VANGUARD FTSE EUROPE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGLT',
    Issuer: 'VANGUARD LONG-TERM TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGM',
    Issuer: 'INVESCO TRUST FOR INVESTMEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGR',
    Issuer: 'VECTOR GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGSH',
    Issuer: 'VANGUARD SHORT-TERM TREASURY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGT',
    Issuer: 'VANGUARD INFO TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VGZ',
    Issuer: 'VISTA GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHAQ',
    Issuer: 'VIVEON HEALTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHAQ+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHAQ=',
    Issuer: 'VIVEON HEALTH ACQUISITION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHAQ^',
    Issuer: 'VIVEON HEALTH ACQUISIT-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHC',
    Issuer: 'VIRNETX HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHI',
    Issuer: 'VALHI INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHNA',
    Issuer: 'VAHANNA TECH EDGE ACQUISI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHNAU',
    Issuer: 'VAHANNA TECH EDGE ACQUISITIO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHNAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VHT',
    Issuer: 'VANGUARD HEALTH CARE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIA',
    Issuer: 'VIA RENEWABLES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIAO',
    Issuer: 'VIA OPTRONICS AG',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIASP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIAV',
    Issuer: 'VIAVI SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VICE',
    Issuer: 'ADVISORSHARES VICE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VICI',
    Issuer: 'VICI PROPERTIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VICR',
    Issuer: 'VICOR CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIDI',
    Issuer: 'VIDENT INTERNATIONAL EQUITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIEW',
    Issuer: 'VIEW INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIEWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIG',
    Issuer: 'VANGUARD DIVIDEND APPREC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIGI',
    Issuer: 'VANGUARD INT DIV APP INDX FD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIGL',
    Issuer: 'VIGIL NEUROSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VII',
    Issuer: '7GC & CO HOLDINGS INC -CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIIAU',
    Issuer: '7GC & CO HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIIAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VINC',
    Issuer: 'VINCERX PHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VINE',
    Issuer: 'FRESH VINE WINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VINO',
    Issuer: 'GAUCHO GROUP HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VINP',
    Issuer: 'VINCI PARTNERS INVESTMENTS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIOG',
    Issuer: 'VANGUARD S&P SMALL-CAP 600 G',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIOO',
    Issuer: 'VANGUARD S&P SMALL-CAP 600 E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIOT',
    Issuer: 'VIOMI TECHNOLOGY CO LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIOV',
    Issuer: 'VANGUARD S&P SMALL-CAP 600 V',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIPS',
    Issuer: 'VIPSHOP HOLDINGS LTD - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIR',
    Issuer: 'VIR BIOTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIRC',
    Issuer: 'VIRCO MFG CORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIRI',
    Issuer: 'VIRIOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIRS',
    Issuer: 'PACER BIOTHREAT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIRT',
    Issuer: 'VIRTU FINANCIAL INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIRX',
    Issuer: 'VIRACTA THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIS',
    Issuer: 'VANGUARD INDUSTRIALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VISL',
    Issuer: 'VISLINK TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIST',
    Issuer: 'VISTA OIL & GAS SAB DE CV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VITL',
    Issuer: 'VITAL FARMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIV',
    Issuer: 'TELEFONICA BRASIL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIVE',
    Issuer: 'VIVEVE MEDICAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIVK',
    Issuer: 'VIVAKOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIVO',
    Issuer: 'MERIDIAN BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIXM',
    Issuer: 'PROSHARES VIX MID-TERM FUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VIXY',
    Issuer: 'PROSHARES VIX SHORT-TERM FUT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VJET',
    Issuer: 'VOXELJET AG-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VKI',
    Issuer: 'INVESCO AD MIT II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VKQ',
    Issuer: 'INVESCO MUNICIPAL TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VKTX',
    Issuer: 'VIKING THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLAT',
    Issuer: 'VALOR LATITUDE ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLATU',
    Issuer: 'VALOR LATITUDE ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLATW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLCN',
    Issuer: 'VOLCON INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLD',
    Issuer: 'VELO3D INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLD+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLDR',
    Issuer: 'VELODYNE LIDAR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLDRW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLGEA',
    Issuer: 'VILLAGE SUPER MARKET-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLN',
    Issuer: 'VALENS SEMICONDUCTOR LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLNS',
    Issuer: 'VALENS CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLO',
    Issuer: 'VALERO ENERGY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLON',
    Issuer: 'VALLON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLRS',
    Issuer: 'CONTROLADORA VUELA CIA-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLT',
    Issuer: 'INVESCO HIGH INCOME TRUST II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLTA',
    Issuer: 'VOLTA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLTA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLU',
    Issuer: 'SPDR S&P 1500 VALUE TILT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLUE',
    Issuer: 'ISHARES MSCI USA VALUE FACTO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLY',
    Issuer: 'VALLEY NATIONAL BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLYPO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VLYPP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMAR',
    Issuer: 'VISION MARINE TECHNOLOGIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMBS',
    Issuer: 'VANGUARD MORTGAGE-BACKED SEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMC',
    Issuer: 'VULCAN MATERIALS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMCA',
    Issuer: 'VALUENCE MERGER CORP I-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMCAU',
    Issuer: 'VALUENCE MERGER CORP I',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMCAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMD',
    Issuer: 'VIEMED HEALTHCARE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMEO',
    Issuer: 'VIMEO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMGA',
    Issuer: 'VMG CONSUMER ACQUISITION C-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMGAU',
    Issuer: 'VMG CONSUMER ACQUISITION COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMGAW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMI',
    Issuer: 'VALMONT INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMO',
    Issuer: 'INVESCO MUNICIPAL OPPORTUNI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMOT',
    Issuer: 'ALPHA VALUE MOM TREND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VMW',
    Issuer: 'VMWARE INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNAM',
    Issuer: 'GLOBAL X MSCI VIETNAM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNCE',
    Issuer: 'VINCE HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNDA',
    Issuer: 'VANDA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNET',
    Issuer: 'VNET GROUP INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNLA',
    Issuer: 'JANUS HENDERSON SHORT DURATI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNM',
    Issuer: 'VANECK VIETNAM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNMC',
    Issuer: 'NATIXIS VAUGHAN NELSON MIDC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNO',
    Issuer: 'VORNADO REALTY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNO-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNO-M',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNO-N',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNO-O',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNOM',
    Issuer: 'VIPER ENERGY PARTNERS LP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNQ',
    Issuer: 'VANGUARD REAL ESTATE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNQI',
    Issuer: 'VANGUARD GLBL EX-US REAL EST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNRX',
    Issuer: 'VOLITIONRX LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNSE',
    Issuer: 'NATIXIS VAUGHN NELSON SELECT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNT',
    Issuer: 'VONTIER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VNTR',
    Issuer: 'VENATOR MATERIALS PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VO',
    Issuer: 'VANGUARD MID-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOC',
    Issuer: 'VOC ENERGY TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOD',
    Issuer: 'VODAFONE GROUP PLC-SP ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOE',
    Issuer: 'VANGUARD MID-CAP VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VONE',
    Issuer: 'VANGUARD RUSSELL 1000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VONG',
    Issuer: 'VANGUARD RUSSELL 1000 GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VONV',
    Issuer: 'VANGUARD RUSSELL 1000 VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOO',
    Issuer: 'VANGUARD S&P 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOOG',
    Issuer: 'VANGUARD S&P 500 GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOOV',
    Issuer: 'VANGUARD S&P 500 VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOR',
    Issuer: 'VOR BIOPHARMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VORB',
    Issuer: 'VIRGIN ORBIT HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VORBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOT',
    Issuer: 'VANGUARD MID-CAP GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOTE',
    Issuer: 'ENGINE NO1 TRANSFORM 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOX',
    Issuer: 'VANGUARD COMMUNICATION SERVI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOXX',
    Issuer: 'VOXX INTERNATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOYA',
    Issuer: 'VOYA FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VOYA-B',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPC',
    Issuer: 'VIRTUS PRIVATE CREDIT STRATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPCB',
    Issuer: 'VPC IMPACT ACQUISITION HOL-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPCBU',
    Issuer: 'VPC IMPACT ACQUISITION HOLD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPCBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPG',
    Issuer: 'VISHAY PRECISION GROUP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPL',
    Issuer: 'VANGUARD FTSE PACIFIC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPN',
    Issuer: 'GLOBAL X DATA CENTER REITS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPOP',
    Issuer: 'SIMPLIFY VOLT POP CULT DISRU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPU',
    Issuer: 'VANGUARD UTILITIES ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VPV',
    Issuer: 'INVESCO PENNSYLVANIA VALUE M',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VQS',
    Issuer: 'VIQ SOLUTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VR',
    Issuer: 'GLOBAL X METAVERSE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRA',
    Issuer: 'VERA BRADLEY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRAI',
    Issuer: 'VIRTUS REAL ASSET INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRAR',
    Issuer: 'GLIMPSE GROUP INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRAY',
    Issuer: 'VIEWRAY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRCA',
    Issuer: 'VERRICA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRDN',
    Issuer: 'VIRIDIAN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRE',
    Issuer: 'VERIS RESIDENTIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VREX',
    Issuer: 'VAREX IMAGING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRIG',
    Issuer: 'INVESCO VARIABLE RATE INVEST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRM',
    Issuer: 'VROOM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRME',
    Issuer: 'VERIFYME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRMEW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRNA',
    Issuer: 'VERONA PHARMA PLC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRNS',
    Issuer: 'VARONIS SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRNT',
    Issuer: 'VERINT SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRP',
    Issuer: 'INVESCO VARIABLE RATE PREFER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRPX',
    Issuer: 'VIRPAX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRRM',
    Issuer: 'VERRA MOBILITY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRSK',
    Issuer: 'VERISK ANALYTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRSN',
    Issuer: 'VERISIGN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRT',
    Issuer: 'VERTIV HOLDINGS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRTS',
    Issuer: 'VIRTUS INVESTMENT PARTNERS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRTV',
    Issuer: 'VERITIV CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VRTX',
    Issuer: 'VERTEX PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VS',
    Issuer: 'VERSUS SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSAC',
    Issuer: 'VISION SENSING ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSACU',
    Issuer: 'VISION SENSING ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSAT',
    Issuer: 'VIASAT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSCO',
    Issuer: "VICTORIA'S SECRET & CO",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSDA',
    Issuer: 'VICTORYSHARES DIVIDEND ACCEL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSEC',
    Issuer: 'VSE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSGX',
    Issuer: 'VANGUARD ESG INTL STOCK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSH',
    Issuer: 'VISHAY INTERTECHNOLOGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSL',
    Issuer: 'VOLSHARES LARGE CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSLU',
    Issuer: 'APPLIED FINANCE VALUATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSMV',
    Issuer: 'VICTORYSHARES US MIN VOL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSPY',
    Issuer: 'VECTORSHARES MIN VOL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSS',
    Issuer: 'VANGUARD FTSE ALL WO X-US SC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSSYW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VST',
    Issuer: 'VISTRA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VST+A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSTA',
    Issuer: 'VASTA PLATFORM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSTM',
    Issuer: 'VERASTEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VSTO',
    Issuer: 'VISTA OUTDOOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VT',
    Issuer: 'VANGUARD TOT WORLD STK ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTAQ',
    Issuer: 'VENTOUX CCM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTAQR',
    Issuer: 'VENTOUX CCM ACQUISITION-RGT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTAQU',
    Issuer: 'VENTOUX CCM ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTC',
    Issuer: 'VANGUARD TOTAL CORPORATE BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTEB',
    Issuer: 'VANGUARD TAX-EXEMPT BOND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTEX',
    Issuer: 'VTEX -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTGN',
    Issuer: 'VISTAGEN THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTHR',
    Issuer: 'VANGUARD RUSSELL 3000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTI',
    Issuer: 'VANGUARD TOTAL STOCK MKT ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTIP',
    Issuer: 'VANGUARD SHORT-TERM TIPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTIQ',
    Issuer: 'VECTOIQ ACQUISITION CO-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTIQU',
    Issuer: 'VECTOIQ ACQUISITION CORP II',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTIQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTN',
    Issuer: 'INVESCO TRUST FOR INVESTMENT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTNR',
    Issuer: 'VERTEX ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTOL',
    Issuer: 'BRISTOW GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTR',
    Issuer: 'VENTAS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTRS',
    Issuer: 'VIATRIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTRU',
    Issuer: 'VITRU LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTSI',
    Issuer: 'VIRTRA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTV',
    Issuer: 'VANGUARD VALUE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTVT',
    Issuer: 'VTV THERAPEUTICS INC- CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTWG',
    Issuer: 'VANGUARD RUSSELL 2000 GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTWO',
    Issuer: 'VANGUARD RUSSELL 2000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTWV',
    Issuer: 'VANGUARD RUSSELL 2000 VALUE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VTYX',
    Issuer: 'VENTYX BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VUG',
    Issuer: 'VANGUARD GROWTH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VUSB',
    Issuer: 'VANGUARD ULTRA SHORT BOND ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VUSE',
    Issuer: 'VIDENT CORE US EQUITY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VUZI',
    Issuer: 'VUZIX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VV',
    Issuer: 'VANGUARD LARGE-CAP ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVI',
    Issuer: 'VIAD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVNT',
    Issuer: 'VIVINT SMART HOME INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVOS',
    Issuer: 'VIVOS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVPR',
    Issuer: 'VIVOPOWER INTERNATIONAL PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVR',
    Issuer: 'INVESCO SENIOR INCOME TRUST',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VVV',
    Issuer: 'VALVOLINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VWE',
    Issuer: 'VINTAGE WINE ESTATES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VWEWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VWID',
    Issuer: 'VIRTUS WMC INTERNATIONAL DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VWO',
    Issuer: 'VANGUARD FTSE EMERGING MARKE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VWOB',
    Issuer: 'VANGUARD EMERG MKTS GOV BND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VXF',
    Issuer: 'VANGUARD EXTENDED MARKET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VXRT',
    Issuer: 'VAXART INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VXUS',
    Issuer: 'VANGUARD TOTAL INTL STOCK',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VXX',
    Issuer: 'IPATH SERIES B S&P 500 VIX',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VXZ',
    Issuer: 'IPATH SER B S&P 500 VIX M/T',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYGG',
    Issuer: 'VY GLOBAL GROWTH-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYGG+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYGG=',
    Issuer: 'VY GLOBAL GROWTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYGR',
    Issuer: 'VOYAGER THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYM',
    Issuer: 'VANGUARD HIGH DVD YIELD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYMI',
    Issuer: 'VANGUARD INT HIGH DVD YLD IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYNE',
    Issuer: 'VYNE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VYNT',
    Issuer: 'VYANT BIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VZ',
    Issuer: 'VERIZON COMMUNICATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VZIO',
    Issuer: 'VIZIO HOLDING  CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'VZLA',
    Issuer: 'VIZSLA SILVER CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'W',
    Issuer: 'WAYFAIR INC- CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAB',
    Issuer: 'WABTEC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WABC',
    Issuer: 'WESTAMERICA BANCORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAFD',
    Issuer: 'WASHINGTON FEDERAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAFDP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAFU',
    Issuer: 'WAH FU EDUCATION GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAL',
    Issuer: 'WESTERN ALLIANCE BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAL-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WALD',
    Issuer: 'WALDENCAST ACQUISITION COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WALDU',
    Issuer: 'WALDENCAST ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WALDW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WANT',
    Issuer: 'DRX DLY CONS DISC BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WARR',
    Issuer: 'WARRIOR TECHNOLOGIES ACQ-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WARR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WARR=',
    Issuer: 'WARRIOR TECHNOLOGIES ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WASH',
    Issuer: 'WASHINGTON TRUST BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAT',
    Issuer: 'WATERS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WATT',
    Issuer: 'ENERGOUS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVC',
    Issuer: 'WAVERLEY CAPITAL ACQUISITI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVC=',
    Issuer: 'WAVERLEY CAPITAL ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVD',
    Issuer: 'WAVEDANCER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVE',
    Issuer: 'ECO WAVE POWER GLOBAL AB-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVS',
    Issuer: 'WESTERN ACQUISITION VENTURES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVSU',
    Issuer: 'WESTERN ACQUISITION VENTURES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WAVSW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WB',
    Issuer: 'WEIBO CORP-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBA',
    Issuer: 'WALGREENS BOOTS ALLIANCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBAT',
    Issuer: 'WISDOMTREE BATTERY VALUE CHA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBD',
    Issuer: 'WARNER BROS DISCOVERY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBEV',
    Issuer: 'WINC INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBIF',
    Issuer: 'WBI BULLBEAR VALUE 3000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBIG',
    Issuer: 'WBI BULLBEAR YIELD 3000 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBII',
    Issuer: 'WBI BULLBEAR GLOBAL INCOME E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBIL',
    Issuer: 'WBI BULLBEAR QUALITY 3000 ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBIT',
    Issuer: 'WBI BULLBEAR TREND S US 3000',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBIY',
    Issuer: 'WBI POWER FACTOR HIGH DIV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBND',
    Issuer: 'WESTERN ASSET TOTAL RETURN E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBS',
    Issuer: 'WEBSTER FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBS-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBS-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBT',
    Issuer: 'WELBILT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBX',
    Issuer: 'WALLBOX NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WBX+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WCBR',
    Issuer: 'WISDOMTREE CYBERSECURITY FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WCC',
    Issuer: 'WESCO INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WCC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WCLD',
    Issuer: 'WISDOMTREE CLOUD COMPUTING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WCN',
    Issuer: 'WASTE CONNECTIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WD',
    Issuer: 'WALKER & DUNLOP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDAY',
    Issuer: 'WORKDAY INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDC',
    Issuer: 'WESTERN DIGITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDFC',
    Issuer: 'WD-40 CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDH',
    Issuer: 'WATERDROP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDI',
    Issuer: 'WESTERN ASSET DIVERS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDIV',
    Issuer: 'SPDR S&P GLOBAL DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WDNA',
    Issuer: 'WISDOMTREE BIOREVOLUTION FND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WE',
    Issuer: 'WEWORK INC-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WE+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEA',
    Issuer: 'WESTERN ASSET PREMIER BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEAT',
    Issuer: 'TEUCRIUM WHEAT FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEAV',
    Issuer: 'WEAVE COMMUNICATIONS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEBL',
    Issuer: 'DIREXION DAILY DOW JONES INT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEBR',
    Issuer: 'WEBER INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEBS',
    Issuer: 'DIREXION DAILY DOW JONES INT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEC',
    Issuer: 'WEC ENERGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEED',
    Issuer: 'ROUNDHILL CANNABIS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEIX',
    Issuer: 'DYNAMIC SHORT SHORT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEJO',
    Issuer: 'WEJO GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEJOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEL',
    Issuer: 'INTEGRATED WELLNESS ACQ - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEL+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEL=',
    Issuer: 'INTEGRATED WELLNESS ACQUISIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WELL',
    Issuer: 'WELLTOWER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEN',
    Issuer: "WENDY'S CO/THE",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WERN',
    Issuer: 'WERNER ENTERPRISES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WES',
    Issuer: 'WESTERN MIDSTREAM PARTNERS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WETF',
    Issuer: 'WISDOMTREE INVESTMENTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEX',
    Issuer: 'WEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WEYS',
    Issuer: 'WEYCO GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WF',
    Issuer: 'WOORI FINANCIAL-SPON ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC',
    Issuer: 'WELLS FARGO & CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-C',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-D',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-L',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-Q',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-R',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-Y',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFC-Z',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFCF',
    Issuer: 'WHERE FOOD COMES FROM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFG',
    Issuer: 'WEST FRASER TIMBER CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFH',
    Issuer: 'DIREXION WORK FROM HOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFHY',
    Issuer: 'WISDOMTREE US HIGH YIELD COR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFIG',
    Issuer: 'WISDOMTREE US CORPORATE BOND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WFRD',
    Issuer: 'WEATHERFORD INTERNATIONAL PL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WGLD',
    Issuer: 'WSHARES ENHANCED GOLD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WGMI',
    Issuer: 'VALKYRIE BITCOIN MINERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WGO',
    Issuer: 'WINNEBAGO INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WGRO',
    Issuer: 'WISDOMTREE US GROWTH AND MOM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WH',
    Issuer: 'WYNDHAM HOTELS & RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHD',
    Issuer: 'CACTUS INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHF',
    Issuer: 'WHITEHORSE FINANCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHG',
    Issuer: 'WESTWOOD HOLDINGS GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHLM',
    Issuer: 'WILHELMINA INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHLR',
    Issuer: 'WHEELER REAL ESTATE INVESTME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHLRD',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHLRL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHLRP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WHR',
    Issuer: 'WHIRLPOOL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIA',
    Issuer: 'WESTERN ASSET INFL-LINK SEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIL',
    Issuer: 'IPATH WOMEN IN LEADERSHIP ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WILC',
    Issuer: 'G. WILLI-FOOD INTERNATIONAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIMI',
    Issuer: 'WIMI HOLOGRAM CLOUD INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINA',
    Issuer: 'WINMARK CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINC',
    Issuer: 'WESTERN ASSET ST DUR INC ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WING',
    Issuer: 'WINGSTOP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINN',
    Issuer: 'HARBOR LONG-TERM GROWERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINT',
    Issuer: 'WINDTREE THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINV',
    Issuer: 'WINVEST ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINVR',
    Issuer: 'WINVEST ACQUISITION CORP-RTS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINVU',
    Issuer: 'WINVEST ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WINVW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIP',
    Issuer: 'SPDR FTSE INTERNATIONAL GOVE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIRE',
    Issuer: 'ENCORE WIRE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WISA',
    Issuer: 'WISA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WISH',
    Issuer: 'CONTEXTLOGIC INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIT',
    Issuer: 'WIPRO LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIW',
    Issuer: 'WESTERN ASSET INFL-LINK OPPS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIX',
    Issuer: 'WIX.COM LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WIZ',
    Issuer: 'MERLYN AI BULL-RIDER BEAR-FI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WK',
    Issuer: 'WORKIVA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKEY',
    Issuer: 'WISEKEY INTL HOLDINGS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKHS',
    Issuer: 'WORKHORSE GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKLY',
    Issuer: 'SOFI WEEKLY DIVIDEND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKME',
    Issuer: 'WALKME LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKSP',
    Issuer: 'WORKSPORT LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WKSPW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLDN',
    Issuer: 'WILLDAN GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLDR',
    Issuer: 'AFFINITY WORLD LEADERS EQUIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLFC',
    Issuer: 'WILLIS LEASE FINANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLK',
    Issuer: 'WESTLAKE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLKP',
    Issuer: 'WESTLAKE CHEMICAL PARTNERS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLL',
    Issuer: 'WHITING PETROLEUM CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLMS',
    Issuer: 'WILLIAMS INDUSTRIAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLTG',
    Issuer: 'WEALTHTRUST DBS LONG TERM GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLTH',
    Issuer: 'LIFEGOAL WEALTH BUILDER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLY',
    Issuer: 'WILEY (JOHN) & SONS-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WLYB',
    Issuer: 'WILEY (JOHN) & SONS-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WM',
    Issuer: 'WASTE MANAGEMENT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMB',
    Issuer: 'WILLIAMS COS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMC',
    Issuer: 'WESTERN ASSET MORTGAGE CAPIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMG',
    Issuer: 'WARNER MUSIC GROUP CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMK',
    Issuer: 'WEIS MARKETS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMPN',
    Issuer: 'WILLIAM PENN BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMS',
    Issuer: 'ADVANCED DRAINAGE SYSTEMS IN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WMT',
    Issuer: 'WALMART INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNC',
    Issuer: 'WABASH NATIONAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNDY',
    Issuer: 'GLOBAL X WIND ENERGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNEB',
    Issuer: 'WESTERN NEW ENGLAND BANCORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNNR',
    Issuer: 'ANDRETTI ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNNR+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNNR=',
    Issuer: 'ANDRETTI ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNS',
    Issuer: 'WNS HOLDINGS LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WNW',
    Issuer: 'MEIWU TECHNOLOGY CO LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOLF',
    Issuer: 'WOLFSPEED INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOMN',
    Issuer: "IMPACT SHARES YWCA WOMEN'S E",
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOOD',
    Issuer: 'ISHARES GLOBAL TIMBER & FORE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOOF',
    Issuer: 'PETCO HEALTH AND WELLNESS CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOR',
    Issuer: 'WORTHINGTON INDUSTRIES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WORX',
    Issuer: 'SCWORX CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WOW',
    Issuer: 'WIDEOPENWEST INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPC',
    Issuer: 'WP CAREY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCA',
    Issuer: 'WARBURG PINCUS CAPITAL COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCA=',
    Issuer: 'WARBURG PINCUS CAPITAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCB',
    Issuer: 'WARBURG PINCUS CAPITAL I-B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCB+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPCB=',
    Issuer: 'WARBURG PINCUS CAPITAL COR B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPM',
    Issuer: 'WHEATON PRECIOUS METALS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPP',
    Issuer: 'WPP PLC-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPRT',
    Issuer: 'WESTPORT FUEL SYSTEMS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WPS',
    Issuer: 'ISHARES INTERNATIONAL DEVELO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WQGA',
    Issuer: 'WORLD QUANTUM GROWTH ACQUI-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WQGA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WQGA=',
    Issuer: 'WORLD QUANTUM GROWTH ACQUISI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRAC',
    Issuer: 'WILLIAMS ROWLAND ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRAC+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRAC=',
    Issuer: 'WILLIAMS ROWLAND ACQUISITION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRAP',
    Issuer: 'WRAP TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRB',
    Issuer: 'WR BERKLEY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRB-E',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRB-F',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRB-G',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRB-H',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRBY',
    Issuer: 'WARBY PARKER INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRE',
    Issuer: 'WASHINGTON REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRK',
    Issuer: 'WESTROCK CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRLD',
    Issuer: 'WORLD ACCEPTANCE CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRN',
    Issuer: 'WESTERN COPPER AND GOLD CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WRND',
    Issuer: 'IQ GLOBAL EQUITY R&D LEA ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSBC',
    Issuer: 'WESBANCO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSBCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSBF',
    Issuer: 'WATERSTONE FINANCIAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSC',
    Issuer: 'WILLSCOT MOBILE MINI HOLDING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSFS',
    Issuer: 'WSFS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSM',
    Issuer: 'WILLIAMS-SONOMA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSO',
    Issuer: 'WATSCO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSO.B',
    Issuer: 'WATSCO INC  -CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSR',
    Issuer: 'WHITESTONE REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WST',
    Issuer: 'WEST PHARMACEUTICAL SERVICES',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WSTG',
    Issuer: 'WAYSIDE TECHNOLOGY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTAI',
    Issuer: 'WISDOMTREE AI AND INNOVATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTBA',
    Issuer: 'WEST BANCORPORATION',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTER',
    Issuer: 'ALKALINE WATER CO INC/THE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTFC',
    Issuer: 'WINTRUST FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTFCM',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTFCP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTI',
    Issuer: 'W&T OFFSHORE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTM',
    Issuer: 'WHITE MOUNTAINS INSURANCE GP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTMA',
    Issuer: 'WELSBACH TECHNOLOGY METALS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTMAR',
    Issuer: 'WELSBACH TECH METALS ACQ -RT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTMAU',
    Issuer: 'WELBACH TECHNOLOGY METALS AC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTMF',
    Issuer: 'WISDOMTREE MGD FUTURES STRAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTRE',
    Issuer: 'WISDOMTREE NEW ECONOMY REAL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTRG',
    Issuer: 'ESSENTIAL UTILITIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTRH',
    Issuer: 'WAITR HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTS',
    Issuer: 'WATTS WATER TECHNOLOGIES-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTT',
    Issuer: 'WIRELESS TELECOM GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTTR',
    Issuer: 'SELECT ENERGY SERVICES INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTV',
    Issuer: 'WISDOMTREE U.S. VALUE FUND',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WTW',
    Issuer: 'WILLIS TOWERS WATSON PLC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WU',
    Issuer: 'WESTERN UNION CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WUGI',
    Issuer: 'ESOTERICA NEXTG ECONOMY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WULF',
    Issuer: 'TERAWULF INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WVE',
    Issuer: 'WAVE LIFE SCIENCES LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WVFC',
    Issuer: 'WVS FINANCIAL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WVVI',
    Issuer: 'WILLAMETTE VALLEY VINEYARDS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WVVIP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WW',
    Issuer: 'WW INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWAC',
    Issuer: 'WORLDWIDE WEBB ACQUISITION-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWACU',
    Issuer: 'WORLDWIDE WEBB ACQUISITION C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWACW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWD',
    Issuer: 'WOODWARD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWE',
    Issuer: 'WORLD WRESTLING ENTERTAIN-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWJD',
    Issuer: 'INSPIRE INTERNATIONAL ESG ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWOW',
    Issuer: 'DIREXION WORLD WITHOUT WASTE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWR',
    Issuer: 'WESTWATER RESOURCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WWW',
    Issuer: 'WOLVERINE WORLD WIDE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WY',
    Issuer: 'WEYERHAEUSER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WYNN',
    Issuer: 'WYNN RESORTS LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WYTC',
    Issuer: 'WYTEC INTERNATIONAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WYTCW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'WYY',
    Issuer: 'WIDEPOINT CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'X',
    Issuer: 'UNITED STATES STEEL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XAIR',
    Issuer: 'BEYOND AIR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XAR',
    Issuer: 'SPDR S&P AEROSPACE & DEF ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBAP',
    Issuer: 'INNOVATOR US EQY ACCEL 9 BUF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBB',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBI',
    Issuer: 'SPDR S&P BIOTECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBIO',
    Issuer: 'XENETIC BIOSCIENCES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBIOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBIT',
    Issuer: 'XBIOTECH INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBJA',
    Issuer: 'INNOVATOR US EQ AC 9 BUFF-J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBJL',
    Issuer: 'INN US EQ ACC 9 BUFF JULY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBOC',
    Issuer: 'INNOVATOR US EQY ACC 9 BUFF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XBTF',
    Issuer: 'VANECK BITCOIN STRATEGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XCCC',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XCEM',
    Issuer: 'COLUMBIA EM CORE EX-CHINA ET',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XCLR',
    Issuer: 'GLOBAL X S&P 500 COLLAR 95-1',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XCUR',
    Issuer: 'EXICURE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDAP',
    Issuer: 'INNOVATOR US EQY ACCEL-APR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDAT',
    Issuer: 'FRANKLIN EXPONENTIAL DATA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDEC',
    Issuer: 'FT CBOE VEST US EQY ENHANCE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDJA',
    Issuer: 'INNOVATOR US EQ ACCELERATE-J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDJL',
    Issuer: 'INN US EQ ACCELERATED JULY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDNA',
    Issuer: 'KELLY CRISPR & GENE EDITING',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDOC',
    Issuer: 'INNOVATOR US EQUITY ACCEL OC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDQQ',
    Issuer: 'INNOVATOR GRW 100 ACCEL QTR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XDSQ',
    Issuer: 'INNOVATOR US EQY ACCL-QUART',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XEL',
    Issuer: 'XCEL ENERGY INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XELA',
    Issuer: 'EXELA TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XELAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XELB',
    Issuer: 'XCEL BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XENE',
    Issuer: 'XENON PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XERS',
    Issuer: 'XERIS BIOPHARMA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XES',
    Issuer: 'SPDR OIL & GAS EQUIP & SERV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFIN',
    Issuer: 'EXCELFIN ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFINU',
    Issuer: 'EXCELFIN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFINW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFLT',
    Issuer: 'XAI OCTAGON FLOATING RATE AL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFLT-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XFOR',
    Issuer: 'X4 PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XGN',
    Issuer: 'EXAGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHB',
    Issuer: 'SPDR S&P HOMEBUILDERS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHE',
    Issuer: 'SPDR S&P HEALTH CARE EQUIPME',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHR',
    Issuer: 'XENIA HOTELS & RESORTS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHS',
    Issuer: 'SPDR S&P HEALTH CARE SER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYC',
    Issuer: 'BONDBLOXX USD HY BOND CCS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYD',
    Issuer: 'BONDBLOXX USD HY BOND CNONCS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYE',
    Issuer: 'BONDBLOXX USD HY BOND ENERGY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYF',
    Issuer: 'BONDBLOXX USD HY BOND F REIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYH',
    Issuer: 'BONDBLOXX USD HY BOND HEALTH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYI',
    Issuer: 'BONDBLOXX USD HY BOND INDUS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XHYT',
    Issuer: 'BONDBLOXX USD HY BOND TMT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XIN',
    Issuer: 'XINYUAN REAL ESTATE CO L-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XITK',
    Issuer: 'SPDR FACTSET INNOVATIVE TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XJH',
    Issuer: 'ISHARES ESG SCREEN S&P MID',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XJR',
    Issuer: 'ISHARES ESG SCREEN SP SMALL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XJUN',
    Issuer: 'FT CBOE VEST US EQUITY ENHAN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XL',
    Issuer: 'XL FLEET CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLB',
    Issuer: 'MATERIALS SELECT SECTOR SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLC',
    Issuer: 'COMM SERV SELECT SECTOR SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLE',
    Issuer: 'ENERGY SELECT SECTOR SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLF',
    Issuer: 'FINANCIAL SELECT SECTOR SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLG',
    Issuer: 'INVESCO S&P 500 TOP 50 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLI',
    Issuer: 'INDUSTRIAL SELECT SECT SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLK',
    Issuer: 'TECHNOLOGY SELECT SECT SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLO',
    Issuer: 'XILIO THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLP',
    Issuer: 'CONSUMER STAPLES SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLRE',
    Issuer: 'REAL ESTATE SELECT SECT SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLSR',
    Issuer: 'SPDR SSGA US SECTOR ROTATE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLU',
    Issuer: 'UTILITIES SELECT SECTOR SPDR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLV',
    Issuer: 'HEALTH CARE SELECT SECTOR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XLY',
    Issuer: 'CONSUMER DISCRETIONARY SELT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XM',
    Issuer: 'QUALTRICS INTERNATIONAL-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XME',
    Issuer: 'SPDR S&P METALS & MINING ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMHQ',
    Issuer: 'INVESCO S&P MIDCAP QUAL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMLV',
    Issuer: 'INVESCO S&P MIDCAP LOW VOLAT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMMO',
    Issuer: 'INVESCO S&P MIDCAP MOMENTUM',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMPT',
    Issuer: 'VANECK CEF MUNI INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMTR',
    Issuer: 'XOMETRY INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XMVM',
    Issuer: 'INVESCO S&P MIDCAP VALUE WIT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XNCR',
    Issuer: 'XENCOR INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XNET',
    Issuer: 'XUNLEI LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XNTK',
    Issuer: 'SPDR NYSE TECHNOLOGY ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOM',
    Issuer: 'EXXON MOBIL CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOMA',
    Issuer: 'XOMA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOMAO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOMAP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOP',
    Issuer: 'SPDR S&P OIL & GAS EXP & PR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOS',
    Issuer: 'XOS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOSWW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XOUT',
    Issuer: 'GRANITESHARES XOUT US L/C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XP',
    Issuer: 'XP INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPAX',
    Issuer: 'XPAC ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPAXU',
    Issuer: 'XPAC ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPAXW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPDB',
    Issuer: 'POWER & DIGITAL ACQUISITIO-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPDBU',
    Issuer: 'POWER & DIGITAL INFRASTRUCTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPDBW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPEL',
    Issuer: 'XPEL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPER',
    Issuer: 'XPERI HOLDING CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPEV',
    Issuer: 'XPENG INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPH',
    Issuer: 'SPDR S&P PHARMACEUTICALS ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPL',
    Issuer: 'SOLITARIO ZINC CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPND',
    Issuer: 'FIRST TRUST EXPANDED TECH',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPO',
    Issuer: 'XPO LOGISTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPOA',
    Issuer: 'DPCM CAPITAL INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPOA+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPOA=',
    Issuer: 'DPCM CAPITAL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPOF',
    Issuer: 'XPONENTIAL FITNESS INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPON',
    Issuer: 'EXPION360 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPP',
    Issuer: 'PROSHARES ULTRA FTSE CHINA50',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XPRO',
    Issuer: 'EXPRO GROUP HOLDINGS NV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRAY',
    Issuer: 'DENTSPLY SIRONA INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRLV',
    Issuer: 'INVESCO S&P 500 EX-RATE SENS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRMI',
    Issuer: 'GLOBAL X S&P 500 RISK MANAGE',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRT',
    Issuer: 'SPDR S&P RETAIL ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRTX',
    Issuer: 'XORTX THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XRX',
    Issuer: 'XEROX HOLDINGS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSD',
    Issuer: 'SPDR S&P SEMICONDUCTOR ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSHD',
    Issuer: 'INVESCO S&P SMALLCAP HIGH DI',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSHQ',
    Issuer: 'INVESCO S&P SMALLCAP QUALITY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSLV',
    Issuer: 'INVESCO S&P SMALLCAP LOW VOL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSMO',
    Issuer: 'INVESCO S&P SMALLCAP MOMENTU',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSOE',
    Issuer: 'WISDMTREE EMERG MKT EX-ST OW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSPA',
    Issuer: 'XPRESSPA GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSVM',
    Issuer: 'INVESCO S&P SMALLCAP VALUE W',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XSW',
    Issuer: 'SPDR S&P SOFTWARE & SER ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XT',
    Issuer: 'ISHARES EXPONENTIAL TECH ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTAP',
    Issuer: 'INNOVATOR US EQTY ACCEL PL',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTJA',
    Issuer: 'INNOVATOR US EQ ACC PLUS - J',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTJL',
    Issuer: 'INN US EQ ACCEL PLUS JULY',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTL',
    Issuer: 'SPDR S&P TELECOM ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTLB',
    Issuer: 'XTL BIOPHARMACEUTICALS-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTN',
    Issuer: 'SPDR S&P TRANSPORTATION ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTNT',
    Issuer: 'XTANT MEDICAL HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTOC',
    Issuer: 'INNOVATOR US EQY ACCEL PL-OC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XTR',
    Issuer: 'GLOBAL X S&P 500 TAIL RISK E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XVOL',
    Issuer: 'ACRUENCE ACTIVE HEDGE US ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XVV',
    Issuer: 'ISHARES ESG SCREENED S&P500',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XWEB',
    Issuer: 'SPDR S&P INTERNET ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XXII',
    Issuer: '22ND CENTURY GROUP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XYF',
    Issuer: 'X FINANCIAL-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XYL',
    Issuer: 'XYLEM INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XYLD',
    Issuer: 'GLOBAL X S&P 500 COVE CALL E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'XYLG',
    Issuer: 'GLOBAL X S&P 500 COVC & GRW',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'Y',
    Issuer: 'ALLEGHANY CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YALA',
    Issuer: 'YALLA GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YANG',
    Issuer: 'DRX DLY FTSE CHINA BEAR 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YCBD',
    Issuer: 'CBDMD INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YCBD-A',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YCL',
    Issuer: 'PROSHARES ULTRA YEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YCS',
    Issuer: 'PROSHARES ULTRASHORT YEN',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YDEC',
    Issuer: 'FT CBOE V INTERN EQ BUFF DEC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YELL',
    Issuer: 'YELLOW CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YELP',
    Issuer: 'YELP INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YETI',
    Issuer: 'YETI HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YEXT',
    Issuer: 'YEXT INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YGMZ',
    Issuer: 'MINGZHU LOGISTICS HOLDINGS L',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YI',
    Issuer: '111 INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YINN',
    Issuer: 'DRX DLY FTSE CHINA BULL 3X',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YJ',
    Issuer: 'YUNJI INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YJUN',
    Issuer: 'FT CBOE VEST INTERNATIONAL E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YLD',
    Issuer: 'PRINCIPAL ACTIVE HIGH YIELD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YLDE',
    Issuer: 'CLEARBRIDG DIV STRGY ESG ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YMAB',
    Issuer: 'Y-MABS THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YMAR',
    Issuer: 'FT CBOE VEST INT EQTY BUF-MA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YMM',
    Issuer: 'FULL TRUCK ALLIANCE -SPN ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YMTX',
    Issuer: 'YUMANITY THERAPEUTICS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YNDX',
    Issuer: 'YANDEX NV-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YOLO',
    Issuer: 'ADVISORSHARES PURE CANNABIS',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YORW',
    Issuer: 'YORK WATER CO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YOTAU',
    Issuer: 'YOTTA ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YOU',
    Issuer: 'CLEAR SECURE INC -CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YPF',
    Issuer: 'YPF S.A.-SPONSORED ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YPS',
    Issuer: 'ARROW REVERSE CAP 500 ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YQ',
    Issuer: '17 EDUCATION & TECHNOLOGY GR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YRD',
    Issuer: 'YIREN DIGITAL LTD - SPS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YSEP',
    Issuer: 'FT CBOE VEST INTERNATIONAL E',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YSG',
    Issuer: 'YATSEN HOLDING LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YTEN',
    Issuer: 'YIELD10 BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YTPG',
    Issuer: 'TPG PACE BENEFICIAL II COR-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YTRA',
    Issuer: 'YATRA ONLINE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YUM',
    Issuer: 'YUM! BRANDS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YUMC',
    Issuer: 'YUM CHINA HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YUMY',
    Issuer: 'VANECK FUTURE OF FOOD ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YVR',
    Issuer: 'LIQUID MEDIA GROUP LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YXI',
    Issuer: 'PROSHARES SHORT FTSE CHINA50',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YY',
    Issuer: 'JOYY INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'YYY',
    Issuer: 'AMPLIFY HIGH INCOME ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'Z',
    Issuer: 'ZILLOW GROUP INC - C',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZAZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZBH',
    Issuer: 'ZIMMER BIOMET HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZBRA',
    Issuer: 'ZEBRA TECHNOLOGIES CORP-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZBZX',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZBZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZCMD',
    Issuer: 'ZHONGCHAO INC-CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZCZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZD',
    Issuer: 'ZIFF DAVIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZDGE',
    Issuer: 'ZEDGE INC-CL B',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEAL',
    Issuer: 'ZEALAND PHARMA A/S-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZECP',
    Issuer: 'ZACKS EARNINGS CONSISTENT PO',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEN',
    Issuer: 'ZENDESK INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZENV',
    Issuer: 'ZENVIA INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEPP',
    Issuer: 'ZEPP HEALTH CORP-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEST',
    Issuer: 'ECOARK HOLDINGS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZETA',
    Issuer: 'ZETA GLOBAL HOLDINGS CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEUS',
    Issuer: 'OLYMPIC STEEL INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEV',
    Issuer: 'LIGHTNING EMOTORS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEV+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZEXIT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZG',
    Issuer: 'ZILLOW GROUP INC - A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZGEN',
    Issuer: 'GENERATION Z ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZGN',
    Issuer: 'ERMENEGILDO ZEGNA HOLDITALIA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZGN+',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZH',
    Issuer: 'ZHIHU INC - ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZHDG',
    Issuer: 'ZEGA BUY AND HEDGE ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZI',
    Issuer: 'ZOOMINFO TECHNOLOGIES INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIEXT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIG',
    Issuer: 'THE ACQUIRERS FUND ETF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIM',
    Issuer: 'ZIM INTEGRATED SHIPPING SERV',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIMV',
    Issuer: 'ZIMVIE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZING',
    Issuer: 'FTAC ZEUS ACQUISITION C-CL A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZINGU',
    Issuer: 'FTAC ZEUS ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZINGW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZION',
    Issuer: 'ZIONS BANCORP NA',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIONL',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIONO',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIONP',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIP',
    Issuer: 'ZIPRECRUITER INC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIVO',
    Issuer: 'ZIVO BIOSCIENCE INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZIVOW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZJZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZKIN',
    Issuer: 'ZK INTERNATIONAL GROUP CO LT',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZLAB',
    Issuer: 'ZAI LAB LTD-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZM',
    Issuer: 'ZOOM VIDEO COMMUNICATIONS-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZME',
    Issuer: 'ZHANGMEN EDUCATION INC- ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZNH',
    Issuer: 'CHINA SOUTHERN AIR-SPONS ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZNTL',
    Issuer: 'ZENTALIS PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZOM',
    Issuer: 'ZOMEDICA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZROZ',
    Issuer: 'PIMCO 25+ YR ZERO CPN US TIF',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZS',
    Issuer: 'ZSCALER INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZSAN',
    Issuer: 'ZOSANO PHARMA CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZSL',
    Issuer: 'PROSHARES ULTRASHORT SILVER',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZT',
    Issuer: 'ZIMMER ENERGY TRANSITION -A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTAQU',
    Issuer: 'ZIMMER ENERGY TRANSITION ACQ',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTAQW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTEK',
    Issuer: 'ZENTEK LTD',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTEST',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTO',
    Issuer: 'ZTO EXPRESS CAYMAN INC-ADR',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTOPU',
    Issuer: 'ZI TOPRUN ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTR',
    Issuer: 'VIRTUS TOTAL RETURN FUND INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZTS',
    Issuer: 'ZOETIS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZUMZ',
    Issuer: 'ZUMIEZ INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZUO',
    Issuer: 'ZUORA INC - CLASS A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZVIA',
    Issuer: 'ZEVIA PBC-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZVO',
    Issuer: 'ZOVIO INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZVV',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZVVV',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZVZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZWRK',
    Issuer: 'Z-WORK ACQUISITION CORP-A',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZWRKU',
    Issuer: 'Z-WORK ACQUISITION CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZWRKW',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZWS',
    Issuer: 'ZURN WATER SOLUTIONS CORP',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZWZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZXIET',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZXZZT',
    Issuer: '',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZY',
    Issuer: 'ZYMERGEN INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZYME',
    Issuer: 'ZYMEWORKS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZYNE',
    Issuer: 'ZYNERBA PHARMACEUTICALS INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
  {
    Symbol: 'ZYXI',
    Issuer: 'ZYNEX INC',
    date: '2022-05-26',
    isEnabled: '1',
    lit: '1',
  },
];